import { useMarketFilter, marketSelect } from './hop-market-filter.js';
import {createPurchaseComponents,purchaseBundle,purchaseBenefitsData} from "./hop-purchase.js?shipping-stock-20261027";
import {normalizeFuel as hoComparisonFuel, normalizeInstallation as hoComparisonInstallation} from "./category-journey-core.js?v=9ddc1b596a53fe48";
import {createNapoleonFireMedia,quantity as napoleonMediaQuantity,media as napoleonMediaCatalog} from "./napoleon-fire-media.js?v=20260916-included-image";
import { C as e, E as t, S as n, T as r, _ as i, a, b as o, c as s, d as c, f as l, g as u, h as d, i as f, l as p, m, n as h, o as g, p as _, r as v, s as y, t as b, u as x, v as S, w as C, x as w, y as ee } from "./napoleon-planning-catalog-PuGpX8RZ.js?v=btu-20260924-1";
//#region node_modules/scheduler/cjs/scheduler.production.js
var T = /* @__PURE__ */ r(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) if (n(c) !== null) m = !0, S || (S = !0, D());
		else {
			var t = n(l);
			t !== null && re(x, t.startTime - e);
		}
	}
	var S = !1, C = -1, w = 5, ee = -1;
	function T() {
		return g ? !0 : !(e.unstable_now() - ee < w);
	}
	function E() {
		if (g = !1, S) {
			var t = e.unstable_now();
			ee = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(C), C = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && T());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && re(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? D() : S = !1;
			}
		}
	}
	var D;
	if (typeof y == "function") D = function() {
		y(E);
	};
	else if (typeof MessageChannel < "u") {
		var te = new MessageChannel(), ne = te.port2;
		te.port1.onmessage = E, D = function() {
			ne.postMessage(null);
		};
	} else D = function() {
		_(E, 0);
	};
	function re(t, n) {
		C = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, re(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, D()))), r;
	}, e.unstable_shouldYield = T, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), E = /* @__PURE__ */ r(((e, t) => {
	t.exports = T();
})), D = /* @__PURE__ */ r(((e) => {
	var t = C();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") if (typeof t == "object" && t) {
			if (t.as == null || t.as === "script") {
				var n = c(t.as, t.crossOrigin);
				i.d.M(e, {
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		} else t ?? i.d.M(e);
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") if (t) {
			var n = c(t.as, t.crossOrigin);
			i.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			});
		} else i.d.m(e);
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.6";
})), te = /* @__PURE__ */ r(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = D();
})), ne = /* @__PURE__ */ r(((e) => {
	var t = E(), n = C(), r = te();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function u(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function d(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = d(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var f = Object.assign, p = Symbol.for("react.element"), m = Symbol.for("react.transitional.element"), h = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), _ = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), y = Symbol.for("react.consumer"), b = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), ee = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), D = Symbol.for("react.activity"), ne = Symbol.for("react.memo_cache_sentinel"), re = Symbol.iterator;
	function ie(e) {
		return typeof e != "object" || !e ? null : (e = re && e[re] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var ae = Symbol.for("react.client.reference");
	function oe(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === ae ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case g: return "Fragment";
			case v: return "Profiler";
			case _: return "StrictMode";
			case S: return "Suspense";
			case w: return "SuspenseList";
			case D: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case h: return "Portal";
			case b: return e.displayName || "Context";
			case y: return (e._context.displayName || "Context") + ".Consumer";
			case x:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case ee: return t = e.displayName || null, t === null ? oe(e.type) || "Memo" : t;
			case T:
				t = e._payload, e = e._init;
				try {
					return oe(e(t));
				} catch {}
		}
		return null;
	}
	var se = Array.isArray, O = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, A = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, ce = [], le = -1;
	function ue(e) {
		return { current: e };
	}
	function j(e) {
		0 > le || (e.current = ce[le], ce[le] = null, le--);
	}
	function M(e, t) {
		le++, ce[le] = e.current, e.current = t;
	}
	var de = ue(null), fe = ue(null), pe = ue(null), me = ue(null);
	function he(e, t) {
		switch (M(pe, t), M(fe, e), M(de, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		j(de), M(de, e);
	}
	function ge() {
		j(de), j(fe), j(pe);
	}
	function _e(e) {
		e.memoizedState !== null && M(me, e);
		var t = de.current, n = Hd(t, e.type);
		t !== n && (M(fe, e), M(de, n));
	}
	function ve(e) {
		fe.current === e && (j(de), j(fe)), me.current === e && (j(me), Qf._currentValue = A);
	}
	var ye, be;
	function xe(e) {
		if (ye === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			ye = t && t[1] || "", be = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + ye + e + be;
	}
	var Se = !1;
	function Ce(e, t) {
		if (!e || Se) return "";
		Se = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			Se = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? xe(n) : "";
	}
	function we(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return xe(e.type);
			case 16: return xe("Lazy");
			case 13: return e.child !== t && t !== null ? xe("Suspense Fallback") : xe("Suspense");
			case 19: return xe("SuspenseList");
			case 0:
			case 15: return Ce(e.type, !1);
			case 11: return Ce(e.type.render, !1);
			case 1: return Ce(e.type, !0);
			case 31: return xe("Activity");
			default: return "";
		}
	}
	function Te(e) {
		try {
			var t = "", n = null;
			do
				t += we(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var Ee = Object.prototype.hasOwnProperty, De = t.unstable_scheduleCallback, Oe = t.unstable_cancelCallback, ke = t.unstable_shouldYield, Ae = t.unstable_requestPaint, je = t.unstable_now, Me = t.unstable_getCurrentPriorityLevel, Ne = t.unstable_ImmediatePriority, Pe = t.unstable_UserBlockingPriority, Fe = t.unstable_NormalPriority, Ie = t.unstable_LowPriority, Le = t.unstable_IdlePriority, Re = t.log, ze = t.unstable_setDisableYieldValue, Be = null, Ve = null;
	function He(e) {
		if (typeof Re == "function" && ze(e), Ve && typeof Ve.setStrictMode == "function") try {
			Ve.setStrictMode(Be, e);
		} catch {}
	}
	var Ue = Math.clz32 ? Math.clz32 : Ge, N = Math.log, We = Math.LN2;
	function Ge(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (N(e) / We | 0) | 0;
	}
	var Ke = 256, qe = 262144, Je = 4194304;
	function Ye(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function Xe(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Ye(n))) : i = Ye(o) : i = Ye(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Ye(n))) : i = Ye(o)) : i = Ye(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function Ze(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function Qe(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function $e() {
		var e = Je;
		return Je <<= 1, !(Je & 62914560) && (Je = 4194304), e;
	}
	function et(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function tt(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function nt(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Ue(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && rt(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function rt(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Ue(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function it(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Ue(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function at(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : ot(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function ot(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function st(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function ct() {
		var e = k.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function lt(e, t) {
		var n = k.p;
		try {
			return k.p = e, t();
		} finally {
			k.p = n;
		}
	}
	var ut = Math.random().toString(36).slice(2), P = "__reactFiber$" + ut, F = "__reactProps$" + ut, dt = "__reactContainer$" + ut, ft = "__reactEvents$" + ut, pt = "__reactListeners$" + ut, mt = "__reactHandles$" + ut, ht = "__reactResources$" + ut, gt = "__reactMarker$" + ut;
	function _t(e) {
		delete e[P], delete e[F], delete e[ft], delete e[pt], delete e[mt];
	}
	function vt(e) {
		var t = e[P];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[dt] || n[P]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
					if (n = e[P]) return n;
					e = df(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function yt(e) {
		if (e = e[P] || e[dt]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function bt(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function xt(e) {
		var t = e[ht];
		return t ||= e[ht] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function St(e) {
		e[gt] = !0;
	}
	var Ct = /* @__PURE__ */ new Set(), wt = {};
	function Tt(e, t) {
		Et(e, t), Et(e + "Capture", t);
	}
	function Et(e, t) {
		for (wt[e] = t, e = 0; e < t.length; e++) Ct.add(t[e]);
	}
	var Dt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Ot = {}, kt = {};
	function At(e) {
		return Ee.call(kt, e) ? !0 : Ee.call(Ot, e) ? !1 : Dt.test(e) ? kt[e] = !0 : (Ot[e] = !0, !1);
	}
	function jt(e, t, n) {
		if (At(t)) if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
					e.removeAttribute(t);
					return;
				case "boolean":
					var r = t.toLowerCase().slice(0, 5);
					if (r !== "data-" && r !== "aria-") {
						e.removeAttribute(t);
						return;
					}
			}
			e.setAttribute(t, "" + n);
		}
	}
	function Mt(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function Nt(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function Pt(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function Ft(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function It(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function Lt(e) {
		if (!e._valueTracker) {
			var t = Ft(e) ? "checked" : "value";
			e._valueTracker = It(e, t, "" + e[t]);
		}
	}
	function Rt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = Ft(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
	}
	function zt(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var Bt = /[\n"\\]/g;
	function Vt(e) {
		return e.replace(Bt, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Ht(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Pt(t)) : e.value !== "" + Pt(t) && (e.value = "" + Pt(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : Wt(e, o, Pt(n)) : Wt(e, o, Pt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + Pt(s) : e.removeAttribute("name");
	}
	function Ut(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				Lt(e);
				return;
			}
			n = n == null ? "" : "" + Pt(n), t = t == null ? n : "" + Pt(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), Lt(e);
	}
	function Wt(e, t, n) {
		t === "number" && zt(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Gt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + Pt(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Kt(e, t, n) {
		if (t != null && (t = "" + Pt(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + Pt(n);
	}
	function qt(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (se(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = Pt(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Lt(e);
	}
	function Jt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Yt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function Xt(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Yt.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Zt(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && Xt(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && Xt(e, o, t[o]);
	}
	function Qt(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var $t = new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), en = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function tn(e) {
		return en.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function nn() {}
	var rn = null;
	function an(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var on = null, sn = null;
	function cn(e) {
		var t = yt(e);
		if (t && (e = t.stateNode)) {
			var n = e[F] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Ht(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + Vt("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[F] || null;
								if (!a) throw Error(i(90));
								Ht(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Rt(r);
					}
					break a;
				case "textarea":
					Kt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Gt(e, !!n.multiple, t, !1);
			}
		}
	}
	var ln = !1;
	function un(e, t, n) {
		if (ln) return e(t, n);
		ln = !0;
		try {
			return e(t);
		} finally {
			if (ln = !1, (on !== null || sn !== null) && (bu(), on && (t = on, e = sn, sn = on = null, cn(t), e))) for (t = 0; t < e.length; t++) cn(e[t]);
		}
	}
	function dn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[F] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var fn = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), pn = !1;
	if (fn) try {
		var mn = {};
		Object.defineProperty(mn, "passive", { get: function() {
			pn = !0;
		} }), window.addEventListener("test", mn, mn), window.removeEventListener("test", mn, mn);
	} catch {
		pn = !1;
	}
	var hn = null, gn = null, _n = null;
	function vn() {
		if (_n) return _n;
		var e, t = gn, n = t.length, r, i = "value" in hn ? hn.value : hn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return _n = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function yn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function bn() {
		return !0;
	}
	function xn() {
		return !1;
	}
	function Sn(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? bn : xn, this.isPropagationStopped = xn, this;
		}
		return f(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = bn);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = bn);
			},
			persist: function() {},
			isPersistent: bn
		}), t;
	}
	var Cn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, wn = Sn(Cn), Tn = f({}, Cn, {
		view: 0,
		detail: 0
	}), En = Sn(Tn), Dn, On, kn, An = f({}, Tn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: Vn,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== kn && (kn && e.type === "mousemove" ? (Dn = e.screenX - kn.screenX, On = e.screenY - kn.screenY) : On = Dn = 0, kn = e), Dn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : On;
		}
	}), jn = Sn(An), Mn = Sn(f({}, An, { dataTransfer: 0 })), Nn = Sn(f({}, Tn, { relatedTarget: 0 })), Pn = Sn(f({}, Cn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Fn = Sn(f({}, Cn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), In = Sn(f({}, Cn, { data: 0 })), Ln = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, Rn = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, zn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Bn(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = zn[e]) ? !!t[e] : !1;
	}
	function Vn() {
		return Bn;
	}
	var Hn = Sn(f({}, Tn, {
		key: function(e) {
			if (e.key) {
				var t = Ln[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = yn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Rn[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: Vn,
		charCode: function(e) {
			return e.type === "keypress" ? yn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? yn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), Un = Sn(f({}, An, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), Wn = Sn(f({}, Tn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: Vn
	})), Gn = Sn(f({}, Cn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Kn = Sn(f({}, An, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), qn = Sn(f({}, Cn, {
		newState: 0,
		oldState: 0
	})), Jn = [
		9,
		13,
		27,
		32
	], Yn = fn && "CompositionEvent" in window, Xn = null;
	fn && "documentMode" in document && (Xn = document.documentMode);
	var Zn = fn && "TextEvent" in window && !Xn, Qn = fn && (!Yn || Xn && 8 < Xn && 11 >= Xn), $n = " ", er = !1;
	function tr(e, t) {
		switch (e) {
			case "keyup": return Jn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function nr(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var rr = !1;
	function ir(e, t) {
		switch (e) {
			case "compositionend": return nr(t);
			case "keypress": return t.which === 32 ? (er = !0, $n) : null;
			case "textInput": return e = t.data, e === $n && er ? null : e;
			default: return null;
		}
	}
	function ar(e, t) {
		if (rr) return e === "compositionend" || !Yn && tr(e, t) ? (e = vn(), _n = gn = hn = null, rr = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return Qn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var or = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function sr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!or[e.type] : t === "textarea";
	}
	function cr(e, t, n, r) {
		on ? sn ? sn.push(r) : sn = [r] : on = r, t = Ed(t, "onChange"), 0 < t.length && (n = new wn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var lr = null, ur = null;
	function dr(e) {
		yd(e, 0);
	}
	function fr(e) {
		if (Rt(bt(e))) return e;
	}
	function pr(e, t) {
		if (e === "change") return t;
	}
	var mr = !1;
	if (fn) {
		var hr;
		if (fn) {
			var gr = "oninput" in document;
			if (!gr) {
				var _r = document.createElement("div");
				_r.setAttribute("oninput", "return;"), gr = typeof _r.oninput == "function";
			}
			hr = gr;
		} else hr = !1;
		mr = hr && (!document.documentMode || 9 < document.documentMode);
	}
	function vr() {
		lr && (lr.detachEvent("onpropertychange", yr), ur = lr = null);
	}
	function yr(e) {
		if (e.propertyName === "value" && fr(ur)) {
			var t = [];
			cr(t, ur, e, an(e)), un(dr, t);
		}
	}
	function br(e, t, n) {
		e === "focusin" ? (vr(), lr = t, ur = n, lr.attachEvent("onpropertychange", yr)) : e === "focusout" && vr();
	}
	function xr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return fr(ur);
	}
	function Sr(e, t) {
		if (e === "click") return fr(t);
	}
	function Cr(e, t) {
		if (e === "input" || e === "change") return fr(t);
	}
	function wr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var Tr = typeof Object.is == "function" ? Object.is : wr;
	function Er(e, t) {
		if (Tr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!Ee.call(t, i) || !Tr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function Dr(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function Or(e, t) {
		var n = Dr(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = Dr(n);
		}
	}
	function kr(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? kr(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function Ar(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = zt(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = zt(e.document);
		}
		return t;
	}
	function jr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Mr = fn && "documentMode" in document && 11 >= document.documentMode, Nr = null, Pr = null, Fr = null, Ir = !1;
	function Lr(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		Ir || Nr == null || Nr !== zt(r) || (r = Nr, "selectionStart" in r && jr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Fr && Er(Fr, r) || (Fr = r, r = Ed(Pr, "onSelect"), 0 < r.length && (t = new wn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = Nr)));
	}
	function Rr(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var zr = {
		animationend: Rr("Animation", "AnimationEnd"),
		animationiteration: Rr("Animation", "AnimationIteration"),
		animationstart: Rr("Animation", "AnimationStart"),
		transitionrun: Rr("Transition", "TransitionRun"),
		transitionstart: Rr("Transition", "TransitionStart"),
		transitioncancel: Rr("Transition", "TransitionCancel"),
		transitionend: Rr("Transition", "TransitionEnd")
	}, Br = {}, Vr = {};
	fn && (Vr = document.createElement("div").style, "AnimationEvent" in window || (delete zr.animationend.animation, delete zr.animationiteration.animation, delete zr.animationstart.animation), "TransitionEvent" in window || delete zr.transitionend.transition);
	function Hr(e) {
		if (Br[e]) return Br[e];
		if (!zr[e]) return e;
		var t = zr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in Vr) return Br[e] = t[n];
		return e;
	}
	var Ur = Hr("animationend"), Wr = Hr("animationiteration"), Gr = Hr("animationstart"), Kr = Hr("transitionrun"), qr = Hr("transitionstart"), Jr = Hr("transitioncancel"), Yr = Hr("transitionend"), Xr = /* @__PURE__ */ new Map(), Zr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Zr.push("scrollEnd");
	function Qr(e, t) {
		Xr.set(e, t), Tt(t, [e]);
	}
	var $r = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, ei = [], ti = 0, ni = 0;
	function ri() {
		for (var e = ti, t = ni = ti = 0; t < e;) {
			var n = ei[t];
			ei[t++] = null;
			var r = ei[t];
			ei[t++] = null;
			var i = ei[t];
			ei[t++] = null;
			var a = ei[t];
			if (ei[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && si(n, i, a);
		}
	}
	function ii(e, t, n, r) {
		ei[ti++] = e, ei[ti++] = t, ei[ti++] = n, ei[ti++] = r, ni |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function ai(e, t, n, r) {
		return ii(e, t, n, r), ci(e);
	}
	function oi(e, t) {
		return ii(e, null, null, t), ci(e);
	}
	function si(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ue(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function ci(e) {
		if (50 < du) throw du = 0, fu = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var li = {};
	function ui(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function di(e, t, n, r) {
		return new ui(e, t, n, r);
	}
	function fi(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function pi(e, t) {
		var n = e.alternate;
		return n === null ? (n = di(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function mi(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function hi(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") fi(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, de.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case D: return e = di(31, n, t, a), e.elementType = D, e.lanes = o, e;
			case g: return gi(n.children, a, o, t);
			case _:
				s = 8, a |= 24;
				break;
			case v: return e = di(12, n, t, a | 2), e.elementType = v, e.lanes = o, e;
			case S: return e = di(13, n, t, a), e.elementType = S, e.lanes = o, e;
			case w: return e = di(19, n, t, a), e.elementType = w, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case b:
						s = 10;
						break a;
					case y:
						s = 9;
						break a;
					case x:
						s = 11;
						break a;
					case ee:
						s = 14;
						break a;
					case T:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = di(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function gi(e, t, n, r) {
		return e = di(7, e, r, t), e.lanes = n, e;
	}
	function _i(e, t, n) {
		return e = di(6, e, null, t), e.lanes = n, e;
	}
	function vi(e) {
		var t = di(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function yi(e, t, n) {
		return t = di(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var bi = /* @__PURE__ */ new WeakMap();
	function xi(e, t) {
		if (typeof e == "object" && e) {
			var n = bi.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: Te(t)
			}, bi.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: Te(t)
		};
	}
	var Si = [], Ci = 0, wi = null, Ti = 0, Ei = [], Di = 0, Oi = null, ki = 1, Ai = "";
	function ji(e, t) {
		Si[Ci++] = Ti, Si[Ci++] = wi, wi = e, Ti = t;
	}
	function Mi(e, t, n) {
		Ei[Di++] = ki, Ei[Di++] = Ai, Ei[Di++] = Oi, Oi = e;
		var r = ki;
		e = Ai;
		var i = 32 - Ue(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Ue(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, ki = 1 << 32 - Ue(t) + i | n << i | r, Ai = a + e;
		} else ki = 1 << a | n << i | r, Ai = e;
	}
	function Ni(e) {
		e.return !== null && (ji(e, 1), Mi(e, 1, 0));
	}
	function Pi(e) {
		for (; e === wi;) wi = Si[--Ci], Si[Ci] = null, Ti = Si[--Ci], Si[Ci] = null;
		for (; e === Oi;) Oi = Ei[--Di], Ei[Di] = null, Ai = Ei[--Di], Ei[Di] = null, ki = Ei[--Di], Ei[Di] = null;
	}
	function Fi(e, t) {
		Ei[Di++] = ki, Ei[Di++] = Ai, Ei[Di++] = Oi, ki = t.id, Ai = t.overflow, Oi = e;
	}
	var Ii = null, I = null, L = !1, Li = null, Ri = !1, zi = Error(i(519));
	function Bi(e) {
		throw Ki(xi(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), zi;
	}
	function Vi(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[P] = e, t[F] = r, n) {
			case "dialog":
				Q("cancel", t), Q("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				Q("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < _d.length; n++) Q(_d[n], t);
				break;
			case "source":
				Q("error", t);
				break;
			case "img":
			case "image":
			case "link":
				Q("error", t), Q("load", t);
				break;
			case "details":
				Q("toggle", t);
				break;
			case "input":
				Q("invalid", t), Ut(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				Q("invalid", t);
				break;
			case "textarea": Q("invalid", t), qt(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || Md(t.textContent, n) ? (r.popover != null && (Q("beforetoggle", t), Q("toggle", t)), r.onScroll != null && Q("scroll", t), r.onScrollEnd != null && Q("scrollend", t), r.onClick != null && (t.onclick = nn), t = !0) : t = !1, t || Bi(e, !0);
	}
	function Hi(e) {
		for (Ii = e.return; Ii;) switch (Ii.tag) {
			case 5:
			case 31:
			case 13:
				Ri = !1;
				return;
			case 27:
			case 3:
				Ri = !0;
				return;
			default: Ii = Ii.return;
		}
	}
	function Ui(e) {
		if (e !== Ii) return !1;
		if (!L) return Hi(e), L = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Ud(e.type, e.memoizedProps)), n = !n), n && I && Bi(e), Hi(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			I = uf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			I = uf(e);
		} else t === 27 ? (t = I, Zd(e.type) ? (e = lf, lf = null, I = e) : I = t) : I = Ii ? cf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function Wi() {
		I = Ii = null, L = !1;
	}
	function Gi() {
		var e = Li;
		return e !== null && (Zl === null ? Zl = e : Zl.push.apply(Zl, e), Li = null), e;
	}
	function Ki(e) {
		Li === null ? Li = [e] : Li.push(e);
	}
	var qi = ue(null), Ji = null, Yi = null;
	function Xi(e, t, n) {
		M(qi, t._currentValue), t._currentValue = n;
	}
	function Zi(e) {
		e._currentValue = qi.current, j(qi);
	}
	function Qi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function $i(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Qi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Qi(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function ea(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					Tr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === me.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			a = a.return;
		}
		e !== null && $i(t, e, n, r), t.flags |= 262144;
	}
	function ta(e) {
		for (e = e.firstContext; e !== null;) {
			if (!Tr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function na(e) {
		Ji = e, Yi = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function ra(e) {
		return aa(Ji, e);
	}
	function ia(e, t) {
		return Ji === null && na(e), aa(e, t);
	}
	function aa(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Yi === null) {
			if (e === null) throw Error(i(308));
			Yi = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Yi = Yi.next = t;
		return n;
	}
	var oa = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, sa = t.unstable_scheduleCallback, ca = t.unstable_NormalPriority, la = {
		$$typeof: b,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function ua() {
		return {
			controller: new oa(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function da(e) {
		e.refCount--, e.refCount === 0 && sa(ca, function() {
			e.controller.abort();
		});
	}
	var fa = null, pa = 0, ma = 0, ha = null;
	function ga(e, t) {
		if (fa === null) {
			var n = fa = [];
			pa = 0, ma = dd(), ha = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return pa++, t.then(_a, _a), t;
	}
	function _a() {
		if (--pa === 0 && fa !== null) {
			ha !== null && (ha.status = "fulfilled");
			var e = fa;
			fa = null, ma = 0, ha = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function va(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var ya = O.S;
	O.S = function(e, t) {
		eu = je(), typeof t == "object" && t && typeof t.then == "function" && ga(e, t), ya !== null && ya(e, t);
	};
	var ba = ue(null);
	function xa() {
		var e = ba.current;
		return e === null ? K.pooledCache : e;
	}
	function Sa(e, t) {
		t === null ? M(ba, ba.current) : M(ba, t.pool);
	}
	function Ca() {
		var e = xa();
		return e === null ? null : {
			parent: la._currentValue,
			pool: e
		};
	}
	var wa = Error(i(460)), Ta = Error(i(474)), Ea = Error(i(542)), Da = { then: function() {} };
	function Oa(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function ka(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(nn, nn), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, Na(e), e;
			default:
				if (typeof t.status == "string") t.then(nn, nn);
				else {
					if (e = K, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, Na(e), e;
				}
				throw ja = t, wa;
		}
	}
	function Aa(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (ja = e, wa) : e;
		}
	}
	var ja = null;
	function Ma() {
		if (ja === null) throw Error(i(459));
		var e = ja;
		return ja = null, e;
	}
	function Na(e) {
		if (e === wa || e === Ea) throw Error(i(483));
	}
	var Pa = null, Fa = 0;
	function Ia(e) {
		var t = Fa;
		return Fa += 1, Pa === null && (Pa = []), ka(Pa, e, t);
	}
	function La(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function Ra(e, t) {
		throw t.$$typeof === p ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function za(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = pi(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = _i(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === g ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === T && Aa(i) === t.type) ? (t = a(t, n.props), La(t, n), t.return = e, t) : (t = hi(n.type, n.key, n.props, null, e.mode, r), La(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = yi(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = gi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = _i("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case m: return n = hi(t.type, t.key, t.props, null, e.mode, n), La(n, t), n.return = e, n;
					case h: return t = yi(t, e.mode, n), t.return = e, t;
					case T: return t = Aa(t), f(e, t, n);
				}
				if (se(t) || ie(t)) return t = gi(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Ia(t), n);
				if (t.$$typeof === b) return f(e, ia(e, t), n);
				Ra(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case m: return n.key === i ? l(e, t, n, r) : null;
					case h: return n.key === i ? u(e, t, n, r) : null;
					case T: return n = Aa(n), p(e, t, n, r);
				}
				if (se(n) || ie(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Ia(n), r);
				if (n.$$typeof === b) return p(e, t, ia(e, n), r);
				Ra(e, n);
			}
			return null;
		}
		function _(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case m: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case h: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case T: return r = Aa(r), _(e, t, n, r, i);
				}
				if (se(r) || ie(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return _(e, t, n, Ia(r), i);
				if (r.$$typeof === b) return _(e, t, n, ia(t, r), i);
				Ra(t, r);
			}
			return null;
		}
		function v(i, a, s, c) {
			for (var l = null, u = null, d = a, m = a = 0, h = null; d !== null && m < s.length; m++) {
				d.index > m ? (h = d, d = null) : h = d.sibling;
				var g = p(i, d, s[m], c);
				if (g === null) {
					d === null && (d = h);
					break;
				}
				e && d && g.alternate === null && t(i, d), a = o(g, a, m), u === null ? l = g : u.sibling = g, u = g, d = h;
			}
			if (m === s.length) return n(i, d), L && ji(i, m), l;
			if (d === null) {
				for (; m < s.length; m++) d = f(i, s[m], c), d !== null && (a = o(d, a, m), u === null ? l = d : u.sibling = d, u = d);
				return L && ji(i, m), l;
			}
			for (d = r(d); m < s.length; m++) h = _(d, i, m, s[m], c), h !== null && (e && h.alternate !== null && d.delete(h.key === null ? m : h.key), a = o(h, a, m), u === null ? l = h : u.sibling = h, u = h);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), L && ji(i, m), l;
		}
		function y(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, m = s, h = s = 0, g = null, v = c.next(); m !== null && !v.done; h++, v = c.next()) {
				m.index > h ? (g = m, m = null) : g = m.sibling;
				var y = p(a, m, v.value, l);
				if (y === null) {
					m === null && (m = g);
					break;
				}
				e && m && y.alternate === null && t(a, m), s = o(y, s, h), d === null ? u = y : d.sibling = y, d = y, m = g;
			}
			if (v.done) return n(a, m), L && ji(a, h), u;
			if (m === null) {
				for (; !v.done; h++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, h), d === null ? u = v : d.sibling = v, d = v);
				return L && ji(a, h), u;
			}
			for (m = r(m); !v.done; h++, v = c.next()) v = _(m, a, h, v.value, l), v !== null && (e && v.alternate !== null && m.delete(v.key === null ? h : v.key), s = o(v, s, h), d === null ? u = v : d.sibling = v, d = v);
			return e && m.forEach(function(e) {
				return t(a, e);
			}), L && ji(a, h), u;
		}
		function x(e, r, o, c) {
			if (typeof o == "object" && o && o.type === g && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case m:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === g) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === T && Aa(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), La(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								} else t(e, r);
								r = r.sibling;
							}
							o.type === g ? (c = gi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = hi(o.type, o.key, o.props, null, e.mode, c), La(c, o), c.return = e, e = c);
						}
						return s(e);
					case h:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
									n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
									break a;
								} else {
									n(e, r);
									break;
								}
								else t(e, r);
								r = r.sibling;
							}
							c = yi(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case T: return o = Aa(o), x(e, r, o, c);
				}
				if (se(o)) return v(e, r, o, c);
				if (ie(o)) {
					if (l = ie(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), y(e, r, o, c);
				}
				if (typeof o.then == "function") return x(e, r, Ia(o), c);
				if (o.$$typeof === b) return x(e, r, ia(e, o), c);
				Ra(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = _i(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				Fa = 0;
				var i = x(e, t, n, r);
				return Pa = null, i;
			} catch (t) {
				if (t === wa || t === Ea) throw t;
				var a = di(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ba = za(!0), Va = za(!1), Ha = !1;
	function Ua(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Wa(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function Ga(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ka(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, G & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = ci(e), si(e, null, n), t;
		}
		return ii(e, r, t, n), ci(e);
	}
	function qa(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, it(e, n);
		}
	}
	function Ja(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Ya = !1;
	function Xa() {
		if (Ya) {
			var e = ha;
			if (e !== null) throw e;
		}
	}
	function Za(e, t, n, r) {
		Ya = !1;
		var i = e.updateQueue;
		Ha = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var p = s.lane & -536870913, m = p !== s.lane;
				if (m ? (J & p) === p : (r & p) === p) {
					p !== 0 && p === ma && (Ya = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var h = e, g = s;
						p = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (h = g.payload, typeof h == "function") {
									d = h.call(_, d, p);
									break a;
								}
								d = h;
								break a;
							case 3: h.flags = h.flags & -65537 | 128;
							case 0:
								if (h = g.payload, p = typeof h == "function" ? h.call(_, d, p) : h, p == null) break a;
								d = f({}, d, p);
								break a;
							case 2: Ha = !0;
						}
					}
					p = s.callback, p !== null && (e.flags |= 64, m && (e.flags |= 8192), m = i.callbacks, m === null ? i.callbacks = [p] : m.push(p));
				} else m = {
					lane: p,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = m, c = d) : u = u.next = m, o |= p;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					m = s, s = m.next, m.next = null, i.lastBaseUpdate = m, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Gl |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Qa(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function $a(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Qa(n[e], t);
	}
	var eo = ue(null), to = ue(0);
	function no(e, t) {
		e = Wl, M(to, e), M(eo, t), Wl = e | t.baseLanes;
	}
	function ro() {
		M(to, Wl), M(eo, eo.current);
	}
	function io() {
		Wl = to.current, j(eo), j(to);
	}
	var ao = ue(null), oo = null;
	function so(e) {
		var t = e.alternate;
		M(R, R.current & 1), M(ao, e), oo === null && (t === null || eo.current !== null || t.memoizedState !== null) && (oo = e);
	}
	function co(e) {
		M(R, R.current), M(ao, e), oo === null && (oo = e);
	}
	function lo(e) {
		e.tag === 22 ? (M(R, R.current), M(ao, e), oo === null && (oo = e)) : uo(e);
	}
	function uo() {
		M(R, R.current), M(ao, ao.current);
	}
	function fo(e) {
		j(ao), oo === e && (oo = null), j(R);
	}
	var R = ue(0);
	function po(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var mo = 0, z = null, B = null, ho = null, go = !1, _o = !1, vo = !1, yo = 0, bo = 0, xo = null, So = 0;
	function V() {
		throw Error(i(321));
	}
	function Co(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!Tr(e[n], t[n])) return !1;
		return !0;
	}
	function wo(e, t, n, r, i, a) {
		return mo = a, z = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, O.H = e === null || e.memoizedState === null ? Bs : Vs, vo = !1, a = n(r, i), vo = !1, _o && (a = Eo(t, n, r, i)), To(e), a;
	}
	function To(e) {
		O.H = zs;
		var t = B !== null && B.next !== null;
		if (mo = 0, ho = B = z = null, go = !1, bo = 0, xo = null, t) throw Error(i(300));
		e === null || ic || (e = e.dependencies, e !== null && ta(e) && (ic = !0));
	}
	function Eo(e, t, n, r) {
		z = e;
		var a = 0;
		do {
			if (_o && (xo = null), bo = 0, _o = !1, 25 <= a) throw Error(i(301));
			if (a += 1, ho = B = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			O.H = Hs, o = t(n, r);
		} while (_o);
		return o;
	}
	function Do() {
		var e = O.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? No(t) : t, e = e.useState()[0], (B === null ? null : B.memoizedState) !== e && (z.flags |= 1024), t;
	}
	function Oo() {
		var e = yo !== 0;
		return yo = 0, e;
	}
	function ko(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function Ao(e) {
		if (go) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			go = !1;
		}
		mo = 0, ho = B = z = null, _o = !1, bo = yo = 0, xo = null;
	}
	function jo() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return ho === null ? z.memoizedState = ho = e : ho = ho.next = e, ho;
	}
	function H() {
		if (B === null) {
			var e = z.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = B.next;
		var t = ho === null ? z.memoizedState : ho.next;
		if (t !== null) ho = t, B = e;
		else {
			if (e === null) throw z.alternate === null ? Error(i(467)) : Error(i(310));
			B = e, e = {
				memoizedState: B.memoizedState,
				baseState: B.baseState,
				baseQueue: B.baseQueue,
				queue: B.queue,
				next: null
			}, ho === null ? z.memoizedState = ho = e : ho = ho.next = e;
		}
		return ho;
	}
	function Mo() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function No(e) {
		var t = bo;
		return bo += 1, xo === null && (xo = []), e = ka(xo, e, t), t = z, (ho === null ? t.memoizedState : ho.next) === null && (t = t.alternate, O.H = t === null || t.memoizedState === null ? Bs : Vs), e;
	}
	function Po(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return No(e);
			if (e.$$typeof === b) return ra(e);
		}
		throw Error(i(438, String(e)));
	}
	function Fo(e) {
		var t = null, n = z.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = z.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = Mo(), z.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = ne;
		return t.index++, n;
	}
	function Io(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Lo(e) {
		return Ro(H(), B, e);
	}
	function Ro(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (mo & f) === f : (J & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === ma && (d = !0);
					else if ((mo & p) === p) {
						u = u.next, p === ma && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, z.lanes |= p, Gl |= p;
					f = u.action, vo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, z.lanes |= f, Gl |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !Tr(o, e.memoizedState) && (ic = !0, d && (n = ha, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function zo(e) {
		var t = H(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			Tr(o, t.memoizedState) || (ic = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Bo(e, t, n) {
		var r = z, a = H(), o = L;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !Tr((B || a).memoizedState, n);
		if (s && (a.memoizedState = n, ic = !0), a = a.queue, ds(Uo.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || ho !== null && ho.memoizedState.tag & 1) {
			if (r.flags |= 2048, os(9, { destroy: void 0 }, Ho.bind(null, r, a, n, t), null), K === null) throw Error(i(349));
			o || mo & 127 || Vo(r, t, n);
		}
		return n;
	}
	function Vo(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = z.updateQueue, t === null ? (t = Mo(), z.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function Ho(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Wo(t) && Go(e);
	}
	function Uo(e, t, n) {
		return n(function() {
			Wo(t) && Go(e);
		});
	}
	function Wo(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !Tr(e, n);
		} catch {
			return !0;
		}
	}
	function Go(e) {
		var t = oi(e, 2);
		t !== null && hu(t, e, 2);
	}
	function Ko(e) {
		var t = jo();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), vo) {
				He(!0);
				try {
					n();
				} finally {
					He(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Io,
			lastRenderedState: e
		}, t;
	}
	function qo(e, t, n, r) {
		return e.baseState = n, Ro(e, B, typeof r == "function" ? r : Io);
	}
	function Jo(e, t, n, r, a) {
		if (Is(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			O.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Yo(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Yo(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = O.T, o = {};
			O.T = o;
			try {
				var s = n(i, r), c = O.S;
				c !== null && c(o, s), Xo(e, t, s);
			} catch (n) {
				Qo(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), O.T = a;
			}
		} else try {
			a = n(i, r), Xo(e, t, a);
		} catch (n) {
			Qo(e, t, n);
		}
	}
	function Xo(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Zo(e, t, n);
		}, function(n) {
			return Qo(e, t, n);
		}) : Zo(e, t, n);
	}
	function Zo(e, t, n) {
		t.status = "fulfilled", t.value = n, $o(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Yo(e, n)));
	}
	function Qo(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, $o(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function $o(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function es(e, t) {
		return t;
	}
	function ts(e, t) {
		if (L) {
			var n = K.formState;
			if (n !== null) {
				a: {
					var r = z;
					if (L) {
						if (I) {
							b: {
								for (var i = I, a = Ri; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = cf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								I = cf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Bi(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = jo(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: es,
			lastRenderedState: t
		}, n.queue = r, n = Ns.bind(null, z, r), r.dispatch = n, r = Ko(!1), a = Fs.bind(null, z, !1, r.queue), r = jo(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Jo.bind(null, z, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function ns(e) {
		return rs(H(), B, e);
	}
	function rs(e, t, n) {
		if (t = Ro(e, t, es)[0], e = Lo(Io)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = No(t);
		} catch (e) {
			throw e === wa ? Ea : e;
		}
		else r = t;
		t = H();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (z.flags |= 2048, os(9, { destroy: void 0 }, is.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function is(e, t) {
		e.action = t;
	}
	function as(e) {
		var t = H(), n = B;
		if (n !== null) return rs(t, n, e);
		H(), t = t.memoizedState, n = H();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function os(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = z.updateQueue, t === null && (t = Mo(), z.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function ss() {
		return H().memoizedState;
	}
	function cs(e, t, n, r) {
		var i = jo();
		z.flags |= e, i.memoizedState = os(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function ls(e, t, n, r) {
		var i = H();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		B !== null && r !== null && Co(r, B.memoizedState.deps) ? i.memoizedState = os(t, a, n, r) : (z.flags |= e, i.memoizedState = os(1 | t, a, n, r));
	}
	function us(e, t) {
		cs(8390656, 8, e, t);
	}
	function ds(e, t) {
		ls(2048, 8, e, t);
	}
	function fs(e) {
		z.flags |= 4;
		var t = z.updateQueue;
		if (t === null) t = Mo(), z.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function ps(e) {
		var t = H().memoizedState;
		return fs({
			ref: t,
			nextImpl: e
		}), function() {
			if (G & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function ms(e, t) {
		return ls(4, 2, e, t);
	}
	function hs(e, t) {
		return ls(4, 4, e, t);
	}
	function gs(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function _s(e, t, n) {
		n = n == null ? null : n.concat([e]), ls(4, 4, gs.bind(null, t, e), n);
	}
	function vs() {}
	function ys(e, t) {
		var n = H();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && Co(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function bs(e, t) {
		var n = H();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && Co(t, r[1])) return r[0];
		if (r = e(), vo) {
			He(!0);
			try {
				e();
			} finally {
				He(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function xs(e, t, n) {
		return n === void 0 || mo & 1073741824 && !(J & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = mu(), z.lanes |= e, Gl |= e, n);
	}
	function Ss(e, t, n, r) {
		return Tr(n, t) ? n : eo.current === null ? !(mo & 42) || mo & 1073741824 && !(J & 261930) ? (ic = !0, e.memoizedState = n) : (e = mu(), z.lanes |= e, Gl |= e, t) : (e = xs(e, n, r), Tr(e, t) || (ic = !0), e);
	}
	function Cs(e, t, n, r, i) {
		var a = k.p;
		k.p = a !== 0 && 8 > a ? a : 8;
		var o = O.T, s = {};
		O.T = s, Fs(e, !1, t, n);
		try {
			var c = i(), l = O.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? Ps(e, t, va(c, r), pu(e)) : Ps(e, t, r, pu(e));
		} catch (n) {
			Ps(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, pu());
		} finally {
			k.p = a, o !== null && s.types !== null && (o.types = s.types), O.T = o;
		}
	}
	function ws() {}
	function Ts(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = Es(e).queue;
		Cs(e, a, t, A, n === null ? ws : function() {
			return Ds(e), n(r);
		});
	}
	function Es(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: A,
			baseState: A,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Io,
				lastRenderedState: A
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Io,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function Ds(e) {
		var t = Es(e);
		t.next === null && (t = e.alternate.memoizedState), Ps(e, t.next.queue, {}, pu());
	}
	function Os() {
		return ra(Qf);
	}
	function ks() {
		return H().memoizedState;
	}
	function As() {
		return H().memoizedState;
	}
	function js(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = pu();
					e = Ga(n);
					var r = Ka(t, e, n);
					r !== null && (hu(r, t, n), qa(r, t, n)), t = { cache: ua() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Ms(e, t, n) {
		var r = pu();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Is(e) ? Ls(t, n) : (n = ai(e, t, n, r), n !== null && (hu(n, e, r), Rs(n, t, r)));
	}
	function Ns(e, t, n) {
		Ps(e, t, n, pu());
	}
	function Ps(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Is(e)) Ls(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, Tr(s, o)) return ii(e, t, i, 0), K === null && ri(), !1;
			} catch {}
			if (n = ai(e, t, i, r), n !== null) return hu(n, e, r), Rs(n, t, r), !0;
		}
		return !1;
	}
	function Fs(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: dd(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Is(e)) {
			if (t) throw Error(i(479));
		} else t = ai(e, n, r, 2), t !== null && hu(t, e, 2);
	}
	function Is(e) {
		var t = e.alternate;
		return e === z || t !== null && t === z;
	}
	function Ls(e, t) {
		_o = go = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function Rs(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, it(e, n);
		}
	}
	var zs = {
		readContext: ra,
		use: Po,
		useCallback: V,
		useContext: V,
		useEffect: V,
		useImperativeHandle: V,
		useLayoutEffect: V,
		useInsertionEffect: V,
		useMemo: V,
		useReducer: V,
		useRef: V,
		useState: V,
		useDebugValue: V,
		useDeferredValue: V,
		useTransition: V,
		useSyncExternalStore: V,
		useId: V,
		useHostTransitionStatus: V,
		useFormState: V,
		useActionState: V,
		useOptimistic: V,
		useMemoCache: V,
		useCacheRefresh: V
	};
	zs.useEffectEvent = V;
	var Bs = {
		readContext: ra,
		use: Po,
		useCallback: function(e, t) {
			return jo().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: ra,
		useEffect: us,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), cs(4194308, 4, gs.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return cs(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			cs(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = jo();
			t = t === void 0 ? null : t;
			var r = e();
			if (vo) {
				He(!0);
				try {
					e();
				} finally {
					He(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = jo();
			if (n !== void 0) {
				var i = n(t);
				if (vo) {
					He(!0);
					try {
						n(t);
					} finally {
						He(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Ms.bind(null, z, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = jo();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Ko(e);
			var t = e.queue, n = Ns.bind(null, z, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: vs,
		useDeferredValue: function(e, t) {
			return xs(jo(), e, t);
		},
		useTransition: function() {
			var e = Ko(!1);
			return e = Cs.bind(null, z, e.queue, !0, !1), jo().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = z, a = jo();
			if (L) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), K === null) throw Error(i(349));
				J & 127 || Vo(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, us(Uo.bind(null, r, o, e), [e]), r.flags |= 2048, os(9, { destroy: void 0 }, Ho.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = jo(), t = K.identifierPrefix;
			if (L) {
				var n = Ai, r = ki;
				n = (r & ~(1 << 32 - Ue(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = yo++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = So++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: Os,
		useFormState: ts,
		useActionState: ts,
		useOptimistic: function(e) {
			var t = jo();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Fs.bind(null, z, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: Fo,
		useCacheRefresh: function() {
			return jo().memoizedState = js.bind(null, z);
		},
		useEffectEvent: function(e) {
			var t = jo(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (G & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Vs = {
		readContext: ra,
		use: Po,
		useCallback: ys,
		useContext: ra,
		useEffect: ds,
		useImperativeHandle: _s,
		useInsertionEffect: ms,
		useLayoutEffect: hs,
		useMemo: bs,
		useReducer: Lo,
		useRef: ss,
		useState: function() {
			return Lo(Io);
		},
		useDebugValue: vs,
		useDeferredValue: function(e, t) {
			return Ss(H(), B.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Lo(Io)[0], t = H().memoizedState;
			return [typeof e == "boolean" ? e : No(e), t];
		},
		useSyncExternalStore: Bo,
		useId: ks,
		useHostTransitionStatus: Os,
		useFormState: ns,
		useActionState: ns,
		useOptimistic: function(e, t) {
			return qo(H(), B, e, t);
		},
		useMemoCache: Fo,
		useCacheRefresh: As
	};
	Vs.useEffectEvent = ps;
	var Hs = {
		readContext: ra,
		use: Po,
		useCallback: ys,
		useContext: ra,
		useEffect: ds,
		useImperativeHandle: _s,
		useInsertionEffect: ms,
		useLayoutEffect: hs,
		useMemo: bs,
		useReducer: zo,
		useRef: ss,
		useState: function() {
			return zo(Io);
		},
		useDebugValue: vs,
		useDeferredValue: function(e, t) {
			var n = H();
			return B === null ? xs(n, e, t) : Ss(n, B.memoizedState, e, t);
		},
		useTransition: function() {
			var e = zo(Io)[0], t = H().memoizedState;
			return [typeof e == "boolean" ? e : No(e), t];
		},
		useSyncExternalStore: Bo,
		useId: ks,
		useHostTransitionStatus: Os,
		useFormState: as,
		useActionState: as,
		useOptimistic: function(e, t) {
			var n = H();
			return B === null ? (n.baseState = e, [e, n.queue.dispatch]) : qo(n, B, e, t);
		},
		useMemoCache: Fo,
		useCacheRefresh: As
	};
	Hs.useEffectEvent = ps;
	function Us(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : f({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Ws = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = Ga(r);
			i.payload = t, n != null && (i.callback = n), t = Ka(e, i, r), t !== null && (hu(t, e, r), qa(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = Ga(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ka(e, i, r), t !== null && (hu(t, e, r), qa(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = pu(), r = Ga(n);
			r.tag = 2, t != null && (r.callback = t), t = Ka(e, r, n), t !== null && (hu(t, e, n), qa(t, e, n));
		}
	};
	function Gs(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !Er(n, r) || !Er(i, a) : !0;
	}
	function Ks(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ws.enqueueReplaceState(t, t.state, null);
	}
	function qs(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = f({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Js(e) {
		$r(e);
	}
	function Ys(e) {
		console.error(e);
	}
	function Xs(e) {
		$r(e);
	}
	function Zs(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Qs(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function $s(e, t, n) {
		return n = Ga(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Zs(e, t);
		}, n;
	}
	function ec(e) {
		return e = Ga(e), e.tag = 3, e;
	}
	function tc(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Qs(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Qs(t, n, r), typeof i != "function" && (ru === null ? ru = new Set([this]) : ru.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function nc(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && ea(t, n, a, !0), n = ao.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return oo === null ? Du() : n.alternate === null && X === 0 && (X = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === Da ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Gu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === Da ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Gu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return Gu(e, r, a), Du(), !1;
		}
		if (L) return t = ao.current, t === null ? (r !== zi && (t = Error(i(423), { cause: r }), Ki(xi(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = xi(r, n), a = $s(e.stateNode, r, a), Ja(e, a), X !== 4 && (X = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== zi && (e = Error(i(422), { cause: r }), Ki(xi(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = xi(o, n), Xl === null ? Xl = [o] : Xl.push(o), X !== 4 && (X = 2), t === null) return !0;
		r = xi(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = $s(n.stateNode, r, e), Ja(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (ru === null || !ru.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = ec(a), tc(a, e, n, r), Ja(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var rc = Error(i(461)), ic = !1;
	function ac(e, t, n, r) {
		t.child = e === null ? Va(t, null, n, r) : Ba(t, e.child, n, r);
	}
	function oc(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return na(t), r = wo(e, t, n, o, a, i), s = Oo(), e !== null && !ic ? (ko(e, t, i), Ac(e, t, i)) : (L && s && Ni(t), t.flags |= 1, ac(e, t, r, i), t.child);
	}
	function sc(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !fi(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, cc(e, t, a, r, i)) : (e = hi(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !jc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? Er : n, n(o, r) && e.ref === t.ref) return Ac(e, t, i);
		}
		return t.flags |= 1, e = pi(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function cc(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (Er(a, r) && e.ref === t.ref) if (ic = !1, t.pendingProps = r = a, jc(e, i)) e.flags & 131072 && (ic = !0);
			else return t.lanes = e.lanes, Ac(e, t, i);
		}
		return gc(e, t, n, r, i);
	}
	function lc(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return dc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && Sa(t, a === null ? null : a.cachePool), a === null ? ro() : no(t, a), lo(t);
			else return r = t.lanes = 536870912, dc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && Sa(t, null), ro(), uo(t)) : (Sa(t, a.cachePool), no(t, a), uo(t), t.memoizedState = null);
		return ac(e, t, i, n), t.child;
	}
	function uc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function dc(e, t, n, r, i) {
		var a = xa();
		return a = a === null ? null : {
			parent: la._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && Sa(t, null), ro(), lo(t), e !== null && ea(e, t, r, !0), t.childLanes = i, null;
	}
	function fc(e, t) {
		return t = Tc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function pc(e, t, n) {
		return Ba(t, e.child, null, n), e = fc(t, t.pendingProps), e.flags |= 2, fo(t), t.memoizedState = null, e;
	}
	function mc(e, t, n) {
		var r = t.pendingProps, a = (t.flags & 128) != 0;
		if (t.flags &= -129, e === null) {
			if (L) {
				if (r.mode === "hidden") return e = fc(t, r), t.lanes = 536870912, uc(null, e);
				if (co(t), (e = I) ? (e = rf(e, Ri), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: Oi === null ? null : {
						id: ki,
						overflow: Ai
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = vi(e), n.return = t, t.child = n, Ii = t, I = null)) : e = null, e === null) throw Bi(t);
				return t.lanes = 536870912, null;
			}
			return fc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (co(t), a) if (t.flags & 256) t.flags &= -257, t = pc(e, t, n);
			else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
			else throw Error(i(558));
			else if (ic || ea(e, t, n, !1), a = (n & e.childLanes) !== 0, ic || a) {
				if (r = K, r !== null && (s = at(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, oi(e, s), hu(r, e, s), rc;
				Du(), t = pc(e, t, n);
			} else e = o.treeContext, I = cf(s.nextSibling), Ii = t, L = !0, Li = null, Ri = !1, e !== null && Fi(t, e), t = fc(t, r), t.flags |= 4096;
			return t;
		}
		return e = pi(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function hc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function gc(e, t, n, r, i) {
		return na(t), n = wo(e, t, n, r, void 0, i), r = Oo(), e !== null && !ic ? (ko(e, t, i), Ac(e, t, i)) : (L && r && Ni(t), t.flags |= 1, ac(e, t, n, i), t.child);
	}
	function _c(e, t, n, r, i, a) {
		return na(t), t.updateQueue = null, n = Eo(t, r, n, i), To(e), r = Oo(), e !== null && !ic ? (ko(e, t, a), Ac(e, t, a)) : (L && r && Ni(t), t.flags |= 1, ac(e, t, n, a), t.child);
	}
	function vc(e, t, n, r, i) {
		if (na(t), t.stateNode === null) {
			var a = li, o = n.contextType;
			typeof o == "object" && o && (a = ra(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Ws, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Ua(t), o = n.contextType, a.context = typeof o == "object" && o ? ra(o) : li, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Us(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Ws.enqueueReplaceState(a, a.state, null), Za(t, r, a, i), Xa(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = qs(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = li, typeof u == "object" && u && (o = ra(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Ks(t, a, r, o), Ha = !1;
			var f = t.memoizedState;
			a.state = f, Za(t, r, a, i), Xa(), l = t.memoizedState, s || f !== l || Ha ? (typeof d == "function" && (Us(t, n, d, r), l = t.memoizedState), (c = Ha || Gs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Wa(e, t), o = t.memoizedProps, u = qs(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = li, typeof l == "object" && l && (c = ra(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Ks(t, a, r, c), Ha = !1, f = t.memoizedState, a.state = f, Za(t, r, a, i), Xa();
			var p = t.memoizedState;
			o !== d || f !== p || Ha || e !== null && e.dependencies !== null && ta(e.dependencies) ? (typeof s == "function" && (Us(t, n, s, r), p = t.memoizedState), (u = Ha || Gs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && ta(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, hc(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ba(t, e.child, null, i), t.child = Ba(t, null, n, i)) : ac(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ac(e, t, i), e;
	}
	function yc(e, t, n, r) {
		return Wi(), t.flags |= 256, ac(e, t, n, r), t.child;
	}
	var bc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function xc(e) {
		return {
			baseLanes: e,
			cachePool: Ca()
		};
	}
	function Sc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Jl), e;
	}
	function Cc(e, t, n) {
		var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (R.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
			if (L) {
				if (a ? so(t) : uo(t), (e = I) ? (e = rf(e, Ri), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: Oi === null ? null : {
						id: ki,
						overflow: Ai
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = vi(e), n.return = t, t.child = n, Ii = t, I = null)) : e = null, e === null) throw Bi(t);
				return of(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (uo(t), a = t.mode, c = Tc({
				mode: "hidden",
				children: c
			}, a), r = gi(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(null, r)) : (so(t), wc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? (so(t), t.flags &= -257, t = Ec(e, t, n)) : t.memoizedState === null ? (uo(t), c = r.fallback, a = t.mode, r = Tc({
				mode: "visible",
				children: r.children
			}, a), c = gi(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ba(t, e.child, null, n), r = t.child, r.memoizedState = xc(n), r.childLanes = Sc(e, s, n), t.memoizedState = bc, t = uc(null, r)) : (uo(t), t.child = e.child, t.flags |= 128, t = null);
			else if (so(t), of(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Ki({
					value: r,
					source: null,
					stack: null
				}), t = Ec(e, t, n);
			} else if (ic || ea(e, t, n, !1), s = (n & e.childLanes) !== 0, ic || s) {
				if (s = K, s !== null && (r = at(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, oi(e, r), hu(s, e, r), rc;
				af(c) || Du(), t = Ec(e, t, n);
			} else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, I = cf(c.nextSibling), Ii = t, L = !0, Li = null, Ri = !1, e !== null && Fi(t, e), t = wc(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (uo(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = pi(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = gi(c, a, n, null), c.flags |= 2) : c = pi(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, uc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = xc(n) : (a = c.cachePool, a === null ? a = Ca() : (l = la._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = Sc(e, s, n), t.memoizedState = bc, uc(e.child, r)) : (so(t), n = e.child, e = n.sibling, n = pi(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function wc(e, t) {
		return t = Tc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function Tc(e, t) {
		return e = di(22, e, null, t), e.lanes = 0, e;
	}
	function Ec(e, t, n) {
		return Ba(t, e.child, null, n), e = wc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function Dc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Qi(e.return, t, n);
	}
	function Oc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function kc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = R.current, s = (o & 2) != 0;
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, M(R, o), ac(e, t, r, n), r = L ? Ti : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && Dc(e, n, t);
			else if (e.tag === 19) Dc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && po(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Oc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && po(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				Oc(t, !0, n, null, a, r);
				break;
			case "together":
				Oc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function Ac(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Gl |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
			if (ea(e, t, n, !1), (n & t.childLanes) === 0) return null;
		} else return null;
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = pi(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = pi(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function jc(e, t) {
		return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && ta(e))) : !0;
	}
	function Mc(e, t, n) {
		switch (t.tag) {
			case 3:
				he(t, t.stateNode.containerInfo), Xi(t, la, e.memoizedState.cache), Wi();
				break;
			case 27:
			case 5:
				_e(t);
				break;
			case 4:
				he(t, t.stateNode.containerInfo);
				break;
			case 10:
				Xi(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, co(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (so(t), e = Ac(e, t, n), e === null ? null : e.sibling) : Cc(e, t, n) : (so(t), t.flags |= 128, null);
				so(t);
				break;
			case 19:
				var i = (e.flags & 128) != 0;
				if (r = (n & t.childLanes) !== 0, r ||= (ea(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return kc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), M(R, R.current), r) break;
				return null;
			case 22: return t.lanes = 0, lc(e, t, n, t.pendingProps);
			case 24: Xi(t, la, e.memoizedState.cache);
		}
		return Ac(e, t, n);
	}
	function Nc(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) ic = !0;
		else {
			if (!jc(e, n) && !(t.flags & 128)) return ic = !1, Mc(e, t, n);
			ic = !!(e.flags & 131072);
		}
		else ic = !1, L && t.flags & 1048576 && Mi(t, Ti, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = Aa(t.elementType), t.type = e, typeof e == "function") fi(e) ? (r = qs(e, r), t.tag = 1, t = vc(null, t, e, r, n)) : (t.tag = 0, t = gc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === x) {
								t.tag = 11, t = oc(null, t, e, r, n);
								break a;
							} else if (a === ee) {
								t.tag = 14, t = sc(null, t, e, r, n);
								break a;
							}
						}
						throw t = oe(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return gc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = qs(r, t.pendingProps), vc(e, t, r, a, n);
			case 3:
				a: {
					if (he(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Wa(e, t), Za(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Xi(t, la, r), r !== o.cache && $i(t, [la], n, !0), Xa(), r = s.element, o.isDehydrated) if (o = {
						element: r,
						isDehydrated: !1,
						cache: s.cache
					}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
						t = yc(e, t, r, n);
						break a;
					} else if (r !== a) {
						a = xi(Error(i(424)), t), Ki(a), t = yc(e, t, r, n);
						break a;
					} else {
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (I = cf(e.firstChild), Ii = t, L = !0, Li = null, Ri = !0, n = Va(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					}
					else {
						if (Wi(), r === a) {
							t = Ac(e, t, n);
							break a;
						}
						ac(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return hc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : L || (n = t.type, e = t.pendingProps, r = Bd(pe.current).createElement(n), r[P] = t, r[F] = e, Pd(r, n, e), St(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return _e(t), e === null && L && (r = t.stateNode = ff(t.type, t.pendingProps, pe.current), Ii = t, Ri = !0, a = I, Zd(t.type) ? (lf = a, I = cf(r.firstChild)) : I = a), ac(e, t, t.pendingProps.children, n), hc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && L && ((a = r = I) && (r = tf(r, t.type, t.pendingProps, Ri), r === null ? a = !1 : (t.stateNode = r, Ii = t, I = cf(r.firstChild), Ri = !1, a = !0)), a || Bi(t)), _e(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(a, o) ? r = null : s !== null && Ud(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = wo(e, t, Do, null, null, n), Qf._currentValue = a), hc(e, t), ac(e, t, r, n), t.child;
			case 6: return e === null && L && ((e = n = I) && (n = nf(n, t.pendingProps, Ri), n === null ? e = !1 : (t.stateNode = n, Ii = t, I = null, e = !0)), e || Bi(t)), null;
			case 13: return Cc(e, t, n);
			case 4: return he(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ba(t, null, r, n) : ac(e, t, r, n), t.child;
			case 11: return oc(e, t, t.type, t.pendingProps, n);
			case 7: return ac(e, t, t.pendingProps, n), t.child;
			case 8: return ac(e, t, t.pendingProps.children, n), t.child;
			case 12: return ac(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Xi(t, t.type, r.value), ac(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, na(t), a = ra(a), r = r(a), t.flags |= 1, ac(e, t, r, n), t.child;
			case 14: return sc(e, t, t.type, t.pendingProps, n);
			case 15: return cc(e, t, t.type, t.pendingProps, n);
			case 19: return kc(e, t, n);
			case 31: return mc(e, t, n);
			case 22: return lc(e, t, n, t.pendingProps);
			case 24: return na(t), r = ra(la), e === null ? (a = xa(), a === null && (a = K, o = ua(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, Ua(t), Xi(t, la, a)) : ((e.lanes & n) !== 0 && (Wa(e, t), Za(t, null, null, n), Xa()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Xi(t, la, r), r !== a.cache && $i(t, [la], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Xi(t, la, r))), ac(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function Pc(e) {
		e.flags |= 4;
	}
	function Fc(e, t, n, r, i) {
		if ((t = (e.mode & 32) != 0) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
			else if (wu()) e.flags |= 8192;
			else throw ja = Da, Ta;
		} else e.flags &= -16777217;
	}
	function Ic(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) if (wu()) e.flags |= 8192;
		else throw ja = Da, Ta;
	}
	function Lc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : $e(), e.lanes |= t, Yl |= t);
	}
	function Rc(e, t) {
		if (!L) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function U(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function zc(e, t, n) {
		var r = t.pendingProps;
		switch (Pi(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return U(t), null;
			case 1: return U(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Zi(la), ge(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ui(t) ? Pc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Gi())), U(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (Pc(t), o === null ? (U(t), Fc(t, a, null, r, n)) : (U(t), Ic(t, o))) : o ? o === e.memoizedState ? (U(t), t.flags &= -16777217) : (Pc(t), U(t), Ic(t, o)) : (e = e.memoizedProps, e !== r && Pc(t), U(t), Fc(t, a, e, r, n)), null;
			case 27:
				if (ve(t), n = pe.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return U(t), null;
					}
					e = de.current, Ui(t) ? Vi(t, e) : (e = ff(a, r, n), t.stateNode = e, Pc(t));
				}
				return U(t), null;
			case 5:
				if (ve(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return U(t), null;
					}
					if (o = de.current, Ui(t)) Vi(t, o);
					else {
						var s = Bd(pe.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[P] = t, o[F] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Pd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Pc(t);
					}
				}
				return U(t), Fc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Pc(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = pe.current, Ui(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = Ii, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[P] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Md(e.nodeValue, n)), e || Bi(t, !0);
					} else e = Bd(e).createTextNode(r), e[P] = t, t.stateNode = e;
				}
				return U(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Ui(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[P] = t;
						} else Wi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						U(t), e = !1;
					} else n = Gi(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (fo(t), t) : (fo(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return U(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = Ui(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[P] = t;
						} else Wi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						U(t), a = !1;
					} else a = Gi(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (fo(t), t) : (fo(t), null);
				}
				return fo(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Lc(t, t.updateQueue), U(t), null);
			case 4: return ge(), e === null && Sd(t.stateNode.containerInfo), U(t), null;
			case 10: return Zi(t.type), U(t), null;
			case 19:
				if (j(R), r = t.memoizedState, r === null) return U(t), null;
				if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) Rc(r, !1);
				else {
					if (X !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
						if (o = po(e), o !== null) {
							for (t.flags |= 128, Rc(r, !1), e = o.updateQueue, t.updateQueue = e, Lc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) mi(n, e), n = n.sibling;
							return M(R, R.current & 1 | 2), L && ji(t, r.treeForkCount), t.child;
						}
						e = e.sibling;
					}
					r.tail !== null && je() > tu && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304);
				}
				else {
					if (!a) if (e = po(o), e !== null) {
						if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Lc(t, e), Rc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !L) return U(t), null;
					} else 2 * je() - r.renderingStartTime > tu && n !== 536870912 && (t.flags |= 128, a = !0, Rc(r, !1), t.lanes = 4194304);
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (U(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = je(), e.sibling = null, n = R.current, M(R, a ? n & 1 | 2 : n & 1), L && ji(t, r.treeForkCount), e);
			case 22:
			case 23: return fo(t), io(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (U(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : U(t), n = t.updateQueue, n !== null && Lc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && j(ba), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Zi(la), U(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function Bc(e, t) {
		switch (Pi(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Zi(la), ge(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return ve(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (fo(t), t.alternate === null) throw Error(i(340));
					Wi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (fo(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					Wi();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return j(R), null;
			case 4: return ge(), null;
			case 10: return Zi(t.type), null;
			case 22:
			case 23: return fo(t), io(), e !== null && j(ba), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Zi(la), null;
			case 25: return null;
			default: return null;
		}
	}
	function Vc(e, t) {
		switch (Pi(t), t.tag) {
			case 3:
				Zi(la), ge();
				break;
			case 26:
			case 27:
			case 5:
				ve(t);
				break;
			case 4:
				ge();
				break;
			case 31:
				t.memoizedState !== null && fo(t);
				break;
			case 13:
				fo(t);
				break;
			case 19:
				j(R);
				break;
			case 10:
				Zi(t.type);
				break;
			case 22:
			case 23:
				fo(t), io(), e !== null && j(ba);
				break;
			case 24: Zi(la);
		}
	}
	function Hc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Uc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Z(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Wc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				$a(t, n);
			} catch (t) {
				Z(e, e.return, t);
			}
		}
	}
	function Gc(e, t, n) {
		n.props = qs(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Z(e, t, n);
		}
	}
	function Kc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Z(e, t, n);
		}
	}
	function qc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Z(e, t, n);
		} finally {
			e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Z(e, t, n);
		}
		else n.current = null;
	}
	function Jc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Yc(e, t, n) {
		try {
			var r = e.stateNode;
			Fd(r, e.type, n, t), r[F] = t;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Xc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
	}
	function Zc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Xc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Qc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = nn));
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Qc(e, t, n), e = e.sibling; e !== null;) Qc(e, t, n), e = e.sibling;
	}
	function $c(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for ($c(e, t, n), e = e.sibling; e !== null;) $c(e, t, n), e = e.sibling;
	}
	function el(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Pd(t, r, n), t[P] = e, t[F] = n;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	var tl = !1, nl = !1, rl = !1, il = typeof WeakSet == "function" ? WeakSet : Set, al = null;
	function ol(e, t) {
		if (e = e.containerInfo, Rd = sp, e = Ar(e), jr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (zd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, al = t; al !== null;) if (t = al, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, al = e;
		else for (; al !== null;) {
			switch (t = al, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = qs(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Z(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								ef(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, al = e;
				break;
			}
			al = t.return;
		}
	}
	function sl(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				xl(e, n), r & 4 && Hc(5, n);
				break;
			case 1:
				if (xl(e, n), r & 4) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Z(n, n.return, e);
				}
				else {
					var i = qs(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Z(n, n.return, e);
					}
				}
				r & 64 && Wc(n), r & 512 && Kc(n, n.return);
				break;
			case 3:
				if (xl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						$a(e, t);
					} catch (e) {
						Z(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && el(n);
			case 26:
			case 5:
				xl(e, n), t === null && r & 4 && Jc(n), r & 512 && Kc(n, n.return);
				break;
			case 12:
				xl(e, n);
				break;
			case 31:
				xl(e, n), r & 4 && fl(e, n);
				break;
			case 13:
				xl(e, n), r & 4 && pl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Ju.bind(null, n), sf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || tl, !r) {
					t = t !== null && t.memoizedState !== null || nl, i = tl;
					var a = nl;
					tl = r, (nl = t) && !a ? Cl(e, n, (n.subtreeFlags & 8772) != 0) : xl(e, n), tl = i, nl = a;
				}
				break;
			case 30: break;
			default: xl(e, n);
		}
	}
	function cl(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, cl(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && _t(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var W = null, ll = !1;
	function ul(e, t, n) {
		for (n = n.child; n !== null;) dl(e, t, n), n = n.sibling;
	}
	function dl(e, t, n) {
		if (Ve && typeof Ve.onCommitFiberUnmount == "function") try {
			Ve.onCommitFiberUnmount(Be, n);
		} catch {}
		switch (n.tag) {
			case 26:
				nl || qc(n, t), ul(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				nl || qc(n, t);
				var r = W, i = ll;
				Zd(n.type) && (W = n.stateNode, ll = !1), ul(e, t, n), pf(n.stateNode), W = r, ll = i;
				break;
			case 5: nl || qc(n, t);
			case 6:
				if (r = W, i = ll, W = null, ul(e, t, n), W = r, ll = i, W !== null) if (ll) try {
					(W.nodeType === 9 ? W.body : W.nodeName === "HTML" ? W.ownerDocument.body : W).removeChild(n.stateNode);
				} catch (e) {
					Z(n, t, e);
				}
				else try {
					W.removeChild(n.stateNode);
				} catch (e) {
					Z(n, t, e);
				}
				break;
			case 18:
				W !== null && (ll ? (e = W, Qd(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(W, n.stateNode));
				break;
			case 4:
				r = W, i = ll, W = n.stateNode.containerInfo, ll = !0, ul(e, t, n), W = r, ll = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Uc(2, n, t), nl || Uc(4, n, t), ul(e, t, n);
				break;
			case 1:
				nl || (qc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Gc(n, t, r)), ul(e, t, n);
				break;
			case 21:
				ul(e, t, n);
				break;
			case 22:
				nl = (r = nl) || n.memoizedState !== null, ul(e, t, n), nl = r;
				break;
			default: ul(e, t, n);
		}
	}
	function fl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Z(t, t.return, e);
			}
		}
	}
	function pl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function ml(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new il()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new il()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function hl(e, t) {
		var n = ml(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Yu.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function gl(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Zd(c.type)) {
							W = c.stateNode, ll = !1;
							break a;
						}
						break;
					case 5:
						W = c.stateNode, ll = !1;
						break a;
					case 3:
					case 4:
						W = c.stateNode.containerInfo, ll = !0;
						break a;
				}
				c = c.return;
			}
			if (W === null) throw Error(i(160));
			dl(o, s, a), W = null, ll = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) vl(t, e), t = t.sibling;
	}
	var _l = null;
	function vl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				gl(t, e), yl(e), r & 4 && (Uc(3, e, e.return), Hc(3, e), Uc(5, e, e.return));
				break;
			case 1:
				gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 64 && tl && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = _l;
				if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
						a: {
							r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
							b: switch (r) {
								case "title":
									o = a.getElementsByTagName("title")[0], (!o || o[gt] || o[P] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Pd(o, r, n), o[P] = e, St(o), r = o;
									break a;
								case "link":
									var s = Vf("link", "href", a).get(r + (n.href || ""));
									if (s) {
										for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								case "meta":
									if (s = Vf("meta", "content", a).get(r + (n.content || ""))) {
										for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								default: throw Error(i(468, r));
							}
							o[P] = e, St(o), r = o;
						}
						e.stateNode = r;
					} else Hf(a, e.type, e.stateNode);
					else e.stateNode = If(a, r, e.memoizedProps);
					else o === r ? r === null && e.stateNode !== null && Yc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps));
				}
				break;
			case 27:
				gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), n !== null && r & 4 && Yc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (gl(t, e), yl(e), r & 512 && (nl || n === null || qc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						Jt(a, "");
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Yc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (rl = !0);
				break;
			case 6:
				if (gl(t, e), yl(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, a = _l, _l = gf(t.containerInfo), gl(t, e), _l = a, yl(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Z(e, e.return, t);
				}
				rl && (rl = !1, bl(e));
				break;
			case 4:
				r = _l, _l = gf(e.stateNode.containerInfo), gl(t, e), yl(e), _l = r;
				break;
			case 12:
				gl(t, e), yl(e);
				break;
			case 31:
				gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 13:
				gl(t, e), yl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && ($l = je()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = tl, d = nl;
				if (tl = u || a, nl = d || l, gl(t, e), nl = d, tl = u, yl(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || tl || nl || Sl(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? $d(m, !0) : $d(l.stateNode, !1);
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, hl(e, n))));
				break;
			case 19:
				gl(t, e), yl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, hl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: gl(t, e), yl(e);
		}
	}
	function yl(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Xc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						$c(e, Zc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (Jt(o, ""), n.flags &= -33), $c(e, Zc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Qc(e, Zc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Z(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function bl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			bl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function xl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) sl(e, t.alternate, t), t = t.sibling;
	}
	function Sl(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Uc(4, t, t.return), Sl(t);
					break;
				case 1:
					qc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Gc(t, t.return, n), Sl(t);
					break;
				case 27: pf(t.stateNode);
				case 26:
				case 5:
					qc(t, t.return), Sl(t);
					break;
				case 22:
					t.memoizedState === null && Sl(t);
					break;
				case 30:
					Sl(t);
					break;
				default: Sl(t);
			}
			e = e.sibling;
		}
	}
	function Cl(e, t, n) {
		for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					Cl(i, a, n), Hc(4, a);
					break;
				case 1:
					if (Cl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Z(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Qa(c[i], s);
						} catch (e) {
							Z(r, r.return, e);
						}
					}
					n && o & 64 && Wc(a), Kc(a, a.return);
					break;
				case 27: el(a);
				case 26:
				case 5:
					Cl(i, a, n), n && r === null && o & 4 && Jc(a), Kc(a, a.return);
					break;
				case 12:
					Cl(i, a, n);
					break;
				case 31:
					Cl(i, a, n), n && o & 4 && fl(i, a);
					break;
				case 13:
					Cl(i, a, n), n && o & 4 && pl(i, a);
					break;
				case 22:
					a.memoizedState === null && Cl(i, a, n), Kc(a, a.return);
					break;
				case 30: break;
				default: Cl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function wl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && da(n));
	}
	function Tl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && da(e));
	}
	function El(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Dl(e, t, n, r), t = t.sibling;
	}
	function Dl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				El(e, t, n, r), i & 2048 && Hc(9, t);
				break;
			case 1:
				El(e, t, n, r);
				break;
			case 3:
				El(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && da(e)));
				break;
			case 12:
				if (i & 2048) {
					El(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Z(t, t.return, e);
					}
				} else El(e, t, n, r);
				break;
			case 31:
				El(e, t, n, r);
				break;
			case 13:
				El(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? El(e, t, n, r) : (a._visibility |= 2, Ol(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? El(e, t, n, r) : kl(e, t), i & 2048 && wl(o, t);
				break;
			case 24:
				El(e, t, n, r), i & 2048 && Tl(t.alternate, t);
				break;
			default: El(e, t, n, r);
		}
	}
	function Ol(e, t, n, r, i) {
		for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					Ol(a, o, s, c, i), Hc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, Ol(a, o, s, c, i)) : u._visibility & 2 ? Ol(a, o, s, c, i) : kl(a, o), i && l & 2048 && wl(o.alternate, o);
					break;
				case 24:
					Ol(a, o, s, c, i), i && l & 2048 && Tl(o.alternate, o);
					break;
				default: Ol(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function kl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					kl(n, r), i & 2048 && wl(r.alternate, r);
					break;
				case 24:
					kl(n, r), i & 2048 && Tl(r.alternate, r);
					break;
				default: kl(n, r);
			}
			t = t.sibling;
		}
	}
	var Al = 8192;
	function jl(e, t, n) {
		if (e.subtreeFlags & Al) for (e = e.child; e !== null;) Ml(e, t, n), e = e.sibling;
	}
	function Ml(e, t, n) {
		switch (e.tag) {
			case 26:
				jl(e, t, n), e.flags & Al && e.memoizedState !== null && Gf(n, _l, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				jl(e, t, n);
				break;
			case 3:
			case 4:
				var r = _l;
				_l = gf(e.stateNode.containerInfo), jl(e, t, n), _l = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Al, Al = 16777216, jl(e, t, n), Al = r) : jl(e, t, n));
				break;
			default: jl(e, t, n);
		}
	}
	function Nl(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Pl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				al = r, Ll(r, e);
			}
			Nl(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Fl(e), e = e.sibling;
	}
	function Fl(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Pl(e), e.flags & 2048 && Uc(9, e, e.return);
				break;
			case 3:
				Pl(e);
				break;
			case 12:
				Pl(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Il(e)) : Pl(e);
				break;
			default: Pl(e);
		}
	}
	function Il(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				al = r, Ll(r, e);
			}
			Nl(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Uc(8, t, t.return), Il(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Il(t));
					break;
				default: Il(t);
			}
			e = e.sibling;
		}
	}
	function Ll(e, t) {
		for (; al !== null;) {
			var n = al;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Uc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: da(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, al = r;
			else a: for (n = e; al !== null;) {
				r = al;
				var i = r.sibling, a = r.return;
				if (cl(r), r === n) {
					al = null;
					break a;
				}
				if (i !== null) {
					i.return = a, al = i;
					break a;
				}
				al = a;
			}
		}
	}
	var Rl = {
		getCacheForType: function(e) {
			var t = ra(la), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return ra(la).controller.signal;
		}
	}, zl = typeof WeakMap == "function" ? WeakMap : Map, G = 0, K = null, q = null, J = 0, Y = 0, Bl = null, Vl = !1, Hl = !1, Ul = !1, Wl = 0, X = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = 0, Xl = null, Zl = null, Ql = !1, $l = 0, eu = 0, tu = Infinity, nu = null, ru = null, iu = 0, au = null, ou = null, su = 0, cu = 0, lu = null, uu = null, du = 0, fu = null;
	function pu() {
		return G & 2 && J !== 0 ? J & -J : O.T === null ? ct() : dd();
	}
	function mu() {
		if (Jl === 0) if (!(J & 536870912) || L) {
			var e = qe;
			qe <<= 1, !(qe & 3932160) && (qe = 262144), Jl = e;
		} else Jl = 536870912;
		return e = ao.current, e !== null && (e.flags |= 32), Jl;
	}
	function hu(e, t, n) {
		(e === K && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) && (Su(e, 0), yu(e, J, Jl, !1)), tt(e, n), (!(G & 2) || e !== K) && (e === K && (!(G & 2) && (Kl |= n), X === 4 && yu(e, J, Jl, !1)), rd(e));
	}
	function gu(e, t, n) {
		if (G & 6) throw Error(i(327));
		var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || Ze(e, t), a = r ? Au(e, t) : Ou(e, t, !0), o = r;
		do {
			if (a === 0) {
				Hl && !r && yu(e, t, 0, !1);
				break;
			} else {
				if (n = e.current.alternate, o && !vu(n)) {
					a = Ou(e, t, !1), o = !1;
					continue;
				}
				if (a === 2) {
					if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
					else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
					if (s !== 0) {
						t = s;
						a: {
							var c = e;
							a = Xl;
							var l = c.current.memoizedState.isDehydrated;
							if (l && (Su(c, s).flags |= 256), s = Ou(c, s, !1), s !== 2) {
								if (Ul && !l) {
									c.errorRecoveryDisabledLanes |= o, Kl |= o, a = 4;
									break a;
								}
								o = Zl, Zl = a, o !== null && (Zl === null ? Zl = o : Zl.push.apply(Zl, o));
							}
							a = s;
						}
						if (o = !1, a !== 2) continue;
					}
				}
				if (a === 1) {
					Su(e, 0), yu(e, t, 0, !0);
					break;
				}
				a: {
					switch (r = e, o = a, o) {
						case 0:
						case 1: throw Error(i(345));
						case 4: if ((t & 4194048) !== t) break;
						case 6:
							yu(r, t, Jl, !Vl);
							break a;
						case 2:
							Zl = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(i(329));
					}
					if ((t & 62914560) === t && (a = $l + 300 - je(), 10 < a)) {
						if (yu(r, t, Jl, !Vl), Xe(r, 0, !0) !== 0) break a;
						su = t, r.timeoutHandle = Kd(_u.bind(null, r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, "Throttled", -0, 0), a);
						break a;
					}
					_u(r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Vl, o, null, -0, 0);
				}
			}
			break;
		} while (1);
		rd(e);
	}
	function _u(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: nn
			}, Ml(t, a, d);
			var m = (a & 62914560) === a ? $l - je() : (a & 4194048) === a ? eu - je() : 0;
			if (m = qf(d, m), m !== null) {
				su = a, e.cancelPendingCommit = m(Lu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), yu(e, a, o, !l);
				return;
			}
		}
		Lu(e, t, a, n, r, i, o, s, c);
	}
	function vu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!Tr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function yu(e, t, n, r) {
		t &= ~ql, t &= ~Kl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Ue(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && rt(e, n, t);
	}
	function bu() {
		return G & 6 ? !0 : (id(0, !1), !1);
	}
	function xu() {
		if (q !== null) {
			if (Y === 0) var e = q.return;
			else e = q, Yi = Ji = null, Ao(e), Pa = null, Fa = 0, e = q;
			for (; e !== null;) Vc(e.alternate, e), e = e.return;
			q = null;
		}
	}
	function Su(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), su = 0, xu(), K = e, q = n = pi(e.current, null), J = t, Y = 0, Bl = null, Vl = !1, Hl = Ze(e, t), Ul = !1, Yl = Jl = ql = Kl = Gl = X = 0, Zl = Xl = null, Ql = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Ue(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Wl = t, ri(), n;
	}
	function Cu(e, t) {
		z = null, O.H = zs, t === wa || t === Ea ? (t = Ma(), Y = 3) : t === Ta ? (t = Ma(), Y = 4) : Y = t === rc ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Bl = t, q === null && (X = 1, Zs(e, xi(t, e.current)));
	}
	function wu() {
		var e = ao.current;
		return e === null ? !0 : (J & 4194048) === J ? oo === null : (J & 62914560) === J || J & 536870912 ? e === oo : !1;
	}
	function Tu() {
		var e = O.H;
		return O.H = zs, e === null ? zs : e;
	}
	function Eu() {
		var e = O.A;
		return O.A = Rl, e;
	}
	function Du() {
		X = 4, Vl || (J & 4194048) !== J && ao.current !== null || (Hl = !0), !(Gl & 134217727) && !(Kl & 134217727) || K === null || yu(K, J, Jl, !1);
	}
	function Ou(e, t, n) {
		var r = G;
		G |= 2;
		var i = Tu(), a = Eu();
		(K !== e || J !== t) && (nu = null, Su(e, t)), t = !1;
		var o = X;
		a: do
			try {
				if (Y !== 0 && q !== null) {
					var s = q, c = Bl;
					switch (Y) {
						case 8:
							xu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							ao.current === null && (t = !0);
							var l = Y;
							if (Y = 0, Bl = null, Pu(e, s, c, l), n && Hl) {
								o = 0;
								break a;
							}
							break;
						default: l = Y, Y = 0, Bl = null, Pu(e, s, c, l);
					}
				}
				ku(), o = X;
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Yi = Ji = null, G = r, O.H = i, O.A = a, q === null && (K = null, J = 0, ri()), o;
	}
	function ku() {
		for (; q !== null;) Mu(q);
	}
	function Au(e, t) {
		var n = G;
		G |= 2;
		var r = Tu(), a = Eu();
		K !== e || J !== t ? (nu = null, tu = je() + 500, Su(e, t)) : Hl = Ze(e, t);
		a: do
			try {
				if (Y !== 0 && q !== null) {
					t = q;
					var o = Bl;
					b: switch (Y) {
						case 1:
							Y = 0, Bl = null, Pu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (Oa(o)) {
								Y = 0, Bl = null, Nu(t);
								break;
							}
							t = function() {
								Y !== 2 && Y !== 9 || K !== e || (Y = 7), rd(e);
							}, o.then(t, t);
							break a;
						case 3:
							Y = 7;
							break a;
						case 4:
							Y = 5;
							break a;
						case 7:
							Oa(o) ? (Y = 0, Bl = null, Nu(t)) : (Y = 0, Bl = null, Pu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (q.tag) {
								case 26: s = q.memoizedState;
								case 5:
								case 27:
									var c = q;
									if (s ? Wf(s) : c.stateNode.complete) {
										Y = 0, Bl = null;
										var l = c.sibling;
										if (l !== null) q = l;
										else {
											var u = c.return;
											u === null ? q = null : (q = u, Fu(u));
										}
										break b;
									}
							}
							Y = 0, Bl = null, Pu(e, t, o, 5);
							break;
						case 6:
							Y = 0, Bl = null, Pu(e, t, o, 6);
							break;
						case 8:
							xu(), X = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				ju();
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return Yi = Ji = null, O.H = r, O.A = a, G = n, q === null ? (K = null, J = 0, ri(), X) : 0;
	}
	function ju() {
		for (; q !== null && !ke();) Mu(q);
	}
	function Mu(e) {
		var t = Nc(e.alternate, e, Wl);
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t;
	}
	function Nu(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = _c(n, t, t.pendingProps, t.type, void 0, J);
				break;
			case 11:
				t = _c(n, t, t.pendingProps, t.type.render, t.ref, J);
				break;
			case 5: Ao(t);
			default: Vc(n, t), t = q = mi(t, Wl), t = Nc(n, t, Wl);
		}
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : q = t;
	}
	function Pu(e, t, n, r) {
		Yi = Ji = null, Ao(t), Pa = null, Fa = 0;
		var i = t.return;
		try {
			if (nc(e, i, t, n, J)) {
				X = 1, Zs(e, xi(n, e.current)), q = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw q = i, t;
			X = 1, Zs(e, xi(n, e.current)), q = null;
			return;
		}
		t.flags & 32768 ? (L || r === 1 ? e = !0 : Hl || J & 536870912 ? e = !1 : (Vl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = ao.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Iu(t, e)) : Fu(t);
	}
	function Fu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Iu(t, Vl);
				return;
			}
			e = t.return;
			var n = zc(t.alternate, t, Wl);
			if (n !== null) {
				q = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				q = t;
				return;
			}
			q = t = e;
		} while (t !== null);
		X === 0 && (X = 5);
	}
	function Iu(e, t) {
		do {
			var n = Bc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, q = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				q = e;
				return;
			}
			q = e = n;
		} while (e !== null);
		X = 6, q = null;
	}
	function Lu(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Hu();
		while (iu !== 0);
		if (G & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= ni, nt(e, n, o, s, c, l), e === K && (q = K = null, J = 0), ou = t, au = e, su = n, cu = o, lu = a, uu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Xu(Fe, function() {
				return Uu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
				r = O.T, O.T = null, a = k.p, k.p = 2, s = G, G |= 4;
				try {
					ol(e, t, n);
				} finally {
					G = s, k.p = a, O.T = r;
				}
			}
			iu = 1, Ru(), zu(), Bu();
		}
	}
	function Ru() {
		if (iu === 1) {
			iu = 0;
			var e = au, t = ou, n = (t.flags & 13878) != 0;
			if (t.subtreeFlags & 13878 || n) {
				n = O.T, O.T = null;
				var r = k.p;
				k.p = 2;
				var i = G;
				G |= 4;
				try {
					vl(t, e);
					var a = zd, o = Ar(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && kr(s.ownerDocument.documentElement, s)) {
						if (c !== null && jr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = Or(s, h), v = Or(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!Rd, zd = Rd = null;
				} finally {
					G = i, k.p = r, O.T = n;
				}
			}
			e.current = t, iu = 2;
		}
	}
	function zu() {
		if (iu === 2) {
			iu = 0;
			var e = au, t = ou, n = (t.flags & 8772) != 0;
			if (t.subtreeFlags & 8772 || n) {
				n = O.T, O.T = null;
				var r = k.p;
				k.p = 2;
				var i = G;
				G |= 4;
				try {
					sl(e, t.alternate, t);
				} finally {
					G = i, k.p = r, O.T = n;
				}
			}
			iu = 3;
		}
	}
	function Bu() {
		if (iu === 4 || iu === 3) {
			iu = 0, Ae();
			var e = au, t = ou, n = su, r = uu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? iu = 5 : (iu = 0, ou = au = null, Vu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (ru = null), st(n), t = t.stateNode, Ve && typeof Ve.onCommitFiberRoot == "function") try {
				Ve.onCommitFiberRoot(Be, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = O.T, i = k.p, k.p = 2, O.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					O.T = t, k.p = i;
				}
			}
			su & 3 && Hu(), rd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === fu ? du++ : (du = 0, fu = e) : du = 0, id(0, !1);
		}
	}
	function Vu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, da(t)));
	}
	function Hu() {
		return Ru(), zu(), Bu(), Uu();
	}
	function Uu() {
		if (iu !== 5) return !1;
		var e = au, t = cu;
		cu = 0;
		var n = st(su), r = O.T, a = k.p;
		try {
			k.p = 32 > n ? 32 : n, O.T = null, n = lu, lu = null;
			var o = au, s = su;
			if (iu = 0, ou = au = null, su = 0, G & 6) throw Error(i(331));
			var c = G;
			if (G |= 4, Fl(o.current), Dl(o, o.current, s, n), G = c, id(0, !1), Ve && typeof Ve.onPostCommitFiberRoot == "function") try {
				Ve.onPostCommitFiberRoot(Be, o);
			} catch {}
			return !0;
		} finally {
			k.p = a, O.T = r, Vu(e, t);
		}
	}
	function Wu(e, t, n) {
		t = xi(n, t), t = $s(e.stateNode, t, 2), e = Ka(e, t, 2), e !== null && (tt(e, 2), rd(e));
	}
	function Z(e, t, n) {
		if (e.tag === 3) Wu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Wu(t, e, n);
				break;
			} else if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (ru === null || !ru.has(r))) {
					e = xi(n, e), n = ec(2), r = Ka(t, n, 2), r !== null && (tc(n, r, t, e), tt(r, 2), rd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new zl();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Ul = !0, i.add(n), e = Ku.bind(null, e, t, n), t.then(e, e));
	}
	function Ku(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, K === e && (J & n) === n && (X === 4 || X === 3 && (J & 62914560) === J && 300 > je() - $l ? !(G & 2) && Su(e, 0) : ql |= n, Yl === J && (Yl = 0)), rd(e);
	}
	function qu(e, t) {
		t === 0 && (t = $e()), e = oi(e, t), e !== null && (tt(e, t), rd(e));
	}
	function Ju(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), qu(e, n);
	}
	function Yu(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), qu(e, n);
	}
	function Xu(e, t) {
		return De(e, t);
	}
	var Zu = null, Qu = null, $u = !1, ed = !1, td = !1, nd = 0;
	function rd(e) {
		e !== Qu && e.next === null && (Qu === null ? Zu = Qu = e : Qu = Qu.next = e), ed = !0, $u || ($u = !0, ud());
	}
	function id(e, t) {
		if (!td && ed) {
			td = !0;
			do
				for (var n = !1, r = Zu; r !== null;) {
					if (!t) if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - Ue(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
						}
						a !== 0 && (n = !0, ld(r, a));
					} else a = J, a = Xe(r, r === K ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ze(r, a) || (n = !0, ld(r, a));
					r = r.next;
				}
			while (n);
			td = !1;
		}
	}
	function ad() {
		od();
	}
	function od() {
		ed = $u = !1;
		var e = 0;
		nd !== 0 && Gd() && (e = nd);
		for (var t = je(), n = null, r = Zu; r !== null;) {
			var i = r.next, a = sd(r, t);
			a === 0 ? (r.next = null, n === null ? Zu = i : n.next = i, i === null && (Qu = n)) : (n = r, (e !== 0 || a & 3) && (ed = !0)), r = i;
		}
		iu !== 0 && iu !== 5 || id(e, !1), nd !== 0 && (nd = 0);
	}
	function sd(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Ue(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = Qe(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = K, n = J, n = Xe(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Y === 2 || Y === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && Oe(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || Ze(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && Oe(r), st(n)) {
				case 2:
				case 8:
					n = Pe;
					break;
				case 32:
					n = Fe;
					break;
				case 268435456:
					n = Le;
					break;
				default: n = Fe;
			}
			return r = cd.bind(null, e), n = De(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && Oe(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function cd(e, t) {
		if (iu !== 0 && iu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Hu() && e.callbackNode !== n) return null;
		var r = J;
		return r = Xe(e, e === K ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (gu(e, r, t), sd(e, je()), e.callbackNode != null && e.callbackNode === n ? cd.bind(null, e) : null);
	}
	function ld(e, t) {
		if (Hu()) return null;
		gu(e, t, !0);
	}
	function ud() {
		Yd(function() {
			G & 6 ? De(Ne, ad) : od();
		});
	}
	function dd() {
		if (nd === 0) {
			var e = ma;
			e === 0 && (e = Ke, Ke <<= 1, !(Ke & 261888) && (Ke = 256)), nd = e;
		}
		return nd;
	}
	function fd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : tn("" + e);
	}
	function pd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function md(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = fd((i[F] || null).action), o = r.submitter;
			o && (t = (t = o[F] || null) ? fd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new wn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (nd !== 0) {
								var e = o ? pd(i, o) : new FormData(i);
								Ts(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? pd(i, o) : new FormData(i), Ts(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var hd = 0; hd < Zr.length; hd++) {
		var gd = Zr[hd];
		Qr(gd.toLowerCase(), "on" + (gd[0].toUpperCase() + gd.slice(1)));
	}
	Qr(Ur, "onAnimationEnd"), Qr(Wr, "onAnimationIteration"), Qr(Gr, "onAnimationStart"), Qr("dblclick", "onDoubleClick"), Qr("focusin", "onFocus"), Qr("focusout", "onBlur"), Qr(Kr, "onTransitionRun"), Qr(qr, "onTransitionStart"), Qr(Jr, "onTransitionCancel"), Qr(Yr, "onTransitionEnd"), Et("onMouseEnter", ["mouseout", "mouseover"]), Et("onMouseLeave", ["mouseout", "mouseover"]), Et("onPointerEnter", ["pointerout", "pointerover"]), Et("onPointerLeave", ["pointerout", "pointerover"]), Tt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Tt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Tt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), Tt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Tt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Tt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var _d = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), vd = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(_d));
	function yd(e, t) {
		t = (t & 4) != 0;
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						$r(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						$r(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function Q(e, t) {
		var n = t[ft];
		n === void 0 && (n = t[ft] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Cd(t, e, 2, !1), n.add(r));
	}
	function bd(e, t, n) {
		var r = 0;
		t && (r |= 4), Cd(n, e, r, t);
	}
	var xd = "_reactListening" + Math.random().toString(36).slice(2);
	function Sd(e) {
		if (!e[xd]) {
			e[xd] = !0, Ct.forEach(function(t) {
				t !== "selectionchange" && (vd.has(t) || bd(t, !1, e), bd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[xd] || (t[xd] = !0, bd("selectionchange", !1, t));
		}
	}
	function Cd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !pn || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function wd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = vt(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		un(function() {
			var r = a, i = an(n), s = [];
			a: {
				var c = Xr.get(e);
				if (c !== void 0) {
					var l = wn, u = e;
					switch (e) {
						case "keypress": if (yn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Hn;
							break;
						case "focusin":
							u = "focus", l = Nn;
							break;
						case "focusout":
							u = "blur", l = Nn;
							break;
						case "beforeblur":
						case "afterblur":
							l = Nn;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = jn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Mn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = Wn;
							break;
						case Ur:
						case Wr:
						case Gr:
							l = Pn;
							break;
						case Yr:
							l = Gn;
							break;
						case "scroll":
						case "scrollend":
							l = En;
							break;
						case "wheel":
							l = Kn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = Fn;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = Un;
							break;
						case "toggle":
						case "beforetoggle": l = qn;
					}
					var d = (t & 4) != 0, f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = dn(m, p), g != null && d.push(Td(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== rn && (u = n.relatedTarget || n.fromElement) && (vt(u) || u[dt])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? vt(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = jn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = Un, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : bt(l), h = u == null ? c : bt(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, vt(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Dd, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Od(s, c, l, d, !1), u !== null && f !== null && Od(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? bt(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = pr;
					else if (sr(c)) if (mr) v = Cr;
					else {
						v = xr;
						var y = br;
					}
					else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Qt(r.elementType) && (v = pr) : v = Sr;
					if (v &&= v(e, r)) {
						cr(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && Wt(c, "number", c.value);
				}
				switch (y = r ? bt(r) : window, e) {
					case "focusin":
						(sr(y) || y.contentEditable === "true") && (Nr = y, Pr = r, Fr = null);
						break;
					case "focusout":
						Fr = Pr = Nr = null;
						break;
					case "mousedown":
						Ir = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						Ir = !1, Lr(s, n, i);
						break;
					case "selectionchange": if (Mr) break;
					case "keydown":
					case "keyup": Lr(s, n, i);
				}
				var b;
				if (Yn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else rr ? tr(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (Qn && n.locale !== "ko" && (rr || x !== "onCompositionStart" ? x === "onCompositionEnd" && rr && (b = vn()) : (hn = i, gn = "value" in hn ? hn.value : hn.textContent, rr = !0)), y = Ed(r, x), 0 < y.length && (x = new In(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = nr(n), b !== null && (x.data = b)))), (b = Zn ? ir(e, n) : ar(e, n)) && (x = Ed(r, "onBeforeInput"), 0 < x.length && (y = new In("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), md(s, e, r, n, i);
			}
			yd(s, t);
		});
	}
	function Td(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Ed(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = dn(e, n), i != null && r.unshift(Td(e, i, a)), i = dn(e, t), i != null && r.push(Td(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Dd(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Od(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = dn(n, a), l != null && o.unshift(Td(n, l, c))) : i || (l = dn(n, a), l != null && o.push(Td(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var kd = /\r\n?/g, Ad = /\u0000|\uFFFD/g;
	function jd(e) {
		return (typeof e == "string" ? e : "" + e).replace(kd, "\n").replace(Ad, "");
	}
	function Md(e, t) {
		return t = jd(t), jd(e) === t;
	}
	function $(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Jt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Jt(e, "" + r);
				break;
			case "className":
				Mt(e, "class", r);
				break;
			case "tabIndex":
				Mt(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				Mt(e, n, r);
				break;
			case "style":
				Zt(e, r, o);
				break;
			case "data": if (t !== "object") {
				Mt(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = tn("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				} else typeof o == "function" && (n === "formAction" ? (t !== "input" && $(e, t, "name", a.name, a, null), $(e, t, "formEncType", a.formEncType, a, null), $(e, t, "formMethod", a.formMethod, a, null), $(e, t, "formTarget", a.formTarget, a, null)) : ($(e, t, "encType", a.encType, a, null), $(e, t, "method", a.method, a, null), $(e, t, "target", a.target, a, null)));
				if (r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = tn("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = nn);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = tn("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				Q("beforetoggle", e), Q("toggle", e), jt(e, "popover", r);
				break;
			case "xlinkActuate":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				Nt(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				Nt(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				Nt(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				Nt(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				jt(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = $t.get(n) || n, jt(e, n, r));
		}
	}
	function Nd(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				Zt(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? Jt(e, r) : (typeof r == "number" || typeof r == "bigint") && Jt(e, "" + r);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = nn);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!wt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[F] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : jt(e, n, r);
			}
		}
	}
	function Pd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				Q("error", e), Q("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: $(e, t, o, s, n, null);
					}
				}
				a && $(e, t, "srcSet", n.srcSet, n, null), r && $(e, t, "src", n.src, n, null);
				return;
			case "input":
				Q("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: $(e, t, r, d, n, null);
					}
				}
				Ut(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in Q("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: $(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Gt(e, !!r, n, !0) : Gt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in Q("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: $(e, t, s, c, n, null);
				}
				qt(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: $(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				Q("beforetoggle", e), Q("toggle", e), Q("cancel", e), Q("close", e);
				break;
			case "iframe":
			case "object":
				Q("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < _d.length; r++) Q(_d[r], e);
				break;
			case "image":
				Q("error", e), Q("load", e);
				break;
			case "details":
				Q("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": Q("error", e), Q("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: $(e, t, u, r, n, null);
				}
				return;
			default: if (Qt(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && $(e, t, c, r, n, null));
	}
	function Fd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || $(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && $(e, t, p, m, r, f);
					}
				}
				Ht(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || $(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && $(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Gt(e, !!n, n ? [] : "", !1) : Gt(e, !!n, t, !0)) : Gt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: $(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && $(e, t, s, a, r, o);
				}
				Kt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: $(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: $(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && $(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: $(e, t, u, p, r, m);
				}
				return;
			default: if (Qt(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && $(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || $(e, t, f, p, r, m);
	}
	function Id(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Ld() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Id(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Rd = null, zd = null;
	function Bd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Vd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Hd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Ud(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Wd = null;
	function Gd() {
		var e = window.event;
		return e && e.type === "popstate" ? e === Wd ? !1 : (Wd = e, !0) : (Wd = null, !1);
	}
	var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e) {
		return Jd.resolve(null).then(e).catch(Xd);
	};
	function Xd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Zd(e) {
		return e === "head";
	}
	function Qd(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$" || n === "/&") {
				if (r === 0) {
					e.removeChild(i), Np(t);
					return;
				}
				r--;
			} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
			else if (n === "html") pf(e.ownerDocument.documentElement);
			else if (n === "head") {
				n = e.ownerDocument.head, pf(n);
				for (var a = n.firstChild; a;) {
					var o = a.nextSibling, s = a.nodeName;
					a[gt] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
				}
			} else n === "body" && pf(e.ownerDocument.body);
			n = i;
		} while (n);
		Np(t);
	}
	function $d(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === "/$") {
				if (e === 0) break;
				e--;
			} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			n = r;
		} while (n);
	}
	function ef(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					ef(n), _t(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function tf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) if (t === "input" && e.type === "hidden") {
				var a = i.name == null ? null : "" + i.name;
				if (i.type === "hidden" && e.getAttribute("name") === a) return e;
			} else return e;
			else if (!e[gt]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = cf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function nf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function rf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function of(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function sf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function cf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var lf = null;
	function uf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return cf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function df(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function ff(e, t, n) {
		switch (t = Bd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function pf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		_t(e);
	}
	var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
	function gf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var _f = k.d;
	k.d = {
		f: vf,
		r: yf,
		D: Sf,
		C: Cf,
		L: wf,
		m: Tf,
		X: Df,
		S: Ef,
		M: Of
	};
	function vf() {
		var e = _f.f(), t = bu();
		return e || t;
	}
	function yf(e) {
		var t = yt(e);
		t !== null && t.tag === 5 && t.type === "form" ? Ds(t) : _f.r(e);
	}
	var bf = typeof document > "u" ? null : document;
	function xf(e, t, n) {
		var r = bf;
		if (r && typeof t == "string" && t) {
			var i = Vt(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), hf.has(i) || (hf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Pd(t, "link", e), St(t), r.head.appendChild(t)));
		}
	}
	function Sf(e) {
		_f.D(e), xf("dns-prefetch", e, null);
	}
	function Cf(e, t) {
		_f.C(e, t), xf("preconnect", e, t);
	}
	function wf(e, t, n) {
		_f.L(e, t, n);
		var r = bf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + Vt(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + Vt(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + Vt(n.imageSizes) + "\"]")) : i += "[href=\"" + Vt(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Af(e);
					break;
				case "script": a = Pf(e);
			}
			mf.has(a) || (e = f({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), mf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(jf(a)) || t === "script" && r.querySelector(Ff(a)) || (t = r.createElement("link"), Pd(t, "link", e), St(t), r.head.appendChild(t)));
		}
	}
	function Tf(e, t) {
		_f.m(e, t);
		var n = bf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + Vt(r) + "\"][href=\"" + Vt(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Pf(e);
			}
			if (!mf.has(a) && (e = f({
				rel: "modulepreload",
				href: e
			}, t), mf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Ff(a))) return;
				}
				r = n.createElement("link"), Pd(r, "link", e), St(r), n.head.appendChild(r);
			}
		}
	}
	function Ef(e, t, n) {
		_f.S(e, t, n);
		var r = bf;
		if (r && e) {
			var i = xt(r).hoistableStyles, a = Af(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(jf(a))) s.loading = 5;
				else {
					e = f({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = mf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					St(c), Pd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Df(e, t) {
		_f.X(e, t);
		var n = bf;
		if (n && e) {
			var r = xt(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = f({
				src: e,
				async: !0
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), St(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Of(e, t) {
		_f.M(e, t);
		var n = bf;
		if (n && e) {
			var r = xt(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = f({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), St(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t, n, r) {
		var a = (a = pe.current) ? gf(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Af(n.href), n = xt(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Af(n.href);
					var o = xt(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, mf.set(e, n), o || Nf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Pf(n), n = xt(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Af(e) {
		return "href=\"" + Vt(e) + "\"";
	}
	function jf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Mf(e) {
		return f({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Nf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Pd(t, "link", n), St(t), e.head.appendChild(t));
	}
	function Pf(e) {
		return "[src=\"" + Vt(e) + "\"]";
	}
	function Ff(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + Vt(n.href) + "\"]");
				if (r) return t.instance = r, St(r), r;
				var a = f({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), St(r), Pd(r, "style", a), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Af(n.href);
				var o = e.querySelector(jf(a));
				if (o) return t.state.loading |= 4, t.instance = o, St(o), o;
				r = Mf(n), (a = mf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement("link"), St(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Pd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Pf(n.src), (a = e.querySelector(Ff(o))) ? (t.instance = a, St(a), a) : (r = n, (a = mf.get(o)) && (r = f({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), St(a), Pd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[gt] || a[P] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Af(r.href), a = t.querySelector(jf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, St(a);
					return;
				}
				a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement("link"), St(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Pd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: b,
		Provider: null,
		Consumer: null,
		_currentValue: A,
		_currentValue2: A,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = et(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = et(0), this.hiddenUpdates = et(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = di(3, null, null, t), e.current = a, a.stateNode = e, t = ua(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, Ua(a), e;
	}
	function tp(e) {
		return e ? (e = li, e) : li;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = Ga(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ka(e, r, t), n !== null && (hu(n, e, t), qa(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = oi(e, 67108864);
			t !== null && hu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = pu();
			t = ot(t);
			var n = oi(e, t);
			n !== null && hu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = O.T;
		O.T = null;
		var a = k.p;
		try {
			k.p = 2, up(e, t, n, r);
		} finally {
			k.p = a, O.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = O.T;
		O.T = null;
		var a = k.p;
		try {
			k.p = 8, up(e, t, n, r);
		} finally {
			k.p = a, O.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) wd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = yt(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = Ye(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Ue(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									rd(a), !(G & 6) && (tu = je() + 500, id(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = oi(a, 2), s !== null && hu(s, a, 2), bu(), ip(a, 2);
					}
					if (a = dp(r), a === null && wd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else wd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = an(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = vt(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Me()) {
				case Ne: return 2;
				case Pe: return 8;
				case Fe:
				case Ie: return 32;
				case Le: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = yt(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = vt(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, lt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, lt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				rn = r, n.target.dispatchEvent(r), rn = null;
			} else return t = yt(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, n) {
		e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = yt(n);
				a !== null && (e.splice(t, 3), t -= 3, Ts(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[F] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[F] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		np(n, pu(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), bu(), t[dt] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = ct();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = n.version;
	if (Lp !== "19.2.6") throw Error(i(527, Lp, "19.2.6"));
	k.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = u(t), e = e === null ? null : d(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.6",
		rendererPackageName: "react-dom",
		currentDispatcherRef: O,
		reconcilerVersion: "19.2.6"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			Be = zp.inject(Rp), Ve = zp;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = Js, s = Ys, c = Xs;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, o, s, c, Pp), e[dt] = t.current, Sd(e), new Fp(t);
	};
})), re = /* @__PURE__ */ r(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = ne();
})), ie = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), ae = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), oe = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), se = (e) => {
	let t = oe(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, O = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, k = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, A = /* @__PURE__ */ t(C(), 1), ce = (0, A.createContext)({}), le = () => (0, A.useContext)(ce), ue = (0, A.forwardRef)(({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => {
	let { size: l = 24, strokeWidth: u = 2, absoluteStrokeWidth: d = !1, color: f = "currentColor", className: p = "" } = le() ?? {}, m = r ?? d ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
	return (0, A.createElement)("svg", {
		ref: c,
		...O,
		width: t ?? l ?? O.width,
		height: t ?? l ?? O.height,
		stroke: e ?? f,
		strokeWidth: m,
		className: ie("lucide", p, i),
		...!a && !k(s) && { "aria-hidden": "true" },
		...s
	}, [...o.map(([e, t]) => (0, A.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), j = (e, t) => {
	let n = (0, A.forwardRef)(({ className: n, ...r }, i) => (0, A.createElement)(ue, {
		ref: i,
		iconNode: t,
		className: ie(`lucide-${ae(se(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = se(e), n;
}, M = j("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), de = j("captions", [["rect", {
	width: "18",
	height: "14",
	x: "3",
	y: "5",
	rx: "2",
	ry: "2",
	key: "12ruh7"
}], ["path", {
	d: "M7 15h4M15 15h2M7 11h2M13 11h4",
	key: "1ueiar"
}]]), fe = j("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), pe = j("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), me = j("chevron-left", [["path", {
	d: "m15 18-6-6 6-6",
	key: "1wnfg3"
}]]), he = j("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), ge = j("download", [
	["path", {
		d: "M12 15V3",
		key: "m9g1x1"
	}],
	["path", {
		d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
		key: "ih7n3h"
	}],
	["path", {
		d: "m7 10 5 5 5-5",
		key: "brsn70"
	}]
]), _e = j("expand", [
	["path", {
		d: "m15 15 6 6",
		key: "1s409w"
	}],
	["path", {
		d: "m15 9 6-6",
		key: "ko1vev"
	}],
	["path", {
		d: "M21 16v5h-5",
		key: "1ck2sf"
	}],
	["path", {
		d: "M21 8V3h-5",
		key: "1qoq8a"
	}],
	["path", {
		d: "M3 16v5h5",
		key: "1t08am"
	}],
	["path", {
		d: "m3 21 6-6",
		key: "wwnumi"
	}],
	["path", {
		d: "M3 8V3h5",
		key: "1ln10m"
	}],
	["path", {
		d: "M9 9 3 3",
		key: "v551iv"
	}]
]), ve = j("external-link", [
	["path", {
		d: "M15 3h6v6",
		key: "1q9fwt"
	}],
	["path", {
		d: "M10 14 21 3",
		key: "gplh6r"
	}],
	["path", {
		d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
		key: "a6xqqp"
	}]
]), ye = j("fast-forward", [["path", {
	d: "M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z",
	key: "b19h5q"
}], ["path", {
	d: "M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z",
	key: "h7h5ge"
}]]), be = j("file-text", [
	["path", {
		d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		key: "1oefj6"
	}],
	["path", {
		d: "M14 2v5a1 1 0 0 0 1 1h5",
		key: "wfsgrz"
	}],
	["path", {
		d: "M10 9H8",
		key: "b1mrlr"
	}],
	["path", {
		d: "M16 13H8",
		key: "t4e002"
	}],
	["path", {
		d: "M16 17H8",
		key: "z1uh3a"
	}]
]), xe = j("folder-heart", [["path", {
	d: "M10.638 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.417",
	key: "10r6g4"
}], ["path", {
	d: "M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
	key: "15cy7q"
}]]), Se = j("folder-plus", [
	["path", {
		d: "M12 10v6",
		key: "1bos4e"
	}],
	["path", {
		d: "M9 13h6",
		key: "1uhe8q"
	}],
	["path", {
		d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		key: "1kt360"
	}]
]), Ce = j("git-compare-arrows", [
	["circle", {
		cx: "5",
		cy: "6",
		r: "3",
		key: "1qnov2"
	}],
	["path", {
		d: "M12 6h5a2 2 0 0 1 2 2v7",
		key: "1yj91y"
	}],
	["path", {
		d: "m15 9-3-3 3-3",
		key: "1lwv8l"
	}],
	["circle", {
		cx: "19",
		cy: "18",
		r: "3",
		key: "1qljk2"
	}],
	["path", {
		d: "M12 18H7a2 2 0 0 1-2-2V9",
		key: "16sdep"
	}],
	["path", {
		d: "m9 15 3 3-3 3",
		key: "1m3kbl"
	}]
]), we = j("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), Te = j("pause", [["rect", {
	x: "14",
	y: "3",
	width: "5",
	height: "18",
	rx: "1",
	key: "kaeet6"
}], ["rect", {
	x: "5",
	y: "3",
	width: "5",
	height: "18",
	rx: "1",
	key: "1wsw3u"
}]]), Ee = j("play", [["path", {
	d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
	key: "10ikf1"
}]]), De = j("plus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "M12 5v14",
	key: "s699le"
}]]), Oe = j("printer", [
	["path", {
		d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
		key: "143wyd"
	}],
	["path", {
		d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
		key: "1itne7"
	}],
	["rect", {
		x: "6",
		y: "14",
		width: "12",
		height: "8",
		rx: "1",
		key: "1ue0tg"
	}]
]), ke = j("rewind", [["path", {
	d: "M12 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 12 18z",
	key: "2a1g8i"
}], ["path", {
	d: "M22 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 22 18z",
	key: "rg3s36"
}]]), Ae = j("rotate-ccw", [["path", {
	d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
	key: "1357e3"
}], ["path", {
	d: "M3 3v5h5",
	key: "1xhq8a"
}]]), je = j("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), Me = j("share-2", [
	["circle", {
		cx: "18",
		cy: "5",
		r: "3",
		key: "gq8acd"
	}],
	["circle", {
		cx: "6",
		cy: "12",
		r: "3",
		key: "w7nqdw"
	}],
	["circle", {
		cx: "18",
		cy: "19",
		r: "3",
		key: "1xt0gg"
	}],
	["line", {
		x1: "8.59",
		x2: "15.42",
		y1: "13.51",
		y2: "17.49",
		key: "47mynk"
	}],
	["line", {
		x1: "15.41",
		x2: "8.59",
		y1: "6.51",
		y2: "10.49",
		key: "1n3mei"
	}]
]), Ne = j("shield-check", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), Pe = j("shopping-bag", [
	["path", {
		d: "M16 10a4 4 0 0 1-8 0",
		key: "1ltviw"
	}],
	["path", {
		d: "M3.103 6.034h17.794",
		key: "awc11p"
	}],
	["path", {
		d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		key: "o988cm"
	}]
]), Fe = j("square", [["rect", {
	width: "18",
	height: "18",
	x: "3",
	y: "3",
	rx: "2",
	key: "afitv7"
}]]), Ie = j("trash-2", [
	["path", {
		d: "M10 11v6",
		key: "nco0om"
	}],
	["path", {
		d: "M14 11v6",
		key: "outv1u"
	}],
	["path", {
		d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
		key: "miytrc"
	}],
	["path", {
		d: "M3 6h18",
		key: "d0wm0j"
	}],
	["path", {
		d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
		key: "e791ji"
	}]
]), Le = j("volume-2", [
	["path", {
		d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		key: "uqj9uw"
	}],
	["path", {
		d: "M16 9a5 5 0 0 1 0 6",
		key: "1q6k2b"
	}],
	["path", {
		d: "M19.364 18.364a9 9 0 0 0 0-12.728",
		key: "ijwkga"
	}]
]), Re = j("volume-x", [
	["path", {
		d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		key: "uqj9uw"
	}],
	["line", {
		x1: "22",
		x2: "16",
		y1: "9",
		y2: "15",
		key: "1ewh16"
	}],
	["line", {
		x1: "16",
		x2: "22",
		y1: "9",
		y2: "15",
		key: "5ykzw1"
	}]
]), ze = j("wrench", [["path", {
	d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
	key: "1ngwbx"
}]]), Be = j("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]);
//#endregion
//#region node_modules/@base-ui/utils/useControlled.mjs
function Ve({ controlled: e, default: t, name: n, state: r = "value" }) {
	let { current: i } = A.useRef(e !== void 0), [a, o] = A.useState(t);
	return [i ? e : a, A.useCallback((e) => {
		i || o(e);
	}, [])];
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/CompositeListContext.mjs
var He = /* @__PURE__ */ A.createContext({
	register: () => {},
	unregister: () => {},
	subscribeMapChange: () => () => {},
	nextIndexRef: { current: 0 }
});
function Ue() {
	return A.useContext(He);
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/CompositeList.mjs
var N = e();
function We(e) {
	let { children: t, elementsRef: n, labelsRef: r, onMapChange: a } = e, o = u(a), [, s] = A.useState(!1), c = i(Ke).current, l = i(Ge).current, f = A.useRef(0), p = A.useRef(!0), m = A.useRef([]), h = A.useRef(null), g = u(() => {
		p.current || (p.current = !0, s((e) => !e));
	}), _ = u((e, t) => {
		l.set(e, t), g();
	}), v = u((e) => {
		l.delete(e), g();
	}), y = u((e) => {
		let t = /* @__PURE__ */ new Map();
		return n.current.length = 0, r && (r.current.length = 0), e.forEach((e) => {
			t.set(e.element, {
				...e.registration.metadata ?? {},
				index: e.index
			}), n.current[e.index] = e.element, r && (r.current[e.index] = e.registration.label === void 0 ? e.registration.textRef?.current?.textContent ?? e.element.textContent : e.registration.label);
		}), f.current = n.current.length, t;
	});
	function b(e) {
		if (h.current?.disconnect(), h.current = null, typeof MutationObserver != "function" || e.length < 2) return;
		let t = new MutationObserver((n) => {
			if (!Ye(n)) return;
			let r = null;
			for (let n of e) if (n.isConnected) {
				if (r && Xe(r, n) > 0) {
					t.disconnect(), g();
					return;
				}
				r = n;
			}
		});
		h.current = t;
		let n = /* @__PURE__ */ new Set();
		for (let t = 1; t < e.length; t += 1) {
			let r = Je(e[t - 1], e[t]);
			r && n.add(r);
		}
		n.forEach((e) => t.observe(e, { childList: !0 }));
	}
	let x = u(() => {
		let [e, t] = qe(l), n = y(e);
		b(t), m.current = e, p.current = !1, c.forEach((e) => e(n)), o(n);
	});
	d(() => (p.current || y(m.current), () => {
		n.current = [], r && (r.current = []);
	}), [
		n,
		r,
		y
	]), d(() => {
		p.current && x();
	}), d(() => () => {
		h.current?.disconnect(), p.current = !0;
	}, []);
	let S = u((e) => (c.add(e), () => {
		c.delete(e);
	})), C = A.useMemo(() => ({
		register: _,
		unregister: v,
		subscribeMapChange: S,
		nextIndexRef: f
	}), [
		_,
		v,
		S,
		f
	]);
	return /* @__PURE__ */ (0, N.jsx)(He.Provider, {
		value: C,
		children: t
	});
}
function Ge() {
	return /* @__PURE__ */ new Map();
}
function Ke() {
	return /* @__PURE__ */ new Set();
}
function qe(e) {
	let t = /* @__PURE__ */ new Set(), n = [], r = [];
	e.forEach((e, i) => {
		if (!i.isConnected) return;
		let a = e.index, o = {
			index: a ?? -1,
			element: i,
			registration: e
		};
		a === null ? r.push(o) : a >= 0 && (t.add(a), n.push(o));
	});
	let i = 0;
	return r.sort((e, t) => Xe(e.element, t.element)), r.forEach((e) => {
		for (; t.has(i);) i += 1;
		e.index = i, n.push(e), i += 1;
	}), t.size > 0 && n.sort((e, t) => e.index - t.index), [n, r.map((e) => e.element)];
}
function Je(e, t) {
	let n = e.parentElement;
	for (; n && !n.contains(t);) n = n.parentElement;
	return n;
}
function Ye(e) {
	for (let t of e) for (let e = 0; e < t.removedNodes.length; e += 1) if (t.removedNodes[e].isConnected) return !0;
	return !1;
}
function Xe(e, t) {
	return e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}
//#endregion
//#region node_modules/@base-ui/react/accordion/root/AccordionRootContext.mjs
var Ze = /* @__PURE__ */ A.createContext(void 0);
function Qe() {
	let e = A.useContext(Ze);
	if (e === void 0) throw Error(m(10));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/accordion/root/AccordionRoot.mjs
var $e = { value: () => null }, et = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, hiddenUntilFound: a, keepMounted: o, loopFocus: s, onValueChange: c, multiple: l = !1, orientation: d = "vertical", value: f, defaultValue: p, style: m, ...h } = e, _ = A.useMemo(() => {
		if (f === void 0) return p ?? [];
	}, [f, p]), v = A.useRef([]), [y, b] = Ve({
		controlled: f,
		default: _,
		name: "Accordion",
		state: "value"
	}), x = u((e, t, n) => {
		if (!l) {
			let t = y[0] === e ? [] : [e];
			if (c?.(t, n), n.isCanceled) return;
			b(t);
		} else if (t) {
			let t = y.slice();
			if (t.push(e), c?.(t, n), n.isCanceled) return;
			b(t);
		} else {
			let t = y.filter((t) => t !== e);
			if (c?.(t, n), n.isCanceled) return;
			b(t);
		}
	}), S = A.useMemo(() => ({
		value: y,
		disabled: i,
		orientation: d
	}), [
		y,
		i,
		d
	]), C = A.useMemo(() => ({
		disabled: i,
		handleValueChange: x,
		hiddenUntilFound: a ?? !1,
		keepMounted: o ?? !1,
		state: S,
		value: y
	}), [
		i,
		x,
		a,
		o,
		S,
		y
	]), w = g("div", e, {
		state: S,
		ref: t,
		props: h,
		stateAttributesMapping: $e
	});
	return /* @__PURE__ */ (0, N.jsx)(Ze.Provider, {
		value: C,
		children: /* @__PURE__ */ (0, N.jsx)(We, {
			elementsRef: v,
			children: w
		})
	});
}), tt = 0;
function nt(e, t = "mui") {
	let [n, r] = A.useState(e), i = e || n;
	return A.useEffect(() => {
		n ?? (tt += 1, r(`${t}-${tt}`));
	}, [n, t]), i;
}
var rt = S.useId;
function it(e, t) {
	if (rt !== void 0) {
		let n = rt();
		return e ?? (t ? `${t}-${n}` : n);
	}
	return nt(e, t);
}
//#endregion
//#region node_modules/@base-ui/react/internals/useBaseUiId.mjs
function at(e) {
	return it(e, "base-ui");
}
//#endregion
//#region node_modules/@base-ui/react/internals/reason-parts.mjs
var ot = "none", st = "trigger-press";
//#endregion
//#region node_modules/@base-ui/react/internals/createBaseUIEventDetails.mjs
function ct(e, t, n, r) {
	let i = !1, a = !1, o = r ?? p;
	return {
		reason: e,
		event: t ?? new Event("base-ui"),
		cancel() {
			i = !0;
		},
		allowPropagation() {
			a = !0;
		},
		get isCanceled() {
			return i;
		},
		get isPropagationAllowed() {
			return a;
		},
		trigger: n,
		...o
	};
}
//#endregion
//#region node_modules/@base-ui/utils/useOnMount.mjs
function lt(e) {
	A.useEffect(e, s);
}
//#endregion
//#region node_modules/@base-ui/utils/useAnimationFrame.mjs
var ut = null;
globalThis.requestAnimationFrame;
var P = new class {
	callbacks = [];
	callbacksCount = 0;
	nextId = 1;
	startId = 1;
	isScheduled = !1;
	tick = (e) => {
		this.isScheduled = !1;
		let t = this.callbacks, n = this.callbacksCount;
		if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, n > 0) for (let n = 0; n < t.length; n += 1) t[n]?.(e);
	};
	request(e) {
		let t = this.nextId;
		return this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1, this.isScheduled ||= (requestAnimationFrame(this.tick), !0), t;
	}
	cancel(e) {
		let t = e - this.startId;
		t < 0 || t >= this.callbacks.length || (this.callbacks[t] = null, --this.callbacksCount);
	}
}(), F = class e {
	static create() {
		return new e();
	}
	static request(e) {
		return P.request(e);
	}
	static cancel(e) {
		return P.cancel(e);
	}
	currentId = ut;
	request(e) {
		this.cancel(), this.currentId = P.request(() => {
			this.currentId = ut, e();
		});
	}
	cancel = () => {
		this.currentId !== ut && (P.cancel(this.currentId), this.currentId = ut);
	};
	disposeEffect = () => this.cancel;
};
function dt() {
	let e = i(F.create).current;
	return lt(e.disposeEffect), e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/useTransitionStatus.mjs
function ft(e, t = !1, n = !1) {
	let [r, i] = A.useState(e && t ? "idle" : void 0), [a, o] = A.useState(e);
	return e && !a && (o(!0), i("starting")), !e && a && r !== "ending" && !n && i("ending"), !e && !a && r === "ending" && i(void 0), d(() => {
		if (!e && a && r !== "ending" && n) {
			let e = F.request(() => {
				i("ending");
			});
			return () => {
				F.cancel(e);
			};
		}
	}, [
		e,
		a,
		r,
		n
	]), d(() => {
		if (!e || t) return;
		let n = F.request(() => {
			i(void 0);
		});
		return () => {
			F.cancel(n);
		};
	}, [t, e]), d(() => {
		if (!e || !t) return;
		e && a && r !== "idle" && i("starting");
		let n = F.request(() => {
			i("idle");
		});
		return () => {
			F.cancel(n);
		};
	}, [
		t,
		e,
		a,
		r
	]), {
		mounted: a,
		setMounted: o,
		transitionStatus: r
	};
}
//#endregion
//#region node_modules/@base-ui/react/collapsible/root/useCollapsibleRoot.mjs
function pt(e) {
	let { open: t, defaultOpen: n, onOpenChange: r, disabled: i } = e, [a, o] = Ve({
		controlled: t,
		default: n,
		name: "Collapsible",
		state: "open"
	}), { mounted: s, setMounted: c, transitionStatus: l } = ft(a, !0, !0), d = at(), [f, p] = A.useState(), m = f === null ? void 0 : f ?? d, h = u((e) => {
		let t = !a, n = ct(st, e.nativeEvent);
		r(t, n), !n.isCanceled && o(t);
	});
	return A.useMemo(() => ({
		defaultPanelId: d,
		disabled: i,
		handleTrigger: h,
		mounted: s,
		open: a,
		panelId: m,
		setMounted: c,
		setOpen: o,
		setPanelIdState: p,
		transitionStatus: l
	}), [
		d,
		i,
		h,
		s,
		a,
		m,
		c,
		o,
		p,
		l
	]);
}
//#endregion
//#region node_modules/@base-ui/react/collapsible/root/CollapsibleRootContext.mjs
var mt = /* @__PURE__ */ A.createContext(void 0);
function ht() {
	let e = A.useContext(mt);
	if (e === void 0) throw Error(m(15));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/useCompositeListItem.mjs
function gt(e = {}) {
	let { guess: t, label: n, metadata: r, textRef: i, index: a } = e, { register: o, unregister: s, subscribeMapChange: c, nextIndexRef: l } = Ue(), u = A.useRef(-1), [f, p] = A.useState(a == null && t ? () => {
		if (u.current === -1) {
			let e = l.current;
			l.current += 1, u.current = e;
		}
		return u.current;
	} : -1), m = a ?? f, h = A.useRef(null), g = A.useCallback((e) => {
		let t = h.current;
		t && s(t), h.current = e, e && o(e, {
			metadata: r ?? null,
			index: a ?? null,
			label: n,
			textRef: i
		});
	}, [
		a,
		o,
		s,
		r,
		n,
		i
	]);
	return d(() => {
		if (a == null) return c((e) => {
			let t = h.current ? e.get(h.current)?.index : null;
			t != null && p(t);
		});
	}, [a, c]), {
		ref: g,
		index: m
	};
}
//#endregion
//#region node_modules/@base-ui/react/accordion/item/AccordionItemContext.mjs
var _t = /* @__PURE__ */ A.createContext(void 0);
function vt() {
	let e = A.useContext(_t);
	if (e === void 0) throw Error(m(9));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/stateAttributesMapping.mjs
var yt = /* @__PURE__ */ function(e) {
	return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({}), bt = { "data-starting-style": "" }, xt = { "data-ending-style": "" }, St = { transitionStatus(e) {
	return e === "starting" ? bt : e === "ending" ? xt : null;
} }, Ct = function(e) {
	return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = yt.startingStyle] = "startingStyle", e[e.endingStyle = yt.endingStyle] = "endingStyle", e;
}({}), wt = /* @__PURE__ */ function(e) {
	return e.panelOpen = "data-panel-open", e;
}({}), Tt = { [Ct.open]: "" }, Et = { [Ct.closed]: "" }, Dt = { open(e) {
	return e ? { [wt.panelOpen]: "" } : null;
} }, Ot = { open(e) {
	return e ? Tt : Et;
} }, kt = /* @__PURE__ */ function(e) {
	return e.index = "data-index", e.disabled = "data-disabled", e.open = "data-open", e;
}({}), At = {
	...Ot,
	index: (e) => ({ [kt.index]: String(e) }),
	...St,
	value: () => null
}, jt = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { className: n, disabled: r = !1, onOpenChange: i, render: a, value: o, style: s, ...l } = e, { ref: d, index: f } = gt(), p = c(t, d), { disabled: m, handleValueChange: h, state: _, value: v } = Qe(), y = at(), b = o ?? y, x = r || m, S = v.indexOf(b) !== -1, C = u((e, t) => {
		i?.(e, t), !t.isCanceled && h(b, e, t);
	}), w = pt({
		open: S,
		onOpenChange: C,
		disabled: x
	}), ee = A.useMemo(() => ({
		open: w.open,
		disabled: w.disabled,
		transitionStatus: w.transitionStatus
	}), [
		w.open,
		w.disabled,
		w.transitionStatus
	]), T = A.useMemo(() => ({
		...w,
		onOpenChange: C,
		state: ee
	}), [
		w,
		ee,
		C
	]), E = A.useMemo(() => ({
		..._,
		hidden: !S && !w.mounted,
		index: f,
		disabled: x,
		open: S
	}), [
		w.mounted,
		x,
		f,
		S,
		_
	]), D = at(), [te, ne] = A.useState(), re = te === null ? void 0 : te ?? D, ie = A.useMemo(() => ({
		defaultTriggerId: D,
		open: S,
		state: E,
		setTriggerId: ne,
		triggerId: re
	}), [
		D,
		S,
		E,
		ne,
		re
	]), ae = g("div", e, {
		state: E,
		ref: p,
		props: l,
		stateAttributesMapping: At
	});
	return /* @__PURE__ */ (0, N.jsx)(mt.Provider, {
		value: T,
		children: /* @__PURE__ */ (0, N.jsx)(_t.Provider, {
			value: ie,
			children: ae
		})
	});
}), Mt = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, ...a } = e, { state: o } = vt();
	return g("h3", e, {
		state: o,
		ref: t,
		props: a,
		stateAttributesMapping: At
	});
}), Nt = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { disabled: n, className: r, id: i, render: a, nativeButton: o = !0, style: s, ...c } = e, { panelId: u, open: f, handleTrigger: p, disabled: m } = ht(), { getButtonProps: h, buttonRef: _ } = l({
		disabled: n || m,
		focusableWhenDisabled: !0,
		native: o
	}), { defaultTriggerId: v, state: y, setTriggerId: b } = vt(), x = i || void 0, S = x ?? v;
	return d(() => (b((e) => x ?? (e === null ? void 0 : e)), () => {
		b((e) => e === x ? null : e);
	}), [x, b]), g("button", e, {
		state: y,
		ref: [t, _],
		props: [
			{
				"aria-controls": f ? u : void 0,
				"aria-expanded": f,
				id: S,
				onClick: p
			},
			c,
			h
		],
		stateAttributesMapping: Dt
	});
});
//#endregion
//#region node_modules/@base-ui/utils/addEventListener.mjs
function Pt(e, t, n, r) {
	return e.addEventListener(t, n, r), () => {
		e.removeEventListener(t, n, r);
	};
}
//#endregion
//#region node_modules/@base-ui/utils/useValueAsRef.mjs
function Ft(e) {
	let t = i(It, e).current;
	return t.next = e, d(t.effect), t;
}
function It(e) {
	let t = {
		current: e,
		next: e,
		effect: () => {
			t.current = t.next;
		}
	};
	return t;
}
//#endregion
//#region node_modules/@base-ui/react/utils/resolveRef.mjs
function Lt(e) {
	return e == null ? e : "current" in e ? e.current : e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/useAnimationsFinished.mjs
var Rt = /* @__PURE__ */ t(te(), 1);
function zt(e, t = !1) {
	let n = dt();
	return u((r, i = null) => {
		n.cancel();
		let a = Lt(e);
		if (a == null) return;
		let o = a, s = () => {
			Rt.flushSync(r);
		};
		if (typeof o.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
			r();
			return;
		}
		function c() {
			Promise.all(o.getAnimations().map((e) => e.finished)).then(() => {
				i?.aborted || s();
			}, () => {
				if (!i?.aborted) {
					if (o.getAnimations().some((e) => e.pending || e.playState !== "finished")) {
						c();
						return;
					}
					s();
				}
			});
		}
		if (t) {
			let e = "data-starting-style";
			if (!o.hasAttribute(e)) {
				n.request(c);
				return;
			}
			let t = new MutationObserver(() => {
				o.hasAttribute(e) || (t.disconnect(), c());
			});
			t.observe(o, {
				attributes: !0,
				attributeFilter: [e]
			}), i?.addEventListener("abort", () => t.disconnect(), { once: !0 });
			return;
		}
		n.request(c);
	});
}
//#endregion
//#region node_modules/@base-ui/react/internals/useOpenChangeComplete.mjs
function Bt(e) {
	let { enabled: t = !0, open: n, ref: r, onComplete: i } = e, a = u(i), o = zt(r, n);
	A.useEffect(() => {
		if (!t) return;
		let e = new AbortController();
		return o(a, e.signal), () => {
			e.abort();
		};
	}, [
		t,
		n,
		a,
		o
	]);
}
//#endregion
//#region node_modules/@base-ui/react/collapsible/panel/useCollapsiblePanel.mjs
var Vt = {
	height: void 0,
	width: void 0
};
function Ht(e) {
	let { externalRef: t, hiddenUntilFound: n, id: r, keepMounted: i, mounted: a, onOpenChange: o, open: s, setMounted: l, setOpen: f, transitionStatus: p } = e, m = A.useRef(null), h = A.useRef(null), [g, _] = A.useState(Vt), v = A.useRef(Vt), y = A.useRef(!1), b = A.useRef(s), x = A.useRef(!1), [S, C] = A.useState(!1), w = A.useRef(null), ee = c(t, m), T = Ft(s), E = zt(m), D = !s && !a, te = S ? "idle" : p, ne = s && (b.current || x.current), re = !s && a && h.current === "css-animation" && g.height === void 0 && g.width === void 0 ? v.current : g, ie = n && D && h.current !== "css-animation", ae = u((e, t = !0) => {
		t && (v.current = e), _(e);
	}), oe = u(() => {
		w.current?.(), w.current = null;
	}), se = u((e) => {
		oe(), w.current = () => {
			w.current = null, e();
		};
	}), O = u(() => {
		s && a && h.current === "css-animation" && (x.current = !0);
	});
	d(() => {
		!S || p === "starting" || C(!1);
	}, [S, p]), A.useEffect(() => () => {
		O(), oe();
	}, [O, oe]), d(() => {
		let e = m.current;
		if (!e) return;
		!s && w.current && oe();
		let t = Wt(e, ne);
		if (h.current = t, s && p === "idle" && b.current && t === "css-animation") {
			v.current = Ut(e);
			return;
		}
		if (s && p === "starting") {
			let n = y.current;
			if (y.current = !1, t === "none") {
				ae(Ut(e)), C(!0);
				return;
			}
			if (t === "css-transition") {
				let t = qt(e);
				return ae(Ut(e)), n ? (se(Kt(e, "transition-duration", "0s")), C(!0), t) : t;
			}
			ae(Ut(e));
			let r = Kt(e, "animation-name", "none");
			if (!n) {
				r();
				return;
			}
			let i = Kt(e, "animation-duration", "0s");
			r(), se(i), C(!0);
			return;
		}
		if (!s && a && (p === "idle" || p === "starting")) {
			if (b.current = !1, x.current = !1, t === "none") {
				ae(Vt, !1), l(!1);
				return;
			}
			ae(Ut(e));
			return;
		}
		if (p !== "ending") return;
		if (t === "none") {
			l(!1);
			return;
		}
		let n = Ut(e);
		if (!(n.height > 0 || n.width > 0)) {
			l(!1);
			return;
		}
		ae(n), t === "css-animation" && Kt(e, "animation-name", "none")();
	}, [
		a,
		s,
		oe,
		ae,
		l,
		se,
		ne,
		p
	]), Bt({
		enabled: s && a && te === "idle",
		open: !0,
		ref: m,
		onComplete() {
			s && ae(Vt, !1);
		}
	}), A.useEffect(() => {
		if (s || !a || te !== "ending" || !m.current) return;
		let e = new AbortController(), t = -1;
		function n() {
			T.current || (l(!1), ae(Vt, !1));
		}
		return t = F.request(() => {
			E(n, e.signal);
		}), () => {
			F.cancel(t), e.abort();
		};
	}, [
		T,
		a,
		s,
		te,
		E,
		ae,
		l
	]), d(() => {
		let e = m.current;
		!e || !n || !D || e.setAttribute("hidden", "until-found");
	}, [D, n]), A.useEffect(function() {
		let e = m.current;
		if (!e) return;
		function t(e) {
			let t = ct(ot, e);
			o(!0, t), !t.isCanceled && (y.current = !0, f(!0));
		}
		return Pt(e, "beforematch", t);
	}, [o, f]);
	let k = i || n || a || s;
	return {
		height: re.height,
		props: {
			...ie ? { [Ct.startingStyle]: "" } : void 0,
			hidden: D,
			id: r
		},
		ref: ee,
		shouldPreventOpenAnimation: ne,
		shouldRender: k,
		transitionStatus: te,
		width: re.width
	};
}
function Ut(e) {
	return {
		height: e.scrollHeight,
		width: e.scrollWidth
	};
}
function Wt(e, t) {
	let n = ee(e).getComputedStyle(e), r = (n.animationName.split(",").map((e) => e.trim()).some((e) => e !== "" && e !== "none") || t) && Gt(n.animationDuration), i = Gt(n.transitionDuration);
	return r && i || i ? "css-transition" : r ? "css-animation" : "none";
}
function Gt(e) {
	return e.split(",").map((e) => e.trim()).some((e) => e !== "" && Number.parseFloat(e) > 0);
}
function Kt(e, t, n) {
	let r = e.style.getPropertyValue(t), i = e.style.getPropertyPriority(t);
	return e.style.setProperty(t, n), () => {
		if (r === "") {
			e.style.removeProperty(t);
			return;
		}
		e.style.setProperty(t, r, i);
	};
}
function qt(e) {
	let t = {
		"justify-content": e.style.justifyContent,
		"align-items": e.style.alignItems,
		"align-content": e.style.alignContent,
		"justify-items": e.style.justifyItems
	};
	Object.keys(t).forEach((t) => {
		e.style.setProperty(t, "initial", "important");
	});
	function n() {
		Object.entries(t).forEach(([t, n]) => {
			if (n === "") {
				e.style.removeProperty(t);
				return;
			}
			e.style.setProperty(t, n);
		});
	}
	let r = F.request(n);
	return () => {
		F.cancel(r), n();
	};
}
//#endregion
//#region node_modules/@base-ui/react/accordion/panel/AccordionPanelCssVars.mjs
var Jt = /* @__PURE__ */ function(e) {
	return e.accordionPanelHeight = "--accordion-panel-height", e.accordionPanelWidth = "--accordion-panel-width", e;
}({}), Yt = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { className: n, hiddenUntilFound: r, keepMounted: i, id: a, render: o, style: s, ...c } = e, { hiddenUntilFound: l, keepMounted: u } = Qe(), { defaultPanelId: f, mounted: p, onOpenChange: m, open: h, setMounted: _, setOpen: v, setPanelIdState: b, transitionStatus: x } = ht(), S = r ?? l, C = i ?? u, w = a || void 0, ee = a ?? f;
	d(() => (b((e) => w ?? (e === null ? void 0 : e)), () => {
		b((e) => e === w ? null : e);
	}), [w, b]);
	let { height: T, props: E, ref: D, shouldPreventOpenAnimation: te, shouldRender: ne, transitionStatus: re, width: ie } = Ht({
		externalRef: t,
		hiddenUntilFound: S,
		id: ee,
		keepMounted: C,
		mounted: p,
		onOpenChange: m,
		open: h,
		setMounted: _,
		setOpen: v,
		transitionStatus: x
	}), { state: ae, triggerId: oe } = vt(), se = {
		...ae,
		transitionStatus: re
	}, O = y(s, se), k = g("div", {
		...e,
		style: void 0
	}, {
		state: se,
		ref: D,
		props: [
			E,
			{
				"aria-labelledby": oe,
				role: "region",
				style: {
					[Jt.accordionPanelHeight]: T === void 0 ? "auto" : `${T}px`,
					[Jt.accordionPanelWidth]: ie === void 0 ? "auto" : `${ie}px`
				}
			},
			c,
			O ? { style: O } : void 0,
			te ? { style: { animationName: "none" } } : void 0
		],
		stateAttributesMapping: At
	});
	return ne ? k : null;
}), Xt = re();
function Zt({ className: e, ...t }) {
	return /* @__PURE__ */ (0, N.jsx)(et, {
		"data-slot": "accordion",
		className: a("flex w-full flex-col", e),
		...t
	});
}
function Qt({ className: e, ...t }) {
	return /* @__PURE__ */ (0, N.jsx)(jt, {
		"data-slot": "accordion-item",
		className: a("not-last:border-b", e),
		...t
	});
}
function $t({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, N.jsx)(Mt, {
		className: "flex",
		children: /* @__PURE__ */ (0, N.jsxs)(Nt, {
			"data-slot": "accordion-trigger",
			className: a("focus-visible:ring-ring/50 focus-visible:border-ring focus-visible:after:border-ring **:data-[slot=accordion-trigger-icon]:text-muted-foreground rounded-lg py-2.5 text-left text-sm font-medium hover:underline focus-visible:ring-3 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 group/accordion-trigger relative flex flex-1 items-start justify-between border border-transparent transition-all outline-none aria-disabled:pointer-events-none aria-disabled:opacity-50", e),
			...n,
			children: [t, /* @__PURE__ */ (0, N.jsx)(pe, {
				"aria-hidden": "true",
				"data-slot": "accordion-trigger-icon",
				className: "accordion-single-chevron"
			})]
		})
	});
}
function en({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, N.jsx)(Yt, {
		"data-slot": "accordion-content",
		className: "data-open:animate-accordion-down data-closed:animate-accordion-up text-sm overflow-hidden",
		...n,
		children: /* @__PURE__ */ (0, N.jsx)("div", {
			className: a("pt-0 pb-2.5 h-(--accordion-panel-height) data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", e),
			children: t
		})
	});
}
//#endregion
//#region lib/product-option-labels.ts
function tn(e, t, n, r) {
	if (e !== "Grills" || !n.includes("size") || !/^\d+ model$/.test(r)) return r;
	let i = t.filter((e) => e.options[n] === r);
	for (let e of i) {
		let t = e.specs.find((e) => e.attribute === "main_cooking_width"), n = e.specs.find((e) => e.attribute === "main_cooking_surface");
		if (String(n?.value || "").includes("&")) {
			let e = [...String(n?.value).matchAll(/(\d+(?:\.\d+)?)\s*[x×]/gi)].map((e) => e[1] + "″");
			if (e.length > 1) return e.join(" + ") + " cooking widths";
		}
		let r = String(n?.value || "").match(/^(\d+(?:\.\d+)?)\s*[x×]/i);
		if (t || r) return `${t?.value || r?.[1]}″ cooking width`;
		let i = e.specs.find((e) => e.attribute === "main_cooking_area");
		if (i) return `${i.value} sq. in. cooking area`;
	}
	let a = i.flatMap((e) => e.specs).find((e) => e.attribute === "main_burners");
	return a ? `${a.value} main burners` : r;
}
//#endregion
//#region lib/configuration-choice.ts
function nn(e, t, n, r) {
	let i = e.filter((e) => e.options[n] === r), a = (e) => Object.entries(t.options).filter(([t, r]) => t !== n && e.options[t] === r).length;
	i.sort((e, t) => a(t) - a(e) || e.manufacturer_sku.localeCompare(t.manufacturer_sku));
	let o = i[0];
	return o ? {
		next: o,
		changes: [...new Set([...Object.keys(t.options), ...Object.keys(o.options)])].filter((e) => e !== n && t.options[e] !== o.options[e]).map((e) => ({
			axis: e,
			from: t.options[e] || "Not applicable",
			to: o.options[e] || "Not applicable"
		}))
	} : null;
}
//#endregion
//#region lib/product-videos.ts
var rn = {
	youtubeId: "OCqyDWJzLBM",
	title: "Let me show you",
	description: ""
};
function an(e) {
	return ["STTR1-BZ", "STTR2-BZ"].includes(e) ? {
		youtubeId: "0E7t2GXJ8ts",
		title: "Napoleon Patioflame fire tables",
		description: ""
	} : ["PRO500VXRSIBNSS", "PRO500VXRSIBPSS"].includes(e) ? {
		youtubeId: "8ZRZx2jnuo4",
		title: "Meet the Prestige PRO 500 with smart technology",
		description: ""
	} : ["PRO665VXRSIBNSS", "PRO665VXRSIBPSS"].includes(e) ? {
		youtubeId: "QGUTutcsM00",
		title: "Meet the Prestige PRO 665 Elite",
		description: ""
	} : ["RPS625RSIBNSS-2", "RPS625RSIBPSS-2"].includes(e) ? {
		youtubeId: "ZQvyICvloKA",
		title: "Rogue PRO-S 625 in action",
		description: ""
	} : ["R425NSS-2", "R425PSS-2"].includes(e) ? {
		youtubeId: "b-uTpiMS7CM",
		title: "Discover Rogue 425",
		description: ""
	} : ["RPS525RSIBNSS-2", "RPS525RSIBPSS-2"].includes(e) ? {
		youtubeId: "S53KfxrKa6w",
		title: "Rogue PRO-S 525 in action",
		description: ""
	} : [
		"NWFPLTI-SS",
		"NWFPMTI-SS",
		"NWFPMTI-PHM"
	].includes(e) ? {
		youtubeId: "pZwUuw6USgE",
		title: "Discover Timberwolf",
		description: "The Timberwolf family video shows multiple sizes and finishes. Your selected configuration is shown above."
	} : e === "PRO285E-BK" ? {
		youtubeId: "BMiAEQlSj8Y",
		title: "TravelQ PRO285E electric grilling",
		description: ""
	} : e === "PRO285X-BK" ? {
		youtubeId: "4-7WFTAOFrs",
		title: "TravelQ PRO285X on the go",
		description: ""
	} : e === "TQ240-BL" ? {
		youtubeId: "VyIbBvlV68E",
		title: "TravelQ 240 in action",
		description: ""
	} : ["TQ285X-BL-1", "TQ285X-RD-1-A"].includes(e) ? {
		youtubeId: "P2rHS2CMcPs",
		title: "TravelQ 285X on the go",
		description: "The TravelQ 285X family video. Color and included accessories depend on your selected configuration."
	} : ["F365DNGT", "F365DPGT"].includes(e) ? {
		youtubeId: "voTjGBYBTUg",
		title: "Discover Freestyle 365",
		description: ""
	} : /^BI(?:32|40)(?:N|P)SS$/.test(e) ? {
		youtubeId: "HYBI_Go7Gyk",
		title: "Built-in 500 Series in action",
		description: "Napoleon’s Built-in 500 Series video. Shown equipment and sizes vary by configuration."
	} : /^(?:BI)?PRO(?:500|665|825).*\-3$/.test(e) ? {
		youtubeId: "zApgTtdaaJo",
		title: "Prestige PRO — Classic",
		description: "Napoleon’s Classic Prestige PRO series video. Features vary by model; review your selected configuration above."
	} : /^BIG(?:32|38|44).*SS-1$/.test(e) ? {
		youtubeId: "So9WRBKwta0",
		title: "Built-in 700 Series in action",
		description: "Explore the stainless-steel Built-in 700 Series. The video shows several sizes and configurations."
	} : e === "NEOFV80IH" ? {
		youtubeId: "5ConJzcfeAg",
		title: "Discover the Phantom Freestand heater",
		description: ""
	} : ["RPS425RSIBNK-2-PHM", "RPS425RSIBPK-2-PHM"].includes(e) ? {
		youtubeId: "e6J6XGDRF0Q",
		title: "Phantom Rogue PRO-S 425 in action",
		description: ""
	} : ["RP525SIBNSS-2", "RP525SIBPSS-2"].includes(e) ? {
		youtubeId: "ElOeKE0dtlU",
		title: "Discover Rogue PRO 525",
		description: ""
	} : ["R425SBNK-2-FB", "R425SBPK-2-FB"].includes(e) ? {
		youtubeId: "a_T-zm9gxeM",
		title: "Rogue 425 with range side burner",
		description: ""
	} : e === "64000" ? {
		youtubeId: "dwFtay5YKdI",
		title: "Cooking with the rotisserie grill basket",
		description: ""
	} : null;
}
var on = new Set(/* @__PURE__ */ "P500VRSIBNSS.P500VRSIBPSS.P500VXRSIBNK-PHM.P500VXRSIBNSS.P500VXRSIBPK-PHM.P500VXRSIBPSS.P665VRSIBNSS.P665VRSIBPSS.P665VXRSIBNSS.P665VXRSIBPSS.PRO500VXRSIBNSS.PRO500VXRSIBPSS.PRO665VXRSIBNSS.PRO665VXRSIBPSS.R425NK-2.R425NK-2-SS.R425NSS-2.R425PK-2.R425PK-2-SS.R425PSS-2.R525NK-2.R525NK-2-SS.R525NSS-2.R525PK-2.R525PK-2-SS.R525PSS-2.R625PK-2.RP425SIBNK-2.RP425SIBNSS-2.RP425SIBPK-2.RP425SIBPSS-2.RP525SIBNK-2.RP525SIBNSS-2.RP525SIBPK-2.RP525SIBPSS-2.RP625SIBNK-2.RP625SIBNSS-2.RP625SIBPK-2.RP625SIBPSS-2.RPS425RSIBNK-2-PHM.RPS425RSIBNSS-2.RPS425RSIBPK-2-PHM.RPS425RSIBPSS-2.RPS525RSIBNSS-2.RPS525RSIBPSS-2.RPS625RSIBNSS-2.RPS625RSIBPSS-2.R425SBNK-2-FB.R425SBPK-2-FB".split("."));
function sn(e) {
	return ["PRO825RSBIPSS-3", "PRO825RSBINSS-3"].includes(e) ? {
		youtubeId: "HeQBp-Bln_E",
		title: "Prestige PRO 825 assembly",
		description: "Follow the manual supplied with your exact model for installation and gas connections."
	} : ["PRO500RSIBPSS-3", "PRO500RSIBNSS-3"].includes(e) ? {
		youtubeId: "XccrNCYrtWs",
		title: "Prestige PRO 500 assembly",
		description: "Follow the manual supplied with your exact model for installation and gas connections."
	} : ["TQ285X-BL-1", "TQ285X-RD-1-A"].includes(e) ? {
		youtubeId: "ArcqOvfmHMc",
		title: "TravelQ 285X scissor-cart assembly",
		description: ""
	} : e === "PRO605CSS" ? {
		youtubeId: "ByKCV0hNiSU",
		title: "PRO605CSS charcoal grill assembly",
		description: ""
	} : on.has(e) ? {
		youtubeId: "XccrNCYrtWs",
		title: "Freestanding grill assembly demonstration",
		description: "",
		demonstration: !0
	} : null;
}
//#endregion
//#region components/napoleon-video.tsx
// Reuse the installed YouTube API; raw listening messages can reset its handshake.
let hopYouTubeApiPromise;
function hopYouTubeApi() {
 if (window.YT?.Player) return Promise.resolve(window.YT);
 if (hopYouTubeApiPromise) return hopYouTubeApiPromise;
 hopYouTubeApiPromise = new Promise((resolve,reject)=>{
  if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
   const script=document.createElement('script');script.src='https://www.youtube.com/iframe_api';script.async=true;document.head.appendChild(script);
  }
  const started=Date.now();const timer=setInterval(()=>{
   if(window.YT?.Player){clearInterval(timer);resolve(window.YT);}
   else if(Date.now()-started>15000){clearInterval(timer);hopYouTubeApiPromise=null;reject(new Error('YouTube API unavailable'));}
  },100);
 });
 return hopYouTubeApiPromise;
}
function cn({ video: e }) {
 const apiSource=!!e?.useYouTubeApi && !e?.sourceUrl && !e?.vimeoId;
 const apiPlayer=(0,A.useRef)(null);
 const apiPending=(0,A.useRef)([]);
 const nativeSource=!!e?.sourceUrl;
 const vimeoSource=!!e?.vimeoId;
 const [vimeoCaptions,setVimeoCaptions]=(0,A.useState)(false);
 const [viewportStarted,startViewport]=(0,A.useState)(false);
 const viewportVisible=(0,A.useRef)(false);
	let t = (0, A.useRef)(null), n = (0, A.useRef)(null), r = (0, A.useRef)(!1), [i, a] = (0, A.useState)(!1), [o, s] = (0, A.useState)(0), [c, l] = (0, A.useState)(!1), [u, d] = (0, A.useState)(!0), [f, p] = (0, A.useState)(!1), m = (command, args = []) => {
        if(apiSource){
            const player=apiPlayer.current;
            if(typeof player?.[command]==='function')player[command](...args);
            else if(apiPending.current.length<10)apiPending.current.push([command,args]);
            return;
        }
        if(e?.sourceUrl){
            const media=t.current;if(!media)return;
            if(command==='playVideo')media.play().catch(()=>a(false));
            else if(command==='pauseVideo')media.pause();
            else if(command==='stopVideo'){media.pause();media.currentTime=0;}
            else if(command==='seekTo')media.currentTime=Math.min(Number.isFinite(media.duration)?media.duration:Infinity,Math.max(0,args[0]));
            else if(command==='mute')media.muted=true;
            else if(command==='unMute')media.muted=false;
            return;
        }
        if(vimeoSource){
            const send=(method,value)=>t.current?.contentWindow?.postMessage({method,...(value===undefined?{}:{value})},'https://player.vimeo.com');
            if(command==='playVideo')send('play');
            else if(command==='pauseVideo')send('pause');
            else if(command==='stopVideo'){send('pause');send('setCurrentTime',0);}
            else if(command==='seekTo')send('setCurrentTime',Math.max(0,args[0]));
            else if(command==='mute')send('setVolume',0);
            else if(command==='unMute')send('setVolume',1);
            else if(command==='setOption'){if(args[2]?.languageCode)send('enableTextTrack',{language:'en'});else send('disableTextTrack');}
            return;
        }
        t.current?.contentWindow?.postMessage(JSON.stringify({event:'command',func:command,args}), 'https://www.youtube-nocookie.com');
    }, h = () => {
		m(i ? "pauseVideo" : "playVideo"), a(!i);
	};
    (0,A.useEffect)(()=>{
        if(!apiSource)return;
        let disposed=false,player,poll;
        const state=event=>{if(!disposed)a(event.data===1);};
        const ready=()=>{
            if(disposed||apiPlayer.current===player||typeof player?.getDuration!=='function')return;
            apiPlayer.current=player;p(true);
            player.addEventListener('onStateChange',state);
            for(const [command,args] of apiPending.current.splice(0))if(typeof player[command]==='function')player[command](...args);
        };
        hopYouTubeApi().then(YT=>{
            if(disposed||!t.current)return;
            player=(t.current.id&&typeof YT.get==='function'?YT.get(t.current.id):null)||new YT.Player(t.current);
            // Google can own the existing player before its API methods arrive.
            player.addEventListener('onReady',ready);
            ready();
            poll=setInterval(()=>{
                if(disposed)return;
                if(!apiPlayer.current){ready();return;}
                const time=player.getCurrentTime?.();if(Number.isFinite(time))s(time);
                const playing=player.getPlayerState?.();if(Number.isFinite(playing))a(playing===1);
            },500);
        }).catch(error=>{if(!disposed){a(false);console.warn('PDP video API unavailable:',error.message);}});
        return()=>{disposed=true;clearInterval(poll);player?.removeEventListener?.('onReady',ready);player?.removeEventListener?.('onStateChange',state);apiPlayer.current=null;apiPending.current=[];};
    },[apiSource,e?.youtubeId]);
    (0,A.useEffect)(()=>{
        if(!vimeoSource)return;
        const send=(method,value)=>t.current?.contentWindow?.postMessage({method,...(value===undefined?{}:{value})},'https://player.vimeo.com');
        const onMessage=event=>{
            if(event.origin!=='https://player.vimeo.com'||event.source!==t.current?.contentWindow)return;
            let message;try{message=typeof event.data==='string'?JSON.parse(event.data):event.data;}catch{return;}
            if(message?.event==='ready'||message?.event==='loaded'||message?.method==='ping'){
                for(const name of ['play','pause','ended','timeupdate'])send('addEventListener',name);
                send('getTextTracks');send('setVolume',0);p(true);
            }
            if(message?.method==='getTextTracks')setVimeoCaptions((message.value||[]).some(track=>track.language?.startsWith('en')));
            if(message?.event==='play')a(true);
            if(message?.event==='pause'||message?.event==='ended')a(false);
            if(message?.event==='timeupdate'&&Number.isFinite(message.data?.seconds))s(message.data.seconds);
            if(message?.event==='error'&&message.data?.method==='play')a(false);
        };
        addEventListener('message',onMessage);return()=>removeEventListener('message',onMessage);
    },[vimeoSource]);
	if ((0, A.useEffect)(() => {
        if(nativeSource||vimeoSource||apiSource)return;
		let e = (e) => {
			if (!(e.origin !== "https://www.youtube-nocookie.com" || e.source !== t.current?.contentWindow)) try {
				let t = typeof e.data == "string" ? JSON.parse(e.data) : e.data;
				t?.event === "onReady" && p(!0), t?.event === "infoDelivery" && Number.isFinite(t.info?.currentTime) && (p(!0), s(t.info.currentTime), Number.isFinite(t.info?.playerState) && a(t.info.playerState === 1)), t?.event === "onStateChange" && a(t.info === 1);
			} catch {}
		};
		return addEventListener("message", e), () => removeEventListener("message", e);
	}, []), (0, A.useEffect)(() => {
		if (f || nativeSource || vimeoSource || apiSource) return;
		let e = () => {
			t.current?.contentWindow?.postMessage(JSON.stringify({ event: "listening" }), "https://www.youtube-nocookie.com"), m("addEventListener", ["onReady"]), m("addEventListener", ["onStateChange"]);
		};
		e();
		let n = setInterval(e, 500);
		return () => clearInterval(n);
	}, [f]), (0, A.useEffect)(() => {
		if (!e || !n.current) return;
		let t = new IntersectionObserver(([entry]) => {
            viewportVisible.current=entry.isIntersecting && entry.intersectionRatio >= (e.autoplayThreshold ?? .25);
            if(viewportVisible.current && (!r.current || e.pauseOffscreen)){
                if(!r.current){r.current=true;startViewport(true);d(true);}
                if(f){if(u)m("mute");m("playVideo");}
            } else if(e.pauseOffscreen && f){m("pauseVideo");}
		}, { threshold: [e.autoplayThreshold ?? .25] });
		return t.observe(n.current), () => t.disconnect();
	}, [e, f]), (0,A.useEffect)(()=>{if(viewportStarted&&f&&(!e.pauseOffscreen||viewportVisible.current)){m("mute");m("playVideo");}},[viewportStarted,f]), !e) return null;
	let g = (e) => m("seekTo", [Math.max(0, o + e), !0]);
	return /* @__PURE__ */ (0, N.jsxs)("div", {
		className: "nap-video",
        "data-video-ready": f ? "true" : "false",
		children: [/* @__PURE__ */ (0, N.jsxs)("div", {
			className: "video-shell",
			ref: n,
			children: [/* @__PURE__ */ (0, N.jsxs)("div", {
				className: "video-frame",
				children: [e.sourceUrl ? (0,N.jsx)('video', {
                    ref:t, src:e.sourceUrl, poster:e.poster, preload:'metadata', playsInline:true, muted:u,
                    controls:false, tabIndex:-1, 'aria-hidden':true, 'data-native-video-managed':'true',
                    onLoadedData:()=>p(true), onPlay:()=>a(true), onPause:()=>a(false), onEnded:()=>a(false),
                    onTimeUpdate:()=>s(t.current?.currentTime||0)
                }) : /* @__PURE__ */ (0, N.jsx)("iframe", {
					ref: t,
					tabIndex: -1,
					"aria-hidden": "true",
					onLoad: () => {
                        if(apiSource)return;
                        if(vimeoSource){t.current?.contentWindow?.postMessage({method:'ping'},'https://player.vimeo.com');return;}
						t.current?.contentWindow?.postMessage(JSON.stringify({ event: "listening" }), "https://www.youtube-nocookie.com");
					},
					src: vimeoSource ? `https://player.vimeo.com/video/${e.vimeoId}?${e.vimeoHash ? "h="+encodeURIComponent(e.vimeoHash)+"&" : ""}autoplay=0&muted=1&controls=0&title=0&byline=0&portrait=0&dnt=1&playsinline=1` : `https://www.youtube-nocookie.com/embed/${e.youtubeId}?autoplay=${!apiSource&&viewportStarted?1:0}&mute=1&enablejsapi=1&origin=${encodeURIComponent(location.origin)}&controls=0&disablekb=1&fs=0&iv_load_policy=3&playsinline=1&rel=0`,
					title: e.title,
					loading: e.eager ? "eager" : "lazy",
					allow: "autoplay; encrypted-media; picture-in-picture"
				}), /* @__PURE__ */ (0, N.jsx)("button", {
					type: "button",
					className: "video-mask",
					onClick: h,
					"aria-label": i ? "Pause video" : "Play video"
				})]
			}), /* @__PURE__ */ (0, N.jsxs)("div", {
				className: "video-controls",
				children: [
					/* @__PURE__ */ (0, N.jsxs)("button", {
						type: "button",
						onClick: h,
						"aria-label": i ? "Pause video" : "Play video",
						children: [i ? /* @__PURE__ */ (0, N.jsx)(Te, {}) : /* @__PURE__ */ (0, N.jsx)(Ee, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: i ? "Pause" : "Play" })]
					}),
					/* @__PURE__ */ (0, N.jsxs)("button", {
						type: "button",
						onClick: () => {
							m("stopVideo"), a(!1), s(0);
						},
						"aria-label": "Stop video",
						children: [/* @__PURE__ */ (0, N.jsx)(Fe, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: "Stop" })]
					}),
					/* @__PURE__ */ (0, N.jsxs)("button", {
						type: "button",
						onClick: () => g(-10),
						"aria-label": "Rewind 10 seconds",
						children: [/* @__PURE__ */ (0, N.jsx)(ke, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: "10s" })]
					}),
					/* @__PURE__ */ (0, N.jsxs)("button", {
						type: "button",
						onClick: () => g(10),
						"aria-label": "Fast forward 10 seconds",
						children: [/* @__PURE__ */ (0, N.jsx)(ye, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: "10s" })]
					}),
					/* @__PURE__ */ (0, N.jsxs)("button", {
						className: c ? "active" : "",
                        disabled:!!e.sourceUrl||(vimeoSource&&!vimeoCaptions),
						type: "button",
						onClick: () => {
							m("setOption", [
								"captions",
								"track",
								c ? {} : { languageCode: "en" }
							]), l(!c);
						},
						"aria-pressed": c,
						"aria-label": "Toggle closed captions",
						children: [/* @__PURE__ */ (0, N.jsx)(de, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: "CC" })]
					}),
					/* @__PURE__ */ (0, N.jsxs)("button", {
						className: u ? "" : "active",
						type: "button",
						onClick: () => {
							m(u ? "unMute" : "mute"), d(!u);
						},
						"aria-label": u ? "Unmute video" : "Mute video",
						children: [u ? /* @__PURE__ */ (0, N.jsx)(Re, {}) : /* @__PURE__ */ (0, N.jsx)(Le, {}), /* @__PURE__ */ (0, N.jsx)("span", { children: u ? "Sound" : "Mute" })]
					})
				]
			})]
		}), e.description && /* @__PURE__ */ (0, N.jsx)("p", {
			className: "small-muted",
			children: e.description
		})]
	});
}
//#endregion
//#region components/napoleon-gallery.tsx
function ln({ title: e, images: t, details: n }) {
	let [r, i] = (0, A.useState)(0), [a, o] = (0, A.useState)(!1), s = (0, A.useRef)(null), c = (0, A.useRef)(null), l = t[r] || t[0], u = n[l] || {}, d = (e) => i((n) => (n + e + t.length) % t.length);
 const [zoomed, setZoomed] = A.useState(false);
 A.useEffect(() => setZoomed(false), [r, a]);
 A.useEffect(() => { const photo=document.querySelector(".n-image-dialog-photo"); if(photo) photo.scrollTo(zoomed?(photo.scrollWidth-photo.clientWidth)/2:0,zoomed?(photo.scrollHeight-photo.clientHeight)/2:0); }, [zoomed]);
	return (0, A.useEffect)(() => {
		let e = c.current;
		if (!a || !e) return;
		let t = document.activeElement, n = document.body.style.overflow;
		return e.showModal(), document.body.style.overflow = "hidden", () => {
			e.open && e.close(), document.body.style.overflow = n, t?.focus();
		};
	}, [a]), l ? /* @__PURE__ */ (0, N.jsxs)("div", {
		className: "n-gallery",
		children: [
			/* @__PURE__ */ (0, N.jsxs)("button", {
				className: "n-main-image n-image-expand",
				onClick: () => o(!0),
				"aria-label": `Enlarge image ${r + 1} of ${t.length}: ${u.alt || e}`,
				children: [/* @__PURE__ */ (0, N.jsx)("img", {
					src: l,
					alt: u.alt || e
				}), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)(_e, { size: 17 }), " View larger"] })]
			}),
            u.caption && (0,N.jsx)("p",{className:"n-gallery-caption",children:u.caption}),
			t.length > 1 && /* @__PURE__ */ (0, N.jsxs)("div", {
				className: "n-thumbnail-rail",
				children: [
					/* @__PURE__ */ (0, N.jsx)("button", {
						className: "n-rail-arrow",
						"aria-label": "Previous thumbnails",
						onClick: () => s.current?.scrollBy({
							left: -240,
							behavior: "smooth"
						}),
						children: /* @__PURE__ */ (0, N.jsx)(me, {})
					}),
					/* @__PURE__ */ (0, N.jsx)("div", {
						className: "n-thumbs",
						ref: s,
						children: t.map((t, a) => /* @__PURE__ */ (0, N.jsx)("button", {
							onClick: () => i(a),
							"aria-label": `View image ${a + 1}: ${n[t]?.alt || e}`,
							"aria-pressed": r === a,
							children: /* @__PURE__ */ (0, N.jsx)("img", {
								src: t,
								alt: "",
								loading: "lazy"
							})
						}, t))
					}),
					/* @__PURE__ */ (0, N.jsx)("button", {
						className: "n-rail-arrow",
						"aria-label": "Next thumbnails",
						onClick: () => s.current?.scrollBy({
							left: 240,
							behavior: "smooth"
						}),
						children: /* @__PURE__ */ (0, N.jsx)(he, {})
					})
				]
			}),
			a && /* @__PURE__ */ (0, N.jsxs)("dialog", {
				ref: c,
				className: "n-image-dialog",
				"aria-label": `${e} image viewer`,
				onCancel: () => o(!1),
				onKeyDown: (e) => {
					t.length < 2 || (e.key === "ArrowLeft" && (e.preventDefault(), d(-1)), e.key === "ArrowRight" && (e.preventDefault(), d(1)));
				},
				onClick: (e) => {
					if (e.target === e.currentTarget) {
						let t = e.currentTarget.getBoundingClientRect();
						(e.clientX < t.left || e.clientX > t.right || e.clientY < t.top || e.clientY > t.bottom) && o(!1);
					}
				},
				children: [
					/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "n-image-dialog-top",
						children: [/* @__PURE__ */ (0, N.jsx)("p", { children: e }), /* @__PURE__ */ (0, N.jsx)("button", {
							autoFocus: !0,
							onClick: () => o(!1),
							"aria-label": "Close image viewer",
							children: /* @__PURE__ */ (0, N.jsx)(Be, {})
						})]
					}),
					/* @__PURE__ */ (0, N.jsx)("div", {
						className: "n-image-dialog-photo" + (zoomed ? " is-zoomed" : ""),
 "data-gallery-zoomed": zoomed,
						children: /* @__PURE__ */ (0, N.jsx)("img", {
							src: l,
							alt: u.alt || e
						})
					}),
					/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "n-image-dialog-bottom",
						children: [
 (0, N.jsx)("button", {className:"n-image-zoom", onClick:()=>setZoomed(!zoomed), "aria-label":zoomed?"Zoom out":"Zoom in", "aria-pressed":zoomed, children:zoomed?"−":"+"}),
							/* @__PURE__ */ (0, N.jsx)("button", {
								onClick: () => d(-1),
								disabled: t.length < 2,
								"aria-label": "Previous product image",
								children: /* @__PURE__ */ (0, N.jsx)(me, {})
							}),
							/* @__PURE__ */ (0, N.jsx)("div", {
								"aria-live": "polite",
								children: /* @__PURE__ */ (0, N.jsxs)("p", { children: [
									"Image ",
									r + 1,
									" of ",
									t.length
								] })
							}),
							/* @__PURE__ */ (0, N.jsx)("button", {
								onClick: () => d(1),
								disabled: t.length < 2,
								"aria-label": "Next product image",
								children: /* @__PURE__ */ (0, N.jsx)(he, {})
							})
						]
					})
				]
			})
		]
	}) : /* @__PURE__ */ (0, N.jsx)("div", {
		className: "n-gallery",
		children: /* @__PURE__ */ (0, N.jsx)("div", {
			className: "n-main-image",
			children: /* @__PURE__ */ (0, N.jsx)("p", { children: "Product photography being sourced" })
		})
	});
}
//#endregion
//#region components/napoleon-installation.tsx
var un = {
	cutout_w_min: "Cutout width (W), minimum",
	cutout_w_max: "Cutout width (W), maximum",
	cutout_x_min: "Front recess width (X), minimum",
	cutout_d_min: "Cutout depth (D), minimum",
	cutout_d_max: "Cutout depth (D), maximum",
	cutout_h_min: "Cutout height (H), minimum",
	cutout_width: "Cutout width",
	cutout_height: "Cutout height",
	cutout_depth: "Cutout depth",
	overall_width: "Overall width",
	overall_height: "Overall height",
	overall_depth: "Overall depth"
}, dn = (e) => un[e.replace("cutout_liner_", "cutout_")] || e.replaceAll("_", " ").replace(/\b\w/g, (e) => e.toUpperCase()).replace(/\bbtus?\b/gi, "BTU");
function fn({ sku: e, facts: t, liner: n }) {
	let r = t.filter((e) => !e.attribute.startsWith("cutout_liner_")), i = t.filter((e) => e.attribute.startsWith("cutout_liner_")), a = t.find((e) => e.scope.startsWith("Noncombustible enclosure only."))?.scope, o = (e) => /* @__PURE__ */ (0, N.jsx)("dl", {
		className: "n-specs",
		children: e.map((e, t) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("dt", { children: dn(e.attribute) }), /* @__PURE__ */ (0, N.jsxs)("dd", { children: [
			e.value,
			" ",
			e.unit
		] })] }, t))
	});
	return /* @__PURE__ */ (0, N.jsxs)("section", {
		className: "n-detail-section n-installation",
		id: "installation",
		children: [
			/* @__PURE__ */ (0, N.jsxs)("p", {
				className: "n-kicker",
				children: ["PLAN THE FIT · ", e]
			}),
			/* @__PURE__ */ (0, N.jsx)("h2", { children: "Installation dimensions" }),
			/* @__PURE__ */ (0, N.jsxs)("p", { children: ["Match each opening to the manufacturer’s drawing. ", t.some((e) => e.attribute.includes("_x_")) && "Width W and front recess X are separate measurements."] }),
			/* @__PURE__ */ (0, N.jsx)("a", {
				className: "n-text-link",
				href: t[0].document_url + "#page=" + t[0].source_page,
				target: "_blank",
				rel: "noreferrer",
				children: "View the manufacturer’s dimension drawing →"
			}),
			a && /* @__PURE__ */ (0, N.jsx)("p", {
				className: "n-installation-requirement",
				children: a
			}),
			/* @__PURE__ */ (0, N.jsxs)("div", {
				className: "n-installation-tables",
				children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: i.length ? "Standard opening · noncombustible enclosure" : r.some((e) => e.attribute.startsWith("overall_")) ? "Component opening and overall dimensions" : "Appliance opening dimensions" }), o(r)] }), i.length > 0 && /* @__PURE__ */ (0, N.jsxs)("div", { children: [
					/* @__PURE__ */ (0, N.jsx)("h3", { children: "Opening with zero-clearance liner" }),
					/* @__PURE__ */ (0, N.jsxs)("p", { children: ["Use these dimensions only with the matching liner. ", n && /* @__PURE__ */ (0, N.jsxs)(w, {
						href: n.href,
						target: "_blank",
						children: [
							n.title,
							" (",
							n.sku,
							") →"
						]
					})] }),
					o(i)
				] })]
			})
		]
	});
}
//#endregion
//#region node_modules/@base-ui/react/internals/field-constants/constants.mjs
var pn = {
	badInput: !1,
	customError: !1,
	patternMismatch: !1,
	rangeOverflow: !1,
	rangeUnderflow: !1,
	stepMismatch: !1,
	tooLong: !1,
	tooShort: !1,
	typeMismatch: !1,
	valid: null,
	valueMissing: !1
}, mn = {
	disabled: !1,
	valid: null,
	touched: !1,
	dirty: !1,
	filled: !1,
	focused: !1
}, hn = { valid(e) {
	return e === null ? null : e ? { "data-valid": "" } : { "data-invalid": "" };
} }, gn = {
	invalid: void 0,
	name: void 0,
	validityData: {
		state: pn,
		errors: [],
		error: "",
		value: "",
		initialValue: null
	},
	setValidityData: x,
	disabled: void 0,
	setTouched: x,
	setDirty: x,
	setFilled: x,
	setFocused: x,
	validationMode: "onSubmit",
	shouldValidateOnChange: () => !1,
	state: mn,
	registerFieldControl: x,
	validation: {
		getValidationProps: (e, t = p) => t,
		inputRef: { current: null },
		registeredInputs: /* @__PURE__ */ new Map(),
		registerInput: x,
		getInputControl: () => null,
		commit: async () => {},
		change: x
	}
}, _n = /* @__PURE__ */ A.createContext(gn);
function vn(e = !0) {
	let t = A.useContext(_n);
	if (t.setValidityData === x && !e) throw Error(m(28));
	return t;
}
//#endregion
//#region node_modules/@base-ui/react/internals/form-context/FormContext.mjs
var yn = /* @__PURE__ */ A.createContext({
	elementRef: { current: null },
	formRef: { current: { fields: /* @__PURE__ */ new Map() } },
	errors: {},
	clearErrors: x,
	validationMode: "onSubmit",
	submitAttemptedRef: { current: !1 }
});
function bn() {
	return A.useContext(yn);
}
//#endregion
//#region node_modules/@base-ui/react/internals/labelable-provider/LabelableContext.mjs
var xn = /* @__PURE__ */ A.createContext({
	controlId: void 0,
	registerControlId: x,
	labelId: void 0,
	setLabelId: x,
	messageIds: [],
	setMessageIds: x,
	getDescriptionProps: (e) => e
});
function Sn() {
	return A.useContext(xn);
}
//#endregion
//#region node_modules/@base-ui/react/internals/labelable-provider/useLabelableId.mjs
function Cn(e = {}) {
	let { id: t, implicit: n = !1, controlRef: r } = e, { controlId: a, registerControlId: s } = Sn(), c = at(t), l = n ? a : void 0, f = i(() => Symbol()), p = A.useRef(!1), m = A.useRef(t != null), h = u(() => {
		!p.current || s === x || (p.current = !1, s(f.current, void 0));
	});
	return d(() => {
		if (s === x) return;
		let e;
		if (n) {
			let n = r?.current;
			e = o(n) && n.closest("label") != null ? t ?? null : l ?? c;
		} else if (t != null) m.current = !0, e = t;
		else if (m.current) e = c;
		else {
			h();
			return;
		}
		if (e === void 0) {
			h();
			return;
		}
		p.current = !0, s(f.current, e);
	}, [
		t,
		r,
		l,
		s,
		n,
		c,
		f,
		h
	]), A.useEffect(() => h, [h]), a ?? c;
}
//#endregion
//#region node_modules/@base-ui/react/internals/shadowDom.mjs
function wn(e) {
	let t = e.activeElement;
	for (; t?.shadowRoot?.activeElement != null;) t = t.shadowRoot.activeElement;
	return t;
}
//#endregion
//#region node_modules/@base-ui/react/internals/field-register-control/useRegisterFieldControl.mjs
function Tn(e, t, n, r, a = !0, o) {
	let { registerFieldControl: s } = vn(), c = i(() => Symbol());
	d(() => {
		let i = c.current;
		if (!a) {
			s(i, void 0);
			return;
		}
		s(i, {
			controlRef: e,
			getValue: r,
			id: t,
			name: o,
			value: n
		});
	}, [
		e,
		a,
		r,
		t,
		o,
		s,
		c,
		n
	]), d(() => {
		let e = c.current;
		return () => {
			s(e, void 0);
		};
	}, [s, c]);
}
//#endregion
//#region node_modules/@base-ui/react/field/control/FieldControl.mjs
var En = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { render: n, className: r, id: i, name: a, value: o, disabled: s = !1, onValueChange: c, defaultValue: l, autoFocus: f = !1, style: p, ...m } = e, { state: h, name: v, disabled: y, setTouched: b, setDirty: x, validityData: S, setFocused: C, setFilled: w, validationMode: ee, validation: T } = vn(), { clearErrors: E } = bn(), D = y || s, te = v ?? a, ne = {
		...h,
		disabled: D
	}, { labelId: re } = Sn(), ie = Cn({ id: i });
	d(() => {
		let e = o != null;
		T.inputRef.current?.value || e && o !== "" ? w(!0) : e && o === "" && w(!1);
	}, [
		T.inputRef,
		w,
		o
	]);
	let ae = A.useRef(null);
	d(() => {
		f && ae.current === wn(_(ae.current)) && C(!0);
	}, [f, C]);
	let [oe] = Ve({
		controlled: o,
		default: l,
		name: "FieldControl",
		state: "value"
	}), se = o !== void 0, O = se ? oe : void 0, k = u(() => T.inputRef.current?.value);
	return Tn(T.inputRef, ie, O, k, !D, a), g("input", e, {
		ref: [t, ae],
		state: ne,
		props: [
			{
				id: ie,
				disabled: D,
				name: te,
				ref: T.inputRef,
				"aria-labelledby": re,
				autoFocus: f,
				...se ? { value: O } : { defaultValue: l },
				onChange(e) {
					let t = e.currentTarget.value;
					c?.(t, ct(ot, e.nativeEvent)), x(t !== (S.initialValue ?? "")), w(t !== ""), e.nativeEvent.defaultPrevented || (E(te), T.change(t));
				},
				onFocus() {
					C(!0);
				},
				onBlur(e) {
					b(!0), C(!1), ee === "onBlur" && T.commit(e.currentTarget.value);
				},
				onKeyDown(e) {
					e.currentTarget.tagName === "INPUT" && e.key === "Enter" && (b(!0), T.commit(e.currentTarget.value));
				}
			},
			m,
			(e) => T.getValidationProps(D, e)
		],
		stateAttributesMapping: hn
	});
}), Dn = /* @__PURE__ */ A.forwardRef(function(e, t) {
	return /* @__PURE__ */ (0, N.jsx)(En, {
		ref: t,
		...e
	});
});
//#endregion
//#region components/ui/input.tsx
function On({ className: e, type: t, ...n }) {
	return /* @__PURE__ */ (0, N.jsx)(Dn, {
		type: t,
		"data-slot": "input",
		className: a("h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", e),
		...n
	});
}
//#endregion
//#region lib/saved-state.ts
var kn = "hearth-outpost-napoleon-v1", An = (e) => Array.isArray(e) ? [...new Set(e.filter((e) => typeof e == "string" && e.length < 120))] : [];
function jn(e) {
	let t = e && typeof e == "object" ? e : {}, n = Array.isArray(t.projectBooks) ? t.projectBooks.filter((e) => e && typeof e.id == "string").map((e) => ({
		id: e.id,
		name: typeof e.name == "string" && e.name.trim() && !/^(My Outdoor Kitchen|My Outdoor Project|Outdoor Project(?: \d+)?|Outdoor Kitchen \d+)$/i.test(e.name) ? e.name : "My Outdoor Home Project",
		notes: typeof e.notes == "string" ? e.notes : "",
		items: Array.isArray(e.items) ? e.items.filter((e) => e && typeof e.sku == "string").map((e) => ({
			sku: e.sku,
			quantity: Math.max(1, Math.min(99, Math.round(Number(e.quantity) || 1))),
			note: typeof e.note == "string" ? e.note : "",
			selected: e.selected !== !1
		})) : []
	})) : [];
	n.length || n.push({
		id: "first-project",
		name: "My Outdoor Home Project",
		notes: "",
		items: (Array.isArray(t.projectBooks) ? [] : An(t.projects)).map((e) => ({
			sku: e,
			quantity: 1,
			note: "",
			selected: !0
		}))
	});
	let r = n.find((e) => e.id === t.activeProjectId) || n[0];
	return {
		projects: r.items.map((e) => e.sku),
		compare: An(t.compare).slice(0, 4),
		cart: An(t.cart),
		cartQuantities: Object.fromEntries(An(t.cart).map((e) => [e, Math.max(1, Math.min(99, Math.round(Number(t.cartQuantities?.[e]) || 1)))])),
		projectBooks: n,
		activeProjectId: r.id
	};
}
function Mn() {
	try {
		return jn(JSON.parse(localStorage.getItem("hearth-outpost-napoleon-v1") || "{}"));
	} catch {
		return jn({});
	}
}
function Nn(e) {
	try {
		return localStorage.setItem(kn, JSON.stringify(jn(e))), window.dispatchEvent(new Event("napoleon-saved")), !0;
	} catch {
		return !1;
	}
}
// Count only grill configurations that the comparison table can render.
// Old/retired keys must not consume invisible comparison slots.
const hoComparableBurners = new Set(["amg-alturi-double-side-burner-w-led-illumination", "amg-alturi-power-burner", "amg-atlas-double-side-burner", "amg-encore-double-side-burner", "amg-encore-power-burner", "amg-estate-double-side-burner-1", "amg-estate-power-burner", "amg-muscle-double-side-burner", "amg-muscle-power-burner", "aog-aog2sbl", "aog-aog2sbt", "fire-magic-aurora-built-in-power-burner", "fire-magic-drop-in-single-side-burner", "fire-magic-echelon-built-in-power-burner", "napoleon-bi10rt", "napoleon-bi12rt", "napoleon-bib10ir", "napoleon-bib10rt", "napoleon-bib12rt", "napoleon-bib18ir", "napoleon-bib18pb", "napoleon-bib18rt"]);
function hoIsComparable(product){return !!product && (product.category === "Grills" || hoComparableBurners.has(product.handle));}
function hoVisibleGrillKeys(keys) {
 const valid = new Set(b.filter(hoIsComparable).flatMap(product => product.variants.map(variant => variant.saved_key)));
 return [...new Set(keys)].filter(key => valid.has(key));
}
function Pn(e, t, n = !1) {
	return !e.includes(t) && e.length >= 4 ? null : n ? [t, ...e.filter((e) => e !== t)] : e.includes(t) ? e : [...e, t];
}
(0, A.lazy)(() => import("./napoleon-napoleon-cart-CmLxdrvy.js?v=btu-20260924-1"));
function Fn() {
	let [e, t] = (0, A.useState)(() => jn({}));
	(0, A.useEffect)(() => {
		let e = () => t(Mn());
		return e(), window.addEventListener("napoleon-saved", e), window.addEventListener("storage", e), () => {
			window.removeEventListener("napoleon-saved", e), window.removeEventListener("storage", e);
		};
	}, []);
	function n(e, t) {
		let n = Mn();
		if (e === "projects") {
			let e = n.projectBooks.find((e) => e.id === n.activeProjectId);
			e.items = e.items.some((e) => e.sku === t) ? e.items.filter((e) => e.sku !== t) : [...e.items, {
				sku: t,
				quantity: 1,
				note: "",
				selected: !0
			}];
		} else {
			let r = e === "compare" ? hoVisibleGrillKeys(n[e]) : n[e];
			if (e === "compare" && !r.includes(t) && r.length >= 4) return !1;
			n[e] = r.includes(t) ? r.filter((e) => e !== t) : [...r, t];
		}
		return Nn(n);
	}
	function r(e, t = !1) {
		let n = Mn(), r = Pn(hoVisibleGrillKeys(n.compare), e, t);
		return r ? (n.compare = r, Nn(n)) : !1;
	}
	function i(e, t = 1) {
		let n = () => {
			let n = Mn();
			return n.cart.includes(e) || n.cart.push(e), n.cartQuantities[e] = (n.cartQuantities[e] || 0) + t, Nn(n);
		};
		return window.napoleonCommerce ? window.napoleonCommerce.addItems([{
			sku: e,
			quantity: t
		}]).then((e) => e && n()).catch(() => !1) : n();
	}
	function a(e, t) {
		let n = Mn();
		return n.cart.includes(e) && (n.cartQuantities[e] = t), Nn(n);
	}
	async function o() {
		let e = Mn(), t = e.projectBooks.find((t) => t.id === e.activeProjectId).items.filter((e) => e.selected);
		if (!t.length) return !1;
		if (window.napoleonCommerce) try {
			if (!await window.napoleonCommerce.addItems(t.map(({ sku: e, quantity: t }) => ({
				sku: e,
				quantity: t
			})))) return !1;
		} catch {
			return !1;
		}
		for (let n of t) e.cart.includes(n.sku) || e.cart.push(n.sku), e.cartQuantities[n.sku] = (e.cartQuantities[n.sku] || 0) + n.quantity;
		return Nn(e);
	}
	function s(e) {
		let t = Mn();
		return t.projectBooks = t.projectBooks.map((n) => n.id === t.activeProjectId ? e(n) : n), Nn(t);
	}
	function c() {
		let e = Mn(), t = crypto.randomUUID();
		return e.projectBooks.push({
			id: t,
			name: "My Outdoor Home Project",
			notes: "",
			items: []
		}), e.activeProjectId = t, Nn(e);
	}
	function l(e) {
		let t = Mn();
		return t.activeProjectId = e, Nn(t);
	}
	function u() {
		let e = Mn();
		return e.projectBooks = e.projectBooks.filter((t) => t.id !== e.activeProjectId), Nn(e);
	}
	return {
		saved: e,
		toggle: n,
		addCompare: r,
		addCart: i,
		setCartQuantity: a,
		addProjectToCart: o,
		updateProject: s,
		createProject: c,
		selectProject: l,
		removeProject: u,
		activeProject: e.projectBooks.find((t) => t.id === e.activeProjectId)
	};
}
//#endregion
//#region components/napoleon-product.tsx
var In = (e) => new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD"
}).format(e), Ln = (e) => ({
	fuel: "Fuel type",
	installation: "Installation style",
	size: "Size",
	size_label: "Size"
})[e] || e.replaceAll("_", " ").replace(/\b\w/g, (e) => e.toUpperCase()).replace(/\bbtus?\b/gi, "BTU");
const NapoleonFireMedia = createNapoleonFireMedia(A,N);
const HopPurchase = createPurchaseComponents(A);
const hopPurchaseData = JSON.parse(document.getElementById("hop-purchase-data")?.textContent || "null");
function Rn({ product: e, initialSku: t, merchandising: n }) {
 window.HearthNapoleonVisibility.use(A);
 const aog=!!e.brand_profile, brand=e.brand||'Napoleon', brandProfile=e.brand_profile;
 const fireMediaPilot = !!document.querySelector('[data-fire-standard="sttropez"]');
	const standardPdp=JSON.parse(document.getElementById('napoleon-shopify-settings')?.textContent||'{}').standardPdp===true;
 const componentPdp=standardPdp && JSON.parse(document.getElementById('napoleon-shopify-settings')?.textContent||'{}').componentPdp===true;
 const appliancePdp=standardPdp && e.category==='Outdoor Cooking Appliances';
 const purchaseRollout = ["Napoleon","American Outdoor Grill","American Made Grills","TrueFlame","Primo Ceramic Grills","AMD"].includes(brand) && !!hopPurchaseData;
 const [hopAddedSignature,setHopAddedSignature]=A.useState('');
 const [selectedAddons,setSelectedAddons]=A.useState([]);
 const [finishingOpen,setFinishingOpen]=A.useState(true);
 const [cartFeedback, setCartFeedback] = A.useState(null), cartPending = A.useRef(false);
	let [r, i] = (0, A.useState)(null), [a, o] = (0, A.useState)(() => e.variants.some((e) => e.manufacturer_sku === t) ? t : e.variants[0].manufacturer_sku), [s, c] = (0, A.useState)(""), [l, u] = (0, A.useState)(1), [d, p] = (0, A.useState)(() => {
		if(brand==="Primo Ceramic Grills")return ["overview","fit","documents","warranty"];if(brand==="American Made Grills")return ["fit","documents"];let r = e.variants.find((e) => e.manufacturer_sku === t) || e.variants[0];
		return e.category === "Outdoor Kitchens" || e.category === "Fire & Heating" && r.feature_cards.length > 0 || n[r.manufacturer_sku].featureRows.some((e) => e.media) ? (standardPdp?["fit","documents","warranty"]:["fit"]) : (standardPdp?["overview","fit","documents","warranty"]:["overview", "fit"]);
	}), { saved: m, toggle: h, addCart: g, addCompare: _ } = Fn();
	(0, A.useEffect)(() => {
		let n = new URLSearchParams(window.location.search).get("sku") || t;
		e.variants.some((e) => e.manufacturer_sku === n) ? o(n) : o(e.variants[0].manufacturer_sku);
	}, [e, t]);
	let v = e.variants.find((e) => e.manufacturer_sku === a) || e.variants[0], y = window.HearthNapoleonVisibility.merchandising(n[v.manufacturer_sku]), b = e.category === "Grills", x = ["Accessories", "Replacement Parts"].includes(e.category), S = v.documents.length > 0, C = e.category === "Fire & Heating" && v.feature_cards.length > 0, ee = e.category === "Outdoor Kitchens", T = an(a), E = sn(a), D = v.key_facts?.length ? v.key_facts : componentPdp && v.component_facts?.length ? v.component_facts : componentPdp ? v.specs.filter(s=>['width','height','depth','net_weight'].includes(s.attribute)).sort((a,b)=>['width','height','depth','net_weight'].indexOf(a.attribute)-['width','height','depth','net_weight'].indexOf(b.attribute)) : appliancePdp ? v.specs.filter(s=>['total_btu','total_cooking_area','main_cooking_surface','width'].includes(s.attribute)).sort((a,b)=>['total_btu','total_cooking_area','main_cooking_surface','width'].indexOf(a.attribute)-['total_btu','total_cooking_area','main_cooking_surface','width'].indexOf(b.attribute)) : (standardPdp && !v.specs.some(s=>s.attribute==='total_btu') ? v.specs.filter(s=>['total_cooking_area','main_cooking_surface','cooking_grid_material','width','height'].includes(s.attribute)).sort((a,b)=>['total_cooking_area','main_cooking_surface','cooking_grid_material','width','height'].indexOf(a.attribute)-['total_cooking_area','main_cooking_surface','cooking_grid_material','width','height'].indexOf(b.attribute)) : v.specs.filter((e) => [
		"main_cooking_area",
		"main_burners",
		"total_btu", ...(standardPdp?["main_cooking_surface","total_cooking_area"]:[])
	].includes(e.attribute))).slice(0, standardPdp?4:3), te = (t, n) => tn(e.category, e.variants, t, n), ne = e.option_axes.filter((t) => new Set(e.variants.map((e) => e.options[t]).filter(Boolean)).size > 1), re = y.featureRows.filter((e) => e.media), ie = y.featureRows.filter((e) => !e.media).map(feature=>standardPdp && !feature.benefit && /warranty/i.test(feature.title) && y.warranty?.summary ? {...feature,benefit:y.warranty.summary} : feature).map(feature=>standardPdp && /^[\d,]+\s*BTU(?:'s)?$/i.test(feature.title.trim()) ? {...feature,title:feature.title.replace(/BTU(?:'s)?$/i,'BTU/h total burner input'),benefit:'The combined rated gas input of the burners fitted to this configuration. BTU/h measures energy used per hour, not cooking temperature.'} : feature);
 A.useEffect(()=>{if(aog){const input=document.querySelector('[data-aog-print-variant]');if(input)input.value=window.napoleonCommerce?.variantId?.(a)||'';}},[a]);
 const hopLines = purchaseBundle(v, l, standardPdp ? selectedAddons : [], [y.liner, ...y.recommended, ...(fireMediaPilot ? napoleonMediaCatalog : [])], fireMediaPilot ? napoleonMediaQuantity : undefined);
 const hopBenefits = purchaseRollout ? purchaseBenefitsData(hopPurchaseData,brand === "American Made Grills" && e.subcategory === "Outdoor Cooking Appliances" ? e.subcategory : e.category,e.handle,a,v.lead_time) : null;
 const productVariantsForPrice=e.variants;
 function ae(e) {
		i(null), o(e), c("");
		let t = new URL(window.location.href);
		t.searchParams.set("sku", e);
		let n = window.napoleonCommerce?.variantId?.(e);
		n && t.searchParams.set("variant", n), window.history.replaceState(window.history.state, "", t);
	}
	function oe(t, n) {
		let r = nn(e.variants, v, t, n);
		r && (r.changes.length ? (i({
			sku: r.next.manufacturer_sku,
			changes: r.changes
		}), c("")) : ae(r.next.manufacturer_sku));
	}
	A.useEffect(() => {setCartFeedback(null);setSelectedAddons([]);}, [a]);
 A.useEffect(() => setCartFeedback(null), [l,selectedAddons]);
 A.useEffect(()=>{if(standardPdp)document.dispatchEvent(new CustomEvent('hx27:napoleon-variant',{detail:{...v,sku:a,price:Math.round(v.price*100)}}));},[a]);
	async function se(e, t = 1) {
		if (cartPending.current) return;
		cartPending.current = true; setCartFeedback({ sku: e, quantity: t, state: "pending" });
		try {
			const added = purchaseRollout && e===a ? await window.napoleonCommerce.addItems(hopLines.map(({sku,quantity})=>({sku,quantity}))) : standardPdp && e===a && selectedAddons.length ? await window.napoleonCommerce.addItems([{sku:e,quantity:t},...selectedAddons.map(sku=>({sku,quantity:t*(fireMediaPilot?napoleonMediaQuantity(sku):1)})).filter(item=>item.quantity>0)]) : await g(e,t);
			setCartFeedback(added ? { sku: e, quantity: t, state: "added" } : null);
            if (purchaseRollout && added && e===a) setHopAddedSignature(JSON.stringify(hopLines.map(({sku,quantity})=>({sku,quantity}))));
			c(added ? `${t} ${t === 1 ? "item" : "items"} added to your cart.` : "This item could not be added to the cart. Please try again.");
		} catch { setCartFeedback(null); c("This item could not be added to the cart. Please try again."); }
		finally { cartPending.current = false; }
	}
	const cartState = cartFeedback?.sku === a && cartFeedback?.quantity === l ? cartFeedback.state : "";
	function O(e = !1) {
		if (!_(a, e)) {
			c("Your comparison already has four grills. Open comparison to remove one and make room.");
			return;
		}
		e && window.location.assign("/collections/all?view=compare-grills");
	}
	function k(e) {
		p((t) => t.includes(e) ? t : [...t, e]);
	}
	async function ce() {
		let e = new URL(window.location.href);
		e.searchParams.set("sku", a);
		try {
			await navigator.clipboard.writeText(e.href), c("Link copied for this exact configuration.");
		} catch {
			c("Share this configuration: " + e.href);
		}
	}
	function le(e, t = !1) {
  if(standardPdp){const checked=selectedAddons.includes(e.sku),toggle=()=>setSelectedAddons(xs=>xs.includes(e.sku)?xs.filter(sku=>sku!==e.sku):[...xs,e.sku]);return (0,N.jsxs)('article',{className:'fm-card hx27-addon'+(checked?' is-selected':''),'data-addon-sku':e.sku,onClick:event=>{if(!event.target.closest('a,input'))toggle();},children:[
   (0,N.jsx)('img',{src:e.image,alt:e.title}),
   (0,N.jsxs)('div',{className:'fm-card-body',children:[(0,N.jsx)('h3',{children:e.title}),(0,N.jsx)('strong',{children:In(e.price)}),(0,N.jsx)('p',{className:'hx27-addon-description',children:e.description}),(0,N.jsx)('a',{className:'hx27-addon-details',href:e.href,target:'_blank',rel:'noopener',children:'View Details'})]}),
   (0,N.jsx)('input',{type:'checkbox','data-hx27-addon':'','aria-label':'Add '+e.title,checked,onChange:toggle})]},e.sku);}

		return /* @__PURE__ */ (0, N.jsxs)("article", {
			className: "addon-product",
			"data-addon-sku": e.sku,
			children: [/* @__PURE__ */ (0, N.jsxs)("div", {
				className: t ? "priority-addon" : "compact-addon",
				children: [
					/* @__PURE__ */ (0, N.jsx)(w, {
						href: e.href,
						target: "_blank",
						rel: "noreferrer",
						children: /* @__PURE__ */ (0, N.jsx)("img", {
							className: "addon-thumb",
							src: e.image || void 0,
							alt: e.title
						})
					}),
					/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: e.title }), /* @__PURE__ */ (0, N.jsxs)("small", { children: [
						e.reason,
						" · ",
						e.price === null ? "Price on request" : In(e.price)
					] })] }),
					/* @__PURE__ */ (0, N.jsxs)(f, {
						variant: "outline",
						onClick: () => se(e.sku),
						"aria-label": "Add " + e.title,
						children: ["Add ", /* @__PURE__ */ (0, N.jsx)(De, { size: 14 })]
					})
				]
			}), /* @__PURE__ */ (0, N.jsxs)("details", {
				className: "nap-addon-details",
				children: [/* @__PURE__ */ (0, N.jsx)("summary", { children: "Details & fit" }), /* @__PURE__ */ (0, N.jsxs)("div", {
					className: "nap-addon-preview",
					children: [/* @__PURE__ */ (0, N.jsx)("img", {
						src: e.image || void 0,
						alt: e.title
					}), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
						/* @__PURE__ */ (0, N.jsxs)("span", {
							className: "eyebrow",
							children: [brand.toUpperCase()+" · ", e.reason]
						}),
						/* @__PURE__ */ (0, N.jsx)("h3", { children: e.title }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: e.description }),
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "mini-commerce",
							children: [/* @__PURE__ */ (0, N.jsx)("span", {
								"aria-label": "No reviews yet",
								children: "☆☆☆☆☆"
							}), /* @__PURE__ */ (0, N.jsx)("strong", { children: e.price === null ? "Price on request" : In(e.price) })]
						}),
						/* @__PURE__ */ (0, N.jsxs)(w, {
							href: e.href,
							target: "_blank",
							rel: "noreferrer",
							children: ["View product ", /* @__PURE__ */ (0, N.jsx)(ve, { size: 13 })]
						})
					] })]
				})]
			})]
		}, e.sku);
	}
	let ue = (e) => /* @__PURE__ */ (0, N.jsx)("div", {
		className: "product-grid similar-grid",
		children: e.map((e) => /* @__PURE__ */ (0, N.jsxs)("article", {
			className: "nap-related-card",
			children: [
				/* @__PURE__ */ (0, N.jsxs)(w, {
					href: e.href,
					target: "_blank",
					rel: "noreferrer",
					children: [
						/* @__PURE__ */ (0, N.jsx)("img", {
							src: e.image || void 0,
							alt: e.title,
							loading: "lazy"
						}),
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: (e.brand||brand).toUpperCase()
						}),
						/* @__PURE__ */ (0, N.jsx)("h3", { children: e.title })
					]
				}),
				/* @__PURE__ */ (0, N.jsx)("p", {
					className: "small-muted",
					children: e.sku
				}),
				/* @__PURE__ */ (0, N.jsx)("strong", { children: e.price === null ? "Price on request" : In(e.price) }),
				/* @__PURE__ */ (0, N.jsxs)(f, {
					variant: "outline",
					onClick: () => se(e.sku),
					children: ["Add to Cart ", /* @__PURE__ */ (0, N.jsx)(De, { size: 14 })]
				})
			]
		}, e.sku))
	}), j = v.key_facts?.length ? (0,N.jsxs)(N.Fragment,{children:[(0,N.jsx)("h3",{children:y.warranty.title}),(0,N.jsx)("p",{children:y.warranty.summary}),(0,N.jsxs)("a",{className:"document-link",href:y.warranty.source,target:"_blank",rel:"noreferrer",children:[(0,N.jsx)(be,{size:18}),y.warranty.sourceLabel]})]}) : /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: y.warranty?.title || v.warranty_source_text }), y.warranty ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
		/* @__PURE__ */ (0, N.jsx)("p", { children: y.warranty.summary }),
		/* @__PURE__ */ (0, N.jsx)("dl", {
			className: "spec-table warranty-table",
			children: y.warranty.rows.map((e) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("dt", { children: e.component }), /* @__PURE__ */ (0, N.jsx)("dd", { children: e.coverage })] }, e.component))
		}),
		/* @__PURE__ */ (0, N.jsx)("p", {
			className: "small-muted",
			children: "Applies to components fitted to this model. Coverage runs from the original purchase date under the written warranty."
		}),
		!y.warranty.conditionsScope && /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
			/* @__PURE__ */ (0, N.jsx)("h3", { children: "What the coverage means" }),
			/* @__PURE__ */ (0, N.jsx)("p", { children: "The warranty addresses manufacturing defects during normal private use. Proper installation, cleaning and maintenance are required. Accessories and bonus items have separate coverage." }),
			/* @__PURE__ */ (0, N.jsx)("h3", { children: "What is excluded" }),
			/* @__PURE__ */ (0, N.jsx)("p", { children: "Damage from misuse, grease fires, poor maintenance, unauthorized changes and environmental exposure is excluded. Replacement-part coverage does not include installation, labor or transportation costs." })
		] }),
		/* @__PURE__ */ (0, N.jsx)("h3", { children: "Keep these details for service" }),
		/* @__PURE__ */ (0, N.jsx)("p", { children: "Retain your receipt, model number and serial number. Contact "+brand+" or an authorized dealer with those details to start a claim." }),
		isPdpResource(y.warranty.source) && /* @__PURE__ */ (0, N.jsxs)("a", {
			className: "document-link",
			href: y.warranty.source,
			target: "_blank",
			rel: "noreferrer",
			children: [
				/* @__PURE__ */ (0, N.jsx)(be, { size: 18 }),
				/* @__PURE__ */ (0, N.jsx)("span", { children: y.warranty.sourceLabel }),
				/* @__PURE__ */ (0, N.jsx)(ve, { size: 16 })
			]
		})
	] }) : /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
		/* @__PURE__ */ (0, N.jsxs)("p", { children: [v.warranty_source_text, aog?". Coverage is subject to the manufacturer’s written conditions for the selected product.":". Coverage is subject to Napoleon’s written conditions for the selected product."] }),
		/* @__PURE__ */ (0, N.jsx)("p", { children: "Keep the purchase receipt, model number and serial number with your ownership records." }),
		v.documents.filter((e) => e.kind === "manual" && isPdpResource(e.url)).map((e) => /* @__PURE__ */ (0, N.jsxs)("a", {
			className: "document-link",
			href: e.url,
			target: "_blank",
			rel: "noreferrer",
			children: ["Read the product warranty in your manual ", /* @__PURE__ */ (0, N.jsx)(ve, { size: 16 })]
		}, e.url))
	] })] });
	return /* @__PURE__ */ (0, N.jsxs)("main", {
		id: "content",
		className: "napoleon-pdp-template"+(standardPdp?" hx27-napoleon":"")+(componentPdp?" nap-component-pdp":""),
 "data-product-handle":e.handle,
 "data-selected-variant":standardPdp?JSON.stringify({...v,sku:a,price:Math.round(v.price*100)}):undefined,
		children: [/* @__PURE__ */ (0, N.jsxs)("div", {
			className: "container",
			children: [
				/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "breadcrumb",
					children: [
						/* @__PURE__ */ (0, N.jsx)(w, {
							href: aog?brandProfile.shop_url:"/",
							children: brand
						}),
						/* @__PURE__ */ (0, N.jsx)("span", { children: "/" }),
						/* @__PURE__ */ (0, N.jsx)("a", {
							href: aog?brandProfile.shop_url:"/?category=" + encodeURIComponent(e.category === "Unresolved assortment" ? "All" : e.category) + "#collection",
							children: e.category === "Unresolved assortment" ? "All Napoleon" : e.category
						}),
						/* @__PURE__ */ (0, N.jsx)("span", { children: "/" }),
						/* @__PURE__ */ (0, N.jsx)("span", { children: a })
					]
				}),
				/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "pdp-top",
					children: [/* @__PURE__ */ (0, N.jsxs)("section", {
						className: "gallery",
						"aria-label": "Product photographs",
						children: [/* @__PURE__ */ (0, N.jsx)(ln, {
							title: e.title,
							images: y.gallery,
							details: v.gallery_metadata
						}, a), /* @__PURE__ */ (0, N.jsxs)("a", {
							className: "fit-link",
							href: "#details",
							onClick: () => k("fit"),
							children: [
								/* @__PURE__ */ (0, N.jsx)(be, { size: 18 }),
								/* @__PURE__ */ (0, N.jsxs)("span", { children: [x ? "Checking size or compatibility?" : "Planning an installation?", /* @__PURE__ */ (0, N.jsx)("strong", { children: x ? "See product details" : "See dimensions & documents" })] }),
								/* @__PURE__ */ (0, N.jsx)(M, { size: 18 })
							]
						})]
					}), /* @__PURE__ */ (0, N.jsxs)("section", {
						className: "buy-panel",
						children: [
							/* @__PURE__ */ (0, N.jsx)(w, {
								href: aog?brandProfile.shop_url:"/",
								className: "eyebrow brand-eyebrow",
								children: (e.brand||brand).toUpperCase()
							}),
							/* @__PURE__ */ (0, N.jsx)("h1", { children: e.title }),
							!aog && /* @__PURE__ */ (0, N.jsxs)("a", {
								href: "#customer-reviews",
								className: "rating",
								children: [/* @__PURE__ */ (0, N.jsx)("span", {
									"aria-hidden": "true",
									children: "☆☆☆☆☆"
								}), /* @__PURE__ */ (0, N.jsx)("small", { children: "No reviews yet" })]
							}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "price-block",
								"aria-live": "polite",
								children: [/* @__PURE__ */ (0, N.jsx)("strong", {
									className: "n-price",
									children: v.price === null ? "Price on request" : In(v.price)
								}), v.msrp_usd !== null && v.price !== null && v.msrp_usd > v.price && /* @__PURE__ */ (0, N.jsxs)("span", {
									className: "nap-msrp",
									children: [!purchaseRollout && (0, N.jsx)("span", { children: "MSRP" }), (0, N.jsx)("del", { children: In(v.msrp_usd) })]
								}), purchaseRollout && (0,N.jsx)(HopPurchase.PriceExtras,{data:hopBenefits,variantId:hopPurchaseData.variants[a]?.id,unitPriceCents:hopPurchaseData.variants[a]?.price})]
							}),
							purchaseRollout && (0,N.jsx)(HopPurchase.Benefits,{data:hopBenefits,warranty:!!v.warranty_source_text,openWarranty:()=>k('warranty'),icons:purchaseIcons()}),
                           brand==="American Made Grills" && (0,N.jsx)("div",{className:"amg-rating-reserve","aria-hidden":"true"}),/* @__PURE__ */ (0, N.jsx)("p", {
								className: "summary",
								children: v.description
							}),
							!fireMediaPilot && /* @__PURE__ */ (0, N.jsx)("div", {
								className: "inline-facts",
								children: D.map((e) => /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsxs)("strong", { children: [
									/^\d+(?:\.\d+)?$/.test(String(e.value)) ? Number(e.value).toLocaleString("en-US") : e.value,
									" ",
									e.unit === "count" ? "" : e.unit
								] }), /* @__PURE__ */ (0, N.jsx)("small", { children: e.label || Ln(e.attribute) })] }, e.attribute))
							}),
							/* @__PURE__ */ (0, N.jsx)("div", {
								className: "configuration",
								children: ne.map((t, n) => /* @__PURE__ */ (0, N.jsxs)("fieldset", { children: [/* @__PURE__ */ (0, N.jsxs)("legend", { children: [
									n + 1,
									". ",
									Ln(t)
								] }), /* @__PURE__ */ (0, N.jsx)("div", {
									className: "option-buttons " + (t === "installation" ? "installation-options" : t.includes("size") ? "size-options" : ""),
									children: [...new Set(e.variants.map((e) => e.options[t]).filter(Boolean))].sort((x,z)=>standardPdp?Math.min(...e.variants.filter(q=>q.options[t]===x).map(q=>q.price))-Math.min(...e.variants.filter(q=>q.options[t]===z).map(q=>q.price)):0).map((optionValue) => /* @__PURE__ */ (0, N.jsxs)(f, {
										variant: "outline",
										"aria-pressed": v.options[t] === optionValue,
										className: v.options[t] === optionValue ? "selected" : "",
										onClick: () => oe(t, optionValue),
										children: [standardPdp && t==='connectivity' ? ({Standard:'No Connectivity',Connected:'WiFi & Bluetooth'}[optionValue] || te(t,optionValue)) : te(t, optionValue), standardPdp && t!=='fuel' && (()=>{const match=productVariantsForPrice.find(q=>q.options[t]===optionValue&&Object.keys(v.options).every(axis=>axis===t||q.options[axis]===v.options[axis]));const delta=match?.price-v.price;return delta?(0,N.jsx)('small',{className:'hx27-option-price',children:(delta>0?' +':' −')+In(Math.abs(delta))}):null;})(), v.options[t] === optionValue && /* @__PURE__ */ (0, N.jsx)(fe, { size: 15 })]
									}, optionValue))
								})] }, t))
							}),
							r && /* @__PURE__ */ (0, N.jsxs)("div", {
								className: "n-configuration-change",
								role: "status",
								children: [
									/* @__PURE__ */ (0, N.jsx)("strong", { children: "This option changes the configuration." }),
									/* @__PURE__ */ (0, N.jsx)("ul", { children: r.changes.map((e) => /* @__PURE__ */ (0, N.jsxs)("li", { children: [
										Ln(e.axis),
										": ",
										te(e.axis, e.from),
										" → ",
										te(e.axis, e.to)
									] }, e.axis)) }),
									/* @__PURE__ */ (0, N.jsxs)("p", { children: ["Model ", r.sku] }),
									/* @__PURE__ */ (0, N.jsx)(f, {
										onClick: () => ae(r.sku),
										children: "Apply configuration"
									}),
									/* @__PURE__ */ (0, N.jsx)(f, {
										variant: "ghost",
										onClick: () => i(null),
										children: "Keep current selection"
									})
								]
							}),
							/* @__PURE__ */ (0, N.jsxs)("p", {
								className: "model n-sku",
								"aria-live": "polite",
								children: [a.startsWith("HO-PRIMO-SHOP-")?"SKU ":"Model ", /* @__PURE__ */ (0, N.jsx)("strong", { children: a })]
							}),
fireMediaPilot && document.querySelector('[data-product-handle="napoleon-st-tropez-square-patioflame-table"]') && (0,N.jsx)(NapoleonFireMedia,{parent:a,extras:selectedAddons,onChange:setSelectedAddons,number:2,lookup:()=>null}),
standardPdp && (y.liner || y.recommended.length>0) && (0,N.jsxs)('details',{className:'hx27-finishing',open:finishingOpen,onToggle:event=>setFinishingOpen(event.currentTarget.open),children:[(0,N.jsx)('summary',{children:'Finishing touches'}),(0,N.jsxs)('div',{className:'fm-product-grid',children:[y.liner&&le(y.liner,true),y.recommended.map(item=>le(item))]})]}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "purchase-row",
								children: [/* @__PURE__ */ (0, N.jsxs)("div", {
									className: "quantity",
									children: [
										/* @__PURE__ */ (0, N.jsx)(f, {
											variant: "ghost",
											"aria-label": "Decrease quantity",
											disabled: l <= 1,
											onClick: () => u((e) => Math.max(1, e - 1)),
											children: /* @__PURE__ */ (0, N.jsx)(we, { size: 16 })
										}),
										/* @__PURE__ */ (0, N.jsx)("input", {
											"aria-label": "Quantity",
											type: "number",
											min: 1,
											max: 99,
											value: l,
											onChange: (e) => u(Math.max(1, Math.min(99, Math.round(Number(e.target.value) || 1))))
										}),
										/* @__PURE__ */ (0, N.jsx)(f, {
											variant: "ghost",
											"aria-label": "Increase quantity",
											disabled: l >= 99,
											onClick: () => u((e) => Math.min(99, e + 1)),
											children: /* @__PURE__ */ (0, N.jsx)(De, { size: 16 })
										})
									]
								}), /* @__PURE__ */ (0, N.jsxs)(f, {
									className: "commerce-button"+(standardPdp&&cartState==='added'?' hx27-added':''),
									onClick: () => se(a, l),
 disabled: cartFeedback?.state === "pending" || cartState === "added" || (purchaseRollout && (v.available === false || v.price === null)),
 "aria-busy": cartState === "pending",
 "aria-live": "polite",
 children: cartState === "added" ? ["Added ", (0, N.jsx)(fe, { size: 18 })] : cartState === "pending" ? "Adding…" : ["Add to Cart ", (0, N.jsx)(M, { size: 18 })]
								})]
							}),
standardPdp && brand!=="AMD" && (0,N.jsxs)('div',{className:'hx27-secondary-actions',children:[(0,N.jsx)(f,{variant:'outline',className:'fm-outline',onClick:()=>{m.projects.includes(a)||h('projects',a);},children:m.projects.includes(a)?'Saved':'Create My Outdoor Project'}),b&&(0,N.jsx)(f,{variant:'outline',className:'fm-outline',onClick:()=>O(),children:m.compare.includes(a)?'Added to Comparison':'Add to Grill Comparison'})]}),
							/* @__PURE__ */ (0, N.jsxs)("p", {
								className: "small-muted nap-fulfillment",
								children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: aog?"Delivery timing confirmed with order":"Ships within 24 hours" }), ""]
							}),
							!standardPdp && b && /* @__PURE__ */ (0, N.jsxs)(f, {
								variant: "outline",
								className: "add-to-compare-button",
								onClick: () => O(),
								children: [/* @__PURE__ */ (0, N.jsx)(Ce, {}), m.compare.includes(a) ? "Saved to Comparison" : "Add selected grill to Comparison"]
							}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "conversion-grid",
								children: [
									/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)(Pe, {}), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: "Free Shipping" }), /* @__PURE__ */ (0, N.jsx)("small", { children: "On qualifying orders" })] })] }),
									/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)(Ae, {}), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: "Hassle-Free Returns" }), /* @__PURE__ */ (0, N.jsx)("small", { children: "On eligible unused purchases" })] })] }),
									v.warranty_source_text && /* @__PURE__ */ (0, N.jsxs)("a", {
										href: fireMediaPilot ? "#fire-warranty" : standardPdp ? "#pdp-warranty" : "#details",
										onClick: () => k("warranty"),
										children: [/* @__PURE__ */ (0, N.jsx)(Ne, {}), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: y.warranty?.title || v.warranty_source_text }), /* @__PURE__ */ (0, N.jsx)("small", { children: "See component coverage & conditions" })] })]
									}),
									S && /* @__PURE__ */ (0, N.jsxs)("a", {
										href: "#details",
										onClick: () => k("documents"),
										children: [/* @__PURE__ */ (0, N.jsx)(be, {}), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: "Product guides & manuals" }), /* @__PURE__ */ (0, N.jsx)("small", { children: "For your selected configuration" })] })]
									})
								]
							}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "pdp-action-tools",
								children: [/* @__PURE__ */ (0, N.jsx)("div", {
									className: "planning-actions single",
									children: /* @__PURE__ */ (0, N.jsxs)(f, {
										variant: "outline",
                                        "data-project-open":aog&&brand!=="Primo Ceramic Grills"?'':undefined,
                                        "data-project-item":aog?JSON.stringify({id:window.napoleonCommerce.variantId(a),sku:a,title:e.title,brand,price:Math.round(v.price*100),quantity:l,href:(()=>{const u=new URL(location.href);u.searchParams.set('variant',window.napoleonCommerce.variantId(a));if(window.Shopify?.theme?.role!=='main'&&window.Shopify?.theme?.id)u.searchParams.set('preview_theme_id',window.Shopify.theme.id);return u.href;})(),image:v.image,configuration:v.options?.fuel||v.title}):undefined,
										onClick: () => {
											if(brand==='Primo Ceramic Grills'){
 if(m.projects.includes(a)){const projectUrl=new URL('/collections/projects',location.origin);if(window.Shopify?.theme?.role!=='main')projectUrl.searchParams.set('preview_theme_id',window.Shopify.theme.id);window.open(projectUrl.href,'_blank','noopener');return;}
 const state=Mn(),book=state.projectBooks.find(book=>book.id===state.activeProjectId);book.items=[...book.items.filter(item=>item.sku!==a),{sku:a,quantity:l,note:'',selected:true}];Nn(state);
 }else if(!aog){m.projects.includes(a) || h('projects',a),window.location.assign('/pages/napoleon-projects');}

										},
										children: [/* @__PURE__ */ (0, N.jsx)(xe, {}), m.projects.includes(a) ? (brand==="Primo Ceramic Grills"?"View My Outdoor Project":"Open My Outdoor Project") : "Add to Outdoor Project"]
									})
								}), /* @__PURE__ */ (0, N.jsxs)("div", {
									className: "utility-actions",
									children: [/* @__PURE__ */ (0, N.jsxs)(f, {
										variant: "ghost",
										onClick: ce,
										children: [/* @__PURE__ */ (0, N.jsx)(Me, {}), "Share"]
									}), /* @__PURE__ */ (0, N.jsxs)(f, {
										variant: "ghost",
										onClick: event => window.HearthOutpostDocuments.print(event),
										children: [/* @__PURE__ */ (0, N.jsx)(Oe, {}), "Print"]
									})]
								})]
							}),
							/* @__PURE__ */ (0, N.jsxs)("p", {
								className: "n-notice",
								role: "status",
								children: [s, s.includes("four grills") && /* @__PURE__ */ (0, N.jsx)(w, {
									href: "/compare/grills",
									children: " Open comparison →"
								})]
							}),
							!standardPdp && (y.liner || y.recommended.length > 0) && /* @__PURE__ */ (0, N.jsxs)("aside", {
								className: "purchase-addons",
								"aria-labelledby": "recommended-addons",
								children: [
									/* @__PURE__ */ (0, N.jsxs)("div", {
										className: "addons-heading",
										children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
											className: "eyebrow",
											children: "COMPLETE YOUR SETUP"
										}), /* @__PURE__ */ (0, N.jsxs)("h2", {
											id: "recommended-addons",
											children: ["Recommended ", b ? "with your grill" : "add-ons"]
										})] }), /* @__PURE__ */ (0, N.jsx)("span", { children: "Quick add" })]
									}),
									y.liner && le(y.liner, !0),
									y.recommended.map((e) => le(e))
								]
							})
						]
					})]
				}),
				b && /* @__PURE__ */ (0, N.jsxs)("button", {
					type: "button",
					className: "pdp-compare-entry",
					onClick: () => O(!0),
					children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [
						/* @__PURE__ */ (0, N.jsx)("span", {
							className: "eyebrow",
							children: "FIND THE RIGHT FIT"
						}),
						/* @__PURE__ */ (0, N.jsx)("strong", { children: "Compare grills side by side." }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: "See price, size, cooking equipment, controls, installation needs and warranty in one place." })
					] }), /* @__PURE__ */ (0, N.jsxs)("span", {
						className: "pdp-compare-cta",
						children: ["Open Grill Comparison ", /* @__PURE__ */ (0, N.jsx)(M, { size: 16 })]
					})]
				}),
				/* @__PURE__ */ (0, N.jsxs)("section", {
					className: "brand-category-rail",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
						className: "eyebrow",
						children: "EXPLORE "+brand.toUpperCase()
					}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "Build the whole outdoor kitchen." })] }), /* @__PURE__ */ (0, N.jsx)("div", {
						className: "brand-category-links",
						children: y.categories.map((e) => /* @__PURE__ */ (0, N.jsxs)(w, {
							href: e.href,
							children: [/* @__PURE__ */ (0, N.jsx)("img", {
								src: e.image || void 0,
								alt: ""
							}), /* @__PURE__ */ (0, N.jsx)("span", { children: e.title })]
						}, e.title))
					})]
				}),
				(brand==="American Made Grills"?(re.length>0||ie.length>0||v.detail_description):(re.length > 0 || ee || C || (componentPdp && ie.length > 0))) && /* @__PURE__ */ (0, N.jsxs)("section", {
					id: "features",
					className: "story-section nap-balanced-features" + (ee ? " nap-kitchen-features" : ""),
					children: [
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "nap-feature-intro",
							children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [
								/* @__PURE__ */ (0, N.jsx)("p", {
									className: "eyebrow",
									children: v.manufacturer_series || e.subcategory
								}),
								/* @__PURE__ */ (0, N.jsx)("h2", { children: brand==="AMD" ? v.feature_heading : ee ? "An outdoor kitchen, thoughtfully brought together." : v.feature_heading }),
								!componentPdp && (brand!=="American Made Grills"||v.detail_description) && (0,N.jsx)("p",{children:brand==="American Made Grills"?v.detail_description:v.description}),
                                componentPdp && (0,N.jsx)("ul",{className:"included-list",children:[...ie,...re].filter((feature,index,features)=>features.findIndex(candidate=>candidate.title===feature.title && candidate.benefit===feature.benefit)===index).slice(0,6).map((feature,index)=>(0,N.jsxs)("li",{children:[(0,N.jsx)(fe,{size:17}),(0,N.jsxs)("span",{children:[feature.title,feature.benefit && (0,N.jsxs)(N.Fragment,{children:[" — ",feature.benefit]})]})]},index))})
							] }), (y.lifestyle || brand!=="American Made Grills" && (ee || C) && v.image) && /* @__PURE__ */ (0, N.jsx)("figure", {
								className: "pdp-lifestyle",
								children: [/* @__PURE__ */ (0, N.jsx)("img", {
									src: y.lifestyle || v.image || void 0,
									alt: y.lifestyle ? y.lifestyleAlt : e.title,
									loading: "lazy"
								}), y.lifestyleCaption && (0,N.jsx)("figcaption",{children:y.lifestyleCaption})]
							})]
						}),
						/* @__PURE__ */ (0, N.jsx)("div", {
							className: "feature-list nap-illustrated-features" + (ee ? " nap-kitchen-feature-grid" : ""),
							children: (componentPdp?[]:re).map((e, t) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [e.media && /* @__PURE__ */ (0, N.jsx)("img", {
								src: e.media.image,
								style: aog && e.media.fit === "contain" ? {objectFit:"contain"} : void 0,
								alt: e.media.alt,
								loading: "lazy"
							}), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
								/* @__PURE__ */ (0, N.jsx)("span", {
									className: "feature-number",
									children: String(t + 1).padStart(2, "0")
								}),
								/* @__PURE__ */ (0, N.jsx)("h3", { children: e.title }),
								e.benefit && /* @__PURE__ */ (0, N.jsx)("p", { children: e.benefit })
							] })] }, t))
						}),
						(componentPdp?[...ie,...re].filter((feature,index,features)=>features.findIndex(candidate=>candidate.title===feature.title && candidate.benefit===feature.benefit)===index).length>6:ie.length>0) && /* @__PURE__ */ (0, N.jsx)("div", {
							className: "nap-feature-benefits",
							children: (componentPdp?[...ie,...re].filter((feature,index,features)=>features.findIndex(candidate=>candidate.title===feature.title && candidate.benefit===feature.benefit)===index).slice(6):ie).map((e, t) => /* @__PURE__ */ (0, N.jsxs)("article", { children: [/* @__PURE__ */ (0, N.jsx)(fe, { size: 17 }), /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: e.title }), e.benefit && /* @__PURE__ */ (0, N.jsx)("p", { children: e.benefit })] })] }, t))
						})
					]
				}),
				brand!=="AMD" && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "product-video brand-video nap-brand-story",
					id: "brand-story",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [
						/* @__PURE__ */ (0, N.jsx)("img", {
							className: "brand-video-logo",
                            style: brand==="Primo Ceramic Grills"?{filter:"brightness(0) invert(1)"}:undefined,
							src: aog?brandProfile.logo:"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-ec5596025277.png?v=1788860781",
							alt: brand
						}),
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: aog?brandProfile.eyebrow:"THE NAPOLEON STORY"
						}),
						/* @__PURE__ */ (brand==="Primo Ceramic Grills"?null:(0, N.jsx)("h2", { children: aog?brandProfile.headline:"Bring more life outdoors." })),
						/* @__PURE__ */ (0, N.jsx)("p", { children: aog?brandProfile.description:"From the cooking surface to the space around it, Napoleon brings grills, kitchen cabinetry, outdoor heating and accessories into one outdoor-living collection." }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: aog?null:"Its approach pairs practical cooking technology with the details that make a space welcoming: room to prepare, places to gather and warmth that carries the evening on." }),
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "brand-video-points",
							children: [
								/* @__PURE__ */ (0, N.jsx)("span", { children: aog?brandProfile.proof[0]:"Grills for different ways of cooking" }),
								/* @__PURE__ */ (0, N.jsx)("span", { children: aog?brandProfile.proof[1]:"Coordinated kitchen components" }),
								/* @__PURE__ */ (0, N.jsx)("span", { children: aog?brandProfile.proof[2]:"Comfort beyond the cooking space" })
							]
						}),
						!standardPdp && /* @__PURE__ */ (0, N.jsxs)(w, {
							className: "text-link",
							href: aog?brandProfile.shop_url:"/",
							children: ["Explore "+brand+" by Hearth Outpost ", /* @__PURE__ */ (0, N.jsx)(M, { size: 16 })]
						})
					] }), /* @__PURE__ */ (0, N.jsx)("div", {
						className: "nap-story-film",
						children: (0,N.jsxs)(N.Fragment,{children:[(aog&&!brandProfile.video?null:(0,N.jsx)(cn,{video:aog?brandProfile.video:T||rn},T?.youtubeId||rn.youtubeId)),standardPdp&&(0,N.jsx)('div',{className:'hx27-brand-shop-action',children:(0,N.jsx)('a',{className:'fm-outline',href:aog?brandProfile.shop_url:'/collections/napoleon',target:'_blank',rel:'noopener',children:'Visit the '+brand+' Shop by Hearth Outpost'})})]})
					})]
				}),
				/* @__PURE__ */ (0, N.jsxs)("section", {
					id: "details",
					className: "details-section",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "details-intro",
						children: [
							/* @__PURE__ */ (0, N.jsx)("p", {
								className: "eyebrow",
								children: "THE DETAILS THAT MATTER"
							}),
							/* @__PURE__ */ (0, N.jsx)("h2", { children: x ? "Know exactly what fits." : "Plan with confidence." }),
							/* @__PURE__ */ (0, N.jsx)("p", { children: x || componentPdp ? "Review size, compatibility, included components and ownership information." : C ? "Review the dimensions, fuel supply and installation requirements for your selected fire feature." : "Review the exact dimensions, cooking equipment and installation requirements for your selected model." })
						]
					}), /* @__PURE__ */ (0, N.jsxs)(Zt, {
						className: "product-accordion",
						value: d,
						onValueChange: p,
						multiple: !0,
						children: [
							brand!=="American Made Grills" && /* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "overview",
								children: [/* @__PURE__ */ (0, N.jsx)($t, { children: "Product overview" }), /* @__PURE__ */ (0, N.jsx)(en, { children: /* @__PURE__ */ (0, N.jsxs)("div", {
									className: "rich-product-description",
									children: [/* @__PURE__ */ (0, N.jsx)("p", { children: v.description }), /* @__PURE__ */ (0, N.jsx)("ul", { children: ie.map((e, t) => /* @__PURE__ */ (0, N.jsxs)("li", { children: [/* @__PURE__ */ (0, N.jsx)(fe, { size: 15 }), /* @__PURE__ */ (0, N.jsxs)("span", { children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: e.title }), e.benefit && /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [" — ", e.benefit] })] })] }, t)) })]
								}) })]
							}),
							/* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "fit",
								children: [/* @__PURE__ */ (0, N.jsx)($t, { children: x ? "Size & compatibility" : "Dimensions & installation" }), /* @__PURE__ */ (0, N.jsxs)(en, { children: [
									/* @__PURE__ */ (0, N.jsxs)("dl", {
										className: "spec-table",
										children: [
											/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("dt", { children: a.startsWith("HO-PRIMO-SHOP-")?"SKU":"Model number" }), /* @__PURE__ */ (0, N.jsx)("dd", { children: a })] }),
											Object.entries(v.options).map(([e, t]) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("dt", { children: Ln(e) }), /* @__PURE__ */ (0, N.jsx)("dd", { children: te(e, t) })] }, e)),
											v.specs.filter(s=>brand!=="American Made Grills"||!(["model","model_number","sku"].includes(s.attribute.toLowerCase())||s.attribute==="fuel"&&v.options.fuel)).map((e, t) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("dt", { children: brand==="American Made Grills"?(e.label||Ln(e.attribute)):Ln(e.attribute) }), /* @__PURE__ */ (0, N.jsxs)("dd", { children: [
												e.value,
												" ",
												e.unit
											] })] }, t))
										]
									}),
									componentPdp && v.component_installation?.length > 0 && (0,N.jsx)("ul",{className:"included-list",children:v.component_installation.map(text=>(0,N.jsx)("li",{children:text},text))}),
                                    v.installation_facts.length > 0 && /* @__PURE__ */ (0, N.jsx)(fn, {
										sku: a,
										facts: v.installation_facts,
										liner: v.installation_liner
									}),
									E && /* @__PURE__ */ (0, N.jsxs)("div", {
										className: "nap-assembly-film",
										children: [E.demonstration && /* @__PURE__ */ (0, N.jsxs)("div", {
											className: "nap-assembly-intro",
											children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "A little assembly. A lot to look forward to." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Get familiar with the process in this grill assembly demonstration. The video may not show your exact model, and your grill’s size, finish and assembly steps may differ. Follow the manual supplied with your grill for model-specific instructions and gas connections." })]
										}), /* @__PURE__ */ (0, N.jsx)(cn, { video: E }, E.youtubeId)]
									})
								] })]
							}),
							v.included_source_facts.length > 0 && /* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "included",
								children: [/* @__PURE__ */ (0, N.jsx)($t, { children: "What’s included" }), /* @__PURE__ */ (0, N.jsx)(en, { children: /* @__PURE__ */ (0, N.jsx)("ul", {
									className: "included-list",
									children: v.included_source_facts.map((e) => /* @__PURE__ */ (0, N.jsxs)("li", { children: [/* @__PURE__ */ (0, N.jsx)(fe, { size: 15 }), e] }, e))
								}) })]
							}),
							S && /* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "documents",
								children: [/* @__PURE__ */ (0, N.jsxs)($t, { children: ["Manuals & documents ", /* @__PURE__ */ (0, N.jsx)("span", {
									className: "doc-count",
									children: v.documents.length || ""
								})] }), /* @__PURE__ */ (0, N.jsx)(en, { children: v.documents.filter((e)=>isPdpResource(e.url)).map((e) => /* @__PURE__ */ (0, N.jsxs)("a", {
									className: "document-link",
									href: e.url,
									target: "_blank",
									rel: "noreferrer",
									children: [
										/* @__PURE__ */ (0, N.jsx)(be, { size: 18 }),
										/* @__PURE__ */ (0, N.jsxs)("span", { children: [e.label, e.note && /* @__PURE__ */ (0, N.jsx)("small", { children: e.note })] }),
										/* @__PURE__ */ (0, N.jsx)(ge, { size: 16 })
									]
								}, e.url)) })]
							}),
							!fireMediaPilot && v.warranty_source_text && /* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "warranty",
                                id: (purchaseRollout||appliancePdp||componentPdp||v.key_facts?.length)?"pdp-warranty":undefined,
								children: [/* @__PURE__ */ (0, N.jsx)($t, { children: "Manufacturer warranty & support" }), /* @__PURE__ */ (0, N.jsx)(en, { children: j })]
							}),
							v.faqs.length > 0 && /* @__PURE__ */ (0, N.jsxs)(Qt, {
								value: "questions",
								children: [/* @__PURE__ */ (0, N.jsx)($t, { children: "Common questions" }), /* @__PURE__ */ (0, N.jsx)(en, { children: v.faqs.map((e) => /* @__PURE__ */ (0, N.jsxs)("div", {
									className: "faq",
									children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: e.question }), /* @__PURE__ */ (0, N.jsx)("p", { children: e.answer })]
								}, e.question)) })]
							})
						]
					})]
				}),
				b && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "ownership-section",
					children: [
						/* @__PURE__ */ (0, N.jsx)("div", {
							className: "section-heading",
							children: /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
								className: "eyebrow",
								children: "OWN IT FOR THE LONG RUN"
							}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "Care, service and support." })] })
						}),
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "ownership-grid",
							children: [
								/* @__PURE__ */ (0, N.jsxs)("article", { children: [
									/* @__PURE__ */ (0, N.jsx)(ze, {}),
									/* @__PURE__ */ (0, N.jsx)("h3", { children: "Care for your cooking system" }),
									/* @__PURE__ */ (0, N.jsx)("p", { children: "Use the cleaning and maintenance instructions for your cooking grids, burners and grease collection system." }),
									/* @__PURE__ */ (0, N.jsxs)("a", {
										href: "#details",
										onClick: () => k("documents"),
										children: ["Open your care guide ", /* @__PURE__ */ (0, N.jsx)(M, { size: 14 })]
									})
								] }),
								/* @__PURE__ */ (0, N.jsxs)("article", { children: [
									/* @__PURE__ */ (0, N.jsx)(Ne, {}),
									/* @__PURE__ */ (0, N.jsx)("h3", { children: "Understand your coverage" }),
									/* @__PURE__ */ (0, N.jsx)("p", { children: y.warranty?.summary || v.warranty_source_text }),
									/* @__PURE__ */ (0, N.jsxs)("a", {
										href: "#details",
										onClick: () => k("warranty"),
										children: ["Read the component terms ", /* @__PURE__ */ (0, N.jsx)(M, { size: 14 })]
									})
								] }),
								/* @__PURE__ */ (0, N.jsxs)("article", { children: [
									/* @__PURE__ */ (0, N.jsx)(xe, {}),
									/* @__PURE__ */ (0, N.jsx)("h3", { children: "Keep your model close" }),
									/* @__PURE__ */ (0, N.jsxs)("p", { children: [
										"Save model ",
										a,
										" with your outdoor project. Keep your serial number and receipt for parts and service."
									] }),
									/* @__PURE__ */ (0, N.jsxs)(w, {
										href: "/projects",
										children: ["Open your project ", /* @__PURE__ */ (0, N.jsx)(M, { size: 14 })]
									})
								] }),
								/* @__PURE__ */ (0, N.jsxs)("article", { children: [
									/* @__PURE__ */ (0, N.jsx)(ge, {}),
									/* @__PURE__ */ (0, N.jsx)("h3", { children: "Your documents" }),
									v.documents.filter((e) => e.kind === "manual" && isPdpResource(e.url)).map((e) => /* @__PURE__ */ (0, N.jsxs)("a", {
										href: e.url,
										target: "_blank",
										rel: "noreferrer",
										children: [e.label, /* @__PURE__ */ (0, N.jsx)(ve, { size: 14 })]
									}, e.url))
								] })
							]
						}),
						y.warranty && /* @__PURE__ */ (0, N.jsxs)("div", {
							className: "ownership-warranty",
							children: [/* @__PURE__ */ (0, N.jsx)("strong", { children: brand+" warranty at a glance" }), /* @__PURE__ */ (0, N.jsxs)("p", { children: [
								y.warranty.summary,
								" ",
								/* @__PURE__ */ (0, N.jsx)("a", {
									href: "#details",
									onClick: () => k("warranty"),
									children: "View coverage by component →"
								})
							] })]
						})
					]
				}),
				y.similar.length > 0 && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "similar-section",
					children: [
						/* @__PURE__ */ (0, N.jsx)("div", {
							className: "section-heading",
							children: /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
								className: "eyebrow",
								children: "COMPARE CLOSE ALTERNATIVES"
							}), /* @__PURE__ */ (0, N.jsx)("h2", { children: brand==="TrueFlame"?"Similar TrueFlame products.":["American Made Grills","AMD"].includes(brand)?"Similar Items":"Similar Napoleon grills." })] })
						}),
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "small-muted",
							children: brand==="TrueFlame"?"Explore other products in this category. Check the exact dimensions and model compatibility.":["American Made Grills","AMD"].includes(brand)?"Explore related products for your outdoor kitchen.":"Compare grills with the same fuel and installation style, and similar primary cooking capacity."
						}),
						ue(y.similar)
					]
				}),
				!aog && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "customer-reviews",
					id: "customer-reviews",
					"data-review-widget-slot": "product",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "reviews-heading",
						children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: "CUSTOMER REVIEWS"
						}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "What owners are saying." })] }), /* @__PURE__ */ (0, N.jsx)("span", {
							className: "reviews-status",
							children: "Review collection opens at launch"
						})]
					}), /* @__PURE__ */ (0, N.jsxs)("div", {
						className: "reviews-shell",
						children: [
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "reviews-summary",
								children: [
									/* @__PURE__ */ (0, N.jsx)("strong", { children: "—" }),
									/* @__PURE__ */ (0, N.jsx)("span", {
										className: "review-stars",
										"aria-label": "No reviews yet",
										children: "☆☆☆☆☆"
									}),
									/* @__PURE__ */ (0, N.jsx)("p", { children: "No customer reviews yet" })
								]
							}),
							/* @__PURE__ */ (0, N.jsx)("div", {
								className: "review-distribution",
								"aria-label": "No ratings collected",
								children: [
									5,
									4,
									3,
									2,
									1
								].map((e) => /* @__PURE__ */ (0, N.jsxs)("div", { children: [
									/* @__PURE__ */ (0, N.jsxs)("span", { children: [e, " star"] }),
									/* @__PURE__ */ (0, N.jsx)("i", {}),
									/* @__PURE__ */ (0, N.jsx)("small", { children: "0" })
								] }, e))
							}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "reviews-empty",
								children: [
									/* @__PURE__ */ (0, N.jsx)("h3", { children: "Be the first to share your experience." }),
									/* @__PURE__ */ (0, N.jsx)("p", { children: "Customer reviews and photographs will appear here when review collection opens." }),
									/* @__PURE__ */ (0, N.jsx)("button", {
										type: "button",
										disabled: !0,
										children: "Write a review at launch"
									})
								]
							})
						]
					})]
				}),
				y.moreAccessories.length > 0 && /* @__PURE__ */ (0, N.jsxs)("section", {
					id: "accessories",
					className: "related-section",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "section-heading",
						children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: "BRING THE KITCHEN TOGETHER"
						}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "More accessories for your configuration." })] }), /* @__PURE__ */ (0, N.jsxs)(w, {
							href: aog?brandProfile.shop_url:"/",
							className: "text-link",
							children: [aog?"Explore "+brand+" ":"Explore Napoleon ", /* @__PURE__ */ (0, N.jsx)(M, { size: 18 })]
						})]
					}), ue(y.moreAccessories)]
				}),
				!standardPdp && y.companions.length > 0 && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "related-section",
					children: [
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "section-heading",
							children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
								className: "eyebrow",
								children: "BRING THE KITCHEN TOGETHER"
							}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "Complete your outdoor kitchen." })] }), /* @__PURE__ */ (0, N.jsxs)(w, {
								className: "text-link",
								href: aog?brandProfile.shop_url:"/",
								children: [aog?"Explore "+brand+" ":"Explore Napoleon ", /* @__PURE__ */ (0, N.jsx)(M, { size: 18 })]
							})]
						}),
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "small-muted",
							children: "Complementary products, each with its own installation requirements."
						}),
						ue(y.companions)
					]
				}),
				v.compatible_products.length > 0 && /* @__PURE__ */ (0, N.jsxs)("section", {
					id: "compatible-products",
					className: "related-section",
					children: [/* @__PURE__ */ (0, N.jsx)("h2", { children: "Compatible products" }), v.compatible_products.map((e) => /* @__PURE__ */ (0, N.jsxs)(w, {
						className: "document-link",
						href: e.href,
						target: "_blank",
						rel: "noreferrer",
						children: [/* @__PURE__ */ (0, N.jsxs)("span", { children: [e.title, /* @__PURE__ */ (0, N.jsxs)("small", { children: [
							e.sku,
							" · ",
							Object.values(e.options).join(" · ")
						] })] }), /* @__PURE__ */ (0, N.jsx)(ve, { size: 16 })]
					}, e.sku))]
				})
			]
		}), purchaseRollout ? (0,N.jsx)(HopPurchase.Sticky,{title:e.title,sku:a,quantity:l,lines:hopLines,hasOptions:!fireMediaPilot&&ne.length>0,hasAccessories:standardPdp&&!!(y.liner||y.recommended.length||(fireMediaPilot&&e.handle==="napoleon-st-tropez-square-patioflame-table")),busy:cartFeedback?.state==='pending',addedSignature:hopAddedSignature,available:v.available,onAdd:()=>se(a,l),cartUrl:hopPurchaseData.cart_url,variantId:sku=>window.napoleonCommerce.purchaseIds?.[sku]||window.napoleonCommerce.variantId(sku)}) : (0, N.jsxs)("div", {
            className: "mobile-buy-bar",
			children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("small", { children: a }), /* @__PURE__ */ (0, N.jsx)("strong", { children: v.price === null ? "Price on request" : In(v.price) })] }), /* @__PURE__ */ (0, N.jsxs)(f, {
				className: "commerce-button"+(standardPdp&&cartState==='added'?' hx27-added':''),
				onClick: () => se(a, l),
 disabled: cartFeedback?.state === "pending" || cartState === "added",
 "aria-busy": cartState === "pending",
 "aria-live": "polite",
 children: cartState === "added" ? ["Added ", (0, N.jsx)(fe, { size: 16 })] : cartState === "pending" ? "Adding…" : ["Add to Cart ", (0, N.jsx)(M, { size: 16 })]
			})]
		})]
	});
}
//#endregion
//#region lib/catalog-listing.json
var napoleonListingSource = /* @__PURE__ */ JSON.parse("[{\"product_id\":\"napoleon-item-55005\",\"title\":\"PRO Silicone Basting Brush with Stainless Steel Handle\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-pro-silicone-basting-brush-with-stainless-steel-handle\",\"image\":\"https://images.salsify.com/image/upload/s--RaDxTpb6--/xe8quvlzw24wuzfwxznd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"55005\",\"title\":\"PRO Silicone Basting Brush with Stainless Steel Handle\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--RaDxTpb6--/xe8quvlzw24wuzfwxznd.jpg\",\"price\":10.99}]},{\"product_id\":\"napoleon-item-55011\",\"title\":\"PRO Stainless Steel Easy Locking Tongs\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-pro-stainless-steel-easy-locking-tongs\",\"image\":\"https://images.salsify.com/image/upload/s--edteF9nC--/fdh10c0jro8t6x87kybt.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"55011\",\"title\":\"PRO Stainless Steel Easy Locking Tongs\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--edteF9nC--/fdh10c0jro8t6x87kybt.jpg\",\"price\":16.99}]},{\"product_id\":\"napoleon-item-55025\",\"title\":\"Grilling Pincer Tongs\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-grilling-pincer-tongs\",\"image\":\"https://images.salsify.com/image/upload/s--7CNkI1Q6--/cneo6iu8jpq1wrpf4lrb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"55025\",\"title\":\"Grilling Pincer Tongs\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--7CNkI1Q6--/cneo6iu8jpq1wrpf4lrb.jpg\",\"price\":12.99}]},{\"product_id\":\"napoleon-item-55217\",\"title\":\"PRO Pizza Cutter\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-pro-pizza-cutter\",\"image\":\"https://images.salsify.com/image/upload/s--sMaYOGQq--/hhq9agwhgin5sgvfrepq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"55217\",\"title\":\"PRO Pizza Cutter\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--sMaYOGQq--/hhq9agwhgin5sgvfrepq.jpg\",\"price\":13.99}]},{\"product_id\":\"napoleon-item-55220\",\"title\":\"Napoleon 15L Cooler Box with Bottle Opener\",\"category\":\"Accessories\",\"subcategory\":\"Portable Accessories\",\"handle\":\"napoleon-napoleon-15l-cooler-box-with-bottle-opener\",\"image\":\"https://images.salsify.com/image/upload/s--jBW81Lky--/rldxibon5kwbdgyzjf1i.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"55220\",\"title\":\"Napoleon 15L Cooler Box with Bottle Opener\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--jBW81Lky--/rldxibon5kwbdgyzjf1i.jpg\",\"price\":121.99}]},{\"product_id\":\"napoleon-item-56003\",\"title\":\"Cast Iron Skillet\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-skillet\",\"image\":\"https://images.salsify.com/image/upload/s--byO6fbiv--/fbuitwyl1b93cfnkw4nw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56003\",\"title\":\"Cast Iron Skillet\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--byO6fbiv--/fbuitwyl1b93cfnkw4nw.jpg\",\"price\":33.99}]},{\"product_id\":\"napoleon-item-56008\",\"title\":\"Cast Iron Sizzle Platter\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-sizzle-platter\",\"image\":\"https://images.salsify.com/image/upload/s--P90l2g02--/xsxs5uhpzhcxse0nqp3i.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56008\",\"title\":\"Cast Iron Sizzle Platter\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--P90l2g02--/xsxs5uhpzhcxse0nqp3i.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-56012\",\"title\":\"Expandable Rib Holder\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-expandable-rib-holder\",\"image\":\"https://images.salsify.com/image/upload/s--0Hpt6MN6--/njchyodrqpqoad717zic.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56012\",\"title\":\"Expandable Rib Holder\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--0Hpt6MN6--/njchyodrqpqoad717zic.jpg\",\"price\":22.99}]},{\"product_id\":\"napoleon-item-56019\",\"title\":\"3 in 1 Roasting Rack\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-3-in-1-roasting-rack\",\"image\":\"https://images.salsify.com/image/upload/s--5Pl-937p--/jqdxzyva2evilrhdrlch.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56019\",\"title\":\"3 in 1 Roasting Rack\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--5Pl-937p--/jqdxzyva2evilrhdrlch.jpg\",\"price\":16.99}]},{\"product_id\":\"napoleon-item-56027\",\"title\":\"Stainless Steel Grilling Wok\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-stainless-steel-grilling-wok\",\"image\":\"https://images.salsify.com/image/upload/s--XEyG8EQ4--/ylan5t4jbzsjbhp9jr4q.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56027\",\"title\":\"Stainless Steel Grilling Wok\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--XEyG8EQ4--/ylan5t4jbzsjbhp9jr4q.jpg\",\"price\":31.99}]},{\"product_id\":\"napoleon-item-56032\",\"title\":\"Chicken Leg Grill Rack\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-chicken-leg-grill-rack\",\"image\":\"https://images.salsify.com/image/upload/s--8bRGyxxP--/ys5btf0iwmknwk62kkzr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56032\",\"title\":\"Chicken Leg Grill Rack\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--8bRGyxxP--/ys5btf0iwmknwk62kkzr.jpg\",\"price\":41.99}]},{\"product_id\":\"napoleon-item-56034\",\"title\":\"Chicken Roaster\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-chicken-roaster\",\"image\":\"https://images.salsify.com/image/upload/s--bAsaoi2Y--/zt1wvufflu2hnhfpzsdo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56034\",\"title\":\"Chicken Roaster\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--bAsaoi2Y--/zt1wvufflu2hnhfpzsdo.jpg\",\"price\":33.99}]},{\"product_id\":\"napoleon-item-56041\",\"title\":\"Enameled Cast Iron Reversible Griddle for PRO 500 & Prestige® 500 Grill Models\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-enameled-cast-iron-reversible-griddle-for-pro-500-prestige-500-grill-models\",\"image\":\"https://images.salsify.com/image/upload/s--yALkUiTC--/yso5gakrxzhpbyri6tzt.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56041\",\"title\":\"Enameled Cast Iron Reversible Griddle for PRO 500 & Prestige® 500 Grill Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--yALkUiTC--/yso5gakrxzhpbyri6tzt.jpg\",\"price\":74.99}]},{\"product_id\":\"napoleon-item-56051\",\"title\":\"Cast Iron Sauce Pan with Lid\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-sauce-pan-with-lid\",\"image\":\"https://images.salsify.com/image/upload/s--l3HEV6xI--/skxk2gvaywjfvzf6nxsp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56051\",\"title\":\"Cast Iron Sauce Pan with Lid\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--l3HEV6xI--/skxk2gvaywjfvzf6nxsp.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-56053\",\"title\":\"Cast Iron Frying Pan\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-frying-pan\",\"image\":\"https://images.salsify.com/image/upload/s--AMN9cCSV--/clsaozhppt8bjleepepp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56053\",\"title\":\"Cast Iron Frying Pan\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--AMN9cCSV--/clsaozhppt8bjleepepp.jpg\",\"price\":32.99}]},{\"product_id\":\"napoleon-item-56054\",\"title\":\"Cast Iron Dessert Cooker\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-dessert-cooker\",\"image\":\"https://images.salsify.com/image/upload/s--_9J778cL--/bhnwxbletbx8rpmozwyq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56054\",\"title\":\"Cast Iron Dessert Cooker\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--_9J778cL--/bhnwxbletbx8rpmozwyq.jpg\",\"price\":10.99}]},{\"product_id\":\"napoleon-item-56055\",\"title\":\"Grill Roasting Pan\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-grill-roasting-pan\",\"image\":\"https://images.salsify.com/image/upload/s--ngLmQsAK--/lat1drnonlofy2uv51hq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56055\",\"title\":\"Grill Roasting Pan\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--ngLmQsAK--/lat1drnonlofy2uv51hq.jpg\",\"price\":66.99}]},{\"product_id\":\"napoleon-item-56056\",\"title\":\"Cast Iron Chef's Press\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-chef-s-press\",\"image\":\"https://images.salsify.com/image/upload/s--NU38Fin8--/k6ir7zgtxvgbyycebqrq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56056\",\"title\":\"Cast Iron Chef's Press\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--NU38Fin8--/k6ir7zgtxvgbyycebqrq.jpg\",\"price\":17.99}]},{\"product_id\":\"napoleon-item-56059\",\"title\":\"Cast Iron Dutch Oven 6qt\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-dutch-oven-6qt\",\"image\":\"https://images.salsify.com/image/upload/s--VbuL-SbA--/kar2eukyuykobjyfjthb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56059\",\"title\":\"Cast Iron Dutch Oven 6qt\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--VbuL-SbA--/kar2eukyuykobjyfjthb.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-56062\",\"title\":\"Cast Iron Dutch Oven 4.5qt\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-dutch-oven-4-5qt\",\"image\":\"https://images.salsify.com/image/upload/s--8w0rvNb8--/ynkwij9wkzzdvx708tyr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56062\",\"title\":\"Cast Iron Dutch Oven 4.5qt\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--8w0rvNb8--/ynkwij9wkzzdvx708tyr.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-56066\",\"title\":\"14\\\"(35.5cm) Stainless Steel Pizza Pan\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-14-35-5cm-stainless-steel-pizza-pan\",\"image\":\"https://images.salsify.com/image/upload/s--SRTJp8sV--/exggewtwceg9fdpruxvq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56066\",\"title\":\"14\\\"(35.5cm) Stainless Steel Pizza Pan\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"14 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--SRTJp8sV--/exggewtwceg9fdpruxvq.jpg\",\"price\":36.99}]},{\"product_id\":\"napoleon-item-56067\",\"title\":\"PRO Chicken Infusion Roaster\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-pro-chicken-infusion-roaster\",\"image\":\"https://images.salsify.com/image/upload/s--ppkkbCPH--/nc8xoycnshycvmupfhku.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56067\",\"title\":\"PRO Chicken Infusion Roaster\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--ppkkbCPH--/nc8xoycnshycvmupfhku.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-56081\",\"title\":\"Porcelain-enameled Cast Iron Griddle with SS Rack for Small SIZZLE ZONE®\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-porcelain-enameled-cast-iron-griddle-with-ss-rack-for-small-sizzle-zone\",\"image\":\"https://images.salsify.com/image/upload/s--8aP6yVbr--/yosfhqv9ndl7xge4oxl4.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56081\",\"title\":\"Porcelain-enameled Cast Iron Griddle with SS Rack for Small SIZZLE ZONE®\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--8aP6yVbr--/yosfhqv9ndl7xge4oxl4.jpg\",\"price\":55.99}]},{\"product_id\":\"napoleon-item-56082\",\"title\":\"Cast Iron Griddle for SIZZLE ZONE® - Large\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-griddle-for-sizzle-zone-large\",\"image\":\"https://images.salsify.com/image/upload/s--g4ZIpGIL--/zkbg5t18yvgypo3i736n.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56082\",\"title\":\"Cast Iron Griddle for SIZZLE ZONE® - Large\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--g4ZIpGIL--/zkbg5t18yvgypo3i736n.jpg\",\"price\":74.99}]},{\"product_id\":\"napoleon-item-56083\",\"title\":\"Cast Iron Reversible Griddle for 22 inch Charcoal Grills\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-reversible-griddle-for-22-inch-charcoal-grills\",\"image\":\"https://images.salsify.com/image/upload/s--VV7hnkQA--/tksjlummjp5dnvjhpyoe.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56083\",\"title\":\"Cast Iron Reversible Griddle for 22 inch Charcoal Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"22 inch\",\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--VV7hnkQA--/tksjlummjp5dnvjhpyoe.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-56093\",\"title\":\"Stainless Steel Griddle Insert for all Rogue® and Freestyle™ 425 models\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-stainless-steel-griddle-insert-for-all-rogue-and-freestyle-425-models\",\"image\":\"https://images.salsify.com/image/upload/s--hTfTCMhe--/ycdvwncngwhvuopkfrwp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56093\",\"title\":\"Stainless Steel Griddle Insert for all Rogue® and Freestyle™ 425 models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--hTfTCMhe--/ycdvwncngwhvuopkfrwp.jpg\",\"price\":187.99}]},{\"product_id\":\"napoleon-item-56094\",\"title\":\"Stainless Steel Griddle Insert for Prestige® PRO, Prestige®, Built-in 700 Series, and Rogue 525 & 625 Models\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-stainless-steel-griddle-insert-for-prestige-pro-prestige-built-in-700-series-and-rogue-525-625-models\",\"image\":\"https://images.salsify.com/image/upload/s--lZN_uF-o--/eegvlznfgavhmu3ifh2c.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56094\",\"title\":\"Stainless Steel Griddle Insert for Prestige® PRO, Prestige®, Built-in 700 Series, and Rogue 525 & 625 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"700 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--lZN_uF-o--/eegvlznfgavhmu3ifh2c.jpg\",\"price\":235.99}]},{\"product_id\":\"napoleon-item-56365\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 365 / 525 Model Grills\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-reversible-griddle-for-rogue-365-525-model-grills\",\"image\":\"https://images.salsify.com/image/upload/s--9xlOCYE7--/jvu3m8ih0pvaq3aygj1o.png\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56365\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 365 / 525 Model Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--9xlOCYE7--/jvu3m8ih0pvaq3aygj1o.png\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-56366\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 365 & 525\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-reversible-griddle-for-rogue-365-525\",\"image\":\"https://images.salsify.com/image/upload/s--31XxRo3b--/z1hyyclxrqwasdkxawxd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56366\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 365 & 525\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--31XxRo3b--/z1hyyclxrqwasdkxawxd.jpg\",\"price\":58.99}]},{\"product_id\":\"napoleon-item-56425\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 425 / 625 and Freestyle™ Model Grills\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-cast-iron-reversible-griddle-for-rogue-425-625-and-freestyle-model-grills\",\"image\":\"https://images.salsify.com/image/upload/s--L0ptnHhW--/zetiymhnlfbqokeioxgu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56425\",\"title\":\"Cast Iron Reversible Griddle for Rogue® 425 / 625 and Freestyle™ Model Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--L0ptnHhW--/zetiymhnlfbqokeioxgu.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-56426\",\"title\":\"Enameled Cast Iron Reversible Griddle for Rogue® 425 Model Grills\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-enameled-cast-iron-reversible-griddle-for-rogue-425-model-grills\",\"image\":\"https://images.salsify.com/image/upload/s--Sbbqzu7D--/x7t9lsqo0fpvobexphap.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"56426\",\"title\":\"Enameled Cast Iron Reversible Griddle for Rogue® 425 Model Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--Sbbqzu7D--/x7t9lsqo0fpvobexphap.jpg\",\"price\":69.99}]},{\"product_id\":\"napoleon-item-57012\",\"title\":\"Flexible Grill Basket\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-flexible-grill-basket\",\"image\":\"https://images.salsify.com/image/upload/s--trjAg7pG--/nq86oqtrt4sfpf46hesv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"57012\",\"title\":\"Flexible Grill Basket\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--trjAg7pG--/nq86oqtrt4sfpf46hesv.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-57013\",\"title\":\"Adjustable Stainless Steel Rotisserie Basket\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-adjustable-stainless-steel-rotisserie-basket\",\"image\":\"https://images.salsify.com/image/upload/s--fMztNYx4--/snmzfzjjps3iwc11bgx1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"57013\",\"title\":\"Adjustable Stainless Steel Rotisserie Basket\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--fMztNYx4--/snmzfzjjps3iwc11bgx1.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-61015\",\"title\":\"Charcoal Storage Bag\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-charcoal-storage-bag\",\"image\":\"https://images.salsify.com/image/upload/s--oeOx60E3--/dobmpr1qxvvac3mdtlpk.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61015\",\"title\":\"Charcoal Storage Bag\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--oeOx60E3--/dobmpr1qxvvac3mdtlpk.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-61024\",\"title\":\"Freestyle™ 24\\\" Griddle Cart Premium Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-freestyle-24-griddle-cart-premium-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--Fva2Lscd--/ivrdzvxq3p2qygmhqlh8.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61024\",\"title\":\"Freestyle™ 24\\\" Griddle Cart Premium Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--Fva2Lscd--/ivrdzvxq3p2qygmhqlh8.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-61028\",\"title\":\"Premium Rogue® 30\\\" Griddle Cart Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-premium-rogue-30-griddle-cart-cover\",\"image\":\"https://images.salsify.com/image/upload/s--28BD-hWu--/unfe4uewrhfs7envabbp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61028\",\"title\":\"Premium Rogue® 30\\\" Griddle Cart Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"30 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--28BD-hWu--/unfe4uewrhfs7envabbp.jpg\",\"price\":74.99}]},{\"product_id\":\"napoleon-item-61093\",\"title\":\"Storage Bag for Stainless Steel Griddle Insert 56093\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-storage-bag-for-stainless-steel-griddle-insert-56093\",\"image\":\"https://images.salsify.com/image/upload/s--UUt2UNVQ--/q9ic7p2jobqf01v80l4x.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61093\",\"title\":\"Storage Bag for Stainless Steel Griddle Insert 56093\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--UUt2UNVQ--/q9ic7p2jobqf01v80l4x.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-61094\",\"title\":\"Storage Bag for Full Sized Griddle Insert 56094\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-storage-bag-for-full-sized-griddle-insert-56094\",\"image\":\"https://images.salsify.com/image/upload/s--F0Bbozqi--/uuse8hct2t0iia8f71ir.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61094\",\"title\":\"Storage Bag for Full Sized Griddle Insert 56094\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--F0Bbozqi--/uuse8hct2t0iia8f71ir.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-61365\",\"title\":\"Rogue® 365 Series Grill Cover (Shelves Up)\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-rogue-365-series-grill-cover-shelves-up\",\"image\":\"https://images.salsify.com/image/upload/s--EYC9z_9I--/qrebydwbivy15ur10qha.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61365\",\"title\":\"Rogue® 365 Series Grill Cover (Shelves Up)\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--EYC9z_9I--/qrebydwbivy15ur10qha.jpg\",\"price\":68.99}]},{\"product_id\":\"napoleon-item-61427\",\"title\":\"Rogue® 425 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-rogue-425-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--4WC0BWOD--/rw2sihgqstjry5cen6xs.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61427\",\"title\":\"Rogue® 425 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--4WC0BWOD--/rw2sihgqstjry5cen6xs.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-61444\",\"title\":\"Freestyle™ Series Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-freestyle-series-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--Ddv4vTg---/dwvhzmetpvcfb23sld5n.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61444\",\"title\":\"Freestyle™ Series Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--Ddv4vTg---/dwvhzmetpvcfb23sld5n.jpg\",\"price\":58.99}]},{\"product_id\":\"napoleon-item-61500\",\"title\":\"PRO 500 & Prestige® 500 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-pro-500-prestige-500-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--9hkwQ6Tg--/jgl7eyfwxhtt7tjpa2er.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61500\",\"title\":\"PRO 500 & Prestige® 500 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--9hkwQ6Tg--/jgl7eyfwxhtt7tjpa2er.jpg\",\"price\":102.99}]},{\"product_id\":\"napoleon-item-61501\",\"title\":\"PRO 500 & Prestige® 500 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-pro-500-prestige-500-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--fw6FKlsk--/f67rvblgyymiaf5ju8zb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61501\",\"title\":\"PRO 500 & Prestige® 500 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--fw6FKlsk--/f67rvblgyymiaf5ju8zb.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-61527\",\"title\":\"Rogue® 525 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-rogue-525-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--EYC9z_9I--/qrebydwbivy15ur10qha.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61527\",\"title\":\"Rogue® 525 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--EYC9z_9I--/qrebydwbivy15ur10qha.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-61605\",\"title\":\"LEX 605 & Charcoal Professional Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-lex-605-charcoal-professional-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--pggU0TNY--/gqa9xlqwpfsbpxlzhtb0.png\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61605\",\"title\":\"LEX 605 & Charcoal Professional Grill Cover\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--pggU0TNY--/gqa9xlqwpfsbpxlzhtb0.png\",\"price\":94.99}]},{\"product_id\":\"napoleon-item-61627\",\"title\":\"Rogue® 625 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-rogue-625-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s---oU85ma3--/wy3wk3ymnywsxfd1pwpf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61627\",\"title\":\"Rogue® 625 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\"},\"image\":\"https://images.salsify.com/image/upload/s---oU85ma3--/wy3wk3ymnywsxfd1pwpf.jpg\",\"price\":84.99}]},{\"product_id\":\"napoleon-item-61628\",\"title\":\"Rogue® 525 & 625 Series Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-rogue-525-625-series-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--q52XTO_s--/wklnqpypmqi3hcqdwcgy.png\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61628\",\"title\":\"Rogue® 525 & 625 Series Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--q52XTO_s--/wklnqpypmqi3hcqdwcgy.png\",\"price\":84.99}]},{\"product_id\":\"napoleon-item-61665\",\"title\":\"Prestige® 665 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-prestige-665-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s---VvqEh5---/emku7fvoaq3lve1qa6sr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61665\",\"title\":\"Prestige® 665 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s---VvqEh5---/emku7fvoaq3lve1qa6sr.jpg\",\"price\":113.99}]},{\"product_id\":\"napoleon-item-61666\",\"title\":\"PRO 665 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-pro-665-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--unFGVJSn--/qutvkdx7sr43haesrdbs.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61666\",\"title\":\"PRO 665 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--unFGVJSn--/qutvkdx7sr43haesrdbs.jpg\",\"price\":61.99}]},{\"product_id\":\"napoleon-item-61810\",\"title\":\"10-inch Built-in Side Burner Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-10-inch-built-in-side-burner-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--7hFnV_W7--/avfphk8qzajr7cyajaz1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61810\",\"title\":\"10-inch Built-in Side Burner Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"10 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--7hFnV_W7--/avfphk8qzajr7cyajaz1.jpg\",\"price\":46.99}]},{\"product_id\":\"napoleon-item-61812\",\"title\":\"12-inch Built-in Side Burner Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-12-inch-built-in-side-burner-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--UdAfXBLE--/xxlmuumu0jwte2ilhrjd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61812\",\"title\":\"12-inch Built-in Side Burner Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"12 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--UdAfXBLE--/xxlmuumu0jwte2ilhrjd.jpg\",\"price\":46.99}]},{\"product_id\":\"napoleon-item-61818\",\"title\":\"18-inch Built-in Side Burner Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-18-inch-built-in-side-burner-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--GEAyS02L--/uw28hrc9tfuam09jjyxl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61818\",\"title\":\"18-inch Built-in Side Burner Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--GEAyS02L--/uw28hrc9tfuam09jjyxl.jpg\",\"price\":58.99}]},{\"product_id\":\"napoleon-item-61825\",\"title\":\"PRO 825 Models Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-pro-825-models-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--k5sfg25F--/s7u7wgtzdw4gmjjuul3w.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61825\",\"title\":\"PRO 825 Models Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"825 model\"},\"image\":\"https://images.salsify.com/image/upload/s--k5sfg25F--/s7u7wgtzdw4gmjjuul3w.jpg\",\"price\":123.99}]},{\"product_id\":\"napoleon-item-61826\",\"title\":\"PRO 825 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-pro-825-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--ezGlLdA6--/hpssntitvzyidb1p9aps.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61826\",\"title\":\"PRO 825 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"825 model\"},\"image\":\"https://images.salsify.com/image/upload/s--ezGlLdA6--/hpssntitvzyidb1p9aps.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-61830\",\"title\":\"500 and 700 Series 32 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-500-and-700-series-32-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--eAH075bh--/wntv27dzdrua4pb9ukuv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61830\",\"title\":\"500 and 700 Series 32 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--eAH075bh--/wntv27dzdrua4pb9ukuv.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-61831\",\"title\":\"Built-in Griddle 700 Series Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-built-in-griddle-700-series-cover\",\"image\":\"https://images.salsify.com/image/upload/s--jFvQtN0L--/sebf3mlerccmzgzpwipc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61831\",\"title\":\"Built-in Griddle 700 Series Cover\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--jFvQtN0L--/sebf3mlerccmzgzpwipc.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-61836\",\"title\":\"700 Series 38 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-700-series-38-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--BcyV5FlO--/cekowudw5gqx3t3mrolu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61836\",\"title\":\"700 Series 38 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--BcyV5FlO--/cekowudw5gqx3t3mrolu.jpg\",\"price\":84.99}]},{\"product_id\":\"napoleon-item-61842\",\"title\":\"700 Series 44 Built-in Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-700-series-44-built-in-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--0NZslVOT--/anwt0s525cpfasmzlcpa.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61842\",\"title\":\"700 Series 44 Built-in Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--0NZslVOT--/anwt0s525cpfasmzlcpa.jpg\",\"price\":102.99}]},{\"product_id\":\"napoleon-item-61914\",\"title\":\"NK18 Charcoal Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-nk18-charcoal-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--x7OEou3---/su9u3qurl3qqyx1ag6ov.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61914\",\"title\":\"NK18 Charcoal Grill Cover\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--x7OEou3---/su9u3qurl3qqyx1ag6ov.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-61915\",\"title\":\"22 Inch Charcoal Grill Cover for Leg Models\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-22-inch-charcoal-grill-cover-for-leg-models\",\"image\":\"https://images.salsify.com/image/upload/s--uOmw4Mva--/u5aguugjc4ajbsln2hbu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61915\",\"title\":\"22 Inch Charcoal Grill Cover for Leg Models\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"22 inch\",\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--uOmw4Mva--/u5aguugjc4ajbsln2hbu.jpg\",\"price\":46.99}]},{\"product_id\":\"napoleon-item-61916\",\"title\":\"22 Inch Charcoal Grill Cover for Cart Models\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-22-inch-charcoal-grill-cover-for-cart-models\",\"image\":\"https://images.salsify.com/image/upload/s--zGBPnbvT--/rpir0gjnki8dmatc0dkj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61916\",\"title\":\"22 Inch Charcoal Grill Cover for Cart Models\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"22 inch\",\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--zGBPnbvT--/rpir0gjnki8dmatc0dkj.jpg\",\"price\":58.99}]},{\"product_id\":\"napoleon-item-61918\",\"title\":\"Apollo® 18 Smoker Premium Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-apollo-18-smoker-premium-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--Iy7O3UYO--/awylwnnne3amgsxhazmx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61918\",\"title\":\"Apollo® 18 Smoker Premium Grill Cover\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--Iy7O3UYO--/awylwnnne3amgsxhazmx.jpg\",\"price\":41.99}]},{\"product_id\":\"napoleon-item-61922\",\"title\":\"Apollo® 22 Smoker Premium Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-apollo-22-smoker-premium-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--UQ3WKKfo--/yplokihtjdf8v62mmoxy.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"61922\",\"title\":\"Apollo® 22 Smoker Premium Grill Cover\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--UQ3WKKfo--/yplokihtjdf8v62mmoxy.jpg\",\"price\":50.99}]},{\"product_id\":\"napoleon-item-62003\",\"title\":\"Abrasive Scrubber for Porcelain Coated Cast Iron Cooking Grids\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-abrasive-scrubber-for-porcelain-coated-cast-iron-cooking-grids\",\"image\":\"https://images.salsify.com/image/upload/s--WUHJvdzh--/brickxmswnggnsh9tro0.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62003\",\"title\":\"Abrasive Scrubber for Porcelain Coated Cast Iron Cooking Grids\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--WUHJvdzh--/brickxmswnggnsh9tro0.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-62007\",\"title\":\"Disposable Grease Drip Trays (6\\\" x 5\\\") - Pack of 5\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-disposable-grease-drip-trays-6-x-5-pack-of-5\",\"image\":\"https://images.salsify.com/image/upload/s--nJsDTw4u--/bvu5c8oam3ejiyqjozo3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62007\",\"title\":\"Disposable Grease Drip Trays (6\\\" x 5\\\") - Pack of 5\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"6 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--nJsDTw4u--/bvu5c8oam3ejiyqjozo3.jpg\",\"price\":5.99}]},{\"product_id\":\"napoleon-item-62008\",\"title\":\"Large Disposable Grease Drip Trays (14\\\" x 8\\\") - Pack of 5\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-large-disposable-grease-drip-trays-14-x-8-pack-of-5\",\"image\":\"https://images.salsify.com/image/upload/s--N53wRsmc--/tt3kghb1kucmulsrbrju.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62008\",\"title\":\"Large Disposable Grease Drip Trays (14\\\" x 8\\\") - Pack of 5\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"14 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--N53wRsmc--/tt3kghb1kucmulsrbrju.jpg\",\"price\":8.99}]},{\"product_id\":\"napoleon-item-62020\",\"title\":\"Drip Pan Liner (3 Pack) for Rogue® 425 Models\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-3-pack-for-rogue-425-models\",\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62020\",\"title\":\"Drip Pan Liner (3 Pack) for Rogue® 425 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"price\":10.99}]},{\"product_id\":\"napoleon-item-62021\",\"title\":\"Drip Pan Liner for Rogue® 525 models - pack of 3\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-for-rogue-525-models-pack-of-3\",\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62021\",\"title\":\"Drip Pan Liner for Rogue® 525 models - pack of 3\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"price\":11.99}]},{\"product_id\":\"napoleon-item-62022\",\"title\":\"Drip Pan Liner for Rogue® 625 models - pack of 3\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-for-rogue-625-models-pack-of-3\",\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62022\",\"title\":\"Drip Pan Liner for Rogue® 625 models - pack of 3\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\"},\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"price\":18.99}]},{\"product_id\":\"napoleon-item-62023\",\"title\":\"Drip Pan Liner for PRO/Prestige® 500 models - pack of 3\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-for-pro-prestige-500-models-pack-of-3\",\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62023\",\"title\":\"Drip Pan Liner for PRO/Prestige® 500 models - pack of 3\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--_CxE8LOU--/hc1e7ijkrpoxs86tkp1m.jpg\",\"price\":13.99}]},{\"product_id\":\"napoleon-item-62024\",\"title\":\"Drip Pan Liner (3 Pack) for Rogue® 365 Models\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-3-pack-for-rogue-365-models\",\"image\":\"https://images.salsify.com/image/upload/s--_QD1GJAv--/lffjqf1ku1mtcnjlxjsx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62024\",\"title\":\"Drip Pan Liner (3 Pack) for Rogue® 365 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--_QD1GJAv--/lffjqf1ku1mtcnjlxjsx.jpg\",\"price\":9.99}]},{\"product_id\":\"napoleon-item-62026\",\"title\":\"Drip Pan Liner (3 Pack) for Freestyle™ 365 Models\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-3-pack-for-freestyle-365-models\",\"image\":\"https://images.salsify.com/image/upload/s--BZvpDLUr--/zoxm1umnxapd6jkgkwzm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62026\",\"title\":\"Drip Pan Liner (3 Pack) for Freestyle™ 365 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--BZvpDLUr--/zoxm1umnxapd6jkgkwzm.jpg\",\"price\":8.99}]},{\"product_id\":\"napoleon-item-62029\",\"title\":\"Drip Pan Liner (3 Pack) for Freestyle™ 425 Models\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liner-3-pack-for-freestyle-425-models\",\"image\":\"https://images.salsify.com/image/upload/s--xkvnr4_j--/gnyyjjf4rnrtor4uqknt.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62029\",\"title\":\"Drip Pan Liner (3 Pack) for Freestyle™ 425 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--xkvnr4_j--/gnyyjjf4rnrtor4uqknt.jpg\",\"price\":10.99}]},{\"product_id\":\"napoleon-item-62031\",\"title\":\"Stainless Steel Grid Scraper\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-stainless-steel-grid-scraper\",\"image\":\"https://images.salsify.com/image/upload/s--e0SDiSpD--/hvmhjyyw6ftjentqzfcx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62031\",\"title\":\"Stainless Steel Grid Scraper\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--e0SDiSpD--/hvmhjyyw6ftjentqzfcx.jpg\",\"price\":7.99}]},{\"product_id\":\"napoleon-item-62042\",\"title\":\"Grill Cleaner for Interior Grids\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-grill-cleaner-for-interior-grids\",\"image\":\"https://images.salsify.com/image/upload/s--1_fqr4tu--/rj7zchww3gpff11ml34b.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62042\",\"title\":\"Grill Cleaner for Interior Grids\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--1_fqr4tu--/rj7zchww3gpff11ml34b.jpg\",\"price\":12.99}]},{\"product_id\":\"napoleon-item-62047\",\"title\":\"Stainless Steel Spray Bottle\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-stainless-steel-spray-bottle\",\"image\":\"https://images.salsify.com/image/upload/s--0_m-3xRL--/lmh39fatgkjbvdh52vqr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62047\",\"title\":\"Stainless Steel Spray Bottle\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--0_m-3xRL--/lmh39fatgkjbvdh52vqr.jpg\",\"price\":13.99}]},{\"product_id\":\"napoleon-item-62050\",\"title\":\"JETFIRE™ Burner Brush Maintenance Kit\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-jetfire-burner-brush-maintenance-kit\",\"image\":\"https://images.salsify.com/image/upload/s--kxfxdQJK--/amnqflpo5cnf3zw0gtc4.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62050\",\"title\":\"JETFIRE™ Burner Brush Maintenance Kit\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--kxfxdQJK--/amnqflpo5cnf3zw0gtc4.jpg\",\"price\":3.99}]},{\"product_id\":\"napoleon-item-62070\",\"title\":\"Drip Pan Liners for P500V Models (3 pcs)\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liners-for-p500v-models-3-pcs\",\"image\":\"https://images.salsify.com/image/upload/s--b63OkOra--/qelqqs9du0nuog4qfig7.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62070\",\"title\":\"Drip Pan Liners for P500V Models (3 pcs)\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--b63OkOra--/qelqqs9du0nuog4qfig7.jpg\",\"price\":17.99}]},{\"product_id\":\"napoleon-item-62071\",\"title\":\"Drip Pan Liners for P665V Models (3 pcs)\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-drip-pan-liners-for-p665v-models-3-pcs\",\"image\":\"https://images.salsify.com/image/upload/s--t19zGBc_--/v8hmdimlfl1muenbsrvn.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62071\",\"title\":\"Drip Pan Liners for P665V Models (3 pcs)\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--t19zGBc_--/v8hmdimlfl1muenbsrvn.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-62072\",\"title\":\"Griddle Cart Grease Tray Liners\",\"category\":\"Accessories\",\"subcategory\":\"Drip Pans\",\"handle\":\"napoleon-griddle-cart-grease-tray-liners\",\"image\":\"https://images.salsify.com/image/upload/s--i1VO2-v3--/nvoqd7fjsr1mimsqesab.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62072\",\"title\":\"Griddle Cart Grease Tray Liners\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--i1VO2-v3--/nvoqd7fjsr1mimsqesab.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-62121\",\"title\":\"Grid Lifter\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-grid-lifter\",\"image\":\"https://images.salsify.com/image/upload/s--qgF0hcZh--/iak594fmuqvblwjvsc6h.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62121\",\"title\":\"Grid Lifter\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--qgF0hcZh--/iak594fmuqvblwjvsc6h.jpg\",\"price\":6.99}]},{\"product_id\":\"napoleon-item-62131\",\"title\":\"Black Grilling Apron\",\"category\":\"Accessories\",\"subcategory\":\"Apparel\",\"handle\":\"napoleon-black-grilling-apron\",\"image\":\"https://images.salsify.com/image/upload/s--VV6A4xg8--/yywjzne5dx5gojhdntfn.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62131\",\"title\":\"Black Grilling Apron\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--VV6A4xg8--/yywjzne5dx5gojhdntfn.jpg\",\"price\":21.99}]},{\"product_id\":\"napoleon-item-62147\",\"title\":\"Genuine Leather BBQ Gloves\",\"category\":\"Accessories\",\"subcategory\":\"Apparel\",\"handle\":\"napoleon-genuine-leather-bbq-gloves\",\"image\":\"https://images.salsify.com/image/upload/s--vYyS2uJY--/yxp53kkopctj3eorqs3d.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62147\",\"title\":\"Genuine Leather BBQ Gloves\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--vYyS2uJY--/yxp53kkopctj3eorqs3d.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-62150\",\"title\":\"PRO Grill Towel\",\"category\":\"Accessories\",\"subcategory\":\"Apparel\",\"handle\":\"napoleon-pro-grill-towel\",\"image\":\"https://images.salsify.com/image/upload/s--6Xe8WhGz--/wojqfzeet8nxjii2j1rw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62150\",\"title\":\"PRO Grill Towel\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6Xe8WhGz--/wojqfzeet8nxjii2j1rw.jpg\",\"price\":17.99}]},{\"product_id\":\"napoleon-item-62151\",\"title\":\"Microfiber Cleaning Towel\",\"category\":\"Accessories\",\"subcategory\":\"Apparel\",\"handle\":\"napoleon-microfiber-cleaning-towel\",\"image\":\"https://images.salsify.com/image/upload/s--JSKquw1s--/lppg4ntxc1sczflibsyj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"62151\",\"title\":\"Microfiber Cleaning Towel\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--JSKquw1s--/lppg4ntxc1sczflibsyj.jpg\",\"price\":7.99}]},{\"product_id\":\"napoleon-item-64000\",\"title\":\"Rotisserie Grill Basket\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-rotisserie-grill-basket\",\"image\":\"https://images.salsify.com/image/upload/s--KcSn1kEN--/rvhumvvp6y6cuxbpllhh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"64000\",\"title\":\"Rotisserie Grill Basket\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--KcSn1kEN--/rvhumvvp6y6cuxbpllhh.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-64008\",\"title\":\"Rotisserie Shish-Kebab Skewer Set\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-rotisserie-shish-kebab-skewer-set\",\"image\":\"https://images.salsify.com/image/upload/s--a9_ElKHh--/tkbcbbjklgkvu2ruuuoa.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"64008\",\"title\":\"Rotisserie Shish-Kebab Skewer Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--a9_ElKHh--/tkbcbbjklgkvu2ruuuoa.jpg\",\"price\":41.99}]},{\"product_id\":\"napoleon-item-67003\",\"title\":\"Hickory Wood Chips\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-hickory-wood-chips\",\"image\":\"https://images.salsify.com/image/upload/s--GkKYUj2q--/zvbbhoioghvn5rr41tdo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67003\",\"title\":\"Hickory Wood Chips\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--GkKYUj2q--/zvbbhoioghvn5rr41tdo.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-67007\",\"title\":\"Apple Wood Chips\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-apple-wood-chips\",\"image\":\"https://images.salsify.com/image/upload/s--GkKYUj2q--/zvbbhoioghvn5rr41tdo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67007\",\"title\":\"Apple Wood Chips\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--GkKYUj2q--/zvbbhoioghvn5rr41tdo.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-67011\",\"title\":\"PRO Stainless Steel Smoker Pipe\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-pro-stainless-steel-smoker-pipe\",\"image\":\"https://images.salsify.com/image/upload/s--rY9arO4x--/bmwayyye4owxvd17ecpx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67011\",\"title\":\"PRO Stainless Steel Smoker Pipe\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--rY9arO4x--/bmwayyye4owxvd17ecpx.jpg\",\"price\":10.99}]},{\"product_id\":\"napoleon-item-67013\",\"title\":\"Stainless Steel Smoker Box\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-stainless-steel-smoker-box\",\"image\":\"https://images.salsify.com/image/upload/s--x07nLcOB--/fsrzrc24et4fk30nho0o.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67013\",\"title\":\"Stainless Steel Smoker Box\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--x07nLcOB--/fsrzrc24et4fk30nho0o.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-67020\",\"title\":\"BBQ Smoking Starter Kit\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-bbq-smoking-starter-kit\",\"image\":\"https://images.salsify.com/image/upload/s--rY9arO4x--/bmwayyye4owxvd17ecpx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67020\",\"title\":\"BBQ Smoking Starter Kit\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--rY9arO4x--/bmwayyye4owxvd17ecpx.jpg\",\"price\":19.99}]},{\"product_id\":\"napoleon-item-67075\",\"title\":\"Travel Smoker Tube\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-travel-smoker-tube\",\"image\":\"https://images.salsify.com/image/upload/s--sqrK4Hq_--/e35qobeszrjejui0juiz.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67075\",\"title\":\"Travel Smoker Tube\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--sqrK4Hq_--/e35qobeszrjejui0juiz.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-67400\",\"title\":\"Charcoal Baskets for Kettle Grills\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-charcoal-baskets-for-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--G0ZjtvnN--/sm9gnm1zjitfzzzxutj4.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67400\",\"title\":\"Charcoal Baskets for Kettle Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--G0ZjtvnN--/sm9gnm1zjitfzzzxutj4.jpg\",\"price\":44.99}]},{\"product_id\":\"napoleon-item-67732\",\"title\":\"Cast Iron Charcoal and Smoker Tray\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-cast-iron-charcoal-and-smoker-tray\",\"image\":\"https://images.salsify.com/image/upload/s--bW6U3HM---/qcjx4qjcxnbyrdkhlgqc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67732\",\"title\":\"Cast Iron Charcoal and Smoker Tray\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--bW6U3HM---/qcjx4qjcxnbyrdkhlgqc.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-67734\",\"title\":\"Cast Iron Jumbo Shrimp Tray\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-jumbo-shrimp-tray\",\"image\":\"https://images.salsify.com/image/upload/s--StYUjBgv--/zuauwmrdy1lewkcxwcya.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67734\",\"title\":\"Cast Iron Jumbo Shrimp Tray\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--StYUjBgv--/zuauwmrdy1lewkcxwcya.jpg\",\"price\":49.99}]},{\"product_id\":\"napoleon-item-67740\",\"title\":\"Charcoal Rake and Tongs\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-charcoal-rake-and-tongs\",\"image\":\"https://images.salsify.com/image/upload/s--bCZ-V8mh--/aefzcsbvbdyfuwqpeymb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67740\",\"title\":\"Charcoal Rake and Tongs\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--bCZ-V8mh--/aefzcsbvbdyfuwqpeymb.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-67745\",\"title\":\"Charcoal Ring and Diffusor Plate\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-charcoal-ring-and-diffusor-plate\",\"image\":\"https://images.salsify.com/image/upload/s--4rZAl-Y3--/qimqri41kfv2zvo3tnsu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67745\",\"title\":\"Charcoal Ring and Diffusor Plate\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--4rZAl-Y3--/qimqri41kfv2zvo3tnsu.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-67802\",\"title\":\"Premium Charcoal Starter\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-premium-charcoal-starter\",\"image\":\"https://images.salsify.com/image/upload/s--KpPKaaaL--/zp9uaxcsd7r8rcdvaqch.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"67802\",\"title\":\"Premium Charcoal Starter\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--KpPKaaaL--/zp9uaxcsd7r8rcdvaqch.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-68001\",\"title\":\"Grill Mat for PRO & Prestige® 500 Series and Smaller\",\"category\":\"Accessories\",\"subcategory\":\"Grill & Shelf Mats\",\"handle\":\"napoleon-grill-mat-for-pro-prestige-500-series-and-smaller\",\"image\":\"https://images.salsify.com/image/upload/s--knmT5_8G--/atgkkmw6izsnaqqmuuyb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68001\",\"title\":\"Grill Mat for PRO & Prestige® 500 Series and Smaller\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--knmT5_8G--/atgkkmw6izsnaqqmuuyb.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-68002\",\"title\":\"Grill Mat for Large Grills\",\"category\":\"Accessories\",\"subcategory\":\"Grill & Shelf Mats\",\"handle\":\"napoleon-grill-mat-for-large-grills\",\"image\":\"https://images.salsify.com/image/upload/s--fxbRCqjD--/sytvqkjy5m1fmexj39p1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68002\",\"title\":\"Grill Mat for Large Grills\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--fxbRCqjD--/sytvqkjy5m1fmexj39p1.jpg\",\"price\":93.99}]},{\"product_id\":\"napoleon-item-68003\",\"title\":\"Prestige® Under Grill Storage, 2 Carts\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-prestige-under-grill-storage-2-carts\",\"image\":\"https://images.salsify.com/image/upload/s--vBo-g2hd--/wzz33oxbew8kz9i2n5kz.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68003\",\"title\":\"Prestige® Under Grill Storage, 2 Carts\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--vBo-g2hd--/wzz33oxbew8kz9i2n5kz.jpg\",\"price\":665.99}]},{\"product_id\":\"napoleon-item-68004\",\"title\":\"Phantom Prestige® Under Grill Storage, 2 Carts\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-phantom-prestige-under-grill-storage-2-carts\",\"image\":\"https://images.salsify.com/image/upload/s--z80FTV35--/s7wa8xhymbejd4fai4vz.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68004\",\"title\":\"Phantom Prestige® Under Grill Storage, 2 Carts\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--z80FTV35--/s7wa8xhymbejd4fai4vz.jpg\",\"price\":665.99}]},{\"product_id\":\"napoleon-item-68006\",\"title\":\"Rogue® PRO-S Under Grill Storage Cart, Matte Black\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-rogue-pro-s-under-grill-storage-cart-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--hXXtHhlt--/enkc3pjp91tmyflideh1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68006\",\"title\":\"Rogue® PRO-S Under Grill Storage Cart, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--hXXtHhlt--/enkc3pjp91tmyflideh1.jpg\",\"price\":278.99}]},{\"product_id\":\"napoleon-item-68008\",\"title\":\"Rogue® PRO Under Grill Storage Cart, Stainless Steel\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-rogue-pro-under-grill-storage-cart-stainless-steel\",\"image\":\"https://images.salsify.com/image/upload/s--5aDLzvmM--/uyowprezxb9fcxwvz9ub.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68008\",\"title\":\"Rogue® PRO Under Grill Storage Cart, Stainless Steel\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--5aDLzvmM--/uyowprezxb9fcxwvz9ub.jpg\",\"price\":278.99}]},{\"product_id\":\"napoleon-item-68009\",\"title\":\"Rogue® PRO Under Grill Storage Cart, Black\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-rogue-pro-under-grill-storage-cart-black\",\"image\":\"https://images.salsify.com/image/upload/s--2SFtLDRS--/vyjdo5rx4oj2glmindxh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"68009\",\"title\":\"Rogue® PRO Under Grill Storage Cart, Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--2SFtLDRS--/vyjdo5rx4oj2glmindxh.jpg\",\"price\":278.99}]},{\"product_id\":\"napoleon-item-69211\",\"title\":\"Heavy Duty Rotisserie Kit for PRO 500 & Prestige® 500 Grill Models\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-heavy-duty-rotisserie-kit-for-pro-500-prestige-500-grill-models\",\"image\":\"https://images.salsify.com/image/upload/s--N906ctOP--/mxwsdxlvpkfoi7wydiqi.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69211\",\"title\":\"Heavy Duty Rotisserie Kit for PRO 500 & Prestige® 500 Grill Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--N906ctOP--/mxwsdxlvpkfoi7wydiqi.jpg\",\"price\":113.99}]},{\"product_id\":\"napoleon-item-69231\",\"title\":\"Commercial Grade Rotisserie Kit for PRO 500 & Prestige® 500 Grill Models\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-commercial-grade-rotisserie-kit-for-pro-500-prestige-500-grill-models\",\"image\":\"https://images.salsify.com/image/upload/s--4vrsQJN5--/in3ihqtwnqg3qpinskx2.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69231\",\"title\":\"Commercial Grade Rotisserie Kit for PRO 500 & Prestige® 500 Grill Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--4vrsQJN5--/in3ihqtwnqg3qpinskx2.jpg\",\"price\":169.99}]},{\"product_id\":\"napoleon-item-69241\",\"title\":\"Commercial Grade Rotisserie Kit for PRO Charcoal Kettle 22 and 18-inch Grills\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-commercial-grade-rotisserie-kit-for-pro-charcoal-kettle-22-and-18-inch-grills\",\"image\":\"https://images.salsify.com/image/upload/s--EyXSMc8F--/jmuous2sbwybba532qfn.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69241\",\"title\":\"Commercial Grade Rotisserie Kit for PRO Charcoal Kettle 22 and 18-inch Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"18 inch\",\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--EyXSMc8F--/jmuous2sbwybba532qfn.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-69301\",\"title\":\"Heavy Duty Rotisserie for Freestyle™ Grill Series\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-heavy-duty-rotisserie-for-freestyle-grill-series\",\"image\":\"https://images.salsify.com/image/upload/s--JdhHEDvx--/gr9ypjskmkobmpesrh2z.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69301\",\"title\":\"Heavy Duty Rotisserie for Freestyle™ Grill Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--JdhHEDvx--/gr9ypjskmkobmpesrh2z.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-69331\",\"title\":\"Commercial Grade Rotisserie Kit for Charcoal PRO Grill (PRO605CSS)\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-commercial-grade-rotisserie-kit-for-charcoal-pro-grill-pro605css\",\"image\":\"https://images.salsify.com/image/upload/s--O9gZHykd--/et4pxbhgaimq2uejf1kb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69331\",\"title\":\"Commercial Grade Rotisserie Kit for Charcoal PRO Grill (PRO605CSS)\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--O9gZHykd--/et4pxbhgaimq2uejf1kb.jpg\",\"price\":187.99}]},{\"product_id\":\"napoleon-item-69851\",\"title\":\"Add-on Rotisserie Kit for Built-in 700 Series 44\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-add-on-rotisserie-kit-for-built-in-700-series-44\",\"image\":\"https://images.salsify.com/image/upload/s--aDygF0AP--/xt2yg7ay9fidlq8ehedb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69851\",\"title\":\"Add-on Rotisserie Kit for Built-in 700 Series 44\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--aDygF0AP--/xt2yg7ay9fidlq8ehedb.jpg\",\"price\":149.99}]},{\"product_id\":\"napoleon-item-69911\",\"title\":\"Heavy Duty Rotisserie Kit for all Rogue® Grill Series\",\"category\":\"Accessories\",\"subcategory\":\"Rotisserie Accessories\",\"handle\":\"napoleon-heavy-duty-rotisserie-kit-for-all-rogue-grill-series\",\"image\":\"https://images.salsify.com/image/upload/s--vARnKLvI--/grr95kenpsz02my1zyr9.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"69911\",\"title\":\"Heavy Duty Rotisserie Kit for all Rogue® Grill Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--vARnKLvI--/grr95kenpsz02my1zyr9.jpg\",\"price\":113.99}]},{\"product_id\":\"napoleon-item-70000\",\"title\":\"10 Inch Personal Sized Pizza/Baking Stone Set\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-10-inch-personal-sized-pizza-baking-stone-set\",\"image\":\"https://images.salsify.com/image/upload/s--bJXAxBey--/ro59x7cufpaotldopsmv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70000\",\"title\":\"10 Inch Personal Sized Pizza/Baking Stone Set\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"10 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--bJXAxBey--/ro59x7cufpaotldopsmv.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-70003\",\"title\":\"PRO Pizza Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-pro-pizza-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--_9QFrAyu--/zc7wmi0nxsjck6gdk3co.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70003\",\"title\":\"PRO Pizza Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--_9QFrAyu--/zc7wmi0nxsjck6gdk3co.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-70006\",\"title\":\"PRO Wireless Digital Thermometer\",\"category\":\"Accessories\",\"subcategory\":\"Thermometers\",\"handle\":\"napoleon-pro-wireless-digital-thermometer\",\"image\":\"https://images.salsify.com/image/upload/s--iV-4GAi_--/tszhmdolgbfdoeix4ynd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70006\",\"title\":\"PRO Wireless Digital Thermometer\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--iV-4GAi_--/tszhmdolgbfdoeix4ynd.jpg\",\"price\":64.99}]},{\"product_id\":\"napoleon-item-70008\",\"title\":\"Rectangular Baking Stone\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-rectangular-baking-stone\",\"image\":\"https://images.salsify.com/image/upload/s--03BxcEMV--/esook34w5gnoi9ks0imv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70008\",\"title\":\"Rectangular Baking Stone\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--03BxcEMV--/esook34w5gnoi9ks0imv.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-70009\",\"title\":\"PRO Stainless Steel Rib / Roast Rack\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-pro-stainless-steel-rib-roast-rack\",\"image\":\"https://images.salsify.com/image/upload/s--1nt7UJeT--/hvzkpyexgt4j44rqr8gh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70009\",\"title\":\"PRO Stainless Steel Rib / Roast Rack\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--1nt7UJeT--/hvzkpyexgt4j44rqr8gh.jpg\",\"price\":80.99}]},{\"product_id\":\"napoleon-item-70012\",\"title\":\"PRO Cutting Board with Stainless Steel Bowls\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-pro-cutting-board-with-stainless-steel-bowls\",\"image\":\"https://images.salsify.com/image/upload/s--KMNwhDXf--/ccrvbiks3n07rsfyxyfp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70012\",\"title\":\"PRO Cutting Board with Stainless Steel Bowls\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--KMNwhDXf--/ccrvbiks3n07rsfyxyfp.jpg\",\"price\":52.99}]},{\"product_id\":\"napoleon-item-70015\",\"title\":\"Eight Stainless Steel Multifunctional Skewers\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-eight-stainless-steel-multifunctional-skewers\",\"image\":\"https://images.salsify.com/image/upload/s--MbmuFbGY--/mloje07cb1qmpqmhwczo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70015\",\"title\":\"Eight Stainless Steel Multifunctional Skewers\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--MbmuFbGY--/mloje07cb1qmpqmhwczo.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-70048\",\"title\":\"Fast Read Thermometer\",\"category\":\"Accessories\",\"subcategory\":\"Thermometers\",\"handle\":\"napoleon-fast-read-thermometer\",\"image\":\"https://images.salsify.com/image/upload/s--adPK-8Sl--/memldzz5icbgtaruj37r.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70048\",\"title\":\"Fast Read Thermometer\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--adPK-8Sl--/memldzz5icbgtaruj37r.jpg\",\"price\":39.99}]},{\"product_id\":\"napoleon-item-70049\",\"title\":\"Grill Light\",\"category\":\"Accessories\",\"subcategory\":\"Grill Lighting\",\"handle\":\"napoleon-grill-light\",\"image\":\"https://images.salsify.com/image/upload/s---2qjYGHO--/iaksklsa0jiuldwblmrc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70049\",\"title\":\"Grill Light\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s---2qjYGHO--/iaksklsa0jiuldwblmrc.jpg\",\"price\":22.99}]},{\"product_id\":\"napoleon-item-70055\",\"title\":\"Breakfast Toolset with 4 Egg Rings\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-breakfast-toolset-with-4-egg-rings\",\"image\":\"https://images.salsify.com/image/upload/s--0BNXezxf--/ebcewm0l226xlwmmx2cb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70055\",\"title\":\"Breakfast Toolset with 4 Egg Rings\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--0BNXezxf--/ebcewm0l226xlwmmx2cb.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-70060\",\"title\":\"Gourmet Burger Press Kit\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-gourmet-burger-press-kit\",\"image\":\"https://images.salsify.com/image/upload/s--QYQj5n41--/k6swrstjd5niydmmmjwh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70060\",\"title\":\"Gourmet Burger Press Kit\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--QYQj5n41--/k6swrstjd5niydmmmjwh.jpg\",\"price\":17.99}]},{\"product_id\":\"napoleon-item-70063\",\"title\":\"Premium Butcher Paper\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-premium-butcher-paper\",\"image\":\"https://images.salsify.com/image/upload/s--bZGvofKB--/qis3c1pa59vej2wrnoxf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70063\",\"title\":\"Premium Butcher Paper\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--bZGvofKB--/qis3c1pa59vej2wrnoxf.jpg\",\"price\":28.99}]},{\"product_id\":\"napoleon-item-70084\",\"title\":\"Premium Pizza Stone\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-premium-pizza-stone\",\"image\":\"https://images.salsify.com/image/upload/s--T8uSQ_Fc--/xdd5rryddaejvfciituh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70084\",\"title\":\"Premium Pizza Stone\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--T8uSQ_Fc--/xdd5rryddaejvfciituh.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-70113\",\"title\":\"Bamboo Cutting Board\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-bamboo-cutting-board\",\"image\":\"https://images.salsify.com/image/upload/s--S_PpOnNA--/fakxumvvhecl6dorsrmp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70113\",\"title\":\"Bamboo Cutting Board\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--S_PpOnNA--/fakxumvvhecl6dorsrmp.jpg\",\"price\":37.99}]},{\"product_id\":\"napoleon-item-70115\",\"title\":\"Bamboo Skewers 12\\\"\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-bamboo-skewers-12\",\"image\":\"https://images.salsify.com/image/upload/s--wX3Vke9E--/c835zj6bucpougajufqx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70115\",\"title\":\"Bamboo Skewers 12\\\"\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"12 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--wX3Vke9E--/c835zj6bucpougajufqx.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-70116\",\"title\":\"Bamboo Skewers 6\\\"\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-bamboo-skewers-6\",\"image\":\"https://images.salsify.com/image/upload/s--_4KaBJE3--/b8vtrqghy6fjjqysztyr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70116\",\"title\":\"Bamboo Skewers 6\\\"\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"6 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--_4KaBJE3--/b8vtrqghy6fjjqysztyr.jpg\",\"price\":5.99}]},{\"product_id\":\"napoleon-item-70122\",\"title\":\"Side Shelf Mat for Rogue & Rogue XT Grill Models\",\"category\":\"Accessories\",\"subcategory\":\"Grill & Shelf Mats\",\"handle\":\"napoleon-side-shelf-mat-for-rogue-rogue-xt-grill-models\",\"image\":\"https://images.salsify.com/image/upload/s--TNo6cWLA--/xhnqzace8njhf011pppc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70122\",\"title\":\"Side Shelf Mat for Rogue & Rogue XT Grill Models\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--TNo6cWLA--/xhnqzace8njhf011pppc.jpg\",\"price\":17.99}]},{\"product_id\":\"napoleon-item-70123\",\"title\":\"Side Shelf Mat for Prestige® & Rogue SE Grill Models\",\"category\":\"Accessories\",\"subcategory\":\"Grill & Shelf Mats\",\"handle\":\"napoleon-side-shelf-mat-for-prestige-rogue-se-grill-models\",\"image\":\"https://images.salsify.com/image/upload/s--TNo6cWLA--/xhnqzace8njhf011pppc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70123\",\"title\":\"Side Shelf Mat for Prestige® & Rogue SE Grill Models\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--TNo6cWLA--/xhnqzace8njhf011pppc.jpg\",\"price\":28.99}]},{\"product_id\":\"napoleon-item-70130\",\"title\":\"ACCU-PROBE™ PRO X: Wireless Bluetooth® Smart Thermometer\",\"category\":\"Accessories\",\"subcategory\":\"Thermometers\",\"handle\":\"napoleon-accu-probe-pro-x-wireless-bluetooth-smart-thermometer\",\"image\":\"https://images.salsify.com/image/upload/s--Z-VTL0Wx--/spogouklzlvne6h6jajj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70130\",\"title\":\"ACCU-PROBE™ PRO X: Wireless Bluetooth® Smart Thermometer\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--Z-VTL0Wx--/spogouklzlvne6h6jajj.jpg\",\"price\":144.99}]},{\"product_id\":\"napoleon-item-70150\",\"title\":\"Ceramic Roasting Pan and Beer Can Chicken Roaster Set\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-ceramic-roasting-pan-and-beer-can-chicken-roaster-set\",\"image\":\"https://images.salsify.com/image/upload/s--oh2NSDO3--/nkygfzyytvy60ege1trt.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70150\",\"title\":\"Ceramic Roasting Pan and Beer Can Chicken Roaster Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--oh2NSDO3--/nkygfzyytvy60ege1trt.jpg\",\"price\":81.99}]},{\"product_id\":\"napoleon-item-70151\",\"title\":\"Ceramic Casserole Dish\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-ceramic-casserole-dish\",\"image\":\"https://images.salsify.com/image/upload/s--dfUz7xKB--/bsp1xdr14uoofr2djww8.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70151\",\"title\":\"Ceramic Casserole Dish\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--dfUz7xKB--/bsp1xdr14uoofr2djww8.jpg\",\"price\":94.99}]},{\"product_id\":\"napoleon-item-70152\",\"title\":\"Cast Iron Round Casserole Dish\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-cast-iron-round-casserole-dish\",\"image\":\"https://images.salsify.com/image/upload/s--aFtTou6w--/jetz8hutmw1qxequa68g.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70152\",\"title\":\"Cast Iron Round Casserole Dish\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--aFtTou6w--/jetz8hutmw1qxequa68g.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-70188\",\"title\":\"Mini BBQ for kids\",\"category\":\"Accessories\",\"subcategory\":\"Kids Grilling Toys\",\"handle\":\"napoleon-mini-bbq-for-kids\",\"image\":\"https://images.salsify.com/image/upload/s--QpjUfbzE--/bpq58t645h6zkyguod8z.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"70188\",\"title\":\"Mini BBQ for kids\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--QpjUfbzE--/bpq58t645h6zkyguod8z.jpg\",\"price\":122.99}]},{\"product_id\":\"napoleon-item-71022\",\"title\":\"Warming Rack for Charcoal Kettle Grills\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-warming-rack-for-charcoal-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--HPgMJ3UV--/mwhkuobpxkcvnuqvliv2.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"71022\",\"title\":\"Warming Rack for Charcoal Kettle Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--HPgMJ3UV--/mwhkuobpxkcvnuqvliv2.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-71301\",\"title\":\"SIZZLE ZONE® Burner Windshield and Skewer Rack - Large\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-sizzle-zone-burner-windshield-and-skewer-rack-large\",\"image\":\"https://images.salsify.com/image/upload/s--vvqXrFCW--/maiclu9m57y9uhzyk0wf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"71301\",\"title\":\"SIZZLE ZONE® Burner Windshield and Skewer Rack - Large\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--vvqXrFCW--/maiclu9m57y9uhzyk0wf.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-71302\",\"title\":\"SIZZLE ZONE® Burner Windshield and Skewer Rack - Small\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-sizzle-zone-burner-windshield-and-skewer-rack-small\",\"image\":\"https://images.salsify.com/image/upload/s--ddvGdFpT--/g11qzmffffrn793pirra.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"71302\",\"title\":\"SIZZLE ZONE® Burner Windshield and Skewer Rack - Small\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--ddvGdFpT--/g11qzmffffrn793pirra.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-71500\",\"title\":\"Multifunctional Warming Rack for Prestige® /PRO 500\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-multifunctional-warming-rack-for-prestige-pro-500\",\"image\":\"https://images.salsify.com/image/upload/s--ra19KVUP--/k0ixstegaofn16bhmsfg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"71500\",\"title\":\"Multifunctional Warming Rack for Prestige® /PRO 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--ra19KVUP--/k0ixstegaofn16bhmsfg.jpg\",\"price\":112.99}]},{\"product_id\":\"napoleon-item-90002\",\"title\":\"Pizza Lover's - Starter Kit\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-pizza-lover-s-starter-kit\",\"image\":\"https://images.salsify.com/image/upload/s--6COfu2wT--/udw036i1j0shwaaumqqo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"90002\",\"title\":\"Pizza Lover's - Starter Kit\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6COfu2wT--/udw036i1j0shwaaumqqo.jpg\",\"price\":84.99}]},{\"product_id\":\"napoleon-item-bi-1808-1dr\",\"title\":\"18\\\" X 8\\\" Single Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-8-single-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--UADX5irY--/ph0qwltqomo4cipmlenf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1808-1DR\",\"title\":\"18\\\" X 8\\\" Single Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--UADX5irY--/ph0qwltqomo4cipmlenf.jpg\",\"price\":669}]},{\"product_id\":\"napoleon-item-bi-1816-1d\",\"title\":\"18\\\" X 16\\\" Single Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-16-single-door\",\"image\":\"https://images.salsify.com/image/upload/s--Y3sBmaZa--/qizvupa4lmpxmrlkzbbg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1816-1D\",\"title\":\"18\\\" X 16\\\" Single Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--Y3sBmaZa--/qizvupa4lmpxmrlkzbbg.jpg\",\"price\":499}]},{\"product_id\":\"napoleon-item-bi-1816-1dr\",\"title\":\"18\\\" X 16\\\" Large Single Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-16-large-single-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--xQq6dt-D--/w7khvvawuplwz2ldgbdm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1816-1DR\",\"title\":\"18\\\" X 16\\\" Large Single Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--xQq6dt-D--/w7khvvawuplwz2ldgbdm.jpg\",\"price\":729}]},{\"product_id\":\"napoleon-item-bi-1816-2dr\",\"title\":\"18\\\" X 16\\\" Double Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-16-double-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--hSleRsiP--/hsrthvzngr5mdngqykm5.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1816-2DR\",\"title\":\"18\\\" X 16\\\" Double Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--hSleRsiP--/hsrthvzngr5mdngqykm5.jpg\",\"price\":839}]},{\"product_id\":\"napoleon-item-bi-1823-zcl\",\"title\":\"Zero Clearance Liner for Built-in 12 Side Burners\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-for-built-in-12-side-burners\",\"image\":\"https://images.salsify.com/image/upload/s--2n8kyRwv--/ym7kv96zeupfmkg2ycos.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1823-ZCL\",\"title\":\"Zero Clearance Liner for Built-in 12 Side Burners\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--2n8kyRwv--/ym7kv96zeupfmkg2ycos.jpg\",\"price\":499}]},{\"product_id\":\"napoleon-item-bi-1824-1d\",\"title\":\"18\\\" x 24\\\" Reversible Single Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-24-reversible-single-door\",\"image\":\"https://images.salsify.com/image/upload/s--Fszidr0O--/wu5micy5byew39enwl71.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1824-1D\",\"title\":\"18\\\" x 24\\\" Reversible Single Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--Fszidr0O--/wu5micy5byew39enwl71.jpg\",\"price\":549}]},{\"product_id\":\"napoleon-item-bi-1824-1w\",\"title\":\"18\\\" X 24\\\" Double Drawer: Waste Bin\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-24-double-drawer-waste-bin\",\"image\":\"https://images.salsify.com/image/upload/s--rLe7pLPf--/g9t83cdhii2gkjpmfeuu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1824-1W\",\"title\":\"18\\\" X 24\\\" Double Drawer: Waste Bin\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--rLe7pLPf--/g9t83cdhii2gkjpmfeuu.jpg\",\"price\":949}]},{\"product_id\":\"napoleon-item-bi-1824-2dr\",\"title\":\"18\\\" X 24\\\" Double Drawer: Large and Standard\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-24-double-drawer-large-and-standard\",\"image\":\"https://images.salsify.com/image/upload/s--rLe7pLPf--/g9t83cdhii2gkjpmfeuu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1824-2DR\",\"title\":\"18\\\" X 24\\\" Double Drawer: Large and Standard\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--rLe7pLPf--/g9t83cdhii2gkjpmfeuu.jpg\",\"price\":949}]},{\"product_id\":\"napoleon-item-bi-1824-3dr\",\"title\":\"18\\\" X 24\\\" Triple Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-18-x-24-triple-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--GY-ZwtTL--/ntogr9sq1g3oe3ewcmes.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-1824-3DR\",\"title\":\"18\\\" X 24\\\" Triple Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--GY-ZwtTL--/ntogr9sq1g3oe3ewcmes.jpg\",\"price\":1049}]},{\"product_id\":\"napoleon-item-bi-2418-bev\",\"title\":\"Multi-Functional Beverage Center\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Sinks & Beverage Centers\",\"handle\":\"napoleon-multi-functional-beverage-center\",\"image\":\"https://images.salsify.com/image/upload/s--imWVngvE--/v93m75ztsvdowcxw8era.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-2418-BEV\",\"title\":\"Multi-Functional Beverage Center\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--imWVngvE--/v93m75ztsvdowcxw8era.jpg\",\"price\":1499}]},{\"product_id\":\"napoleon-item-bi-2423-zcl\",\"title\":\"Zero Clearance Liner for Built-in 700 Series Dual Burners\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-for-built-in-700-series-dual-burners\",\"image\":\"https://images.salsify.com/image/upload/s--2ohvEgw0--/xtoy1rpzkyikirxpkptr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-2423-ZCL\",\"title\":\"Zero Clearance Liner for Built-in 700 Series Dual Burners\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--2ohvEgw0--/xtoy1rpzkyikirxpkptr.jpg\",\"price\":549}]},{\"product_id\":\"napoleon-item-bi-3016-2d\",\"title\":\"30\\\" x 16\\\" Small Double Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-30-x-16-small-double-door\",\"image\":\"https://images.salsify.com/image/upload/s--8fUcDifP--/yfbl8xm97uurk9qhg61z.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3016-2D\",\"title\":\"30\\\" x 16\\\" Small Double Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"30 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--8fUcDifP--/yfbl8xm97uurk9qhg61z.jpg\",\"price\":669}]},{\"product_id\":\"napoleon-item-bi-3024-2d\",\"title\":\"30\\\" X 24\\\" Double Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-30-x-24-double-door\",\"image\":\"https://images.salsify.com/image/upload/s--Z_LTFS6C--/zef3szvfhetyh6lheyu1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3024-2D\",\"title\":\"30\\\" X 24\\\" Double Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"30 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--Z_LTFS6C--/zef3szvfhetyh6lheyu1.jpg\",\"price\":829}]},{\"product_id\":\"napoleon-item-bi-3323-zcl\",\"title\":\"Zero Clearance Liner LEX485 / P500\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-lex485-p500\",\"image\":\"https://images.salsify.com/image/upload/s--UQfDYCir--/wld6hytak2kgovpnk9l3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3323-ZCL\",\"title\":\"Zero Clearance Liner LEX485 / P500\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--UQfDYCir--/wld6hytak2kgovpnk9l3.jpg\",\"price\":1109}]},{\"product_id\":\"napoleon-item-bi-3616-1d2dr\",\"title\":\"36\\\" X 16\\\" Single Door & Double Drawer Combo\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-16-single-door-double-drawer-combo\",\"image\":\"https://images.salsify.com/image/upload/s--pJ0HFt9G--/hq4cqvfum1jxjyd2ceqx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3616-1D2DR\",\"title\":\"36\\\" X 16\\\" Single Door & Double Drawer Combo\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--pJ0HFt9G--/hq4cqvfum1jxjyd2ceqx.jpg\",\"price\":1049}]},{\"product_id\":\"napoleon-item-bi-3616-2d\",\"title\":\"36\\\" X 16\\\" Small Double Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-16-small-double-door\",\"image\":\"https://images.salsify.com/image/upload/s--mL_8j1wC--/ierawgj7jdjzqrbeytjb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3616-2D\",\"title\":\"36\\\" X 16\\\" Small Double Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--mL_8j1wC--/ierawgj7jdjzqrbeytjb.jpg\",\"price\":899}]},{\"product_id\":\"napoleon-item-bi-3623-zcl\",\"title\":\"Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft\",\"image\":\"https://images.salsify.com/image/upload/s--2gUDoLBH--/q2xqvbylcszidntwafow.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3623-ZCL\",\"title\":\"Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--2gUDoLBH--/q2xqvbylcszidntwafow.jpg\",\"price\":729}]},{\"product_id\":\"napoleon-item-bi-3624-1d1w\",\"title\":\"36\\\" X 24\\\" Single Door & Waste Bin Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-24-single-door-waste-bin-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--sBzn0_OY--/uhdazrq9yowztzryl8yl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3624-1D1W\",\"title\":\"36\\\" X 24\\\" Single Door & Waste Bin Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--sBzn0_OY--/uhdazrq9yowztzryl8yl.jpg\",\"price\":1399}]},{\"product_id\":\"napoleon-item-bi-3624-1d2dr\",\"title\":\"36\\\" X 24\\\" Single Door & Standard Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-24-single-door-standard-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--3bvdmCsf--/ahfhyvvmirsgmm4far1m.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3624-1D2DR\",\"title\":\"36\\\" X 24\\\" Single Door & Standard Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--3bvdmCsf--/ahfhyvvmirsgmm4far1m.jpg\",\"price\":1399}]},{\"product_id\":\"napoleon-item-bi-3624-1d3dr\",\"title\":\"36\\\" X 24\\\" Single Door & Triple Drawer Combo\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-24-single-door-triple-drawer-combo\",\"image\":\"https://images.salsify.com/image/upload/s--0g2WAbRE--/l5p9v1dybgw4ij4ib6bs.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3624-1D3DR\",\"title\":\"36\\\" X 24\\\" Single Door & Triple Drawer Combo\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--0g2WAbRE--/l5p9v1dybgw4ij4ib6bs.jpg\",\"price\":1499}]},{\"product_id\":\"napoleon-item-bi-3624-2d\",\"title\":\"36\\\" X 24\\\" Large Double Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-36-x-24-large-double-door\",\"image\":\"https://images.salsify.com/image/upload/s--SA5obWaR--/a5wuqkr5gvyv7cjvnwxa.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-3624-2D\",\"title\":\"36\\\" X 24\\\" Large Double Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--SA5obWaR--/a5wuqkr5gvyv7cjvnwxa.jpg\",\"price\":949}]},{\"product_id\":\"napoleon-item-bi-4208-1dr\",\"title\":\"42\\\" X 8\\\" Extra Large Single Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-8-extra-large-single-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--vVVTjbeB--/ybjnfmv1jivphwdwvtpj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4208-1DR\",\"title\":\"42\\\" X 8\\\" Extra Large Single Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--vVVTjbeB--/ybjnfmv1jivphwdwvtpj.jpg\",\"price\":1279}]},{\"product_id\":\"napoleon-item-bi-4216-1d2dr\",\"title\":\"42\\\" X 16\\\" Single Door & Double Drawer Combo\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-16-single-door-double-drawer-combo\",\"image\":\"https://images.salsify.com/image/upload/s--hYhQxc3y--/quugpmnrwxev5rqgwrw8.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4216-1D2DR\",\"title\":\"42\\\" X 16\\\" Single Door & Double Drawer Combo\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--hYhQxc3y--/quugpmnrwxev5rqgwrw8.jpg\",\"price\":1279}]},{\"product_id\":\"napoleon-item-bi-4216-2d\",\"title\":\"42\\\" x 16\\\" Small Double Door\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-16-small-double-door\",\"image\":\"https://images.salsify.com/image/upload/s--LxOR9haN--/vta9sac6rytgrrkfdybl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4216-2D\",\"title\":\"42\\\" x 16\\\" Small Double Door\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--LxOR9haN--/vta9sac6rytgrrkfdybl.jpg\",\"price\":889}]},{\"product_id\":\"napoleon-item-bi-4223-zcl\",\"title\":\"Zero Clearance Liner for Built-in 700 Series 38\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-for-built-in-700-series-38\",\"image\":\"https://images.salsify.com/image/upload/s--njnZAWqV--/aqyumgroifkpshtjd4z6.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4223-ZCL\",\"title\":\"Zero Clearance Liner for Built-in 700 Series 38\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--njnZAWqV--/aqyumgroifkpshtjd4z6.jpg\",\"price\":829}]},{\"product_id\":\"napoleon-item-bi-4224-1d1w\",\"title\":\"42\\\" X 24\\\" Large Door & Waste Bin Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-24-large-door-waste-bin-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--W-MVOVuY--/tpmhduwa4bkvmt3pdiqf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4224-1D1W\",\"title\":\"42\\\" X 24\\\" Large Door & Waste Bin Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--W-MVOVuY--/tpmhduwa4bkvmt3pdiqf.jpg\",\"price\":1449}]},{\"product_id\":\"napoleon-item-bi-4224-1d2dr\",\"title\":\"42\\\" X 24\\\" Large Single Door & Standard Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-24-large-single-door-standard-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--fj2IRqPn--/ew2zsx4ygxxjreyp2ees.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4224-1D2DR\",\"title\":\"42\\\" X 24\\\" Large Single Door & Standard Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--fj2IRqPn--/ew2zsx4ygxxjreyp2ees.jpg\",\"price\":1499}]},{\"product_id\":\"napoleon-item-bi-4224-1d3dr\",\"title\":\"42\\\" X 24\\\" Large Single Door & Triple Drawer\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Doors & Drawers\",\"handle\":\"napoleon-42-x-24-large-single-door-triple-drawer\",\"image\":\"https://images.salsify.com/image/upload/s--HpAMstnb--/u7ttm8w3dbkccxvgvgj3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4224-1D3DR\",\"title\":\"42\\\" X 24\\\" Large Single Door & Triple Drawer\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--HpAMstnb--/u7ttm8w3dbkccxvgvgj3.jpg\",\"price\":1609}]},{\"product_id\":\"napoleon-item-bi-4823-zcl\",\"title\":\"Zero Clearance Liner for Built-in 700 Series 44\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Insulating Liners\",\"handle\":\"napoleon-zero-clearance-liner-for-built-in-700-series-44\",\"image\":\"https://images.salsify.com/image/upload/s--svVWFdTx--/rbevawchvryi387yczfk.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-4823-ZCL\",\"title\":\"Zero Clearance Liner for Built-in 700 Series 44\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--svVWFdTx--/rbevawchvryi387yczfk.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-item-bi-tsk\",\"title\":\"Slide-Out Propane Tank Kit\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Propane Tank Storage\",\"handle\":\"napoleon-slide-out-propane-tank-kit\",\"image\":\"https://images.salsify.com/image/upload/s--3kNaD_pU--/qbyimymtjeuxqbnstxp2.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"BI-TSK\",\"title\":\"Slide-Out Propane Tank Kit\",\"fuel\":\"Propane\",\"installation\":null,\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://images.salsify.com/image/upload/s--3kNaD_pU--/qbyimymtjeuxqbnstxp2.jpg\",\"price\":109}]},{\"product_id\":\"napoleon-bi10rt\",\"title\":\"Built-in 500 Series Single Range Top Burner, Stainless Steel Cover\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bi10rt\",\"image\":\"https://images.salsify.com/image/upload/s--JxU1VqhW--/jdj9mputcr4ylb3sxnmb.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BI10RTNSS\",\"title\":\"Built-in 500 Series Single Range Top Burner, Stainless Steel Cover\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--JxU1VqhW--/jdj9mputcr4ylb3sxnmb.jpg\",\"price\":499},{\"manufacturer_sku\":\"BI10RTPSS\",\"title\":\"Built-in 500 Series Single Range Top Burner, Stainless Steel Cover\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--JxU1VqhW--/jdj9mputcr4ylb3sxnmb.jpg\",\"price\":499}]},{\"product_id\":\"napoleon-bi12rt\",\"title\":\"Built-in 500 Series Inline Dual Range Top Burner, Stainless Steel Cover\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bi12rt\",\"image\":\"https://images.salsify.com/image/upload/s--A96JZCc0--/e2xukptmg3qvbqybyuwo.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BI12RTNSS\",\"title\":\"Built-in 500 Series Inline Dual Range Top Burner, Stainless Steel Cover\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--A96JZCc0--/e2xukptmg3qvbqybyuwo.jpg\",\"price\":779},{\"manufacturer_sku\":\"BI12RTPSS\",\"title\":\"Built-in 500 Series Inline Dual Range Top Burner, Stainless Steel Cover\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--A96JZCc0--/e2xukptmg3qvbqybyuwo.jpg\",\"price\":779}]},{\"product_id\":\"napoleon-built-in-500-gas-grills\",\"title\":\"Built-in 500 Series Gas Grills\",\"category\":\"Grills\",\"subcategory\":\"Built-in Grill Heads\",\"handle\":\"napoleon-built-in-500-gas-grills\",\"image\":\"https://images.salsify.com/image/upload/s--BbhBFRfa--/nz7l9mel18gzpdyy48yp.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BI32NSS\",\"title\":\"Built-in 500 Series 32 Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--BbhBFRfa--/nz7l9mel18gzpdyy48yp.jpg\",\"price\":1514},{\"manufacturer_sku\":\"BI32PSS\",\"title\":\"Built-in 500 Series 32 Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--BbhBFRfa--/nz7l9mel18gzpdyy48yp.jpg\",\"price\":1514}]},{\"product_id\":\"napoleon-bib10ir\",\"title\":\"Built-in 700 Series 10-inch Single Infrared Burner\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib10ir\",\"image\":\"https://images.salsify.com/image/upload/s--crXCLf3z--/rxhyp3dev7ig9tfsc9et.jpg\",\"sku_count\":4,\"variants\":[{\"manufacturer_sku\":\"BIB10IRNSS\",\"title\":\"Built-In 700 Series 10\\\" Single Infrared Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--crXCLf3z--/rxhyp3dev7ig9tfsc9et.jpg\",\"price\":779},{\"manufacturer_sku\":\"BIB10IRPSS\",\"title\":\"Built-In 700 Series 10\\\" Single Infrared Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--crXCLf3z--/rxhyp3dev7ig9tfsc9et.jpg\",\"price\":779},{\"manufacturer_sku\":\"BIB10IRNMK\",\"title\":\"Built-In 700 Series 10\\\" Single Infrared Burner Natural Gas, Matte Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--NoMp_RyS--/oioc06msvzn9jrgdyqjo.jpg\",\"price\":679},{\"manufacturer_sku\":\"BIB10IRPMK\",\"title\":\"Built-In 700 Series 10\\\" Single Infrared Burner Propane, Matte Black\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--NoMp_RyS--/oioc06msvzn9jrgdyqjo.jpg\",\"price\":679}]},{\"product_id\":\"napoleon-bib10rt\",\"title\":\"Built-In 700 Series 10\\\"  Single Range Top Burner Stainless Steel\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib10rt\",\"image\":\"https://images.salsify.com/image/upload/s--rDMutXWh--/rrngchi15fa0kofx4lnr.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIB10RTNSS\",\"title\":\"Built-In 700 Series 10\\\"  Single Range Top Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--rDMutXWh--/rrngchi15fa0kofx4lnr.jpg\",\"price\":679},{\"manufacturer_sku\":\"BIB10RTPSS\",\"title\":\"Built-In 700 Series 10\\\"  Single Range Top Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"10 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--rDMutXWh--/rrngchi15fa0kofx4lnr.jpg\",\"price\":679}]},{\"product_id\":\"napoleon-bib12rt\",\"title\":\"Built-in 700 Series 12\\\" Inline Dual Range Burner Stainless Steel\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib12rt\",\"image\":\"https://images.salsify.com/image/upload/s--DeQvqJgm--/plxgp3o2exrribde5xr2.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIB12RTNSS\",\"title\":\"Built-in 700 Series 12\\\" Inline Dual Range Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"12 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--DeQvqJgm--/plxgp3o2exrribde5xr2.jpg\",\"price\":889},{\"manufacturer_sku\":\"BIB12RTPSS\",\"title\":\"Built-in 700 Series 12\\\" Inline Dual Range Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"12 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--DeQvqJgm--/plxgp3o2exrribde5xr2.jpg\",\"price\":889}]},{\"product_id\":\"napoleon-bib18ir\",\"title\":\"Built-In 700 Series 18\\\" Dual Infrared Burner Stainless Steel\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib18ir\",\"image\":\"https://images.salsify.com/image/upload/s--O18hAYMi--/vqbyaxwr3hsehzyrp9jk.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIB18IRNSS\",\"title\":\"Built-In 700 Series 18\\\" Dual Infrared Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--O18hAYMi--/vqbyaxwr3hsehzyrp9jk.jpg\",\"price\":1109},{\"manufacturer_sku\":\"BIB18IRPSS\",\"title\":\"Built-In 700 Series 18\\\" Dual Infrared Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--O18hAYMi--/vqbyaxwr3hsehzyrp9jk.jpg\",\"price\":1109}]},{\"product_id\":\"napoleon-bib18pb\",\"title\":\"Built-In 700 Series 18\\\" Power Burner Stainless Steel\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib18pb\",\"image\":\"https://images.salsify.com/image/upload/s--i5nn4bap--/kfdtku2j2ssnslk3j8xx.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIB18PBNSS\",\"title\":\"Built-In 700 Series 18\\\" Power Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--i5nn4bap--/kfdtku2j2ssnslk3j8xx.jpg\",\"price\":1679},{\"manufacturer_sku\":\"BIB18PBPSS\",\"title\":\"Built-In 700 Series 18\\\" Power Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--i5nn4bap--/kfdtku2j2ssnslk3j8xx.jpg\",\"price\":1679}]},{\"product_id\":\"napoleon-bib18rt\",\"title\":\"Built-In 700 Series 18\\\" Dual Range Top Burner Stainless Steel\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Side Burners & Power Burners\",\"handle\":\"napoleon-bib18rt\",\"image\":\"https://images.salsify.com/image/upload/s--1RcLoiIH--/ylqjnfdzrhwdgpqezluy.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIB18RTNSS\",\"title\":\"Built-In 700 Series 18\\\" Dual Range Top Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--1RcLoiIH--/ylqjnfdzrhwdgpqezluy.jpg\",\"price\":999},{\"manufacturer_sku\":\"BIB18RTPSS\",\"title\":\"Built-In 700 Series 18\\\" Dual Range Top Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"18 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--1RcLoiIH--/ylqjnfdzrhwdgpqezluy.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-built-in-700-griddle\",\"title\":\"Built-in 700 Series Griddle\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Griddles\",\"handle\":\"napoleon-built-in-700-griddle\",\"image\":\"https://images.salsify.com/image/upload/s--xwRyunVJ--/xwqsphe8oouqbwed6ejb.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"BIG32FTNSS\",\"title\":\"Built-In 700 Series 32\\\" Griddle, Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--xwRyunVJ--/xwqsphe8oouqbwed6ejb.jpg\",\"price\":1994},{\"manufacturer_sku\":\"BIG32FTPSS\",\"title\":\"Built-In 700 Series 32\\\" Griddle, Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--xwRyunVJ--/xwqsphe8oouqbwed6ejb.jpg\",\"price\":1994}]},{\"product_id\":\"napoleon-built-in-700-gas-grills-1\",\"title\":\"Built-in 700 Series Gas Grills\",\"category\":\"Grills\",\"subcategory\":\"Built-in Grill Heads\",\"handle\":\"napoleon-built-in-700-gas-grills-1\",\"image\":\"https://images.salsify.com/image/upload/s--qxUXEAtF--/dj0myprzkijnkeb8ee0u.jpg\",\"sku_count\":8,\"variants\":[{\"manufacturer_sku\":\"BIG32RBNMK-1\",\"title\":\"Built-In 700 Series 32\\\" with Infrared Rear Burner Natural Gas, Matte Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--qxUXEAtF--/dj0myprzkijnkeb8ee0u.jpg\",\"price\":2104},{\"manufacturer_sku\":\"BIG32RBNSS-1\",\"title\":\"Built-In 700 Series 32\\\" with Infrared Rear Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--gHBQDOWW--/ixu2taico6svqmvqv6va.jpg\",\"price\":1994},{\"manufacturer_sku\":\"BIG32RBPMK-1\",\"title\":\"Built-In 700 Series 32\\\" with Infrared Rear Burner, Propane, Matte Black\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--qxUXEAtF--/dj0myprzkijnkeb8ee0u.jpg\",\"price\":2104},{\"manufacturer_sku\":\"BIG32RBPSS-1\",\"title\":\"Built-In 700 Series 32\\\" with Infrared Rear Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"32 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--gHBQDOWW--/ixu2taico6svqmvqv6va.jpg\",\"price\":1994},{\"manufacturer_sku\":\"BIG38RBNSS-1\",\"title\":\"Built-In 700 Series 38\\\" with Infrared Rear Burner Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"38 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ZXV5sZWe--/tunu66se147qpzbwrriy.jpg\",\"price\":2809},{\"manufacturer_sku\":\"BIG38RBPSS-1\",\"title\":\"Built-In 700 Series 38\\\" with Infrared Rear Burner Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"38 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ZXV5sZWe--/tunu66se147qpzbwrriy.jpg\",\"price\":2809},{\"manufacturer_sku\":\"BIG44RBNSS-1\",\"title\":\"Built-In 700 Series 44\\\" with Dual Infrared Rear Burners, Natural Gas, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"44 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--RLIT3Tqo--/sbjtfhoy5w6wpm9jvhsf.jpg\",\"price\":3599},{\"manufacturer_sku\":\"BIG44RBPSS-1\",\"title\":\"Built-In 700 Series 44\\\" with Dual Infrared Rear Burners, Propane, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"44 inch\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--RLIT3Tqo--/sbjtfhoy5w6wpm9jvhsf.jpg\",\"price\":3599}]},{\"product_id\":\"napoleon-prestige-pro-825-classic-3\",\"title\":\"Prestige PRO 825 — Classic\",\"category\":\"Grills\",\"subcategory\":\"Built-in Grill Heads\",\"handle\":\"napoleon-prestige-pro-825-classic-3\",\"image\":\"https://images.salsify.com/image/upload/s--DteHsP2l--/h9bprpdxmzaxbmqxehhq.jpg\",\"sku_count\":4,\"variants\":[{\"manufacturer_sku\":\"BIPRO825RBINSS-3\",\"title\":\"Built-in Prestige® PRO 825 Natural Gas Grill Head with Infrared Bottom and Rear Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"options\":{\"size\":\"825 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--DteHsP2l--/h9bprpdxmzaxbmqxehhq.jpg\",\"price\":4499},{\"manufacturer_sku\":\"BIPRO825RBIPSS-3\",\"title\":\"Built-in Prestige® PRO 825 Propane Gas Grill Head with Infrared Bottom and Rear Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"size\":\"825 model\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--DteHsP2l--/h9bprpdxmzaxbmqxehhq.jpg\",\"price\":4499},{\"manufacturer_sku\":\"PRO825RSBINSS-3\",\"title\":\"Classic Prestige® PRO 825 Natural Gas Grill with Power Side Burner and Infrared Rear & Bottom Burners, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"825 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--SQrGdZqZ--/a5lqz6vgrficmkoqwgut.jpg\",\"price\":6649},{\"manufacturer_sku\":\"PRO825RSBIPSS-3\",\"title\":\"Classic Prestige® PRO 825 Propane Gas Grill with Power Side Burner and Infrared Rear & Bottom Burners, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"825 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/hpet6sclnedzgqconoog.jpg?v=1770221564\",\"price\":6599}]},{\"product_id\":\"napoleon-item-ct-2424\",\"title\":\"OASIS® Universal 24\\\" x 24\\\" Stainless Steel Countertop\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-universal-24-x-24-stainless-steel-countertop\",\"image\":\"https://images.salsify.com/image/upload/s--bbkx0b0Z--/ptldhhn2ar4cndusmgeg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2424\",\"title\":\"OASIS® Universal 24\\\" x 24\\\" Stainless Steel Countertop\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--bbkx0b0Z--/ptldhhn2ar4cndusmgeg.jpg\",\"price\":229}]},{\"product_id\":\"napoleon-item-ct-2424-bib10\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 10\\\" Burner Cutout\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-24-x-24-stainless-steel-countertop-with-10-burner-cutout\",\"image\":\"https://images.salsify.com/image/upload/s--KE5PRIxr--/kzcvcrfbap5exhoxgyi3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2424-BIB10\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 10\\\" Burner Cutout\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--KE5PRIxr--/kzcvcrfbap5exhoxgyi3.jpg\",\"price\":229}]},{\"product_id\":\"napoleon-item-ct-2424-bib12\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 12\\\" Burner Cutout\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-24-x-24-stainless-steel-countertop-with-12-burner-cutout\",\"image\":\"https://images.salsify.com/image/upload/s--qSQMuVdS--/hceqog5lynivutas5ozb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2424-BIB12\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 12\\\" Burner Cutout\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--qSQMuVdS--/hceqog5lynivutas5ozb.jpg\",\"price\":249}]},{\"product_id\":\"napoleon-item-ct-2424-ugc18\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 18\\\" Burner Cutout\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-24-x-24-stainless-steel-countertop-with-18-burner-cutout\",\"image\":\"https://images.salsify.com/image/upload/s--yf7vNKuk--/xihnrk0y6dayv1et40h7.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2424-UGC18\",\"title\":\"OASIS® 24\\\" x 24\\\" Stainless Steel Countertop with 18\\\" Burner Cutout\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--yf7vNKuk--/xihnrk0y6dayv1et40h7.jpg\",\"price\":219}]},{\"product_id\":\"napoleon-item-ct-2426-bib10-ep\",\"title\":\"OASIS® 24\\\" x 26\\\" Stainless Steel End Countertop with 10\\\" Burner Cutout\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-24-x-26-stainless-steel-end-countertop-with-10-burner-cutout\",\"image\":\"https://images.salsify.com/image/upload/s--WPZB1AhD--/dohkczotno2zhburqm2l.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2426-BIB10-EP\",\"title\":\"OASIS® 24\\\" x 26\\\" Stainless Steel End Countertop with 10\\\" Burner Cutout\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--WPZB1AhD--/dohkczotno2zhburqm2l.jpg\",\"price\":249}]},{\"product_id\":\"napoleon-item-ct-2426-ep\",\"title\":\"OASIS® 24\\\" x 26\\\" Stainless Steel End Countertop\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-24-x-26-stainless-steel-end-countertop\",\"image\":\"https://images.salsify.com/image/upload/s--B-m5HLU7--/kwl24g3a0uerynd9hptl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-2426-EP\",\"title\":\"OASIS® 24\\\" x 26\\\" Stainless Steel End Countertop\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"24 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--B-m5HLU7--/kwl24g3a0uerynd9hptl.jpg\",\"price\":249}]},{\"product_id\":\"napoleon-item-ct-3624-ugc32\",\"title\":\"OASIS® 36\\\" x 24\\\" Stainless Steel Countertop for 32\\\" Built-in Grill and Under Grill Cabinet\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-36-x-24-stainless-steel-countertop-for-32-built-in-grill-and-under-grill-cabinet\",\"image\":\"https://images.salsify.com/image/upload/s--cnLnoyeP--/cojwzhgwb5co6vuqpjb5.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-3624-UGC32\",\"title\":\"OASIS® 36\\\" x 24\\\" Stainless Steel Countertop for 32\\\" Built-in Grill and Under Grill Cabinet\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--cnLnoyeP--/cojwzhgwb5co6vuqpjb5.jpg\",\"price\":329}]},{\"product_id\":\"napoleon-item-ct-4224-ugc38\",\"title\":\"OASIS® 42\\\" x 24\\\" Stainless Steel Countertop for 38\\\" Grill Head\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-42-x-24-stainless-steel-countertop-for-38-grill-head\",\"image\":\"https://images.salsify.com/image/upload/s--O9ughQNy--/zg36eoqzntkhbmhoiqly.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-4224-UGC38\",\"title\":\"OASIS® 42\\\" x 24\\\" Stainless Steel Countertop for 38\\\" Grill Head\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"42 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--O9ughQNy--/zg36eoqzntkhbmhoiqly.jpg\",\"price\":379}]},{\"product_id\":\"napoleon-item-ct-4824-ugc44\",\"title\":\"OASIS® 48\\\" x 24\\\" Stainless Steel Countertop for 44\\\" Grill Head\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-48-x-24-stainless-steel-countertop-for-44-grill-head\",\"image\":\"https://images.salsify.com/image/upload/s--qdrGr8WH--/efw2kgovfqaj35h7kbsm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-4824-UGC44\",\"title\":\"OASIS® 48\\\" x 24\\\" Stainless Steel Countertop for 44\\\" Grill Head\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"48 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--qdrGr8WH--/efw2kgovfqaj35h7kbsm.jpg\",\"price\":429}]},{\"product_id\":\"napoleon-item-ct-wfcep\",\"title\":\"OASIS® 36\\\" x 24\\\" Stainless Steel End Panel for Waterfall Edge\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Countertops\",\"handle\":\"napoleon-oasis-36-x-24-stainless-steel-end-panel-for-waterfall-edge\",\"image\":\"https://images.salsify.com/image/upload/s--F6lAJbIT--/njicjim2uzdqqq43a63z.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"CT-WFCEP\",\"title\":\"OASIS® 36\\\" x 24\\\" Stainless Steel End Panel for Waterfall Edge\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--F6lAJbIT--/njicjim2uzdqqq43a63z.jpg\",\"price\":309}]},{\"product_id\":\"napoleon-freestyle-griddle\",\"title\":\"Freestyle 24 Inch Griddle\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Griddles\",\"handle\":\"napoleon-freestyle-griddle\",\"image\":\"https://images.salsify.com/image/upload/s--pqtoVxCq--/vqcomrhsgudkhwza3lcd.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"F24DFTNK\",\"title\":\"Freestyle™ 24 Inch Pre-seasoned Non-Stick Griddle, Natural gas\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"24 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\"},\"image\":\"https://images.salsify.com/image/upload/s--pqtoVxCq--/vqcomrhsgudkhwza3lcd.jpg\",\"price\":629},{\"manufacturer_sku\":\"F24DFTPK\",\"title\":\"Freestyle™ 24 Inch Pre-seasoned Non-Stick Griddle, Propane\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"24 inch\",\"fuel\":\"Propane\",\"installation\":\"Cart\"},\"image\":\"https://images.salsify.com/image/upload/s--pqtoVxCq--/vqcomrhsgudkhwza3lcd.jpg\",\"price\":579}]},{\"product_id\":\"napoleon-freestyle-series-current\",\"title\":\"Freestyle™ Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-freestyle-series-current\",\"image\":\"https://images.salsify.com/image/upload/s--Su5ier4g--/bgvmb5od2wkbezizlr1n.jpg\",\"sku_count\":4,\"variants\":[{\"manufacturer_sku\":\"F365DNGT\",\"title\":\"Freestyle™ 365 Natural Gas Grill, Graphite Grey\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"365 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://images.salsify.com/image/upload/s--Su5ier4g--/bgvmb5od2wkbezizlr1n.jpg\",\"price\":579},{\"manufacturer_sku\":\"F365DPGT\",\"title\":\"Freestyle™ 365 Propane Gas Grill, Graphite Grey\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"365 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://images.salsify.com/image/upload/s--Su5ier4g--/bgvmb5od2wkbezizlr1n.jpg\",\"price\":529},{\"manufacturer_sku\":\"F425DNGT\",\"title\":\"Freestyle™ 425 Natural Gas Grill, Graphite Grey\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://images.salsify.com/image/upload/s--OIe8V7jj--/ipvf54vmwrafskdhkzhy.jpg\",\"price\":679},{\"manufacturer_sku\":\"F425DPGT\",\"title\":\"Freestyle™ 425 Propane Gas Grill, Graphite Grey\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://images.salsify.com/image/upload/s--OIe8V7jj--/ipvf54vmwrafskdhkzhy.jpg\",\"price\":629}]},{\"product_id\":\"napoleon-item-gabr001\",\"title\":\"Grill Brush with Palmyra Bristles\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-grill-brush-with-palmyra-bristles\",\"image\":\"https://images.salsify.com/image/upload/s--BXRRC7Do--/ainfxlhgb3sabcqdv1gc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GABR001\",\"title\":\"Grill Brush with Palmyra Bristles\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--BXRRC7Do--/ainfxlhgb3sabcqdv1gc.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-gabr010\",\"title\":\"Griddle Brush Replacement Pads\",\"category\":\"Accessories\",\"subcategory\":\"Grill Maintenance & Safety\",\"handle\":\"napoleon-griddle-brush-replacement-pads\",\"image\":\"https://images.salsify.com/image/upload/s--wStMGS9y--/nec6vvbuhzruzv4c50h4.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GABR010\",\"title\":\"Griddle Brush Replacement Pads\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--wStMGS9y--/nec6vvbuhzruzv4c50h4.jpg\",\"price\":4.99}]},{\"product_id\":\"napoleon-item-gacp003\",\"title\":\"Breakfast Rings\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-breakfast-rings\",\"image\":\"https://images.salsify.com/image/upload/s--D6elqaLn--/cobj7ybghhujbpcotmyn.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACP003\",\"title\":\"Breakfast Rings\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--D6elqaLn--/cobj7ybghhujbpcotmyn.jpg\",\"price\":22.99}]},{\"product_id\":\"napoleon-item-gacp004\",\"title\":\"Squeeze Bottles\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-squeeze-bottles\",\"image\":\"https://images.salsify.com/image/upload/s--njwl1O1u--/xzava2rcmdqo8cwsdccw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACP004\",\"title\":\"Squeeze Bottles\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--njwl1O1u--/xzava2rcmdqo8cwsdccw.jpg\",\"price\":9.99}]},{\"product_id\":\"napoleon-item-gacp006\",\"title\":\"Pancake Mixer and Dispenser\",\"category\":\"Accessories\",\"subcategory\":\"Cooking Products\",\"handle\":\"napoleon-pancake-mixer-and-dispenser\",\"image\":\"https://images.salsify.com/image/upload/s--9SjA2KZq--/vovacvx4d2fgngi2ldn3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACP006\",\"title\":\"Pancake Mixer and Dispenser\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--9SjA2KZq--/vovacvx4d2fgngi2ldn3.jpg\",\"price\":11.99}]},{\"product_id\":\"napoleon-item-gacv001\",\"title\":\"Freestyle™ 36\\\" Griddle Models Premium Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-freestyle-36-griddle-models-premium-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--28BD-hWu--/unfe4uewrhfs7envabbp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACV001\",\"title\":\"Freestyle™ 36\\\" Griddle Models Premium Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"36 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--28BD-hWu--/unfe4uewrhfs7envabbp.jpg\",\"price\":75.99}]},{\"product_id\":\"napoleon-item-gacv002\",\"title\":\"Prestige® PRO 500 Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-prestige-pro-500-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--1j4o_RxB--/yb876b3ymtk5gqy3iklv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACV002\",\"title\":\"Prestige® PRO 500 Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--1j4o_RxB--/yb876b3ymtk5gqy3iklv.jpg\",\"price\":107.99}]},{\"product_id\":\"napoleon-item-gacv003\",\"title\":\"Prestige® PRO 665 Grill Cover\",\"category\":\"Accessories\",\"subcategory\":\"Covers\",\"handle\":\"napoleon-prestige-pro-665-grill-cover\",\"image\":\"https://images.salsify.com/image/upload/s--5iB0vdlZ--/twbcunib0jk2naeeiq4j.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GACV003\",\"title\":\"Prestige® PRO 665 Grill Cover\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--5iB0vdlZ--/twbcunib0jk2naeeiq4j.jpg\",\"price\":122.99}]},{\"product_id\":\"napoleon-candidate-gafl001\",\"title\":\"Black Stone® Charcoal\",\"category\":\"Unresolved assortment\",\"subcategory\":\"Price-only candidate\",\"handle\":\"napoleon-black-stone-charcoal\",\"image\":null,\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GAFL001\",\"title\":\"Black Stone® Charcoal\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":null,\"price\":24.99}]},{\"product_id\":\"napoleon-item-gama001\",\"title\":\"Prestige® PRO 665 Skirt Kit\",\"category\":\"Accessories\",\"subcategory\":\"Grill Storage\",\"handle\":\"napoleon-prestige-pro-665-skirt-kit\",\"image\":\"https://images.salsify.com/image/upload/s--X8zEh0LQ--/qw8e2ooeobomhfajkbbq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GAMA001\",\"title\":\"Prestige® PRO 665 Skirt Kit\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--X8zEh0LQ--/qw8e2ooeobomhfajkbbq.jpg\",\"price\":143.99}]},{\"product_id\":\"napoleon-item-gama002\",\"title\":\"Silicone Drawer Liner for Prestige® PRO 665\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-silicone-drawer-liner-for-prestige-pro-665\",\"image\":\"https://images.salsify.com/image/upload/s--sMHga_Z7--/itg4oc5kq0o1uasxeqop.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GAMA002\",\"title\":\"Silicone Drawer Liner for Prestige® PRO 665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--sMHga_Z7--/itg4oc5kq0o1uasxeqop.jpg\",\"price\":22.99}]},{\"product_id\":\"napoleon-item-gasm001\",\"title\":\"Electric Smoker Box for Prestige® PRO 500VX Grills\",\"category\":\"Accessories\",\"subcategory\":\"Charcoal & Smoker Accessories\",\"handle\":\"napoleon-electric-smoker-box-for-prestige-pro-500vx-grills\",\"image\":\"https://images.salsify.com/image/upload/s--TjePdLlg--/uuxwinfvi7eohzegpvbq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GASM001\",\"title\":\"Electric Smoker Box for Prestige® PRO 500VX Grills\",\"fuel\":\"Electric\",\"installation\":null,\"options\":{\"size\":\"500 model\",\"fuel\":\"Electric\"},\"image\":\"https://images.salsify.com/image/upload/s--TjePdLlg--/uuxwinfvi7eohzegpvbq.jpg\",\"price\":565.99}]},{\"product_id\":\"napoleon-item-gatl001\",\"title\":\"Travel Tool Set\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-travel-tool-set\",\"image\":\"https://images.salsify.com/image/upload/s--6XChklwO--/znon2pwe3743vbeojir5.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL001\",\"title\":\"Travel Tool Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6XChklwO--/znon2pwe3743vbeojir5.jpg\",\"price\":45.99}]},{\"product_id\":\"napoleon-item-gatl002\",\"title\":\"3-Piece Starter Tool Set\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-3-piece-starter-tool-set\",\"image\":\"https://images.salsify.com/image/upload/s--r945B7qP--/imueadvwuez65qx2qxih.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL002\",\"title\":\"3-Piece Starter Tool Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--r945B7qP--/imueadvwuez65qx2qxih.jpg\",\"price\":36.99}]},{\"product_id\":\"napoleon-item-gatl003\",\"title\":\"Grill Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-grill-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--gcnGI7Oy--/my3nmyjgezol6pnse9vo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL003\",\"title\":\"Grill Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--gcnGI7Oy--/my3nmyjgezol6pnse9vo.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-gatl004\",\"title\":\"Grill Tongs\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-grill-tongs\",\"image\":\"https://images.salsify.com/image/upload/s--V08g0OQ2--/k5a9ksecskmcjxt68jga.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL004\",\"title\":\"Grill Tongs\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--V08g0OQ2--/k5a9ksecskmcjxt68jga.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-gatl005\",\"title\":\"Silicone Basting Brush\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-silicone-basting-brush\",\"image\":\"https://images.salsify.com/image/upload/s--F4kdqE7E--/x5zvyc7vrfh8hkpa53qb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL005\",\"title\":\"Silicone Basting Brush\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--F4kdqE7E--/x5zvyc7vrfh8hkpa53qb.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-gatl007\",\"title\":\"Premium Grill Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-premium-grill-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--6eifdpHF--/tacet5ymycushh0vhahf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL007\",\"title\":\"Premium Grill Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6eifdpHF--/tacet5ymycushh0vhahf.jpg\",\"price\":24.99}]},{\"product_id\":\"napoleon-item-gatl008\",\"title\":\"Premium Grill Tongs\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-premium-grill-tongs\",\"image\":\"https://images.salsify.com/image/upload/s--hkApAIjv--/znejbxryx5yjrvl5ysj1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL008\",\"title\":\"Premium Grill Tongs\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--hkApAIjv--/znejbxryx5yjrvl5ysj1.jpg\",\"price\":24.99}]},{\"product_id\":\"napoleon-item-gatl011\",\"title\":\"Griddle Spatula 2-Piece Set\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-spatula-2-piece-set\",\"image\":\"https://images.salsify.com/image/upload/s--a_Oj1gAf--/imv0wmpehbup9yzpep1x.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL011\",\"title\":\"Griddle Spatula 2-Piece Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--a_Oj1gAf--/imv0wmpehbup9yzpep1x.jpg\",\"price\":24.99}]},{\"product_id\":\"napoleon-item-gatl012\",\"title\":\"Griddle Starter 3-Piece Set\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-starter-3-piece-set\",\"image\":\"https://images.salsify.com/image/upload/s--wTLHJuRZ--/cexctsk44xxpreipfw0p.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL012\",\"title\":\"Griddle Starter 3-Piece Set\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--wTLHJuRZ--/cexctsk44xxpreipfw0p.jpg\",\"price\":28.99}]},{\"product_id\":\"napoleon-item-gatl013\",\"title\":\"Griddle 4-Piece Cleaning Kit\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-4-piece-cleaning-kit\",\"image\":\"https://images.salsify.com/image/upload/s--eb-yJcrl--/s0e04iyhtb44gtdsitpg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL013\",\"title\":\"Griddle 4-Piece Cleaning Kit\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--eb-yJcrl--/s0e04iyhtb44gtdsitpg.jpg\",\"price\":38.99}]},{\"product_id\":\"napoleon-item-gatl014\",\"title\":\"Griddle Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--6MQOhCFH--/llf8afbeudrdzedmvmzt.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL014\",\"title\":\"Griddle Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6MQOhCFH--/llf8afbeudrdzedmvmzt.jpg\",\"price\":13.99}]},{\"product_id\":\"napoleon-item-gatl015\",\"title\":\"Griddle Burger Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-burger-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--Sxybp3oU--/ktlmhwro07vqgvvireus.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL015\",\"title\":\"Griddle Burger Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--Sxybp3oU--/ktlmhwro07vqgvvireus.jpg\",\"price\":14.99}]},{\"product_id\":\"napoleon-item-gatl016\",\"title\":\"Griddle Scraper\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-scraper\",\"image\":\"https://images.salsify.com/image/upload/s--3NjR3Cpc--/gs61lj1ivjylgmnsojfk.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL016\",\"title\":\"Griddle Scraper\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--3NjR3Cpc--/gs61lj1ivjylgmnsojfk.jpg\",\"price\":11.99}]},{\"product_id\":\"napoleon-item-gatl017\",\"title\":\"Griddle Scoop Spatula\",\"category\":\"Accessories\",\"subcategory\":\"Grilling Tools\",\"handle\":\"napoleon-griddle-scoop-spatula\",\"image\":\"https://images.salsify.com/image/upload/s--IySKA2cT--/q8vkdwlxt32lgpae5me7.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GATL017\",\"title\":\"Griddle Scoop Spatula\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--IySKA2cT--/q8vkdwlxt32lgpae5me7.jpg\",\"price\":19.99}]},{\"product_id\":\"napoleon-item-im-1dfep-mk\",\"title\":\"OASIS® Enclosure Kit for Fridge - End of Run, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-enclosure-kit-for-fridge-end-of-run-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--jmwGqM7M--/szmwn3hdseelhpozzpj3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-1DFEP-MK\",\"title\":\"OASIS® Enclosure Kit for Fridge - End of Run, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--jmwGqM7M--/szmwn3hdseelhpozzpj3.jpg\",\"price\":309}]},{\"product_id\":\"napoleon-item-im-1dfmp-mk\",\"title\":\"OASIS® Enclosure Kit for Fridge - Mid Run, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-enclosure-kit-for-fridge-mid-run-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--aXNl4--e--/lzuhbrdy5xiptq92bsvr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-1DFMP-MK\",\"title\":\"OASIS® Enclosure Kit for Fridge - Mid Run, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--aXNl4--e--/lzuhbrdy5xiptq92bsvr.jpg\",\"price\":189}]},{\"product_id\":\"napoleon-item-im-2dc-mk-1\",\"title\":\"OASIS® Two Drawer Cabinet, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-two-drawer-cabinet-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--TcoBBloZ--/nqqd7s1w7lypkugw7oby.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-2DC-MK-1\",\"title\":\"OASIS® Two Drawer Cabinet, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--TcoBBloZ--/nqqd7s1w7lypkugw7oby.jpg\",\"price\":889}]},{\"product_id\":\"napoleon-item-im-3dc-mk-1\",\"title\":\"OASIS® Three Drawer Cabinet, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-three-drawer-cabinet-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--iePmRHMb--/yrezyt7isvbolm9xvq8j.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-3DC-MK-1\",\"title\":\"OASIS® Three Drawer Cabinet, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--iePmRHMb--/yrezyt7isvbolm9xvq8j.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-item-im-45lt-mk\",\"title\":\"OASIS® 45° Large Transition Piece, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-45-large-transition-piece-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--_bV2YM0m--/uw0gshi7hu6v3geaaosc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-45LT-MK\",\"title\":\"OASIS® 45° Large Transition Piece, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--_bV2YM0m--/uw0gshi7hu6v3geaaosc.jpg\",\"price\":109}]},{\"product_id\":\"napoleon-item-im-45t-mk\",\"title\":\"OASIS® 45° Transition Piece, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-45-transition-piece-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--st7BOgGm--/uclcdbvdqfbw9xjost2v.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-45T-MK\",\"title\":\"OASIS® 45° Transition Piece, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--st7BOgGm--/uclcdbvdqfbw9xjost2v.jpg\",\"price\":109}]},{\"product_id\":\"napoleon-item-im-cep-mk\",\"title\":\"OASIS® End Panel, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-end-panel-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--bVqlNDTI--/u6ijcokv5volj4gkz67t.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-CEP-MK\",\"title\":\"OASIS® End Panel, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--bVqlNDTI--/u6ijcokv5volj4gkz67t.jpg\",\"price\":109}]},{\"product_id\":\"napoleon-item-im-drc-mk-1\",\"title\":\"OASIS® Cabinet with Reversible Door, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-cabinet-with-reversible-door-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--_SjkQ93t--/arhvuf46yngdnkgdwg04.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-DRC-MK-1\",\"title\":\"OASIS® Cabinet with Reversible Door, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--_SjkQ93t--/arhvuf46yngdnkgdwg04.jpg\",\"price\":549}]},{\"product_id\":\"napoleon-item-im-ptc-mk-1-na\",\"title\":\"OASIS® Propane Tank Cabinet, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-propane-tank-cabinet-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--_SjkQ93t--/arhvuf46yngdnkgdwg04.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-PTC-MK-1-NA\",\"title\":\"OASIS® Propane Tank Cabinet, Matte Black\",\"fuel\":\"Propane\",\"installation\":null,\"options\":{\"fuel\":\"Propane\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--_SjkQ93t--/arhvuf46yngdnkgdwg04.jpg\",\"price\":669}]},{\"product_id\":\"napoleon-item-im-ugc18-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series Dual Burners, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-700-series-dual-burners-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--5-Haa01B--/i5rdr1oxo1hi6h2tas5h.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC18-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series Dual Burners, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--5-Haa01B--/i5rdr1oxo1hi6h2tas5h.jpg\",\"price\":669}]},{\"product_id\":\"napoleon-item-im-ugc32-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in BIG32, BI32, BIG32FT, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-big32-bi32-big32ft-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--WO2lQblF--/yiefg5pluymdtifaxhs1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC32-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in BIG32, BI32, BIG32FT, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--WO2lQblF--/yiefg5pluymdtifaxhs1.jpg\",\"price\":779}]},{\"product_id\":\"napoleon-item-im-ugc38-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series 38, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-700-series-38-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--rHP5fD2y--/a4otysjlr2zdful1zjhb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC38-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series 38, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--rHP5fD2y--/a4otysjlr2zdful1zjhb.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-item-im-ugc44-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series 44, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-700-series-44-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--JRdPL9S9--/qmgffsv9zvssiv1nm60l.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC44-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series 44, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--JRdPL9S9--/qmgffsv9zvssiv1nm60l.jpg\",\"price\":1349}]},{\"product_id\":\"napoleon-item-im-ugc500-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 500 or Prestige® 500, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-prestige-pro-500-or-prestige-500-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--UmG8-CU---/gcsmgepuzlz3zn92cpcd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC500-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 500 or Prestige® 500, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--UmG8-CU---/gcsmgepuzlz3zn92cpcd.jpg\",\"price\":779}]},{\"product_id\":\"napoleon-item-im-ugc665-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 665, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-prestige-pro-665-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--s2za_Pa3--/a2fzjzetezv9rsr3r8zf.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC665-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 665, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--s2za_Pa3--/a2fzjzetezv9rsr3r8zf.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-item-im-ugc825-mk-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 825, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-under-grill-cabinet-for-built-in-prestige-pro-825-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--2H1_CymV--/hvswnjkxzvxujoghjkxm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC825-MK-1\",\"title\":\"OASIS® Under Grill Cabinet for Built-in Prestige® PRO 825, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"825 model\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--2H1_CymV--/hvswnjkxzvxujoghjkxm.jpg\",\"price\":1449}]},{\"product_id\":\"napoleon-item-im-wdc-mk-1\",\"title\":\"OASIS® Waste Drawer Cabinet, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-oasis-waste-drawer-cabinet-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--64Navb8K--/weyq0is2011x6alpheyp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-WDC-MK-1\",\"title\":\"OASIS® Waste Drawer Cabinet, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--64Navb8K--/weyq0is2011x6alpheyp.jpg\",\"price\":999}]},{\"product_id\":\"napoleon-item-im-wsf-mk\",\"title\":\"OASIS® Wall Spacer, Matte Black\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Cabinet Trim & Enclosures\",\"handle\":\"napoleon-oasis-wall-spacer-matte-black\",\"image\":\"https://images.salsify.com/image/upload/s--ztmYHP-i--/rdktijvf6imacbufpiwc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-WSF-MK\",\"title\":\"OASIS® Wall Spacer, Matte Black\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--ztmYHP-i--/rdktijvf6imacbufpiwc.jpg\",\"price\":109}]},{\"product_id\":\"napoleon-item-n370-0775\",\"title\":\"Infrared Burner Kit for P500/665 and PRO 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-infrared-burner-kit-for-p500-665-and-pro-500\",\"image\":\"https://images.salsify.com/image/upload/s--Xzof57Lj--/taxbffwsbk3hhrjlrdfi.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"N370-0775\",\"title\":\"Infrared Burner Kit for P500/665 and PRO 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--Xzof57Lj--/taxbffwsbk3hhrjlrdfi.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-neofv80ih\",\"title\":\"Phantom Freestand Outdoor Electric Infrared Heater\",\"category\":\"Fire & Heating\",\"subcategory\":\"Patio Heaters\",\"handle\":\"napoleon-phantom-freestand-outdoor-electric-infrared-heater\",\"image\":\"https://images.salsify.com/image/upload/s--B9niKujO--/tzxxg9j1yruc51a86ntg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"NEOFV80IH\",\"title\":\"Phantom Freestand Outdoor Electric Infrared Heater\",\"fuel\":\"Electric\",\"installation\":null,\"options\":{\"fuel\":\"Electric\"},\"image\":\"https://images.salsify.com/image/upload/s--B9niKujO--/tzxxg9j1yruc51a86ntg.jpg\",\"price\":859}]},{\"product_id\":\"napoleon-item-nfr055ouss-1\",\"title\":\"Outdoor Rated Stainless Steel Fridge\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Outdoor Refrigeration\",\"handle\":\"napoleon-outdoor-rated-stainless-steel-fridge\",\"image\":\"https://images.salsify.com/image/upload/s--b2QCUHhO--/gfnow4qe2ymcbxtgqbzg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"NFR055OUSS-1\",\"title\":\"Outdoor Rated Stainless Steel Fridge\",\"fuel\":\"Electric\",\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\",\"fuel\":\"Electric\"},\"image\":\"https://images.salsify.com/image/upload/s--b2QCUHhO--/gfnow4qe2ymcbxtgqbzg.jpg\",\"price\":2109}]},{\"product_id\":\"napoleon-timberwolf-smokeless-fire-pits\",\"title\":\"Timberwolf Smokeless Fire Pits\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pits\",\"handle\":\"napoleon-timberwolf-smokeless-fire-pits\",\"image\":\"https://images.salsify.com/image/upload/s--TCz_ZWe5--/vh5farjzyjqr6mpyaaxz.jpg\",\"sku_count\":3,\"variants\":[{\"manufacturer_sku\":\"NWFPLTI-SS\",\"title\":\"Timberwolf® Smokeless Fire Pit, 22-inch, Stainless Steel\",\"fuel\":\"Wood\",\"installation\":null,\"options\":{\"size\":\"22 inch\",\"fuel\":\"Wood\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--TCz_ZWe5--/vh5farjzyjqr6mpyaaxz.jpg\",\"price\":709},{\"manufacturer_sku\":\"NWFPMTI-PHM\",\"title\":\"Timberwolf® Smokeless Fire Pit, 18-inch, Matte Black\",\"fuel\":\"Wood\",\"installation\":null,\"options\":{\"size\":\"18 inch\",\"fuel\":\"Wood\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--Q4TGGWF_--/ylf25evipsufcdzpphpx.jpg\",\"price\":549},{\"manufacturer_sku\":\"NWFPMTI-SS\",\"title\":\"Timberwolf® Smokeless Fire Pit, 18-inch, Stainless Steel\",\"fuel\":\"Wood\",\"installation\":null,\"options\":{\"size\":\"18 inch\",\"fuel\":\"Wood\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--P_gMJBP3--/wowrduus3efx4juphygi.jpg\",\"price\":509}]},{\"product_id\":\"napoleon-item-nwo20ti-bk\",\"title\":\"Round Fire Pit Side Table\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pit Tables & Surrounds\",\"handle\":\"napoleon-round-fire-pit-side-table\",\"image\":\"https://images.salsify.com/image/upload/s--xMEmwvZ2--/vfwuhcz8z2e4ecilztca.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"NWO20TI-BK\",\"title\":\"Round Fire Pit Side Table\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--xMEmwvZ2--/vfwuhcz8z2e4ecilztca.jpg\",\"price\":379}]},{\"product_id\":\"napoleon-item-nwo44ti-bk\",\"title\":\"Round Fire Pit Table Surround for 18- and 22-inch fire pits\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pit Tables & Surrounds\",\"handle\":\"napoleon-round-fire-pit-table-surround-for-18-and-22-inch-fire-pits\",\"image\":\"https://images.salsify.com/image/upload/s--_mzdv9A3--/wmghut9dkyzgcf22iyym.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"NWO44TI-BK\",\"title\":\"Round Fire Pit Table Surround for 18- and 22-inch fire pits\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"22 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--_mzdv9A3--/wmghut9dkyzgcf22iyym.jpg\",\"price\":859}]},{\"product_id\":\"napoleon-oasis-301-outdoor-kitchen\",\"title\":\"OASIS 301 Outdoor Kitchen\",\"category\":\"Outdoor Kitchens\",\"subcategory\":\"Outdoor Kitchen Kit\",\"handle\":\"napoleon-oasis-301-outdoor-kitchen\",\"image\":\"https://images.salsify.com/image/upload/s--KGp69GFp--/hylj7ree1veso0ujvjw5.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"ODK301-BIG32RBNMK-1\",\"title\":\"OASIS® 301 Outdoor Kitchen, Matte Black, Natural Gas, Series 32\",\"fuel\":\"Natural Gas\",\"installation\":\"Outdoor kitchen kit\",\"options\":{\"fuel\":\"Natural Gas\",\"installation\":\"Outdoor kitchen kit\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--KGp69GFp--/hylj7ree1veso0ujvjw5.jpg\",\"price\":5329},{\"manufacturer_sku\":\"ODK301-BIG32RBPMK-1\",\"title\":\"OASIS® 301 Outdoor Kitchen, Matte Black, Propane, Series 32\",\"fuel\":\"Propane\",\"installation\":\"Outdoor kitchen kit\",\"options\":{\"fuel\":\"Propane\",\"installation\":\"Outdoor kitchen kit\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--KGp69GFp--/hylj7ree1veso0ujvjw5.jpg\",\"price\":5329}]},{\"product_id\":\"napoleon-oasis-outdoor-kitchen-kit-countertops\",\"title\":\"OASIS Outdoor Kitchen Kit with Stainless Steel Countertops\",\"category\":\"Outdoor Kitchens\",\"subcategory\":\"Outdoor Kitchen Kit\",\"handle\":\"napoleon-oasis-outdoor-kitchen-kit-countertops\",\"image\":\"https://images.salsify.com/image/upload/s--aSdXezA3--/ynott95ww4u4hpio9d4e.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"OOK-001\",\"title\":\"OASIS® Outdoor Kitchen Kit, Matte Black, Natural Gas, Series 32 with Stainless Steel Countertops\",\"fuel\":\"Natural Gas\",\"installation\":\"Outdoor kitchen kit\",\"options\":{\"fuel\":\"Natural Gas\",\"installation\":\"Outdoor kitchen kit\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--aSdXezA3--/ynott95ww4u4hpio9d4e.jpg\",\"price\":6149},{\"manufacturer_sku\":\"OOK-002\",\"title\":\"OASIS® Outdoor Kitchen Kit, Matte Black, Propane, Series 32 with Stainless Steel Countertops\",\"fuel\":\"Propane\",\"installation\":\"Outdoor kitchen kit\",\"options\":{\"fuel\":\"Propane\",\"installation\":\"Outdoor kitchen kit\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--aSdXezA3--/ynott95ww4u4hpio9d4e.jpg\",\"price\":6149}]},{\"product_id\":\"napoleon-prestige-v\",\"title\":\"Prestige Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-prestige-v\",\"image\":\"https://images.salsify.com/image/upload/s--QvWsEOLR--/gihymxzttwh6icpdzw4z.jpg\",\"sku_count\":10,\"variants\":[{\"manufacturer_sku\":\"P500VRSIBNSS\",\"title\":\"Prestige® 500 Natural Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Standard\"},\"image\":\"https://images.salsify.com/image/upload/s--QvWsEOLR--/gihymxzttwh6icpdzw4z.jpg\",\"price\":1949},{\"manufacturer_sku\":\"P500VRSIBPSS\",\"title\":\"Prestige® 500 Propane Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Standard\"},\"image\":\"https://images.salsify.com/image/upload/s--QvWsEOLR--/gihymxzttwh6icpdzw4z.jpg\",\"price\":1899},{\"manufacturer_sku\":\"P500VXRSIBNK-PHM\",\"title\":\"Phantom Prestige® 500 Connected, Natural Gas Grill with Infrared Side and Rear Burner, Matte Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Matte Black\",\"connectivity\":\"Connected\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/jgpgmjtjsoq9ccpldsgz.jpg?v=1770221590\",\"price\":2499},{\"manufacturer_sku\":\"P500VXRSIBNSS\",\"title\":\"Prestige® 500 Connected, Natural Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Connected\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/qtn2kk6udsid1wqrviqy.jpg?v=1770221582\",\"price\":2179},{\"manufacturer_sku\":\"P500VXRSIBPK-PHM\",\"title\":\"Phantom Prestige® 500 Connected, Propane Gas Grill with Infrared Side and Rear Burner, Matte Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Matte Black\",\"connectivity\":\"Connected\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/jgpgmjtjsoq9ccpldsgz.jpg?v=1770221590\",\"price\":2449},{\"manufacturer_sku\":\"P500VXRSIBPSS\",\"title\":\"Prestige® 500 Connected, Propane Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Connected\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/qtn2kk6udsid1wqrviqy.jpg?v=1770221582\",\"price\":2129},{\"manufacturer_sku\":\"P665VRSIBNSS\",\"title\":\"Prestige® 665 Natural Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Standard\"},\"image\":\"https://images.salsify.com/image/upload/s--dugG5lhr--/c1vtwfafzjzsc2xxcv2p.jpg\",\"price\":2699},{\"manufacturer_sku\":\"P665VRSIBPSS\",\"title\":\"Prestige® 665 Propane Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Standard\"},\"image\":\"https://images.salsify.com/image/upload/s--dugG5lhr--/c1vtwfafzjzsc2xxcv2p.jpg\",\"price\":2649},{\"manufacturer_sku\":\"P665VXRSIBNSS\",\"title\":\"Prestige® 665 Connected, Natural Gas Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Connected\"},\"image\":\"https://images.salsify.com/image/upload/s--2Phqwb-D--/wixovxk5r2kl7zwhkprg.jpg\",\"price\":2929},{\"manufacturer_sku\":\"P665VXRSIBPSS\",\"title\":\"Prestige® 665 Connected, Propane Grill with Infrared Side and Rear Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"connectivity\":\"Connected\"},\"image\":\"https://images.salsify.com/image/upload/s--2Phqwb-D--/wixovxk5r2kl7zwhkprg.jpg\",\"price\":2879}]},{\"product_id\":\"napoleon-prestige-pro-500-legacy-3\",\"title\":\"Prestige PRO 500 — Legacy\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-prestige-pro-500-legacy-3\",\"image\":\"https://images.salsify.com/image/upload/s--KOHnyg58--/tqvhe19hlfqe0h5eunbj.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"PRO500RSIBNSS-3\",\"title\":\"Legacy Prestige® PRO 500 Natural Gas Grill with Infrared Rear and Side Burners, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--KOHnyg58--/tqvhe19hlfqe0h5eunbj.jpg\",\"price\":2799},{\"manufacturer_sku\":\"PRO500RSIBPSS-3\",\"title\":\"Legacy Prestige® PRO 500 Propane Gas Grill with Infrared Rear and Side Burners, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--KOHnyg58--/tqvhe19hlfqe0h5eunbj.jpg\",\"price\":2749}]},{\"product_id\":\"napoleon-prestige-pro-smart\",\"title\":\"Prestige PRO Smart Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-prestige-pro-smart\",\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/op16qjvhpu5ge6jypnkp.jpg?v=1770221557\",\"sku_count\":4,\"variants\":[{\"manufacturer_sku\":\"PRO500VXRSIBNSS\",\"title\":\"Prestige® PRO 500 Natural Gas Grill with Smart Technology\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"equipment\":\"Smart technology\",\"finish\":\"Stainless Steel\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/op16qjvhpu5ge6jypnkp.jpg?v=1770221557\",\"price\":3899},{\"manufacturer_sku\":\"PRO500VXRSIBPSS\",\"title\":\"Prestige® PRO 500 Propane Gas Grill with Smart Technology\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"500 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"equipment\":\"Smart technology\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--2So_2sm---/awnuhvmjx67ub55rhtrv.jpg\",\"price\":3849},{\"manufacturer_sku\":\"PRO665VXRSIBNSS\",\"title\":\"Prestige® PRO 665 Elite Natural Gas Grill with Smart Technology & Electric Smoker Box\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"equipment\":\"Elite with electric smoker box\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--t_pVWEM_--/nhoe7fj30xeyztxnecaz.jpg\",\"price\":5749},{\"manufacturer_sku\":\"PRO665VXRSIBPSS\",\"title\":\"Prestige® PRO 665 Elite Propane Gas Grill with Smart Technology & Electric Smoker Box\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"665 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"equipment\":\"Elite with electric smoker box\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--t_pVWEM_--/nhoe7fj30xeyztxnecaz.jpg\",\"price\":5699}]},{\"product_id\":\"napoleon-item-pro605css\",\"title\":\"Charcoal Professional Grill, Stainless Steel\",\"category\":\"Grills\",\"subcategory\":\"Charcoal Grills\",\"handle\":\"napoleon-charcoal-professional-grill-stainless-steel\",\"image\":\"https://images.salsify.com/image/upload/s--oAI9U3tB--/tjgwvasd7abdte4tc9wo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"PRO605CSS\",\"title\":\"Charcoal Professional Grill, Stainless Steel\",\"fuel\":\"Charcoal\",\"installation\":\"Cart\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Stainless Steel\",\"installation\":\"Cart\"},\"image\":\"https://images.salsify.com/image/upload/s--oAI9U3tB--/tjgwvasd7abdte4tc9wo.jpg\",\"price\":1484}]},{\"product_id\":\"napoleon-rogue-series-current\",\"title\":\"Rogue® Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-rogue-series-current\",\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/lspigotipcpsvmhm5osu.jpg?v=1770221594\",\"sku_count\":13,\"variants\":[{\"manufacturer_sku\":\"R425NK-2\",\"title\":\"Rogue® 425 Natural Gas Grill, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/lspigotipcpsvmhm5osu.jpg?v=1770221594\",\"price\":764},{\"manufacturer_sku\":\"R425NK-2-SS\",\"title\":\"Rogue® 425 Natural Gas Grill, Black, Stainless Steel Grids\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Stainless steel\"},\"image\":\"https://images.salsify.com/image/upload/s--WOAHI7cZ--/guyttzaslmctespntqyu.jpg\",\"price\":899},{\"manufacturer_sku\":\"R425NSS-2\",\"title\":\"Rogue® 425 Natural Gas Grill, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/jyfoy2mwl9pphstsu7as.jpg?v=1770221587\",\"price\":854},{\"manufacturer_sku\":\"R425PK-2\",\"title\":\"Rogue® 425 Propane Gas Grill, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/lspigotipcpsvmhm5osu.jpg?v=1770221594\",\"price\":719},{\"manufacturer_sku\":\"R425PK-2-SS\",\"title\":\"Rogue® 425 Propane Gas Grill, Black, Stainless Steel Grids\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Stainless steel\"},\"image\":\"https://images.salsify.com/image/upload/s--WOAHI7cZ--/guyttzaslmctespntqyu.jpg\",\"price\":849},{\"manufacturer_sku\":\"R425PSS-2\",\"title\":\"Rogue® 425 Propane Gas Grill, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/jyfoy2mwl9pphstsu7as.jpg?v=1770221587\",\"price\":809},{\"manufacturer_sku\":\"R525NK-2\",\"title\":\"Rogue® 525 Natural Gas Grill, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://images.salsify.com/image/upload/s--iVjHsT2T--/eul0fwkyaciyajdoyyj9.jpg\",\"price\":854},{\"manufacturer_sku\":\"R525NK-2-SS\",\"title\":\"Rogue® 525 Natural Gas Grill, Black, Stainless Steel Grids\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Stainless steel\"},\"image\":\"https://images.salsify.com/image/upload/s--iVjHsT2T--/eul0fwkyaciyajdoyyj9.jpg\",\"price\":999},{\"manufacturer_sku\":\"R525NSS-2\",\"title\":\"Rogue® 525 Natural Gas Grill, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://images.salsify.com/image/upload/s--OWyu8V-d--/vdmxwqjhrvt4we0g2b4u.jpg\",\"price\":899},{\"manufacturer_sku\":\"R525PK-2\",\"title\":\"Rogue® 525 Propane Gas Grill, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://images.salsify.com/image/upload/s--iVjHsT2T--/eul0fwkyaciyajdoyyj9.jpg\",\"price\":809},{\"manufacturer_sku\":\"R525PK-2-SS\",\"title\":\"Rogue® 525 Propane Gas Grill, Black, Stainless Steel Grids\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Stainless steel\"},\"image\":\"https://images.salsify.com/image/upload/s--iVjHsT2T--/eul0fwkyaciyajdoyyj9.jpg\",\"price\":949},{\"manufacturer_sku\":\"R525PSS-2\",\"title\":\"Rogue® 525 Propane Gas Grill, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://images.salsify.com/image/upload/s--OWyu8V-d--/vdmxwqjhrvt4we0g2b4u.jpg\",\"price\":854},{\"manufacturer_sku\":\"R625PK-2\",\"title\":\"Rogue® 625 Propane Gas Grill, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\",\"cooking_grids\":\"Porcelain-coated cast iron\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/f5fqz4ibi9cwgzfrmm7b.png?v=1770221574\",\"price\":999}]},{\"product_id\":\"napoleon-rogue-pro-phantom-griddle\",\"title\":\"Rogue PRO Phantom 30 Inch Griddle\",\"category\":\"Outdoor Cooking Appliances\",\"subcategory\":\"Griddles\",\"handle\":\"napoleon-rogue-pro-phantom-griddle\",\"image\":\"https://images.salsify.com/image/upload/s--rPhGLuSh--/j02fbze99ilcrw2uwbiq.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"RP30FTNK-PHM\",\"title\":\"Rogue® PRO Phantom 30 Inch Griddle, Rust-Resistant Stainless Steel Cooktop, Natural Gas\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"30 inch\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--rPhGLuSh--/j02fbze99ilcrw2uwbiq.jpg\",\"price\":854},{\"manufacturer_sku\":\"RP30FTPK-PHM\",\"title\":\"Rogue® PRO Phantom 30 Inch Griddle, Rust-Resistant Stainless Steel Cooktop, Propane\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"30 inch\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--rPhGLuSh--/j02fbze99ilcrw2uwbiq.jpg\",\"price\":809}]},{\"product_id\":\"napoleon-rogue-pro-series-current\",\"title\":\"Rogue® PRO Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-rogue-pro-series-current\",\"image\":\"https://images.salsify.com/image/upload/s--6aBoXNIp--/flna2vaoafzgpza7r6mv.jpg\",\"sku_count\":12,\"variants\":[{\"manufacturer_sku\":\"RP425SIBNK-2\",\"title\":\"Rogue® PRO 425 Natural Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--6aBoXNIp--/flna2vaoafzgpza7r6mv.jpg\",\"price\":1016},{\"manufacturer_sku\":\"RP425SIBNSS-2\",\"title\":\"Rogue® PRO 425 Natural Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--mKoKU9HN--/jalr1llrtfnwvprkbk4q.jpg\",\"price\":1106},{\"manufacturer_sku\":\"RP425SIBPK-2\",\"title\":\"Rogue® PRO 425 Propane Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--6aBoXNIp--/flna2vaoafzgpza7r6mv.jpg\",\"price\":971},{\"manufacturer_sku\":\"RP425SIBPSS-2\",\"title\":\"Rogue® PRO 425 Propane Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--mKoKU9HN--/jalr1llrtfnwvprkbk4q.jpg\",\"price\":1061},{\"manufacturer_sku\":\"RP525SIBNK-2\",\"title\":\"Rogue® PRO 525 Natural Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--XGiO7oTR--/va3qhecywwfqnl5ax507.jpg\",\"price\":1106},{\"manufacturer_sku\":\"RP525SIBNSS-2\",\"title\":\"Rogue® PRO 525 Natural Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ylQN0cW5--/fwrqckdizz731yxeui8z.jpg\",\"price\":1196},{\"manufacturer_sku\":\"RP525SIBPK-2\",\"title\":\"Rogue® PRO 525 Propane Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--XGiO7oTR--/va3qhecywwfqnl5ax507.jpg\",\"price\":1061},{\"manufacturer_sku\":\"RP525SIBPSS-2\",\"title\":\"Rogue® PRO 525 Propane Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ylQN0cW5--/fwrqckdizz731yxeui8z.jpg\",\"price\":1151},{\"manufacturer_sku\":\"RP625SIBNK-2\",\"title\":\"Rogue® PRO 625 Natural Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/zfi7zjjncznafae2q4vn.jpg?v=1770221593\",\"price\":1196},{\"manufacturer_sku\":\"RP625SIBNSS-2\",\"title\":\"Rogue® PRO 625 Natural Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/x1hv4svukzjwkxvjq02r.jpg?v=1770221593\",\"price\":1304},{\"manufacturer_sku\":\"RP625SIBPK-2\",\"title\":\"Rogue® PRO 625 Propane Gas Grill with Infrared Side Burner, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://images.salsify.com/image/upload/s--U7g3KK1Z--/rq6j3pg5kxy6ubrakagb.jpg\",\"price\":1151},{\"manufacturer_sku\":\"RP625SIBPSS-2\",\"title\":\"Rogue® PRO 625 Propane Gas Grill with Infrared Side Burner, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--4e948zsy--/nvqjipyotvoz11byfs8d.jpg\",\"price\":1259}]},{\"product_id\":\"napoleon-rogue-pro-s-series-current\",\"title\":\"Rogue® PRO-S Grills\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-rogue-pro-s-series-current\",\"image\":\"https://images.salsify.com/image/upload/s--z0rY6k7u--/tpmrwscngqb5xxt0scdx.jpg\",\"sku_count\":8,\"variants\":[{\"manufacturer_sku\":\"RPS425RSIBNK-2-PHM\",\"title\":\"Phantom Rogue® PRO-S 425 Natural Gas Grill with Infrared Side and Rear Burners, Matte Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--z0rY6k7u--/tpmrwscngqb5xxt0scdx.jpg\",\"price\":1556},{\"manufacturer_sku\":\"RPS425RSIBNSS-2\",\"title\":\"Rogue® PRO-S 425 Natural Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--nAUh4KyR--/xj5eppj7sbj77i2djplw.jpg\",\"price\":1466},{\"manufacturer_sku\":\"RPS425RSIBPK-2-PHM\",\"title\":\"Phantom Rogue® PRO-S 425 Propane Gas Grill with Infrared Side and Rear Burners, Matte Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Matte Black\"},\"image\":\"https://images.salsify.com/image/upload/s--z0rY6k7u--/tpmrwscngqb5xxt0scdx.jpg\",\"price\":1511},{\"manufacturer_sku\":\"RPS425RSIBPSS-2\",\"title\":\"Rogue® PRO-S 425 Propane Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--nAUh4KyR--/xj5eppj7sbj77i2djplw.jpg\",\"price\":1421},{\"manufacturer_sku\":\"RPS525RSIBNSS-2\",\"title\":\"Rogue® PRO-S 525 Natural Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/ho7zvkzsk8nnbqkddnlq.jpg?v=1770221579\",\"price\":1556},{\"manufacturer_sku\":\"RPS525RSIBPSS-2\",\"title\":\"Rogue® PRO-S 525 Propane Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"525 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--UfPZTUL---/ym5ogrksijrmshslbdoi.jpg\",\"price\":1511},{\"manufacturer_sku\":\"RPS625RSIBNSS-2\",\"title\":\"Rogue® PRO-S 625 Natural Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--YyKJIGxt--/lwcnvew4gebn2cnhudh6.jpg\",\"price\":1646},{\"manufacturer_sku\":\"RPS625RSIBPSS-2\",\"title\":\"Rogue® PRO-S 625 Propane Gas Grill with Infrared Side and Rear Burners, Stainless Steel\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"625 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--YyKJIGxt--/lwcnvew4gebn2cnhudh6.jpg\",\"price\":1601}]},{\"product_id\":\"napoleon-item-s81001\",\"title\":\"Burner Kit for LEX Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-burner-kit-for-lex-series\",\"image\":\"https://images.salsify.com/image/upload/s--WXffGsPR--/kk4viyujmwmmebftctkl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81001\",\"title\":\"Burner Kit for LEX Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--WXffGsPR--/kk4viyujmwmmebftctkl.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-s81004\",\"title\":\"Infrared Side Burner for Rogue® 425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-infrared-side-burner-for-rogue-425\",\"image\":\"https://images.salsify.com/image/upload/s--BtoTT8In--/akkrotqkd31vrw2jkody.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81004\",\"title\":\"Infrared Side Burner for Rogue® 425\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--BtoTT8In--/akkrotqkd31vrw2jkody.jpg\",\"price\":66.99}]},{\"product_id\":\"napoleon-item-s81005\",\"title\":\"Infrared Side Burner for LEX 485 & Prestige® 450/500/665\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-infrared-side-burner-for-lex-485-prestige-450-500-665\",\"image\":\"https://images.salsify.com/image/upload/s--n-VEOu5z--/yyzkxseql7lxlms4swq0.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81005\",\"title\":\"Infrared Side Burner for LEX 485 & Prestige® 450/500/665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"450 model\"},\"image\":\"https://images.salsify.com/image/upload/s--n-VEOu5z--/yyzkxseql7lxlms4swq0.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s81007\",\"title\":\"Main Infrared Burner for LEX 605/730 & Prestige® II 450\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-main-infrared-burner-for-lex-605-730-prestige-ii-450\",\"image\":\"https://images.salsify.com/image/upload/s--GveHsyre--/hzil3tcon2l8izwuhlo9.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81007\",\"title\":\"Main Infrared Burner for LEX 605/730 & Prestige® II 450\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"450 model\"},\"image\":\"https://images.salsify.com/image/upload/s--GveHsyre--/hzil3tcon2l8izwuhlo9.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s81013\",\"title\":\"Infrared Burner Upgrade Kit for Prestige® 500/665, PRO 500 and Built-in 700 / 500 Series Gas Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-infrared-burner-upgrade-kit-for-prestige-500-665-pro-500-and-built-in-700-500-series-gas-grills\",\"image\":\"https://images.salsify.com/image/upload/s--GuprNdr_--/h7sg1wxsqgvaoyu67wst.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81013\",\"title\":\"Infrared Burner Upgrade Kit for Prestige® 500/665, PRO 500 and Built-in 700 / 500 Series Gas Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--GuprNdr_--/h7sg1wxsqgvaoyu67wst.jpg\",\"price\":221.99}]},{\"product_id\":\"napoleon-item-s81014\",\"title\":\"Infrared SIZZLE ZONE™ Burner Upgrade Kit for Prestige® PRO 665\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-infrared-sizzle-zone-burner-upgrade-kit-for-prestige-pro-665\",\"image\":\"https://images.salsify.com/image/upload/s--bQkyzOE_--/fr38hpunrscpxvxdssus.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S81014\",\"title\":\"Infrared SIZZLE ZONE™ Burner Upgrade Kit for Prestige® PRO 665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--bQkyzOE_--/fr38hpunrscpxvxdssus.jpg\",\"price\":221.99}]},{\"product_id\":\"napoleon-item-s82001\",\"title\":\"3\\\" Caster Set for Rogue® Series and Prestige® 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Wheels\",\"handle\":\"napoleon-3-caster-set-for-rogue-series-and-prestige-500\",\"image\":\"https://images.salsify.com/image/upload/s---krimiaZ--/qdwlqetaushdnfebjol5.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S82001\",\"title\":\"3\\\" Caster Set for Rogue® Series and Prestige® 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s---krimiaZ--/qdwlqetaushdnfebjol5.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-s82002\",\"title\":\"Heavy Duty Swivel Castors upgrade kit for Rogue® (4 pc)\",\"category\":\"Replacement Parts\",\"subcategory\":\"Wheels\",\"handle\":\"napoleon-heavy-duty-swivel-castors-upgrade-kit-for-rogue-4-pc\",\"image\":\"https://images.salsify.com/image/upload/s--aoyvXA7G--/be3nauhq7yxqmvzx9thx.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S82002\",\"title\":\"Heavy Duty Swivel Castors upgrade kit for Rogue® (4 pc)\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--aoyvXA7G--/be3nauhq7yxqmvzx9thx.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s82003\",\"title\":\"Heavy Duty Swivel Castors upgrade kit for Prestige® and LEX485-1 (4 pc)\",\"category\":\"Replacement Parts\",\"subcategory\":\"Wheels\",\"handle\":\"napoleon-heavy-duty-swivel-castors-upgrade-kit-for-prestige-and-lex485-1-4-pc\",\"image\":\"https://images.salsify.com/image/upload/s--ocDRvXuZ--/da2zndfmd3wunwkfflo6.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S82003\",\"title\":\"Heavy Duty Swivel Castors upgrade kit for Prestige® and LEX485-1 (4 pc)\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"485 model\"},\"image\":\"https://images.salsify.com/image/upload/s--ocDRvXuZ--/da2zndfmd3wunwkfflo6.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s82004\",\"title\":\"Heavy Duty Swivel Castors Upgrade Kit for PRO500 models (4 pc)\",\"category\":\"Replacement Parts\",\"subcategory\":\"Wheels\",\"handle\":\"napoleon-heavy-duty-swivel-castors-upgrade-kit-for-pro500-models-4-pc\",\"image\":\"https://images.salsify.com/image/upload/s--sCcA0gaT--/pafle30mn61liktqliem.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S82004\",\"title\":\"Heavy Duty Swivel Castors Upgrade Kit for PRO500 models (4 pc)\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--sCcA0gaT--/pafle30mn61liktqliem.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s83001\",\"title\":\"Two Stainless Steel Cooking Grids for LEX 485, LD 485 and L485\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-lex-485-ld-485-and-l485\",\"image\":\"https://images.salsify.com/image/upload/s--yOaFhyUv--/ssi61qe9ydjlonidnoz9.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83001\",\"title\":\"Two Stainless Steel Cooking Grids for LEX 485, LD 485 and L485\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--yOaFhyUv--/ssi61qe9ydjlonidnoz9.jpg\",\"price\":175.99}]},{\"product_id\":\"napoleon-item-s83002\",\"title\":\"Two Stainless Steel Cooking Grids for Triumph® 325\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-triumph-325\",\"image\":\"https://images.salsify.com/image/upload/s--4R6F9eM8--/synexflolpo8mrpvugvp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83002\",\"title\":\"Two Stainless Steel Cooking Grids for Triumph® 325\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--4R6F9eM8--/synexflolpo8mrpvugvp.jpg\",\"price\":99.99}]},{\"product_id\":\"napoleon-item-s83004\",\"title\":\"Two Cast Iron Cooking Grids for Triumph® 325\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-triumph-325\",\"image\":\"https://images.salsify.com/image/upload/s--NIcy-ZQF--/hhethk57rmb9vrlhxexc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83004\",\"title\":\"Two Cast Iron Cooking Grids for Triumph® 325\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--NIcy-ZQF--/hhethk57rmb9vrlhxexc.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s83005\",\"title\":\"Two Cast Iron Cooking Grids for LEX 485, LD 485 and L485\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-lex-485-ld-485-and-l485\",\"image\":\"https://images.salsify.com/image/upload/s--XSaYd4AE--/bpsy9je2cmlgmhad6wju.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83005\",\"title\":\"Two Cast Iron Cooking Grids for LEX 485, LD 485 and L485\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--XSaYd4AE--/bpsy9je2cmlgmhad6wju.jpg\",\"price\":149.99}]},{\"product_id\":\"napoleon-item-s83006\",\"title\":\"Two Cast Iron Cooking Grids for Prestige® 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-prestige-500\",\"image\":\"https://images.salsify.com/image/upload/s--XSaYd4AE--/bpsy9je2cmlgmhad6wju.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83006\",\"title\":\"Two Cast Iron Cooking Grids for Prestige® 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--XSaYd4AE--/bpsy9je2cmlgmhad6wju.jpg\",\"price\":149.99}]},{\"product_id\":\"napoleon-item-s83007\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 525\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-rogue-525\",\"image\":\"https://images.salsify.com/image/upload/s--J1-n_KU---/qsnojocmgm9ww0wb9zel.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83007\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 525\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--J1-n_KU---/qsnojocmgm9ww0wb9zel.jpg\",\"price\":193.99}]},{\"product_id\":\"napoleon-item-s83008\",\"title\":\"Two Cast Iron Cooking Grids for Rogue® 425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-rogue-425\",\"image\":\"https://images.salsify.com/image/upload/s--Q8y7hH6s--/gw7lpe2nig8nq2xduemc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83008\",\"title\":\"Two Cast Iron Cooking Grids for Rogue® 425\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--Q8y7hH6s--/gw7lpe2nig8nq2xduemc.jpg\",\"price\":119.99}]},{\"product_id\":\"napoleon-item-s83011\",\"title\":\"Two Stainless Steel Cooking Grids for Prestige® 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-prestige-500\",\"image\":\"https://images.salsify.com/image/upload/s--z2yOj0bY--/kh6qy44acw4b3wfkvrwb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83011\",\"title\":\"Two Stainless Steel Cooking Grids for Prestige® 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--z2yOj0bY--/kh6qy44acw4b3wfkvrwb.jpg\",\"price\":193.99}]},{\"product_id\":\"napoleon-item-s83012\",\"title\":\"Stainless Steel Side Burner Grid for Prestige® 500/665, Rogue® SE, PRO & PRO-S 425/525/625\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-side-burner-grid-for-prestige-500-665-rogue-se-pro-pro-s-425-525-625\",\"image\":\"https://images.salsify.com/image/upload/s--ygYwcPzb--/eteqhrgn6joj4vtacaa8.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83012\",\"title\":\"Stainless Steel Side Burner Grid for Prestige® 500/665, Rogue® SE, PRO & PRO-S 425/525/625\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ygYwcPzb--/eteqhrgn6joj4vtacaa8.jpg\",\"price\":66.99}]},{\"product_id\":\"napoleon-item-s83015\",\"title\":\"Two Cast Iron Cooking Grids for Rogue® 365\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-rogue-365\",\"image\":\"https://images.salsify.com/image/upload/s--Ic3115ik--/pkw9fezn5tyeioeu2oyw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83015\",\"title\":\"Two Cast Iron Cooking Grids for Rogue® 365\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--Ic3115ik--/pkw9fezn5tyeioeu2oyw.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s83016\",\"title\":\"Two Stainless Steel Cooking Grids for Rogue® 365\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-rogue-365\",\"image\":\"https://images.salsify.com/image/upload/s--ilbHbKWW--/lhtfkmdinofiiegrrttb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83016\",\"title\":\"Two Stainless Steel Cooking Grids for Rogue® 365\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ilbHbKWW--/lhtfkmdinofiiegrrttb.jpg\",\"price\":119.99}]},{\"product_id\":\"napoleon-item-s83017\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 525\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-cast-iron-cooking-grids-for-rogue-525\",\"image\":\"https://images.salsify.com/image/upload/s--e_JHabRY--/tcojfgv0cptwotebedy5.png\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83017\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 525\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--e_JHabRY--/tcojfgv0cptwotebedy5.png\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s83018\",\"title\":\"Cast Cooking Grid for 22\\\" Kettle Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-cast-cooking-grid-for-22-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s---tpMA1QG--/ape0jopoxsyjwlx4uud8.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83018\",\"title\":\"Cast Cooking Grid for 22\\\" Kettle Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"22 inch\"},\"image\":\"https://images.salsify.com/image/upload/s---tpMA1QG--/ape0jopoxsyjwlx4uud8.jpg\",\"price\":138.99}]},{\"product_id\":\"napoleon-item-s83019\",\"title\":\"Cast Cooking Grid for 18\\\" Kettle Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-cast-cooking-grid-for-18-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--VHsquIIl--/dt0lumsjgpnedt8j1xnk.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83019\",\"title\":\"Cast Cooking Grid for 18\\\" Kettle Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"18 inch\"},\"image\":\"https://images.salsify.com/image/upload/s--VHsquIIl--/dt0lumsjgpnedt8j1xnk.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s83020\",\"title\":\"Five Cast Stainless Steel Cooking Grids for PRO & Prestige® 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-five-cast-stainless-steel-cooking-grids-for-pro-prestige-500\",\"image\":\"https://images.salsify.com/image/upload/s--xe_s-VQ4--/cm7n85mk82c5i6w1n9fl.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83020\",\"title\":\"Five Cast Stainless Steel Cooking Grids for PRO & Prestige® 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--xe_s-VQ4--/cm7n85mk82c5i6w1n9fl.jpg\",\"price\":798.99}]},{\"product_id\":\"napoleon-item-s83021\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 625 Models\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-cast-iron-cooking-grids-for-rogue-625-models\",\"image\":\"https://images.salsify.com/image/upload/s--5hPuZMbA--/roan3z35rppdokkdgpat.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83021\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 625 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\"},\"image\":\"https://images.salsify.com/image/upload/s--5hPuZMbA--/roan3z35rppdokkdgpat.jpg\",\"price\":131.99}]},{\"product_id\":\"napoleon-item-s83024\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 525\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-cast-iron-cooking-grids-for-rogue-525-item-s83024\",\"image\":\"https://images.salsify.com/image/upload/s--BuYF389J--/ekjp07unx73zlgjarkuu.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83024\",\"title\":\"Three Cast Iron Cooking Grids for Rogue® 525\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--BuYF389J--/ekjp07unx73zlgjarkuu.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s83025\",\"title\":\"Stainless Steel Infrared Side Burner Grid for Rogue® XT, Freestyle™ and LD4X Models\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-infrared-side-burner-grid-for-rogue-xt-freestyle-and-ld4x-models\",\"image\":\"https://images.salsify.com/image/upload/s--I_m1ZVgN--/fvruohl7nmhnlvkumidj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83025\",\"title\":\"Stainless Steel Infrared Side Burner Grid for Rogue® XT, Freestyle™ and LD4X Models\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--I_m1ZVgN--/fvruohl7nmhnlvkumidj.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s83026\",\"title\":\"Six Cast Stainless Steel Cooking Grids for Prestige® PRO 665\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-six-cast-stainless-steel-cooking-grids-for-prestige-pro-665\",\"image\":\"https://images.salsify.com/image/upload/s--vrXRIkJJ--/ii8sjbftwcr7nh56fiep.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83026\",\"title\":\"Six Cast Stainless Steel Cooking Grids for Prestige® PRO 665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--vrXRIkJJ--/ii8sjbftwcr7nh56fiep.jpg\",\"price\":1054.99}]},{\"product_id\":\"napoleon-item-s83027\",\"title\":\"Six Cast Stainless Steel Cooking Grids for Prestige® PRO 825\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-six-cast-stainless-steel-cooking-grids-for-prestige-pro-825\",\"image\":\"https://images.salsify.com/image/upload/s--x_eKCG5k--/rc1ovc9b6vceb0myctne.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83027\",\"title\":\"Six Cast Stainless Steel Cooking Grids for Prestige® PRO 825\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"825 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--x_eKCG5k--/rc1ovc9b6vceb0myctne.jpg\",\"price\":1164.99}]},{\"product_id\":\"napoleon-item-s83028\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 700 Series 32\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-built-in-700-series-32\",\"image\":\"https://images.salsify.com/image/upload/s--oIuwSpLq--/czrpe9lluqfepup74sdw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83028\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 700 Series 32\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--oIuwSpLq--/czrpe9lluqfepup74sdw.jpg\",\"price\":299.99}]},{\"product_id\":\"napoleon-item-s83029\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 700 Series 38\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-built-in-700-series-38\",\"image\":\"https://images.salsify.com/image/upload/s--QHyiiDM7--/masswyg0vpxi4pqeqtrq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83029\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 700 Series 38\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--QHyiiDM7--/masswyg0vpxi4pqeqtrq.jpg\",\"price\":326.99}]},{\"product_id\":\"napoleon-item-s83030\",\"title\":\"Four Stainless Steel Cooking Grids for Built-in 700 Series 44\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-four-stainless-steel-cooking-grids-for-built-in-700-series-44\",\"image\":\"https://images.salsify.com/image/upload/s--K67hoDJI--/nbwycxtxaomhcxazpwph.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83030\",\"title\":\"Four Stainless Steel Cooking Grids for Built-in 700 Series 44\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--K67hoDJI--/nbwycxtxaomhcxazpwph.jpg\",\"price\":404.99}]},{\"product_id\":\"napoleon-item-s83031\",\"title\":\"Stainless Steel Cooking Grid for Built-in 700 Series Single Range Top Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-built-in-700-series-single-range-top-burner\",\"image\":\"https://images.salsify.com/image/upload/s--NUI8w3xx--/ep9wtqmqjjfcbs0xrgxy.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83031\",\"title\":\"Stainless Steel Cooking Grid for Built-in 700 Series Single Range Top Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--NUI8w3xx--/ep9wtqmqjjfcbs0xrgxy.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-s83032\",\"title\":\"Two Stainless Steel Cooking Grids for Built-in 700 Series Dual Range Top Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-built-in-700-series-dual-range-top-burner\",\"image\":\"https://images.salsify.com/image/upload/s--ZAAwWfVP--/c3fdbet5drcvmzocslw3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83032\",\"title\":\"Two Stainless Steel Cooking Grids for Built-in 700 Series Dual Range Top Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--ZAAwWfVP--/c3fdbet5drcvmzocslw3.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s83033\",\"title\":\"Two Stainless Steel Cooking Grids for Built-in 700 Series Dual Infrared Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-built-in-700-series-dual-infrared-burner\",\"image\":\"https://images.salsify.com/image/upload/s--tHsjkKB3--/yfikw0anu4myxewbr2ft.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83033\",\"title\":\"Two Stainless Steel Cooking Grids for Built-in 700 Series Dual Infrared Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--tHsjkKB3--/yfikw0anu4myxewbr2ft.jpg\",\"price\":204.99}]},{\"product_id\":\"napoleon-item-s83034\",\"title\":\"Stainless Steel Cooking Grid for 18 model Side Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-18-model-side-burner\",\"image\":\"https://images.salsify.com/image/upload/s--XplfN7xT--/gg6uozw4rov4pz0nsqwl.png\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83034\",\"title\":\"Stainless Steel Cooking Grid for 18 model Side Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--XplfN7xT--/gg6uozw4rov4pz0nsqwl.png\",\"price\":99.99}]},{\"product_id\":\"napoleon-item-s83035\",\"title\":\"Stainless Steel Cooking Grid for Built-in 700 Series 12-inch Inline Dual Range Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-12-inch-inline-dual-range-burner\",\"image\":\"https://images.salsify.com/image/upload/s--I_m1ZVgN--/fvruohl7nmhnlvkumidj.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83035\",\"title\":\"Stainless Steel Cooking Grid for Built-in 700 Series 12-inch Inline Dual Range Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--I_m1ZVgN--/fvruohl7nmhnlvkumidj.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s83036\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 500 Series 32\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-built-in-500-series-32\",\"image\":\"https://images.salsify.com/image/upload/s--78vgZOPY--/rlfdefxow84vecygede7.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83036\",\"title\":\"Three Stainless Steel Cooking Grids for Built-in 500 Series 32\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--78vgZOPY--/rlfdefxow84vecygede7.jpg\",\"price\":154.99}]},{\"product_id\":\"napoleon-item-s83037\",\"title\":\"Stainless Steel Cooking Grid for 12 model Side Burner\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-12-model-side-burner\",\"image\":\"https://images.salsify.com/image/upload/s--LS4_OK_a--/gqt9v7cre5gavfhs7wkd.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83037\",\"title\":\"Stainless Steel Cooking Grid for 12 model Side Burner\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--LS4_OK_a--/gqt9v7cre5gavfhs7wkd.jpg\",\"price\":32.99}]},{\"product_id\":\"napoleon-item-s83038\",\"title\":\"Cast Stainless Steel Side Burner Grid for Prestige® 500/665, Rogue® SE 425/525/625\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-cast-stainless-steel-side-burner-grid-for-prestige-500-665-rogue-se-425-525-625\",\"image\":\"https://images.salsify.com/image/upload/s--4fe2gwMw--/o6zx3ro8ib4t5dpkjfp1.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83038\",\"title\":\"Cast Stainless Steel Side Burner Grid for Prestige® 500/665, Rogue® SE 425/525/625\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--4fe2gwMw--/o6zx3ro8ib4t5dpkjfp1.jpg\",\"price\":160.99}]},{\"product_id\":\"napoleon-item-s83039\",\"title\":\"Two Cast Iron Cooking Grids for Freestyle™ 365\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-cast-iron-cooking-grids-for-freestyle-365\",\"image\":\"https://images.salsify.com/image/upload/s--Ic3115ik--/pkw9fezn5tyeioeu2oyw.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83039\",\"title\":\"Two Cast Iron Cooking Grids for Freestyle™ 365\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--Ic3115ik--/pkw9fezn5tyeioeu2oyw.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s83040\",\"title\":\"Stainless Steel Cooking Grid for 22 inch Charcoal Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-22-inch-charcoal-grills\",\"image\":\"https://images.salsify.com/image/upload/s--Lhf5T6Mo--/bw8eokrpzeoz3c0cfdlq.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83040\",\"title\":\"Stainless Steel Cooking Grid for 22 inch Charcoal Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"22 inch\",\"fuel\":\"Charcoal\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--Lhf5T6Mo--/bw8eokrpzeoz3c0cfdlq.jpg\",\"price\":77.99}]},{\"product_id\":\"napoleon-item-s83041\",\"title\":\"Stainless Steel Cooking Grid for 18 inch Charcoal Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-stainless-steel-cooking-grid-for-18-inch-charcoal-grills\",\"image\":\"https://images.salsify.com/image/upload/s--H60x-5GC--/mosr88rhex44u9xrujrr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83041\",\"title\":\"Stainless Steel Cooking Grid for 18 inch Charcoal Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"size\":\"18 inch\",\"fuel\":\"Charcoal\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--H60x-5GC--/mosr88rhex44u9xrujrr.jpg\",\"price\":66.99}]},{\"product_id\":\"napoleon-item-s83043\",\"title\":\"Two Stainless Steel Cooking Grids for Rogue® 425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-two-stainless-steel-cooking-grids-for-rogue-425\",\"image\":\"https://images.salsify.com/image/upload/s--3rFaZE_t--/pxf09wcw35uvrsdlip2j.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83043\",\"title\":\"Two Stainless Steel Cooking Grids for Rogue® 425\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--3rFaZE_t--/pxf09wcw35uvrsdlip2j.jpg\",\"price\":150.99}]},{\"product_id\":\"napoleon-item-s83044\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 525\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-rogue-525-item-s83044\",\"image\":\"https://images.salsify.com/image/upload/s--J1-n_KU---/qsnojocmgm9ww0wb9zel.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83044\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 525\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--J1-n_KU---/qsnojocmgm9ww0wb9zel.jpg\",\"price\":177.99}]},{\"product_id\":\"napoleon-item-s83045\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 625 Models\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-rogue-625-models\",\"image\":\"https://images.salsify.com/image/upload/s--c8eFbWUB--/xstzoisqa9rboltzddak.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83045\",\"title\":\"Three Stainless Steel Cooking Grids for Rogue® 625 Models\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\",\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--c8eFbWUB--/xstzoisqa9rboltzddak.jpg\",\"price\":188.99}]},{\"product_id\":\"napoleon-item-s83047\",\"title\":\"Cast Iron Cooking grids for PRO18 Charcoal Grill\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-cast-iron-cooking-grids-for-pro18-charcoal-grill\",\"image\":\"https://images.salsify.com/image/upload/s--S-46IQRN--/jgqyzzkeyp4u66cucufb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S83047\",\"title\":\"Cast Iron Cooking grids for PRO18 Charcoal Grill\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--S-46IQRN--/jgqyzzkeyp4u66cucufb.jpg\",\"price\":121.99}]},{\"product_id\":\"napoleon-item-s85001\",\"title\":\"14\\\" Regulator for Propane LEX, Rogue® & Prestige® Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Regulator\",\"handle\":\"napoleon-14-regulator-for-propane-lex-rogue-prestige-series\",\"image\":\"https://images.salsify.com/image/upload/s--J_nn5yVO--/newdon8okf58o2zklkd2.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85001\",\"title\":\"14\\\" Regulator for Propane LEX, Rogue® & Prestige® Series\",\"fuel\":\"Propane\",\"installation\":null,\"options\":{\"size\":\"14 inch\",\"fuel\":\"Propane\"},\"image\":\"https://images.salsify.com/image/upload/s--J_nn5yVO--/newdon8okf58o2zklkd2.jpg\",\"price\":43.99}]},{\"product_id\":\"napoleon-item-s85002\",\"title\":\"10' Natural Gas hose with 3/8\\\" Quick Connect\",\"category\":\"Replacement Parts\",\"subcategory\":\"Hose\",\"handle\":\"napoleon-10-natural-gas-hose-with-3-8-quick-connect\",\"image\":\"https://images.salsify.com/image/upload/s--IbU56ANR--/bxawsbxqd7zezagryhhk.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85002\",\"title\":\"10' Natural Gas hose with 3/8\\\" Quick Connect\",\"fuel\":\"Natural Gas\",\"installation\":null,\"options\":{\"size\":\"8 inch\",\"fuel\":\"Natural Gas\"},\"image\":\"https://images.salsify.com/image/upload/s--IbU56ANR--/bxawsbxqd7zezagryhhk.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s85003\",\"title\":\"10' Natural Gas hose with 1/2\\\" Quick Connect\",\"category\":\"Replacement Parts\",\"subcategory\":\"Hose\",\"handle\":\"napoleon-10-natural-gas-hose-with-1-2-quick-connect\",\"image\":\"https://images.salsify.com/image/upload/s--l4UISl6h--/upntg6e4j0j1zk60aqen.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85003\",\"title\":\"10' Natural Gas hose with 1/2\\\" Quick Connect\",\"fuel\":\"Natural Gas\",\"installation\":null,\"options\":{\"size\":\"2 inch\",\"fuel\":\"Natural Gas\"},\"image\":\"https://images.salsify.com/image/upload/s--l4UISl6h--/upntg6e4j0j1zk60aqen.jpg\",\"price\":154.99}]},{\"product_id\":\"napoleon-item-s85008\",\"title\":\"Natural Gas Regulator Kit for all Built-ins\",\"category\":\"Replacement Parts\",\"subcategory\":\"Regulator\",\"handle\":\"napoleon-natural-gas-regulator-kit-for-all-built-ins\",\"image\":\"https://images.salsify.com/image/upload/s--aSGvXavu--/i2pixhhcrofptniym8no.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85008\",\"title\":\"Natural Gas Regulator Kit for all Built-ins\",\"fuel\":\"Natural Gas\",\"installation\":null,\"options\":{\"fuel\":\"Natural Gas\"},\"image\":\"https://images.salsify.com/image/upload/s--aSGvXavu--/i2pixhhcrofptniym8no.jpg\",\"price\":77.99}]},{\"product_id\":\"napoleon-item-s85009\",\"title\":\"Propane Regulator for BIG32/38 and BI500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Regulator\",\"handle\":\"napoleon-propane-regulator-for-big32-38-and-bi500\",\"image\":\"https://images.salsify.com/image/upload/s--wLxXmRUl--/igui9acw5q9usubzo9ws.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85009\",\"title\":\"Propane Regulator for BIG32/38 and BI500\",\"fuel\":\"Propane\",\"installation\":null,\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://images.salsify.com/image/upload/s--wLxXmRUl--/igui9acw5q9usubzo9ws.jpg\",\"price\":32.99}]},{\"product_id\":\"napoleon-item-s85010\",\"title\":\"Propane Regulator for BIPRO665/825 and BIG44\",\"category\":\"Replacement Parts\",\"subcategory\":\"Regulator\",\"handle\":\"napoleon-propane-regulator-for-bipro665-825-and-big44\",\"image\":\"https://images.salsify.com/image/upload/s--2mKPuqUe--/krwvbcrn4i9r4tbn96hr.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S85010\",\"title\":\"Propane Regulator for BIPRO665/825 and BIG44\",\"fuel\":\"Propane\",\"installation\":null,\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://images.salsify.com/image/upload/s--2mKPuqUe--/krwvbcrn4i9r4tbn96hr.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s87001\",\"title\":\"1 Burner & 2 Sear Plates for Rogue® Series, Prestige® 500 and PRO 500 Model Gas Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Kit\",\"handle\":\"napoleon-1-burner-2-sear-plates-for-rogue-series-prestige-500-and-pro-500-model-gas-grills\",\"image\":\"https://images.salsify.com/image/upload/s--MGOGMBIJ--/dclodor1fl2rkpjvhxw4.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87001\",\"title\":\"1 Burner & 2 Sear Plates for Rogue® Series, Prestige® 500 and PRO 500 Model Gas Grills\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"500 model\"},\"image\":\"https://images.salsify.com/image/upload/s--MGOGMBIJ--/dclodor1fl2rkpjvhxw4.jpg\",\"price\":65.99}]},{\"product_id\":\"napoleon-item-s87002\",\"title\":\"1 Burner & 1 Sear Plate for Triumph® Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Kit\",\"handle\":\"napoleon-1-burner-1-sear-plate-for-triumph-series\",\"image\":\"https://images.salsify.com/image/upload/s--lMoSJaDw--/rffgqgftljxesgjndgca.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87002\",\"title\":\"1 Burner & 1 Sear Plate for Triumph® Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--lMoSJaDw--/rffgqgftljxesgjndgca.jpg\",\"price\":49.99}]},{\"product_id\":\"napoleon-item-s87003\",\"title\":\"Three Stainless Steel Cooking Grids for Triumph® 410 and LD410\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-stainless-steel-cooking-grids-for-triumph-410-and-ld410\",\"image\":\"https://images.salsify.com/image/upload/s--YaC1oJkv--/rwenwkruyopack83dbsc.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87003\",\"title\":\"Three Stainless Steel Cooking Grids for Triumph® 410 and LD410\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--YaC1oJkv--/rwenwkruyopack83dbsc.jpg\",\"price\":150.99}]},{\"product_id\":\"napoleon-item-s87004\",\"title\":\"Three Cast Iron Cooking Grids for Triumph® 410 and LD410 Gas Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-three-cast-iron-cooking-grids-for-triumph-410-and-ld410-gas-grills\",\"image\":\"https://images.salsify.com/image/upload/s--t2RsgfIh--/jfqiqap5gc9xdahvap3f.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87004\",\"title\":\"Three Cast Iron Cooking Grids for Triumph® 410 and LD410 Gas Grills\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--t2RsgfIh--/jfqiqap5gc9xdahvap3f.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s87005\",\"title\":\"Four Stainless Steel Cooking Grids for Triumph® 495\",\"category\":\"Replacement Parts\",\"subcategory\":\"Grids\",\"handle\":\"napoleon-four-stainless-steel-cooking-grids-for-triumph-495\",\"image\":\"https://images.salsify.com/image/upload/s--gJ075rSk--/jb12x9qspxqqhf6gs0un.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87005\",\"title\":\"Four Stainless Steel Cooking Grids for Triumph® 495\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Stainless Steel\"},\"image\":\"https://images.salsify.com/image/upload/s--gJ075rSk--/jb12x9qspxqqhf6gs0un.jpg\",\"price\":150.99}]},{\"product_id\":\"napoleon-item-s87012\",\"title\":\"1 Burner & 2 Sear Plates for Prestige® PRO 665/825\",\"category\":\"Replacement Parts\",\"subcategory\":\"Kit\",\"handle\":\"napoleon-1-burner-2-sear-plates-for-prestige-pro-665-825\",\"image\":\"https://images.salsify.com/image/upload/s--GNMZPWCw--/ps2eovoz35wchvftxx4n.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87012\",\"title\":\"1 Burner & 2 Sear Plates for Prestige® PRO 665/825\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"665 model\"},\"image\":\"https://images.salsify.com/image/upload/s--GNMZPWCw--/ps2eovoz35wchvftxx4n.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s87019\",\"title\":\"1 Burner & 2 Sear Plates for Built-in 500 and 700 Series 32/38/44\",\"category\":\"Replacement Parts\",\"subcategory\":\"Kit\",\"handle\":\"napoleon-1-burner-2-sear-plates-for-built-in-500-and-700-series-32-38-44\",\"image\":\"https://images.salsify.com/image/upload/s--ZZGxNr0N--/zhkhvbak3ozm7ckctiuz.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87019\",\"title\":\"1 Burner & 2 Sear Plates for Built-in 500 and 700 Series 32/38/44\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--ZZGxNr0N--/zhkhvbak3ozm7ckctiuz.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s87024\",\"title\":\"Replacement Sear Plates Rogue® 425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Sear Plates\",\"handle\":\"napoleon-replacement-sear-plates-rogue-425\",\"image\":\"https://images.salsify.com/image/upload/s--U-L7Weib--/r1mblbwq2kqq18mfpjbb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87024\",\"title\":\"Replacement Sear Plates Rogue® 425\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--U-L7Weib--/r1mblbwq2kqq18mfpjbb.jpg\",\"price\":77.99}]},{\"product_id\":\"napoleon-item-s87025\",\"title\":\"Replacement Sear Plates Rogue® 525, Prestige®, PRO 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Sear Plates\",\"handle\":\"napoleon-replacement-sear-plates-rogue-525-prestige-pro-500\",\"image\":\"https://images.salsify.com/image/upload/s--L7Ynkenk--/izg6qlqq3lsyzpvmylgm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87025\",\"title\":\"Replacement Sear Plates Rogue® 525, Prestige®, PRO 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--L7Ynkenk--/izg6qlqq3lsyzpvmylgm.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s87026\",\"title\":\"Replacement Sear Plates Rogue® 625, Prestige® 665\",\"category\":\"Replacement Parts\",\"subcategory\":\"Sear Plates\",\"handle\":\"napoleon-replacement-sear-plates-rogue-625-prestige-665\",\"image\":\"https://images.salsify.com/image/upload/s---Z9qvemF--/phyyv35dcgtmbq0i3cdg.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87026\",\"title\":\"Replacement Sear Plates Rogue® 625, Prestige® 665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\"},\"image\":\"https://images.salsify.com/image/upload/s---Z9qvemF--/phyyv35dcgtmbq0i3cdg.jpg\",\"price\":110.99}]},{\"product_id\":\"napoleon-item-s87027\",\"title\":\"Replacement Burners Rogue® 425, Freestyle™ 365\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-replacement-burners-rogue-425-freestyle-365\",\"image\":\"https://images.salsify.com/image/upload/s--QqSDcBaO--/kaubvokrwyhulsjat3cm.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87027\",\"title\":\"Replacement Burners Rogue® 425, Freestyle™ 365\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s--QqSDcBaO--/kaubvokrwyhulsjat3cm.jpg\",\"price\":88.99}]},{\"product_id\":\"napoleon-item-s87028\",\"title\":\"Replacement Burners Rogue® 525, Freestyle™ 425, Prestige®, PRO 500\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-replacement-burners-rogue-525-freestyle-425-prestige-pro-500\",\"image\":\"https://images.salsify.com/image/upload/s--UuDlpLFB--/shcdvoovbafkxmhi4vio.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87028\",\"title\":\"Replacement Burners Rogue® 525, Freestyle™ 425, Prestige®, PRO 500\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"525 model\"},\"image\":\"https://images.salsify.com/image/upload/s--UuDlpLFB--/shcdvoovbafkxmhi4vio.jpg\",\"price\":133.99}]},{\"product_id\":\"napoleon-item-s87029\",\"title\":\"Replacement Burners Rogue® 625, Prestige® 665\",\"category\":\"Replacement Parts\",\"subcategory\":\"Burner\",\"handle\":\"napoleon-replacement-burners-rogue-625-prestige-665\",\"image\":\"https://images.salsify.com/image/upload/s--BO8ercwJ--/c3vsnjy8enwbsagppjzv.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87029\",\"title\":\"Replacement Burners Rogue® 625, Prestige® 665\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"625 model\"},\"image\":\"https://images.salsify.com/image/upload/s--BO8ercwJ--/c3vsnjy8enwbsagppjzv.jpg\",\"price\":154.99}]},{\"product_id\":\"napoleon-item-s87030\",\"title\":\"Replacement Sear Plates Freestyle™ 365\",\"category\":\"Replacement Parts\",\"subcategory\":\"Sear Plates\",\"handle\":\"napoleon-replacement-sear-plates-freestyle-365\",\"image\":\"https://images.salsify.com/image/upload/s--L_4V-bn4--/hqsnxj4lzuhxhfaumbvh.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87030\",\"title\":\"Replacement Sear Plates Freestyle™ 365\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"365 model\"},\"image\":\"https://images.salsify.com/image/upload/s--L_4V-bn4--/hqsnxj4lzuhxhfaumbvh.jpg\",\"price\":44.99}]},{\"product_id\":\"napoleon-item-s87031\",\"title\":\"Replacement Sear Plates Freestyle™ 425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Sear Plates\",\"handle\":\"napoleon-replacement-sear-plates-freestyle-425\",\"image\":\"https://images.salsify.com/image/upload/s---3XuEypp--/ftm6zqm4jh2abowdhup3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S87031\",\"title\":\"Replacement Sear Plates Freestyle™ 425\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"425 model\"},\"image\":\"https://images.salsify.com/image/upload/s---3XuEypp--/ftm6zqm4jh2abowdhup3.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s89001\",\"title\":\"2 Spark Igniter & Electrode Kit for Prestige® 308/450 after 2005\",\"category\":\"Replacement Parts\",\"subcategory\":\"Igniter\",\"handle\":\"napoleon-2-spark-igniter-electrode-kit-for-prestige-308-450-after-2005\",\"image\":\"https://images.salsify.com/image/upload/s--uJH0WDZi--/piamqlroly4woskdcyql.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S89001\",\"title\":\"2 Spark Igniter & Electrode Kit for Prestige® 308/450 after 2005\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"308 model\"},\"image\":\"https://images.salsify.com/image/upload/s--uJH0WDZi--/piamqlroly4woskdcyql.jpg\",\"price\":54.99}]},{\"product_id\":\"napoleon-item-s91001\",\"title\":\"Temperature Gauge for LEX Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-lex-series\",\"image\":\"https://images.salsify.com/image/upload/s--6oDPeDmp--/jqxzxtvm9i8vchobcws3.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91001\",\"title\":\"Temperature Gauge for LEX Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--6oDPeDmp--/jqxzxtvm9i8vchobcws3.jpg\",\"price\":21.99}]},{\"product_id\":\"napoleon-item-s91002\",\"title\":\"Temperature Gauge for Legend 485\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-legend-485\",\"image\":\"https://images.salsify.com/image/upload/s--VxIFKcKb--/ynz9mcvunwzwmnfi1xda.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91002\",\"title\":\"Temperature Gauge for Legend 485\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--VxIFKcKb--/ynz9mcvunwzwmnfi1xda.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-s91003\",\"title\":\"Temperature Gauge for Prestige® Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-prestige-series\",\"image\":\"https://images.salsify.com/image/upload/s--J_jt7Hez--/yp9tgkb5w6sqins0newi.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91003\",\"title\":\"Temperature Gauge for Prestige® Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--J_jt7Hez--/yp9tgkb5w6sqins0newi.jpg\",\"price\":27.99}]},{\"product_id\":\"napoleon-item-s91004\",\"title\":\"Temperature Gauge for Triumph® Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-triumph-series\",\"image\":\"https://images.salsify.com/image/upload/s--L33TROCC--/g9lwjoxcxir2u5jmt8be.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91004\",\"title\":\"Temperature Gauge for Triumph® Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--L33TROCC--/g9lwjoxcxir2u5jmt8be.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-s91005\",\"title\":\"Temperature Gauge for  Prestige® PRO Series\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-prestige-pro-series\",\"image\":\"https://images.salsify.com/image/upload/s--2z_0NWSa--/eifvazxi9ive5bogid7j.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91005\",\"title\":\"Temperature Gauge for  Prestige® PRO Series\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--2z_0NWSa--/eifvazxi9ive5bogid7j.jpg\",\"price\":30.99}]},{\"product_id\":\"napoleon-item-s91006\",\"title\":\"Temperature Gauge for Charcoal Kettle Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-charcoal-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--nYHx1UsZ--/m0skhuyqwhdrqxgrcwpo.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91006\",\"title\":\"Temperature Gauge for Charcoal Kettle Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--nYHx1UsZ--/m0skhuyqwhdrqxgrcwpo.jpg\",\"price\":41.99}]},{\"product_id\":\"napoleon-item-s91007\",\"title\":\"Temperature Gauge for PRO Charcoal Kettle Grills\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-pro-charcoal-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--0eWIgeC7--/fvznbvuxw7ew82xqycfy.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91007\",\"title\":\"Temperature Gauge for PRO Charcoal Kettle Grills\",\"fuel\":\"Charcoal\",\"installation\":null,\"options\":{\"fuel\":\"Charcoal\"},\"image\":\"https://images.salsify.com/image/upload/s--0eWIgeC7--/fvznbvuxw7ew82xqycfy.jpg\",\"price\":41.99}]},{\"product_id\":\"napoleon-item-s91009\",\"title\":\"Temperature Gauge for Built-in 500 and 700 Series 32/38/44\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-built-in-500-and-700-series-32-38-44\",\"image\":\"https://images.salsify.com/image/upload/s--BuKwMMkV--/k3bgx1bwriyt2ecjjanb.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91009\",\"title\":\"Temperature Gauge for Built-in 500 and 700 Series 32/38/44\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--BuKwMMkV--/k3bgx1bwriyt2ecjjanb.jpg\",\"price\":25.99}]},{\"product_id\":\"napoleon-item-s91010\",\"title\":\"Temperature Gauge for Phantom P500 / RSE425\",\"category\":\"Replacement Parts\",\"subcategory\":\"Gauge\",\"handle\":\"napoleon-temperature-gauge-for-phantom-p500-rse425\",\"image\":\"https://images.salsify.com/image/upload/s--4wEYr66a--/brq7hsovrpsofla3jrlp.jpg\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"S91010\",\"title\":\"Temperature Gauge for Phantom P500 / RSE425\",\"fuel\":null,\"installation\":null,\"options\":{},\"image\":\"https://images.salsify.com/image/upload/s--4wEYr66a--/brq7hsovrpsofla3jrlp.jpg\",\"price\":38.99}]},{\"product_id\":\"napoleon-freestyle-sb\",\"title\":\"Freestyle Grills with Range Side Burner\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-freestyle-sb\",\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/cso0xpfsetfawalgz3xy.jpg?v=1770221573\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"F365DSBPGT-ECP\",\"title\":\"Freestyle™ 365 Propane Gas Grill with Range Side Burner, Graphite Grey\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"365 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/cso0xpfsetfawalgz3xy.jpg?v=1770221573\",\"price\":629},{\"manufacturer_sku\":\"F425DSBPGT-ECP\",\"title\":\"Freestyle™ 425 Propane Gas Grill with Range Side Burner, Graphite Grey\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Graphite Grey\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/m6ouec50huvy074gqjj1.jpg?v=1770221588\",\"price\":729}]},{\"product_id\":\"napoleon-rogue-range-side-burner\",\"title\":\"Rogue 425 Grills with Range Side Burner\",\"category\":\"Grills\",\"subcategory\":\"Gas Grills\",\"handle\":\"napoleon-rogue-range-side-burner\",\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/j75w2w1d4ntqkui7xw1t.jpg?v=1770221553\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"R425SBNK-2-FB\",\"title\":\"Rogue® 425 Natural Gas Grill with Range Side Burner, Black\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Natural Gas\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0278/7065/8649/files/j75w2w1d4ntqkui7xw1t.jpg?v=1770221553\",\"price\":879},{\"manufacturer_sku\":\"R425SBPK-2-FB\",\"title\":\"Rogue® 425 Propane Gas Grill with Range Side Burner, Black\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"options\":{\"size\":\"425 model\",\"fuel\":\"Propane\",\"installation\":\"Cart\",\"finish\":\"Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-d10de0d5ef81.jpg?v=1788862670\",\"price\":829}]},{\"product_id\":\"napoleon-item-im-ugc12tk-mk\",\"title\":\"OASIS Adaptor Kit for BI12 / BIB12\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Adapter Kits\",\"handle\":\"napoleon-item-im-ugc12tk-mk\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-c4b71270598c.png?v=1788862745\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC12TK-MK\",\"title\":\"OASIS® Adaptor Kit for BI12/BIB12 when using IM-UGC18-MK-1\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-c4b71270598c.png?v=1788862745\",\"price\":37}]},{\"product_id\":\"napoleon-item-im-ugc32-mk\",\"title\":\"OASIS Under Grill Cabinet for Built-in 700 Series 32\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-item-im-ugc32-mk\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a8a5983e1a7a.jpg?v=1788862675\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-UGC32-MK\",\"title\":\"OASIS® Under Grill Cabinet for Built-in 700 Series 32\",\"fuel\":null,\"installation\":null,\"options\":{\"size\":\"32 inch\",\"finish\":\"Matte Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a8a5983e1a7a.jpg?v=1788862675\",\"price\":699}]},{\"product_id\":\"napoleon-item-im-wdc-mk\",\"title\":\"OASIS Waste Drawer Cabinet\",\"category\":\"Outdoor Kitchen Components\",\"subcategory\":\"Modular Cabinets\",\"handle\":\"napoleon-item-im-wdc-mk\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-6e184db5d0b3.jpg?v=1788862679\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"IM-WDC-MK\",\"title\":\"OASIS® Waste Drawer Cabinet\",\"fuel\":null,\"installation\":null,\"options\":{\"finish\":\"Matte Black\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-6e184db5d0b3.jpg?v=1788862679\",\"price\":899}]},{\"product_id\":\"napoleon-apollo-charcoal-smokers\",\"title\":\"Apollo Charcoal Water Smokers\",\"category\":\"Grills\",\"subcategory\":\"Smokers\",\"handle\":\"napoleon-apollo-charcoal-water-smokers\",\"image\":\"https://images.salsify.com/image/upload/s--JfQtBBwM--/nafqnhem2dz8enuzsheg.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"AS18K\",\"title\":\"Apollo® 18 Charcoal Water Smoker\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"size\":\"18 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--JfQtBBwM--/nafqnhem2dz8enuzsheg.jpg\",\"price\":395},{\"manufacturer_sku\":\"AS22K\",\"title\":\"Apollo® 22 Charcoal Water Smoker\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"size\":\"22 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--tJQiVlKh--/ti6rw1kcjxfapidhzxrn.jpg\",\"price\":494}]},{\"product_id\":\"napoleon-pro-charcoal-kettles\",\"title\":\"PRO Charcoal Kettle Grills\",\"category\":\"Grills\",\"subcategory\":\"Charcoal Grills\",\"handle\":\"napoleon-pro-charcoal-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--nfEUtsEr--/efbcxyi2pkcvdm7iw7ss.jpg\",\"sku_count\":3,\"variants\":[{\"manufacturer_sku\":\"PRO18K-LEG-3\",\"title\":\"PRO18 Charcoal Kettle Grill, Black\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Black\",\"size\":\"18 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--nfEUtsEr--/efbcxyi2pkcvdm7iw7ss.jpg\",\"price\":287},{\"manufacturer_sku\":\"PRO22K-LEG-3\",\"title\":\"PRO22 Charcoal Kettle Grill, Black\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Black\",\"size\":\"22 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--FI3Pjw_9--/of9zaizimdghhynkvfyy.jpg\",\"price\":350},{\"manufacturer_sku\":\"PRO22K-CART-3\",\"title\":\"PRO22 Charcoal Kettle Grill, Black with Cart\",\"fuel\":\"Charcoal\",\"installation\":\"Cart\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Black\",\"size\":\"22 inch\",\"installation\":\"Cart\"},\"image\":\"https://images.salsify.com/image/upload/s--tRUElLod--/vdtrx6ucklqjjor2kg66.jpg\",\"price\":494}]},{\"product_id\":\"napoleon-nk-charcoal-kettles\",\"title\":\"NK Charcoal Kettle Grills\",\"category\":\"Grills\",\"subcategory\":\"Charcoal Grills\",\"handle\":\"napoleon-nk-charcoal-kettle-grills\",\"image\":\"https://images.salsify.com/image/upload/s--CHyHgKZW--/frbktv0ssxw4chltcpch.jpg\",\"sku_count\":2,\"variants\":[{\"manufacturer_sku\":\"NK18K-LEG-3\",\"title\":\"NK18 Charcoal Kettle Grill, Black\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Black\",\"size\":\"18 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--CHyHgKZW--/frbktv0ssxw4chltcpch.jpg\",\"price\":161},{\"manufacturer_sku\":\"NK22K-LEG-3\",\"title\":\"NK22 Charcoal Kettle Grill, Black\",\"fuel\":\"Charcoal\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Charcoal\",\"finish\":\"Black\",\"size\":\"22 inch\",\"installation\":\"Freestanding\"},\"image\":\"https://images.salsify.com/image/upload/s--2hiZeoqc--/m5u08ichvzadynxld21v.jpg\",\"price\":224}]},{\"product_id\":\"napoleon-st-tropez-rectangle-patioflame-table\",\"title\":\"St. Tropez Rectangle Patioflame Table\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Tables\",\"handle\":\"napoleon-st-tropez-rectangle-patioflame-table\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a25d709a4fbb.jpg?v=1788860636\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"STTR1-BZ\",\"title\":\"St. Tropez Rectangle Patioflame Table\",\"fuel\":\"Propane\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a25d709a4fbb.jpg?v=1788860636\",\"price\":1889}]},{\"product_id\":\"napoleon-st-tropez-square-patioflame-table\",\"title\":\"St. Tropez Square Patioflame Table\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Tables\",\"handle\":\"napoleon-st-tropez-square-patioflame-table\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-5ca55cfca942.png?v=1788860654\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"STTR2-BZ\",\"title\":\"St. Tropez Square Patioflame Table\",\"fuel\":\"Propane\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-5ca55cfca942.png?v=1788860654\",\"price\":1889}]},{\"product_id\":\"napoleon-30-inch-linear-patioflame-burner-kit\",\"title\":\"30-inch Linear Patioflame Burner Kit\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pit Burner Kits\",\"handle\":\"napoleon-30-inch-linear-patioflame-burner-kit\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-aca16fb0b28d.jpg?v=1788860663\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GPFR60\",\"title\":\"30-inch Linear Patioflame Burner Kit\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-aca16fb0b28d.jpg?v=1788860663\",\"price\":719}]},{\"product_id\":\"napoleon-24-inch-square-patioflame-burner-kit\",\"title\":\"24-inch Square Patioflame Burner Kit\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pit Burner Kits\",\"handle\":\"napoleon-24-inch-square-patioflame-burner-kit\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-efcbede2eabf.jpg?v=1788860676\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GPFS60\",\"title\":\"24-inch Square Patioflame Burner Kit\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-efcbede2eabf.jpg?v=1788860676\",\"price\":719}]},{\"product_id\":\"napoleon-48-inch-linear-patioflame\",\"title\":\"48-inch Linear Patioflame Burner Kit\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Pit Burner Kits\",\"handle\":\"napoleon-48-inch-linear-patioflame\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-320d7ceb5317.jpg?v=1788860685\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GPFL48\",\"title\":\"48-inch Linear Patioflame Burner Kit\",\"fuel\":\"Propane\",\"installation\":\"Built-in\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-320d7ceb5317.jpg?v=1788860685\",\"price\":1659}]},{\"product_id\":\"napoleon-linear-gas-patioflame\",\"title\":\"Linear Gas Patioflame\",\"category\":\"Fire & Heating\",\"subcategory\":\"Fire Tables\",\"handle\":\"napoleon-linear-gas-patioflame\",\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-221da446aeea.jpg?v=1788860699\",\"sku_count\":1,\"variants\":[{\"manufacturer_sku\":\"GPFL48MHP\",\"title\":\"Linear Gas Patioflame\",\"fuel\":\"Propane\",\"installation\":\"Freestanding\",\"options\":{\"fuel\":\"Propane\"},\"image\":\"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-221da446aeea.jpg?v=1788860699\",\"price\":1999}]}]"), Bn = (e) => new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD"
}).format(e), Vn = [
	"Grills",
	"Outdoor Kitchens",
	"Outdoor Kitchen Components",
	"Outdoor Cooking Appliances",
	"Fire & Heating",
	"Accessories",
	"Replacement Parts",
	"All"
], Hn = [
	[
		"napoleon-prestige-pro-smart",
		"Prestige PRO",
		"For the cook who wants more.",
		"Explore smart-equipped Prestige PRO configurations, premium cooking systems and the details that make a grill the centerpiece of your patio."
	],
	[
		"napoleon-prestige-v",
		"Prestige",
		"Make every gathering your own.",
		"Choose your size, fuel and finish, with connected and Phantom configurations available within the Prestige range."
	],
	[
		"napoleon-built-in-700-gas-grills-1",
		"Built-in 700 Series",
		"The foundation of your outdoor kitchen.",
		"Three grill widths, natural gas or propane, and a built-in format for a kitchen planned around your space."
	],
	[
		"napoleon-rogue-pro-s-series-current",
		"Rogue PRO-S",
		"Bring more possibilities to the grill.",
		"Explore Rogue PRO-S configurations with infrared side cooking and rear-burner capability. Select the size and fuel that suit your setup."
	],
	[
		"napoleon-rogue-pro-series-current",
		"Rogue PRO",
		"A place for everyday grilling.",
		"Find your combination of cooking space, side cooking and finish across the Rogue PRO family."
	],
	[
		"napoleon-rogue-series-current",
		"Rogue",
		"Your backyard, your routine.",
		"Explore practical gas-grill configurations with multiple sizes and finishes. Compare the exact features of each model."
	],
	[
		"napoleon-built-in-500-gas-grills",
		"Built-in 500 Series",
		"A dedicated place to cook.",
		"A 32-inch built-in grill in natural gas or propane, ready to become the center of your outdoor kitchen."
	],
	[
		"napoleon-prestige-pro-825-classic-3",
		"Prestige PRO 825 Classic",
		"Two cooking zones. One centerpiece.",
		"Choose the dual-lid PRO 825 as a built-in grill head or a freestanding cart, with natural gas and propane options."
	]
], Un = [
	[
		"Grills",
		"Grills",
		"Start with the centerpiece.",
		"napoleon-prestige-pro-smart"
	],
	[
		"Outdoor Kitchens",
		"Outdoor kitchen packages",
		"Coordinated OASIS kitchen packages.",
		"napoleon-oasis-301-outdoor-kitchen"
	],
	[
		"Outdoor Kitchen Components",
		"Kitchen components & storage",
		"Cabinets, drawers, countertops & refrigeration.",
		"napoleon-item-bi-1824-3dr"
	],
	[
		"Outdoor Cooking Appliances",
		"Griddles & side cooking",
		"Make room for more on the menu.",
		"napoleon-built-in-700-griddle"
	],
	[
		"Fire & Heating",
		"Fire & heating",
		"Stay a little longer.",
		"napoleon-timberwolf-smokeless-fire-pits"
	],
	[
		"Accessories",
		"Grilling accessories",
		"The finishing touches for every cook.",
		"napoleon-item-70035"
	],
	["Replacement Parts", "Replacement Parts", "Find replacement burners, cooking grids, igniters and more.", "replacement-parts"]
], Wn = {
	"Replacement Parts": {src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/h7sg1wxsqgvaoyu67wst.jpg?v=1788862243", alt: "Napoleon infrared burner replacement kit S81013"},
	"Outdoor Kitchens": {
		src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-330adf5aaae1.jpg?v=1788860075",
		alt: "Manufacturer photograph of a Napoleon OASIS outdoor kitchen beside a swimming pool"
	},
	"Fire & Heating": {
		src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-5ca55cfca942.png?v=1788860654",
		alt: "Napoleon St. Tropez square Patioflame fire table in rustic bronze with flames"
	}
}, Gn = {
	Grills: {
		title: "Find your next favorite place to cook.",
		copy: "Compare gas, charcoal, electric and portable grills. Choose the fuel and installation first, then explore the real configurations within each family."
	},
	"Outdoor Kitchens": {
		title: "Bring your outdoor kitchen together.",
		copy: "Explore coordinated OASIS kitchen packages. Compare the included grill, cabinetry and countertop details for each package. For individual cabinets, drawers and refrigeration, explore Outdoor Kitchen Components."
	},
	"Outdoor Kitchen Components": {
		title: "Give every part of the kitchen a place.",
		copy: "Explore cabinetry, access doors, drawers, countertops and refrigeration. Product-specific dimensions and installation documents help you plan the surrounding kitchen."
	},
	"Outdoor Cooking Appliances": {
		title: "More possibilities beside the grill.",
		copy: "Add a dedicated griddle, range burner or infrared cooking station. Match the fuel and installation to your layout, then compare the exact cooking equipment."
	},
	"Fire & Heating": {
		title: "Make more of the evening outdoors.",
		copy: "Explore fire features and outdoor heating for your seating area. Compare the heat source, dimensions and placement requirements for the product you choose."
	},
	Accessories: {
		title: "Make every cooking session your own.",
		copy: "Find cookware, utensils, covers and useful finishing touches. For accessories made for a particular grill, follow the listed model compatibility."
	},
	"Replacement Parts": {
		title: "Find the part that belongs to your grill.",
		copy: "Search by exact part number and confirm it against your product manual. Model names and appearance alone do not establish replacement-part compatibility."
	},
	All: {
		title: "Explore the complete Napoleon collection.",
		copy: "Browse grills, outdoor kitchens, fire features and accessories together, or choose a category to narrow your search."
	}
};
function Kn() {
 window.HearthNapoleonVisibility.use(A);
 const zn = napoleonListingSource.filter(product => window.HearthNapoleonVisibility.allows(product));
 const visibleCategories = Vn.filter(category => category === 'All' || zn.some(product => product.category === category));
 const marketFilter=useMarketFilter(A);
	let [e, t] = (0, A.useState)(""), [n, r] = (0, A.useState)("Grills"), [i, a] = (0, A.useState)(""), [o, s] = (0, A.useState)(""), [c, l] = (0, A.useState)("featured"), [u, d] = (0, A.useState)(""), [p, m] = (0, A.useState)(!1);
	(0, A.useEffect)(() => {
		function e() {
			let e = new URLSearchParams(window.location.search), n = e.get("category") || "Grills", i = visibleCategories.includes(n) ? n : "Grills", o = zn.filter((e) => i === "All" || e.category === i), c = e.get("fuel") || "", u = e.get("installation") || "", f = e.get("type") || "", p = e.get("sort") || "featured";
			r(i), t((e.get("q") || "").slice(0, 200)), a(o.some((e) => e.variants.some((e) => e.fuel === c)) ? c : ""), s(o.some((e) => e.variants.some((e) => e.installation === u)) ? u : ""), d(o.some((e) => e.subcategory === f) ? f : ""), l([
				"featured",
				"name",
				"price"
			].includes(p) ? p : "featured"), m(!0);
		}
		return e(), window.addEventListener("popstate", e), () => window.removeEventListener("popstate", e);
	}, []), (0, A.useEffect)(() => {
		if (!p) return;
		let t = new URL(window.location.href);
		for (let [r, a] of Object.entries({
			category: n === "Grills" ? "" : n,
			q: e,
			fuel: i,
			installation: o,
			type: u,
			sort: c === "featured" ? "" : c
		})) a ? t.searchParams.set(r, a) : t.searchParams.delete(r);
		window.history.replaceState(window.history.state, "", t);
	}, [
		p,
		n,
		e,
		i,
		o,
		u,
		c
	]);
	function h(e) {
		r(e), d(""), a(""), s(""), t(""), document.getElementById("collection")?.scrollIntoView({ behavior: "smooth" });
	}
	let g = (t) => t.variants.filter((n) => (!i || n.fuel === i) && (!o || n.installation === o) && `${t.title} ${n.title} ${n.manufacturer_sku}`.toLowerCase().includes(e.toLowerCase())), _ = (e) => n === "All" || e.category === n, v = [...new Set(zn.filter(_).map((e) => e.subcategory))].sort(), y = zn.filter((e) => marketFilter.matches(e.handle) && _(e) && (!u || e.subcategory === u) && g(e).length > 0), b = (e) => Math.min(...g(e).map((e) => e.price ?? Infinity));
	c === "name" && (y = [...y].sort((e, t) => e.title.localeCompare(t.title))), c === "price" && (y = [...y].sort((e, t) => b(e) - b(t)));
	let x = (e, t) => zn.find((t) => t.product_id === e)?.image || zn.find((e) => e.category === t && e.image)?.image;
	return /* @__PURE__ */ (0, N.jsx)(N.Fragment, { children: /* @__PURE__ */ (0, N.jsxs)("main", {
		id: "content",
		className: "napoleon-store",
		children: [
			/* @__PURE__ */ (0, N.jsxs)("section", {
				className: "brand-hero original-brand-hero n-premium-hero",
				children: [/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "brand-hero-copy",
					children: [
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "brand-hero-breadcrumb",
							children: [
								/* @__PURE__ */ (0, N.jsx)(w, {
									href: "/",
									children: "Brands"
								}),
								/* @__PURE__ */ (0, N.jsx)(he, { size: 11 }),
								/* @__PURE__ */ (0, N.jsx)("span", { children: "Napoleon" })
							]
						}),
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "n-brand-lockup",
							children: [/* @__PURE__ */ (0, N.jsx)("img", {
								src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-ec5596025277.png?v=1788860781",
								alt: "Napoleon",
								width: "768",
								height: "392"
							}), /* @__PURE__ */ (0, N.jsxs)("span", { children: ["by ", /* @__PURE__ */ (0, N.jsx)("b", { children: "Hearth Outpost" })] })]
						}),
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: "GRILL. GATHER. STAY AWHILE."
						}),
						/* @__PURE__ */ (0, N.jsxs)("h1", { children: [
							"The outdoors,",
							/* @__PURE__ */ (0, N.jsx)("br", {}),
							"beautifully brought together."
						] }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: "Napoleon grills, outdoor kitchens and fire features bring more possibilities to the space you love. Start with your grill. Build an experience around it." }),
						/* @__PURE__ */ (0, N.jsxs)("div", {
							className: "hero-actions",
							children: [/* @__PURE__ */ (0, N.jsxs)("a", {
								href: "#collection",
								className: "hero-primary",
								children: ["Shop Napoleon ", /* @__PURE__ */ (0, N.jsx)(M, { size: 18 })]
							}), /* @__PURE__ */ (0, N.jsxs)("a", {
								href: "#grill-series",
								className: "hero-secondary",
								children: ["Find your grill ", /* @__PURE__ */ (0, N.jsx)(M, { size: 16 })]
							})]
						})
					]
				}), /* @__PURE__ */ (0, N.jsx)("div", {
					className: "brand-hero-image",
					children: /* @__PURE__ */ (0, N.jsx)("img", {
						src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-356ba6cc17e8.png?v=1788860787&width=1600",
                        srcSet: [640,960,1600].map(w=>"https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-356ba6cc17e8.png?v=1788860787&width="+w+" "+w+"w").join(","), sizes:"100vw", fetchPriority:"high",
						alt: "Napoleon outdoor kitchen with a dual-lid Prestige PRO 825 built-in grill, stainless storage, dual burner, refrigerator, Phantom heater and fire table"
					})
				})]
			}),
			/* @__PURE__ */ (0, N.jsxs)("nav", {
				className: "brand-jumpnav",
				children: [
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "#explore-range",
						children: "Explore the range"
					}),
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "#grill-series",
						children: "Find your grill"
					}),
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "#collection",
						children: "Shop Napoleon"
					}),
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "#brand-story",
						children: "Why Napoleon"
					}),
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "#napoleon-planning",
						children: "Plan your space"
					})
				]
			}),
			/* @__PURE__ */ (0, N.jsxs)("section", {
				className: "n-brand-section",
				id: "explore-range",
				children: [/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "n-section-heading",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-kicker",
						children: "ONE OUTDOOR SPACE. SO MANY POSSIBILITIES."
					}), /* @__PURE__ */ (0, N.jsxs)("h2", { children: [
						"Start with the grill.",
						/* @__PURE__ */ (0, N.jsx)("br", {}),
						"Make the rest your own."
					] })] }), /* @__PURE__ */ (0, N.jsx)("p", { children: "From the first flame to the final detail, explore a collection that goes well beyond the grill." })]
				}), /* @__PURE__ */ (0, N.jsx)("div", {
					className: "n-range-grid",
					children: Un.filter(([category]) => category === "Replacement Parts" || zn.some(product => product.category === category)).map(([e, t, n, r], i) => /* @__PURE__ */ (0, N.jsxs)(e === "Replacement Parts" ? "a" : "button", {
						className: "n-range-card " + (i === 0 ? "n-range-primary" : ""),
						href: e === "Replacement Parts" ? "/collections/replacement-parts" : void 0,
						onClick: e === "Replacement Parts" ? void 0 : () => h(e),
						children: [/* @__PURE__ */ (0, N.jsx)("div", {
							className: "n-range-photo" + ((e !== 'Fire & Heating' || window.HearthNapoleonVisibility.allows('napoleon-st-tropez-square-patioflame-table') ? Wn[e] : null) ? e === "Fire & Heating" ? " n-range-fire-table" : " n-range-scene" : ""),
							children: /* @__PURE__ */ (0, N.jsx)("img", {
								src: i === 0 ? "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-485987943baa.png?v=1788860181" : (e !== 'Fire & Heating' || window.HearthNapoleonVisibility.allows('napoleon-st-tropez-square-patioflame-table') ? Wn[e] : null)?.src || x(r, e) || void 0,
								alt: (e !== 'Fire & Heating' || window.HearthNapoleonVisibility.allows('napoleon-st-tropez-square-patioflame-table') ? Wn[e] : null)?.alt || `Napoleon ${t}`,
								loading: "lazy"
							})
						}), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
							/* @__PURE__ */ (0, N.jsx)("h3", { children: t }),
							/* @__PURE__ */ (0, N.jsx)("p", { children: n }),
							/* @__PURE__ */ (0, N.jsxs)("span", { children: [
								"Explore ",
								t.toLowerCase(),
								" ",
								/* @__PURE__ */ (0, N.jsx)(M, { size: 18 })
							] })
						] })]
					}, e))
				})]
			}),
			/* @__PURE__ */ (0, N.jsxs)("section", {
				id: "grill-series",
				className: "n-brand-section n-series-section",
				children: [/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "n-section-heading",
					children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-kicker",
						children: "FIND YOUR NAPOLEON"
					}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "A grill for the way you live." })] }), /* @__PURE__ */ (0, N.jsx)(w, {
						className: "n-text-link",
						href: "/compare/grills",
						children: "Compare your selected grills →"
					})]
				}), /* @__PURE__ */ (0, N.jsx)("div", {
					className: "n-series-grid",
					children: Hn.map(([e, t, n, r]) => {
						let i = zn.find((t) => t.product_id === e);
						return i && /* @__PURE__ */ (0, N.jsxs)("article", { children: [/* @__PURE__ */ (0, N.jsx)(w, {
							href: "/products/" + i.handle,
							children: /* @__PURE__ */ (0, N.jsx)("img", {
								src: i.image || void 0,
								alt: `Napoleon ${t}`,
								loading: "lazy"
							})
						}), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
							/* @__PURE__ */ (0, N.jsx)("p", {
								className: "n-kicker",
								children: t
							}),
							/* @__PURE__ */ (0, N.jsx)("div", {
								className: "n-series-installations",
								children: [...new Set(i.variants.map((e) => e.installation).filter(Boolean))].map((e) => {
									let t = i.variants.find((t) => t.installation === e);
									return /* @__PURE__ */ (0, N.jsx)(w, {
										href: "/products/" + i.handle + "?sku=" + encodeURIComponent(t.manufacturer_sku),
										children: e === "Cart" ? "Freestanding" : e
									}, e);
								})
							}),
							/* @__PURE__ */ (0, N.jsx)("h3", { children: n }),
							/* @__PURE__ */ (0, N.jsx)("p", { children: r }),
							/* @__PURE__ */ (0, N.jsxs)(w, {
								href: "/products/" + i.handle,
								children: [
									"Explore ",
									t,
									" ",
									/* @__PURE__ */ (0, N.jsx)(M, { size: 16 })
								]
							})
						] })] }, e);
					})
				})]
			}),
			/* @__PURE__ */ (0, N.jsxs)("section", {
				id: "brand-story",
				className: "n-brand-story",
				children: [/* @__PURE__ */ (0, N.jsxs)("div", { children: [
					/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-kicker",
						children: "THE NAPOLEON DETAILS"
					}),
					/* @__PURE__ */ (0, N.jsxs)("h2", { children: [
						"It’s what happens",
						/* @__PURE__ */ (0, N.jsx)("br", {}),
						"around the flame."
					] }),
					/* @__PURE__ */ (0, N.jsx)("p", { children: "A grill should fit how you cook, whether that means a quick dinner, slow weekend cooking or a full patio gathering. Napoleon’s range gives you room to choose the cooking system, installation and finish that make sense for you." })
				] }), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
					/* @__PURE__ */ (0, N.jsxs)("article", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "A distinctive cooking surface." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Napoleon’s WAVE cooking grids are a signature detail across many grill families. Compare the grid material and cooking area on the exact configuration you choose." })] }),
					/* @__PURE__ */ (0, N.jsxs)("article", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "More ways to bring the heat." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Explore infrared searing, rear burners, griddles and side cooking where offered. Match the equipment to what you actually love to cook." })] }),
					/* @__PURE__ */ (0, N.jsxs)("article", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "A kitchen that comes together." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "OASIS modular cabinetry and built-in components let you plan beyond the grill, with dedicated storage and layouts built around compatible equipment." })] })
				] })]
			}),
			/* @__PURE__ */ (0, N.jsxs)("section", {
				id: "collection",
				className: "n-collection",
				children: [
					/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "n-sticky-collection",
						children: [
							/* @__PURE__ */ (0, N.jsx)("div", {
								className: "n-collection-heading",
								children: /* @__PURE__ */ (0, N.jsxs)("div", { children: [
									/* @__PURE__ */ (0, N.jsx)("p", {
										className: "n-kicker",
										children: "THE NAPOLEON COLLECTION"
									}),
									/* @__PURE__ */ (0, N.jsx)("h2", { children: Gn[n].title }),
									/* @__PURE__ */ (0, N.jsx)("p", { children: Gn[n].copy })
								] })
							}),
							/* @__PURE__ */ (0, N.jsx)("div", {
								className: "n-filters",
								"aria-label": "Product categories",
								children: visibleCategories.map((e) => /* @__PURE__ */ (0, N.jsx)(f, {
									"aria-pressed": n === e,
									variant: n === e ? "default" : "outline",
									onClick: () => {
										r(e), d(""), a(""), s("");
									},
									children: e === "All" ? "All Napoleon" : e
								}, e))
							}),
							["Grills", "Outdoor Cooking Appliances"].includes(n) && /* @__PURE__ */ (0, N.jsxs)("div", {
								className: "n-collection-facets",
								children: [/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Fuel", /* @__PURE__ */ (0, N.jsxs)("select", {
									value: i,
									onChange: (e) => a(e.target.value),
									children: [/* @__PURE__ */ (0, N.jsx)("option", {
										value: "",
										children: "All fuels"
									}), [...new Set(zn.filter((e) => e.category === n).flatMap((e) => e.variants.map((e) => e.fuel)).filter((e) => !!e))].map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
								})] }), /* @__PURE__ */ (0, N.jsxs)("label", { children: ["Installation", /* @__PURE__ */ (0, N.jsxs)("select", {
									value: o,
									onChange: (e) => s(e.target.value),
									children: [/* @__PURE__ */ (0, N.jsx)("option", {
										value: "",
										children: "All installations"
									}), [...new Set(zn.filter((e) => e.category === n).flatMap((e) => e.variants.map((e) => e.installation)).filter((e) => !!e))].map((e) => /* @__PURE__ */ (0, N.jsx)("option", {
										value: e,
										children: e === "Cart" ? "Freestanding with cart" : e
									}, e))]
								})] })]
							}),
							n === "Outdoor Kitchen Components" && /* @__PURE__ */ (0, N.jsxs)("div", {
								className: "n-component-shortcuts",
								children: [/* @__PURE__ */ (0, N.jsx)("span", { children: "Explore components:" }), [
									"Modular Cabinets",
									"Doors & Drawers",
									"Countertops",
									"Outdoor Refrigeration"
								].map((e) => /* @__PURE__ */ (0, N.jsx)(f, {
									variant: u === e ? "default" : "outline",
									onClick: () => {
										d(e), t("");
									},
									children: e === "Outdoor Refrigeration" ? "Refrigeration" : e
								}, e))]
							}),
							/* @__PURE__ */ (0, N.jsxs)("div", {
								className: "n-search-row",
								children: [
									marketSelect(N,marketFilter),
									v.length > 1 && /* @__PURE__ */ (0, N.jsxs)("label", { children: ["Product type", /* @__PURE__ */ (0, N.jsxs)("select", {
										value: u,
										onChange: (e) => d(e.target.value),
										children: [/* @__PURE__ */ (0, N.jsx)("option", {
											value: "",
											children: "All types"
										}), v.map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
									})] }),
									/* @__PURE__ */ (0, N.jsxs)("label", {
										className: "n-search",
										children: [/* @__PURE__ */ (0, N.jsx)(je, { size: 18 }), /* @__PURE__ */ (0, N.jsx)(On, {
											"aria-label": "Search Napoleon products or model numbers",
											placeholder: "Search products or model numbers",
											value: e,
											onChange: (e) => t(e.target.value)
										})]
									}),
									/* @__PURE__ */ (0, N.jsxs)("p", {
										className: "n-count",
										children: [
											y.length,
											" ",
											n === "All" ? "product families" : n.toLowerCase() + " families"
										]
									}),
									/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Sort", /* @__PURE__ */ (0, N.jsxs)("select", {
										value: c,
										onChange: (e) => l(e.target.value),
										children: [
											/* @__PURE__ */ (0, N.jsx)("option", {
												value: "featured",
												children: "Featured"
											}),
											/* @__PURE__ */ (0, N.jsx)("option", {
												value: "name",
												children: "Name"
											}),
											/* @__PURE__ */ (0, N.jsx)("option", {
												value: "price",
												children: "Price: low to high"
											})
										]
									})] }),
									(i || o || e || u || marketFilter.value) && /* @__PURE__ */ (0, N.jsx)(f, {
										variant: "ghost",
										onClick: () => {
											a(""), s(""), d(""), t(""), marketFilter.change("");
										},
										children: "Clear filters"
									})
								]
							})
						]
					}),
					/* @__PURE__ */ (0, N.jsx)("div", {
						className: "n-grid",
						children: y.map((e) => {
							let t = g(e), n = t[0], r = t.map((e) => e.price).filter((e) => e !== null);
							return /* @__PURE__ */ (0, N.jsxs)(w, {
								className: "n-card",
								href: "/products/" + e.handle + "?sku=" + encodeURIComponent(n.manufacturer_sku),
								children: [
									/* @__PURE__ */ (0, N.jsx)("div", {
										className: "n-card-image",
										children: n.image ? /* @__PURE__ */ (0, N.jsx)("img", {
											src: n.image,
											alt: `${e.title} — ${Object.values(n.options).join(", ")}`,
											loading: "lazy"
										}) : /* @__PURE__ */ (0, N.jsx)("span", { children: "Product photography being sourced" })
									}),
									/* @__PURE__ */ (0, N.jsxs)("p", {
										className: "n-kicker",
										children: ["NAPOLEON · ", e.subcategory]
									}),
									/* @__PURE__ */ (0, N.jsx)("h3", { children: e.title }),
									/* @__PURE__ */ (0, N.jsx)("p", {
										className: "n-card-price",
										children: r.length ? `${new Set(r).size > 1 ? "From " : ""}${Bn(Math.min(...r))}` : "Price available on request"
									}),
									/* @__PURE__ */ (0, N.jsxs)("p", {
										className: "n-card-options",
										children: [
											e.sku_count > 1 ? "Choose your configuration" : "Explore product",
											" ",
											/* @__PURE__ */ (0, N.jsx)(M, { size: 15 })
										]
									})
								]
							}, e.product_id);
						})
					}),
					!y.length && /* @__PURE__ */ (0, N.jsxs)("div", {
						className: "n-empty",
						children: [
							/* @__PURE__ */ (0, N.jsx)("h3", { children: "No matching products" }),
							/* @__PURE__ */ (0, N.jsx)("p", { children: "Try a model number, a shorter search or another category." }),
							/* @__PURE__ */ (0, N.jsx)(f, {
								onClick: () => {
									t(""), a(""), s(""), d("");
								},
								children: "Clear filters"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ (0, N.jsxs)("section", {
				id: "napoleon-planning",
				className: "n-brand-planning",
				children: [/* @__PURE__ */ (0, N.jsx)("img", {
					src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/ODK105MK-BIG32P-1-DE-Web-Gallery-11-ODK105MK-BIG32-1_WithoutPeople2_b51b0532.jpg?v=1792728707",
					alt: "Napoleon OASIS outdoor kitchen",
					loading: "lazy"
				}), /* @__PURE__ */ (0, N.jsxs)("div", { children: [
					/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-kicker",
						children: "BRING YOUR PLANS TOGETHER"
					}),
					/* @__PURE__ */ (0, N.jsxs)("h2", { children: [
						"Your outdoor kitchen,",
						/* @__PURE__ */ (0, N.jsx)("br", {}),
						"one considered detail at a time."
					] }),
					/* @__PURE__ */ (0, N.jsxs)("ol", { children: [
						/* @__PURE__ */ (0, N.jsxs)("li", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "Choose the centerpiece." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Start with cooking space, fuel and a built-in or freestanding grill." })] }),
						/* @__PURE__ */ (0, N.jsxs)("li", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "Build around your routine." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Add side cooking, storage and the equipment that earns its place in your kitchen." })] }),
						/* @__PURE__ */ (0, N.jsxs)("li", { children: [/* @__PURE__ */ (0, N.jsx)("h3", { children: "Confirm the fit." }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Check model-specific cutouts, utilities, clearances and compatibility before installation." })] })
					] }),
					/* @__PURE__ */ (0, N.jsxs)(w, {
						className: "n-primary",
						href: "/projects",
						children: [/* @__PURE__ */ (0, N.jsx)(xe, { size: 18 }), " Start your Outdoor Project"]
					})
				] })]
			})
		]
	}) });
}
//#endregion
//#region lib/comparison-metrics.ts
var qn = (e) => `${typeof e.value === "number" && /btu/i.test(e.attribute + " " + e.unit) ? e.value.toLocaleString("en-US") : e.value} ${e.unit}`.trim(), Jn = {
	height: "Height",
	depth: "Depth",
	width: "Width",
	net_weight: "Net weight",
	main_cooking_area: "Primary cooking surface",
	main_cooking_surface: "Primary cooking surface",
	"Primary cooking area": "Primary cooking surface",
	total_cooking_area: "Total cooking area",
	main_burner_btu: "Main-burner heat output",
	"Main burner output": "Main-burner heat output",
	rear_burner_btu: "Backburner output",
	side_burner_btu: "Side burner output",
	inner_burner_btu: "Inner burner output",
	outer_burner_btu: "Outer burner output",
	btu_per_burner: "Output per burner",
	btu_per_main_burner: "Output per main burner",
	total_btu: "Total appliance heat output",
	main_burners: "Main burner count",
	height_lid_open: "Overall height with lid open",
	"Overall height — hood open": "Overall height with lid open",
	lid_opening_type: "Lid opening",
	shelves_down_width: "Width with shelves folded",
	width_shelves_down: "Width with shelves folded",
	"Cart width — shelves folded": "Width with shelves folded",
	"Overall width — shelves folded": "Width with shelves folded",
	work_surface_height: "Work-surface height",
	"Work-surface height": "Work-surface height",
	cooking_surface_height: "Cooking-surface height",
	height_cart_folded: "Height with cart folded",
	height_legs_folded: "Height with legs folded",
	width_cart_folded: "Width with cart folded",
	width_one_shelf_raised: "Width with one shelf raised",
	"Cart width — one shelf raised": "Width with one shelf raised",
	"Overall width — one shelf raised": "Width with one shelf raised"
};
function Yn(e) {
	let t = [], n = e.flatMap((e) => {
		if (e.attribute !== "Overall dimensions — hood closed") return [e];
		let t = String(e.value).match(/^(.+?) W × (.+?) D × (.+?) H$/);
		return t ? [
			{
				attribute: "Width",
				value: t[1],
				unit: ""
			},
			{
				attribute: "Depth",
				value: t[2],
				unit: ""
			},
			{
				attribute: "Height",
				value: t[3],
				unit: ""
			}
		] : [e];
	});
	for (let e of n) {
		let n = Jn[e.attribute] || e.attribute, r = t.find((e) => e.attribute === n);
		r ? qn(r) !== qn(e) && (r.value = qn(r) + "; " + qn(e), r.unit = "") : t.push({
			...e,
			attribute: n
		});
	}
	return t;
}
var Xn = {
	BI32NSS: {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	BI32PSS: {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG32RBNMK-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG32RBNSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG32RBPMK-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG32RBPSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-3623-ZCL",
			title: "Zero Clearance Liner for Built-in BIG32, BI32, BIG32FT",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-big32-bi32-big32ft?sku=BI-3623-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG38RBNSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"5 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-4223-ZCL",
			title: "Zero Clearance Liner for Built-in 700 Series 38",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-700-series-38?sku=BI-4223-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG38RBPSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"5 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-4223-ZCL",
			title: "Zero Clearance Liner for Built-in 700 Series 38",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-700-series-38?sku=BI-4223-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG44RBNSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-4823-ZCL",
			title: "Zero Clearance Liner for Built-in 700 Series 44",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-700-series-44?sku=BI-4823-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIG44RBPSS-1": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: {
			sku: "BI-4823-ZCL",
			title: "Zero Clearance Liner for Built-in 700 Series 44",
			href: "/products/napoleon-zero-clearance-liner-for-built-in-700-series-44?sku=BI-4823-ZCL",
			evidence: "Manufacturer liner product title identifies supported appliance family; manufacturer cutout table supplies separate liner opening and combustible-enclosure requirement."
		}
	},
	"BIPRO825RBINSS-3": {
		equipment: [
			"Substantial 9.5 mm stainless grids",
			"Rotisserie equipment included",
			"Wood-chip smoking built in"
		],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"BIPRO825RBIPSS-3": {
		equipment: [
			"Substantial 9.5 mm stainless grids",
			"Rotisserie equipment included",
			"Wood-chip smoking built in"
		],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"PRO825RSBINSS-3": {
		equipment: [
			"Substantial 9.5 mm stainless grids",
			"Rotisserie equipment included",
			"Wood-chip smoking built in",
			"Infrared SIZZLE ZONE® Bottom Burner"
		],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Two-Stage Power Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid"
		],
		liner: null
	},
	"PRO825RSBIPSS-3": {
		equipment: [
			"Substantial 9.5 mm stainless grids",
			"Rotisserie equipment included",
			"Wood-chip smoking built in",
			"Infrared SIZZLE ZONE® Bottom Burner"
		],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"6 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Two-Stage Power Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid"
		],
		liner: null
	},
	F365DNGT: {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Enamelled Single Level Sear Plates"
		],
		liner: null
	},
	F365DPGT: {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Enamelled Single Level Sear Plates"
		],
		liner: null
	},
	F425DNGT: {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Enamelled Single Level Sear Plates"
		],
		liner: null
	},
	F425DPGT: {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Enamelled Single Level Sear Plates"
		],
		liner: null
	},
	"NK14K-LEG-3": {
		equipment: [],
		controls: [],
		included: ["Chrome Plated Cooking Grid"],
		liner: null
	},
	P500VRSIBNSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE 2.0 ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P500VRSIBPSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE 2.0 ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"P500VXRSIBNK-PHM": {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Cast Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P500VXRSIBNSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"P500VXRSIBPK-PHM": {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Cast Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P500VXRSIBPSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P665VRSIBNSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE 2.0 ignition"],
		included: [
			"5 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P665VRSIBPSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE 2.0 ignition"],
		included: [
			"5 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P665VXRSIBNSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	P665VXRSIBPSS: {
		equipment: ["Stainless steel WAVE grids", "Rotisserie equipment included"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE 2.0 ignition",
			"Connected cooking"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"8.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"PRO285-BK": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"PRO285E-BK": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Adjustable electric heat control"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"PRO285N-BK": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"PRO285X-BK": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"PRO285X-MK-PHM": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Includes a hinged warming rack."],
		liner: null
	},
	"PRO500RSIBNSS-3": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid"
		],
		liner: null
	},
	"PRO500RSIBPSS-3": {
		equipment: ["Substantial 9.5 mm stainless grids", "Rotisserie equipment included"],
		controls: ["Controls with SafetyGlow", "JETFIRE ignition"],
		included: [
			"4 Stainless Steel Main Burners",
			"9.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner with Included Heavy Duty Rotisserie Kit",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid"
		],
		liner: null
	},
	PRO500VXRSIBNSS: {
		equipment: [
			"Napoleon’s WAVE cooking surface",
			"Rotisserie equipment included",
			"SIZZLE ZONE®"
		],
		controls: [
			"JETFIRE 2.0 ignition",
			"Controls with SafetyGlow",
			"See changes in burner output",
			"Metal controls with illuminated rings",
			"Cooking controls on your phone",
			"Choose familiar controls or Smart Mode"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"WAVE Cooking Grids",
			"Rotisserie-Ready Roasting",
			"Space-Saving Warming Rack Storage"
		],
		liner: null
	},
	PRO500VXRSIBPSS: {
		equipment: [
			"Napoleon’s WAVE cooking surface",
			"Rotisserie equipment included",
			"SIZZLE ZONE®"
		],
		controls: [
			"JETFIRE 2.0 ignition",
			"Controls with SafetyGlow",
			"See changes in burner output",
			"Metal controls with illuminated rings",
			"Cooking controls on your phone",
			"Choose familiar controls or Smart Mode"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"WAVE Cooking Grids",
			"Rotisserie-Ready Roasting",
			"Space-Saving Warming Rack Storage"
		],
		liner: null
	},
	PRO665VXRSIBNSS: {
		equipment: [
			"Napoleon’s WAVE cooking surface",
			"Built-In Electric Smoker Box",
			"A rotisserie kit included",
			"SIZZLE ZONE®"
		],
		controls: [
			"JETFIRE 2.0 ignition",
			"Controls with SafetyGlow",
			"Read burner output through light",
			"Metal controls with illuminated rings",
			"Cooking controls on your phone",
			"Choose familiar controls or Smart Mode"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"WAVE Cooking Grids",
			"Built-In Electric Smoker Box",
			"Rotisserie-Ready Roasting",
			"Space-Saving Warming Rack Storage"
		],
		liner: null
	},
	PRO665VXRSIBPSS: {
		equipment: [
			"Napoleon’s WAVE cooking surface",
			"Built-In Electric Smoker Box",
			"A rotisserie kit included",
			"SIZZLE ZONE®"
		],
		controls: [
			"JETFIRE 2.0 ignition",
			"Controls with SafetyGlow",
			"Read burner output through light",
			"Metal controls with illuminated rings",
			"Cooking controls on your phone",
			"Choose familiar controls or Smart Mode"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"WAVE Cooking Grids",
			"Built-In Electric Smoker Box",
			"Rotisserie-Ready Roasting",
			"Space-Saving Warming Rack Storage"
		],
		liner: null
	},
	PRO605CSS: {
		equipment: ["Porcelain-coated cast iron grids", "Charcoal heat for rotisserie cooking"],
		controls: [],
		included: [
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"Rear Charcoal Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"LIFT EASE Roll Top Lid"
		],
		liner: null
	},
	"R425NK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R425NK-2-SS": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R425NSS-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R425PK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R425PK-2-SS": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R425PSS-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525NK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525NK-2-SS": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525NSS-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525PK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525PK-2-SS": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R525PSS-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls shaped for your hand",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Chrome-Plated Warming Rack"
		],
		liner: null
	},
	"R625PK-2": {
		equipment: ["Cast iron WAVE grids"],
		controls: [],
		included: [
			"5 Stainless Steel Main Burners",
			"Cast Iron WAVE Cooking Grids",
			"Dual-level sear plates vaporize drippings"
		],
		liner: null
	},
	"RP425SIBNK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP425SIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP425SIBPK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP425SIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP525SIBNK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP525SIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP525SIBPK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP525SIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP625SIBNK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP625SIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP625SIBPK-2": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"Porcelainized Cast Iron Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RP625SIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids"],
		controls: [
			"Controls you can see after sunset",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates",
			"Stainless Steel Warming Rack"
		],
		liner: null
	},
	"RPS425RSIBNK-2-PHM": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS425RSIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS425RSIBPK-2-PHM": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS425RSIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"3 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS525RSIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS525RSIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"4 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS625RSIBNSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"RPS625RSIBPSS-2": {
		equipment: ["7.5 mm stainless WAVE grids", "Rear-burner cooking"],
		controls: [
			"Controls with SafetyGlow",
			"JETFIRE ignition",
			"Adjust the cooking heat"
		],
		included: [
			"5 Stainless Steel Main Burners",
			"7.5 mm Stainless Steel WAVE Cooking Grids",
			"Infrared SIZZLE ZONE® Side Burner",
			"Infrared Rear Rotisserie Burner",
			"ACCU-PROBE Temperature Gauge",
			"Dual-Level Stainless Steel Sear Plates"
		],
		liner: null
	},
	"TQ240-BL": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Ergonomic Control Knob", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"TQ285-BL-1": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"TQ285-RD-1-A": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"TQ285X-BL-1": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"TQ285X-RD-1-A": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["Controls shaped for your hand", "JETFIRE ignition"],
		included: ["Porcelain Coated Cast Iron WAVE Cooking Grids", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"F365DSBPGT-ECP": {
		equipment: ["Porcelain-coated WAVE grids"],
		controls: ["JETFIRE ignition for the main burners"],
		included: [
			"The Freestyle 365 Propane Gas Barbecue with Range Side Burner is a compact grill with premium features and unbeatable value.",
			"Ignited by the instant JETFIRE ignition system that lights the main burners with a jet of flame easily, every time.",
			"Get the perfect sear over the cast iron porcelainized enamel cooking grids.",
			"Three stainless steel burners provide even heat, easily controlled and monitored by the onboard temperature gauge.",
			"Create beautiful sauces and side dishes while grilling a delightful meal by using the integrated range side burner."
		],
		liner: null
	},
	"F425DSBPGT-ECP": {
		equipment: ["Porcelain-coated WAVE grids"],
		controls: ["JETFIRE ignition for the main burners"],
		included: [
			"The Freestyle 425 Propane Gas Barbecue with Range Side Burner is a compact grill with premium features and unbeatable value.",
			"Ignited by the instant JETFIRE ignition system that lights the main burners with a jet of flame easily, every time.",
			"Get the perfect sear over the cast iron porcelainized enamel cooking grids.",
			"Four stainless steel burners provide even heat, easily controlled and monitored by the onboard temperature gauge.",
			"Create beautiful sauces and side dishes while grilling a delightful meal by using the integrated range side burner."
		],
		liner: null
	},
	"R425SBNK-2-FB": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["JETFIRE ignition"],
		included: [
			"Three stainless steel main burners with adjustable heat control.",
			"Porcelain-coated cast iron WAVE cooking grids.",
			"Integrated range side burner for sauces and side dishes.",
			"Battery-free JETFIRE ignition lights individual main burners.",
			"Two levels of stainless steel sear plates protect the burners and vaporize drippings."
		],
		liner: null
	},
	"R425SBPK-2-FB": {
		equipment: ["Porcelain-coated cast iron grids"],
		controls: ["JETFIRE ignition"],
		included: [
			"Three stainless steel main burners with adjustable heat control.",
			"Porcelain-coated cast iron WAVE cooking grids.",
			"Integrated range side burner for sauces and side dishes.",
			"Battery-free JETFIRE ignition lights individual main burners.",
			"Two levels of stainless steel sear plates protect the burners and vaporize drippings."
		],
		liner: null
	},
	AS18K: {
		equipment: ["304 stainless steel cooking grids", "Stainless steel rotisserie ring"],
		controls: ["Adjust the cooking heat", "Adjust the smoking conditions"],
		included: [
			"Premium 304 Stainless Steel Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Durable Stainless Steel Rotisserie Ring"
		],
		liner: null
	},
	AS22K: {
		equipment: ["304 stainless steel cooking grids", "Stainless steel rotisserie ring"],
		controls: ["Adjust the cooking heat", "Adjust the smoking conditions"],
		included: [
			"Premium 304 Stainless Steel Cooking Grids",
			"ACCU-PROBE Temperature Gauge with Smoke and Sear Range",
			"Durable Stainless Steel Rotisserie Ring"
		],
		liner: null
	},
	"PRO18K-LEG-3": {
		equipment: [
			"Porcelain-coated cast iron grids",
			"Three cooking-grid heights",
			"An extension ring for rotisserie setup"
		],
		controls: [],
		included: [
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Hinged Cooking Grids with Three Height Adjustments",
			"Stainless Steel Extension Ring with Rotisserie Holder"
		],
		liner: null
	},
	"PRO22K-LEG-3": {
		equipment: [
			"Porcelain-coated cast iron grids",
			"Three cooking-grid heights",
			"An extension ring for rotisserie setup"
		],
		controls: [],
		included: [
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Hinged Cooking Grids with Three Height Adjustments",
			"Stainless Steel Extension Ring with Rotisserie Holder"
		],
		liner: null
	},
	"PRO22K-CART-3": {
		equipment: [
			"Porcelain-coated cast iron grids",
			"Three cooking-grid heights",
			"An extension ring for rotisserie setup"
		],
		controls: [],
		included: [
			"Porcelain Coated Cast Iron WAVE Cooking Grids",
			"ACCU-PROBE Temperature Gauge",
			"Hinged Cooking Grids with Three Height Adjustments",
			"Stainless Steel Extension Ring with Rotisserie Holder"
		],
		liner: null
	},
	"NK18K-LEG-3": {
		equipment: [],
		controls: [],
		included: ["Stainless steel cooking grid", "ACCU-PROBE Temperature Gauge"],
		liner: null
	},
	"NK22K-LEG-3": {
		equipment: [],
		controls: [],
		included: ["Chrome Plated Cooking Grid", "ACCU-PROBE Temperature Gauge"],
		liner: null
	}
}, Zn = {
	BI32NSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0Z6mT22_--/ikqlisdsux93nmn5fd0f.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	BI32PSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0Z6mT22_--/ikqlisdsux93nmn5fd0f.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG32RBNSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG32RBPSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG38RBNSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG38RBPSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG44RBNSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG44RBPSS-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--XbcndCc5--/hr1autaqp29boaajk9ug.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIPRO825RBINSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--suDC_myR--/y32nqhivlazfmwtst3xm.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIPRO825RBIPSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--suDC_myR--/y32nqhivlazfmwtst3xm.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"PRO825RSBINSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--9Q8NxmgI--/bqw2dxvcm1h7cmvuehjc.pdf#page=23",
		sourceLabel: "Model-specific warranty · page 23",
		source_page: 23,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"PRO825RSBIPSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--9Q8NxmgI--/bqw2dxvcm1h7cmvuehjc.pdf#page=23",
		sourceLabel: "Model-specific warranty · page 23",
		source_page: 23,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	F365DNGT: {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	F365DPGT: {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	F425DNGT: {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	F425DPGT: {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	P500VRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P500VRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"P500VXRSIBNK-PHM": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P500VXRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"P500VXRSIBPK-PHM": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P500VXRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P665VRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P665VRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P665VXRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	P665VXRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--oU_RQeGK--/fjfvvpjnvdinxqkvaaao.pdf#page=36",
		sourceLabel: "Model-specific warranty · page 36",
		source_page: 36,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"PRO285-BK": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--qABN-sag--/c3hfgvjlhqwn4fkdgmvy.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"PRO285E-BK": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Porcelain-enameled grease shield",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Heating element and thermostat",
				coverage: "2 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--iRsWCeRx--/uk3uh2xvbxfnmbact5nb.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"PRO285N-BK": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--qABN-sag--/c3hfgvjlhqwn4fkdgmvy.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"PRO285X-BK": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--uy9pRcCH--/cgwuiv4to84fmmjck2ei.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"PRO285X-MK-PHM": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--uy9pRcCH--/cgwuiv4to84fmmjck2ei.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"PRO500RSIBNSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--9Q8NxmgI--/bqw2dxvcm1h7cmvuehjc.pdf#page=23",
		sourceLabel: "Model-specific warranty · page 23",
		source_page: 23,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"PRO500RSIBPSS-3": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--9Q8NxmgI--/bqw2dxvcm1h7cmvuehjc.pdf#page=23",
		sourceLabel: "Model-specific warranty · page 23",
		source_page: 23,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	PRO500VXRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "5 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--gB9hplJu--/fyqzqw1as3ibhjnimrbo.pdf#page=58",
		sourceLabel: "Model-specific warranty · page 58",
		source_page: 58,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	PRO500VXRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "5 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--gB9hplJu--/fyqzqw1as3ibhjnimrbo.pdf#page=58",
		sourceLabel: "Model-specific warranty · page 58",
		source_page: 58,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	PRO665VXRSIBNSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--xx37g2I4--/sxalmxaauklwhhzs2pox.pdf#page=66",
		sourceLabel: "Model-specific warranty · page 66",
		source_page: 66,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	PRO665VXRSIBPSS: {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Electrical Components",
				coverage: "3 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--xx37g2I4--/sxalmxaauklwhhzs2pox.pdf#page=66",
		sourceLabel: "Model-specific warranty · page 66",
		source_page: 66,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"R425NK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425NK-2-SS": {
		title: "15 Year Warranty",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0QNC1kEZ--/d8h4jgdv4lsnolxsh8sx.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425NSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425PK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425PK-2-SS": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0QNC1kEZ--/d8h4jgdv4lsnolxsh8sx.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425PSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525NK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525NK-2-SS": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0QNC1kEZ--/d8h4jgdv4lsnolxsh8sx.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525NSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525PK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525PK-2-SS": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--0QNC1kEZ--/d8h4jgdv4lsnolxsh8sx.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R525PSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R625PK-2": {
		title: "Manufacturer warranty",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP425SIBNK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP425SIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP425SIBPK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP425SIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP525SIBNK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP525SIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP525SIBPK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP525SIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP625SIBNK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP625SIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP625SIBPK-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RP625SIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS425RSIBNK-2-PHM": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS425RSIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS425RSIBPK-2-PHM": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS425RSIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS525RSIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS525RSIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS625RSIBNSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"RPS625RSIBPSS-2": {
		title: "15 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"TQ240-BL": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Painted steel lid and base",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--DPwHgCHh--/xn3hnxbtqsnqlskse38c.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"TQ285-BL-1": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--sXIMZDOk--/chme4g3eozsh6yamg8oe.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"TQ285-RD-1-A": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--sXIMZDOk--/chme4g3eozsh6yamg8oe.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"TQ285X-BL-1": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--cDZ4bhFf--/b83eefoze9ozcoz8wp6o.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"TQ285X-RD-1-A": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "10 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "10 years"
			},
			{
				component: "Porcelain enamel lid",
				coverage: "10 years"
			},
			{
				component: "Painted steel lid",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel tube burners",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Porcelain-enameled cast iron cooking grids",
				coverage: "5 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "Stainless steel or porcelain sear plates",
				coverage: "3 years full coverage, plus 50% off until the 10th year"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--cDZ4bhFf--/b83eefoze9ozcoz8wp6o.pdf#page=2",
		sourceLabel: "Model-specific warranty · page 2",
		source_page: 2,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"F365DSBPGT-ECP": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"F425DSBPGT-ECP": {
		title: "10 Year Limited",
		rows: [
			{
				component: "Hood",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "10 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "10 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Sear Plates",
				coverage: "10 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "10 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "10 Years"
			},
			{
				component: "All Other Parts",
				coverage: "10 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--TIiyRp1I--/xzy4yivmzmjgiurwcevl.pdf#page=20",
		sourceLabel: "Model-specific warranty · page 20",
		source_page: 20,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425SBNK-2-FB": {
		title: "15 Year Warranty",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"R425SBPK-2-FB": {
		title: "15 Year Warranty",
		rows: [
			{
				component: "Hood",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "15 Years"
			},
			{
				component: "Aluminum Castings",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			}
		],
		source: "https://images.salsify.com/image/upload/s--QN6fMWdR--/wgvuo7qk2wuv8zabw1ls.pdf#page=25",
		sourceLabel: "Model-specific warranty · page 25",
		source_page: 25,
		summary: "Coverage differs by component. The table below follows the warranty supplied with this model."
	},
	"NK14K-LEG-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	AS18K: {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	AS22K: {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"PRO18K-LEG-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"PRO22K-LEG-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"PRO22K-CART-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"NK18K-LEG-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"NK22K-LEG-3": {
		title: "10-year limited warranty",
		rows: [
			{
				component: "Porcelain-enamel lid and bowl",
				coverage: "10 years"
			},
			{
				component: "Air control system",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "Chrome-plated cooking grids",
				coverage: "3 years; 50% off replacement parts until year 10"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · Charcoal Kettle Series and Apollo Smokers",
		summary: "Ten-year lid and bowl coverage, with separate terms for air controls, cooking grids and other parts.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	PRO605CSS: {
		title: "15-year limited warranty",
		rows: [
			{
				component: "Aluminum castings / stainless steel base",
				coverage: "15 years"
			},
			{
				component: "Stainless steel lid",
				coverage: "15 years"
			},
			{
				component: "Porcelain-enamel cast-iron grids",
				coverage: "5 years; 50% off replacement parts until year 15"
			},
			{
				component: "Other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty · PRO605CSS Charcoal Cart",
		summary: "Fifteen-year coverage on the listed structural components; cooking grids and other parts have separate terms.",
		conditionsScope: "See the current US warranty and model manual for complete conditions."
	},
	"BIG32RBNMK-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			},
			{
				component: "Electrical components",
				coverage: "3 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US limited lifetime warranty",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"BIG32RBPMK-1": {
		title: "Limited lifetime warranty",
		rows: [
			{
				component: "Hood",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "All Other Parts",
				coverage: "15 Years"
			},
			{
				component: "Electrical components",
				coverage: "3 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US limited lifetime warranty",
		source_page: 25,
		summary: "Lifetime coverage on the listed structural parts, stainless grids and tube burners; other components have separate terms."
	},
	"STTR1-BZ": {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Aluminum tabletop and pedestal",
				coverage: "3 years"
			},
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-8ee4f4d7f597.pdf?v=1788860641",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	"STTR2-BZ": {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Aluminum tabletop and pedestal",
				coverage: "3 years"
			},
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-8ee4f4d7f597.pdf?v=1788860641",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	GPFR60: {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a098778a61c3.pdf?v=1788860667",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	GPFS60: {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-a098778a61c3.pdf?v=1788860667",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	GPFL48: {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-4e1dd02a4983.pdf?v=1788860689",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	GPFL48MHP: {
		title: "3 Year Limited Warranty",
		summary: "Napoleon covers manufacturing defects for the original purchaser during normal private use, subject to correct installation and maintenance. Coverage varies by component; labor, removal and reinstallation are not included.",
		rows: [
			{
				component: "Stainless steel housing",
				coverage: "3 years"
			},
			{
				component: "Stainless steel burner assembly",
				coverage: "3 years"
			},
			{
				component: "All other parts",
				coverage: "2 years"
			}
		],
		source: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-4e1dd02a4983.pdf?v=1788860689",
		sourceLabel: "Read the written warranty in your manual",
		conditionsScope: "Original purchaser; normal private use; installation and maintenance conditions apply."
	},
	"ODK301-BIG32RBNMK-1": {
		title: "Coverage by kitchen component",
		summary: "The included 700 Series grill has limited lifetime coverage on specified components. Cabinetry and the separate side burner follow Napoleon’s OASIS and built-in component terms. Coverage is not lifetime for every part of the kitchen.",
		rows: [
			{
				component: "Grill — Hood",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Grill — Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Grill — Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Grill — Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Grill — All Other Parts",
				coverage: "15 Years"
			},
			{
				component: "Grill — Electrical components",
				coverage: "3 years"
			},
			{
				component: "OASIS / side burner — aluminum castings and stainless steel base, where fitted",
				coverage: "10 years"
			},
			{
				component: "OASIS / side burner — stainless steel tube burners, where fitted",
				coverage: "10 years"
			},
			{
				component: "Side burner — ceramic infrared burner, excluding screen",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "OASIS — stainless steel door and drawer panels, where fitted",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "OASIS / side burner — other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty — grill and OASIS component terms",
		conditionsScope: "The written warranty and exact component manuals control conditions and exclusions."
	},
	"ODK301-BIG32RBPMK-1": {
		title: "Coverage by kitchen component",
		summary: "The included 700 Series grill has limited lifetime coverage on specified components. Cabinetry and the separate side burner follow Napoleon’s OASIS and built-in component terms. Coverage is not lifetime for every part of the kitchen.",
		rows: [
			{
				component: "Grill — Hood",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Porcelain Enamel Lid",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Aluminum Castings",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Cooking Grids",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Tube Burners",
				coverage: "Lifetime"
			},
			{
				component: "Grill — Stainless Steel Sear Plates",
				coverage: "15 Years"
			},
			{
				component: "Grill — Porcelain Enamel Cast Iron Grids",
				coverage: "15 Years"
			},
			{
				component: "Grill — Stainless Steel Infrared Rotisserie",
				coverage: "15 Years"
			},
			{
				component: "Grill — Infrared Bottom/Side Burner",
				coverage: "15 Years"
			},
			{
				component: "Grill — All Other Parts",
				coverage: "15 Years"
			},
			{
				component: "Grill — Electrical components",
				coverage: "3 years"
			},
			{
				component: "OASIS / side burner — aluminum castings and stainless steel base, where fitted",
				coverage: "10 years"
			},
			{
				component: "OASIS / side burner — stainless steel tube burners, where fitted",
				coverage: "10 years"
			},
			{
				component: "Side burner — ceramic infrared burner, excluding screen",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "OASIS — stainless steel door and drawer panels, where fitted",
				coverage: "5 years; 50% off replacement parts until year 10"
			},
			{
				component: "OASIS / side burner — other parts",
				coverage: "2 years"
			}
		],
		source: "https://www.napoleon.com/en/us/grills/support/napoleon-warranty",
		sourceLabel: "Napoleon US warranty — grill and OASIS component terms",
		conditionsScope: "The written warranty and exact component manuals control conditions and exclusions."
	}
}, Qn = (e) => new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD"
}).format(e), $n = (e) => e.replaceAll("_", " ").replace(/\b\w/g, (e) => e.toUpperCase()).replace(/\bbtus?\b/gi, "BTU"), er = (e, t) => Yn(e.v.specs).filter((e) => t.includes(e.attribute)).map(qn).join(" · ");
// Family cards retain exact variants for pricing, imagery and saved comparisons.
function hoGrillFamilyCard({ product, variants, selected, add }) {
 const [chosen, setChosen] = A.useState(variants[0].saved_key);
 const variant = variants.find(item => item.saved_key === chosen) || variants[0];
 const keys = [...new Set(variants.flatMap(item => Object.keys(item.options || {})))];
 const controls = keys.filter(key => new Set(variants.map(item => item.options[key]).filter(Boolean)).size > 1);
 function change(key, value) {
  const candidates = variants.filter(item => item.options[key] === value);
  candidates.sort((a, b) => keys.filter(k => k !== key && b.options[k] === variant.options[k]).length - keys.filter(k => k !== key && a.options[k] === variant.options[k]).length);
  if (candidates[0]) setChosen(candidates[0].saved_key);
 }
 return N.jsxs("article", {children: [
  N.jsxs("a", {href: variant.product_url, target: "_blank", rel: "noreferrer", children: [
   variant.image && N.jsx("img", {src: variant.image, alt: product.title}),
   N.jsx("span", {className: "eyebrow", children: product.brand}),
   N.jsx("h3", {children: product.title})
  ]}),
  controls.length > 0 && N.jsx("div", {className: "n-finder-fields ho-family-options", children: controls.map(key => N.jsxs("label", {children: [
   $n(key), N.jsx("select", {value: variant.options[key] || "", onChange: event => change(key, event.target.value), children: [...new Set(variants.map(item => item.options[key]).filter(Boolean))].map(value => N.jsx("option", {value, children: value}, value))})
  ]}, key))}),
  N.jsx("p", {children: Object.values(variant.options).filter(Boolean).join(" · ")}),
  N.jsx("small", {children: variant.manufacturer_sku}),
  N.jsx("strong", {children: variant.price === null ? "Price on request" : Qn(variant.price)}),
  N.jsxs(f, {variant: "outline", disabled: selected.includes(variant.saved_key), onClick: () => add(variant.saved_key), children: [selected.includes(variant.saved_key) ? "Added" : "Add to comparison", N.jsx(De, {size: 14})]})
 ]});
}
function hoGrillFamilies(catalog, search, fuel, installation, brand) {
 return catalog.filter(product => hoIsComparable(product) && (!brand || product.brand === brand)).flatMap(product => {
  const matches = product.variants.filter(variant => (!search.trim() || `${product.brand} ${product.title} ${variant.manufacturer_sku}`.toLowerCase().includes(search.trim().toLowerCase())) && (!fuel || hoComparisonFuel(variant.fuel) === fuel) && (!installation || hoComparisonInstallation(variant.installation) === installation));
  const groups = new Map();
  matches.forEach(variant => {const key = JSON.stringify([variant.installation || "", ...Object.entries(variant.options || {}).filter(([name]) => /size|width|model/i.test(name))]); if (!groups.has(key)) groups.set(key, []); groups.get(key).push(variant);});
  return [...groups].map(([installation, variants]) => ({p: product, v: variants[0], variants, familyKey: `${product.handle || product.product_id || product.title}:${installation}`}));
 });
}
function tr() {
	let { saved: e, toggle: t, addCompare: n, addCart: r } = Fn(), [i, a] = (0, A.useState)(""), [o, s] = (0, A.useState)(""), [c, l] = (0, A.useState)(""), [u, d] = (0, A.useState)(""), [p, m] = (0, A.useState)(""), [g, _] = (0, A.useState)(12);
	(0, A.useEffect)(() => {
		let e = new URLSearchParams(window.location.search).get("models");
		if (!e) return;
		let t = [...new Set(e.split(","))].filter((e) => hoIsComparable(h(e)?.p)).slice(0, 4);
		if (t.length) {
			let e = Mn();
			e.compare = t, Nn(e);
		}
	}, []);
	let y = e.compare.flatMap((e) => {
		let t = h(e);
		return t && hoIsComparable(t.p) ? [t] : [];
	}), x = !!(i.trim() || o || u || c), S = (0, A.useMemo)(() => x ? hoGrillFamilies(b, i, o, u, c) : [], [
		i,
		o,
		c,
		u,
		x,
		e.compare
	]), C = y[0], ee = C && C.p.category === "Grills" ? b.filter((e) => e.category === "Grills" && e.product_id !== C.p.product_id).flatMap((t) => {
		let n = t.variants.find((t) => hoComparisonFuel(t.fuel) === hoComparisonFuel(C.v.fuel) && hoComparisonInstallation(t.installation) === hoComparisonInstallation(C.v.installation) && !e.compare.includes(t.saved_key));
		if (!n) return [];
		let r = Number(er(C, ["Primary cooking surface"]).replace(/[^0-9.]/g, "")), i = Number(er({
			p: t,
			v: n
		}, ["Primary cooking surface"]).replace(/[^0-9.]/g, ""));
		return !r || !i || Math.abs(r - i) / r > .35 ? [] : [{
			p: t,
			v: n,
			score: Math.abs(r - i) / r
		}];
	}).sort((e, t) => e.score - t.score).slice(0, 3) : [], T = [...new Set(y.flatMap((e) => Yn(e.v.specs).map((e) => e.attribute)))], E = {
		...Xn,
		...v
	}, D = Zn, te = [
		{
			label: "Price",
			value: (e) => e.v.price === null ? "Price on request" : Qn(e.v.price),
			group: "Configuration & price"
		},
		{
			label: "Fuel",
			value: (e) => e.v.fuel || "—",
			group: "Configuration & price"
		},
		{
			label: "Installation",
			value: (e) => e.v.installation || "—",
			group: "Configuration & price"
		},
		{
			label: "Selected options",
			value: (e) => Object.values(e.v.options).filter(Boolean).join(" · "),
			group: "Configuration & price"
		},
		...T.map((e) => ({
			label: $n(e),
			value: (t) => er(t, [e]) || "Not published",
			group: /width|height|depth|cutout|clearance|dimension|weight/i.test(e) ? "Dimensions & installation" : "Cooking & performance"
		})),
		{
			label: "Cooking equipment",
			value: (e) => E[e.v.saved_key]?.equipment.join(" · ") || er(e, ["Rotisserie & searing"]) || "Not published",
			group: "Cooking equipment & ownership"
		},
		{
			label: "Controls & ignition",
			value: (e) => E[e.v.saved_key]?.controls.join(" · ") || er(e, ["Controls"]) || "Not published",
			group: "Cooking equipment & ownership"
		},
		{
			label: "Included & built-in equipment",
			value: (e) => E[e.v.saved_key]?.included.join(" · ") || "Not published",
			group: "Cooking equipment & ownership"
		},
		{
			label: "Combustible enclosure",
			value: (e) => E[e.v.saved_key]?.liner ? [
				E[e.v.saved_key].liner.title,
				E[e.v.saved_key].liner.sku,
				"required"
			].filter(Boolean).join(" · ") : er(e, ["Required installation accessories"]) || "Not applicable or not published",
			group: "Cooking equipment & ownership"
		},
		{
			label: "Manufacturer warranty",
			value: (e) => D[e.v.saved_key]?.summary || E[e.v.saved_key]?.warranty || e.v.warranty_source_text || "Not published",
			group: "Cooking equipment & ownership"
		}
	];
	async function ne() {
		let t = new URL("/collections/all?view=compare-grills", window.location.origin);
		t.searchParams.set("models", e.compare.join(","));
		try {
			await navigator.clipboard.writeText(t.href), m("Comparison link copied with the exact configurations.");
		} catch {
			m("Copy this comparison link: " + t.href);
		}
	}
	let re = (t) => /* @__PURE__ */ (0, N.jsx)("div", {
		className: "nap-compare-results",
		children: t.map(({ p: product, v: variant, variants, familyKey }) => N.jsx(hoGrillFamilyCard, {
   product, variants: variants || [variant], selected: e.compare,
   add: key => m(n(key) ? "Added to your comparison." : "You have four grills selected. Remove one before adding another.")
  }, familyKey || variant.saved_key))
	}), ie = /* @__PURE__ */ (0, N.jsxs)("section", {
		className: "nap-comparison-finder",
		children: [
			/* @__PURE__ */ (0, N.jsx)("div", {
				className: "section-heading",
				children: /* @__PURE__ */ (0, N.jsxs)("div", { children: [/* @__PURE__ */ (0, N.jsx)("p", {
					className: "eyebrow",
					children: "FIND YOUR NEXT COMPARISON"
				}), /* @__PURE__ */ (0, N.jsx)("h2", { children: "Find a grill." })] })
			}),
			/* @__PURE__ */ (0, N.jsxs)("div", {
				className: "n-finder-fields",
				children: [
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Product or model", /* @__PURE__ */ (0, N.jsx)("input", {
						value: i,
						onChange: (e) => {
							a(e.target.value), _(12);
						},
						placeholder: "Search a series or exact model"
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Brand", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: c,
						onChange: (e) => {
							l(e.target.value), _(12);
						},
						children: [
							/* @__PURE__ */ (0, N.jsx)("option", {
								value: "",
								children: "All brands"
							}),
							...[...new Set(b.filter(hoIsComparable).map(f => f.brand).filter(Boolean))].sort().map(brand => (0, N.jsx)("option", {value: brand, children: brand}, brand))
						]
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Fuel", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: o,
						onChange: (e) => {
							s(e.target.value), _(12);
						},
						children: [/* @__PURE__ */ (0, N.jsx)("option", {
							value: "",
							children: "All fuels"
						}), [...new Set(b.filter(hoIsComparable).flatMap((e) => e.variants.map((e) => hoComparisonFuel(e.fuel))).filter((e) => !!e))].sort().map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Installation", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: u,
						onChange: (e) => {
							d(e.target.value), _(12);
						},
						children: [/* @__PURE__ */ (0, N.jsx)("option", {
							value: "",
							children: "All installations"
						}), [...new Set(b.filter(hoIsComparable).flatMap((e) => e.variants.map((e) => hoComparisonInstallation(e.installation))).filter((e) => !!e))].sort().map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
					})] })
				]
			}),
			x && /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
				/* @__PURE__ */ (0, N.jsxs)("p", {
					className: "small-muted",
					children: [S.length, S.length === 1 ? " matching family" : " matching families"]
				}),
				re(S.slice(0, g)),
				S.length > g && /* @__PURE__ */ (0, N.jsx)(f, {
					variant: "outline",
					onClick: () => _((e) => e + 12),
					children: "Show more grills"
				}),
				/* @__PURE__ */ (0, N.jsx)(f, {
					variant: "ghost",
					onClick: () => {
						a(""), s(""), l(""), d(""), _(12);
					},
					children: "Clear filters"
				})
			] })
		]
	});
	return /* @__PURE__ */ (0, N.jsxs)("main", {
		id: "content",
		className: "nap-comparison-page container",
		children: [
			/* @__PURE__ */ (0, N.jsxs)("div", {
				className: "breadcrumb",
				children: [
					/* @__PURE__ */ (0, N.jsx)("a", {
						href: "/",
						children: "Home"
					}),
					/* @__PURE__ */ (0, N.jsx)("span", { children: "/" }),
					"Grill comparison"
				]
			}),
			/* @__PURE__ */ (0, N.jsx)("p", {
				className: "eyebrow",
				children: "HEARTH OUTPOST · GRILL COMPARISON"
			}),
			/* @__PURE__ */ (0, N.jsx)("h1", { children: "Find your perfect grill." }),
			/* @__PURE__ */ (0, N.jsx)("p", { children: "Compare up to four exact configurations across brands in one shared tool." }),
			/* @__PURE__ */ (0, N.jsx)("nav", {
				className: "nap-comparison-back",
				children: /* @__PURE__ */ (0, N.jsxs)("a", {
					href: "/collections/all?view=grills",
					children: ["Shop all grills ", /* @__PURE__ */ (0, N.jsx)(M, { size: 14 })]
				})
			}),
			/* @__PURE__ */ (0, N.jsx)("p", {
				className: "n-notice",
				role: "status",
				children: p
			}),
			y.length ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
				/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "nap-comparison-toolbar",
					children: [
						/* @__PURE__ */ (0, N.jsxs)("span", { children: [y.length, " of 4 grills selected"] }),
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: ne,
							children: [/* @__PURE__ */ (0, N.jsx)(Me, { size: 16 }), "Share comparison"]
						}),
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: event => window.HearthOutpostDocuments.print(event),
							children: [/* @__PURE__ */ (0, N.jsx)(Oe, { size: 16 }), "Print"]
						})
					]
				}),
				/* @__PURE__ */ (0, N.jsx)("p", {
					className: "small-muted",
					children: "Primary and total cooking areas are separate measurements. Main-burner output and total appliance output also measure different scopes."
				}),
				y.length > 1 && (0, N.jsxs)("div", {className:"nap-comparison-guide", children:[
 (0,N.jsx)("span",{children:"Swipe to compare all " + y.length + " grills"}),
 (0,N.jsx)("button",{type:"button","aria-label":"Scroll comparison left",onClick:event=>event.currentTarget.parentElement.nextElementSibling.scrollBy({left:-240,behavior:"smooth"}),children:(0,N.jsx)(me,{size:18})}),
 (0,N.jsx)("button",{type:"button","aria-label":"Scroll comparison right",onClick:event=>event.currentTarget.parentElement.nextElementSibling.scrollBy({left:240,behavior:"smooth"}),children:(0,N.jsx)(he,{size:18})})]}),
 /* @__PURE__ */ (0, N.jsx)("div", {
					className: "nap-comparison-scroll",
					tabIndex: 0,
					role: "region",
					"aria-label": "Grill comparison; scroll horizontally",
					children: /* @__PURE__ */ (0, N.jsxs)("table", {
						className: "nap-comparison-table",
						children: [
							/* @__PURE__ */ (0, N.jsx)("thead", { children: /* @__PURE__ */ (0, N.jsxs)("tr", { children: [/* @__PURE__ */ (0, N.jsx)("th", { children: "Compare your configurations" }), y.map(({ p: e, v: n }, r) => /* @__PURE__ */ (0, N.jsxs)("th", { children: [

								/* @__PURE__ */ (0, N.jsx)("span", {
									className: "eyebrow",
									children: r === 0 ? "YOUR SELECTED GRILL" : "COMPARISON " + (r + 1)
								}),
								/* @__PURE__ */ (0, N.jsx)("div", {
									className: "nap-brand-logo " + (e.brand === "Fire Magic" ? "fire-magic" : e.brand === "Napoleon" ? "napoleon" : "other-brand"),
									children: /* @__PURE__ */ (0, N.jsx)("img", {
										src: e.brand_logo || (e.brand === "Napoleon" ? "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-ec5596025277.png?v=1788860781" : globalThis.napoleonAssetBase + "fire-magic-logo-orange-transparent.png"),
										alt: e.brand
									})
								}),
								/* @__PURE__ */ (0, N.jsxs)("a", {
									href: n.product_url,
									target: "_blank",
									rel: "noreferrer",
									children: [
										n.image && /* @__PURE__ */ (0, N.jsx)("img", {
											className: "nap-comparison-product",
											src: n.image,
											alt: e.title
										}),
										/* @__PURE__ */ (0, N.jsx)("h2", { children: e.title }),
										/* @__PURE__ */ (0, N.jsx)("p", { children: n.manufacturer_sku })
									]
								}),

							] }, n.saved_key))] }) }),
							[
								"Configuration & price",
								"Cooking & performance",
								"Dimensions & installation",
								"Cooking equipment & ownership"
							].map((e) => /* @__PURE__ */ (0, N.jsxs)("tbody", { children: [/* @__PURE__ */ (0, N.jsx)("tr", {
								className: "nap-comparison-group",
								children: /* @__PURE__ */ (0, N.jsx)("th", {
									colSpan: y.length + 1,
									children: e
								})
							}), te.filter((t) => t.group === e && y.some((e) => t.value(e) !== "—")).map((e, t) => /* @__PURE__ */ (0, N.jsxs)("tr", { children: [/* @__PURE__ */ (0, N.jsx)("th", {
								scope: "row",
								children: e.label
							}), y.map((t) => /* @__PURE__ */ (0, N.jsx)("td", { children: e.value(t) }, t.v.saved_key))] }, e.label + t))] }, e)),
							/* @__PURE__ */ (0, N.jsx)("tfoot", { children: /* @__PURE__ */ (0, N.jsxs)("tr", { children: [/* @__PURE__ */ (0, N.jsx)("th", { children: "Make it yours" }), y.map(({ v: configuration }) => {
								let n = e.cart.includes(configuration.saved_key);
								return /* @__PURE__ */ (0, N.jsxs)("td", { children: [/* @__PURE__ */ (0, N.jsx)(f, {
									className: n ? "nap-comparison-added" : "",
									onClick: () => {
										n || m(r(configuration.saved_key) ? "Selected configuration added to your cart." : "Your browser could not save the cart.");
									},
									disabled: configuration.price === null || n,
									children: n ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [/* @__PURE__ */ (0, N.jsx)(fe, { size: 14 }), "Added to cart"] }) : /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: ["Add to Cart ", /* @__PURE__ */ (0, N.jsx)(De, { size: 14 })] })
								}), /* @__PURE__ */ (0, N.jsxs)("a", {
									href: configuration.product_url,
									target: "_blank",
									rel: "noreferrer",
									children: ["View this configuration ", /* @__PURE__ */ (0, N.jsx)(M, { size: 14 })]
								}), /* @__PURE__ */ (0, N.jsxs)(f, {
									variant: "ghost",
									className: "nap-comparison-remove",
									"aria-label": "Remove " + configuration.manufacturer_sku + " from comparison",
									onClick: () => t("compare", configuration.saved_key),
									children: [/* @__PURE__ */ (0, N.jsx)(Be, { size: 14 }), "Remove"] })] }, configuration.saved_key);
							})] }) })
						]
					})
				}),
				ie,
				ee.length > 0 && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "nap-comparison-alternatives",
					children: [
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "eyebrow",
							children: "COMPARE CLOSE ALTERNATIVES"
						}),
						/* @__PURE__ */ (0, N.jsx)("h2", { children: "Similar cooking capacity. Same installation style." }),
						re(ee)
					]
				})
			] }) : /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [ie, /* @__PURE__ */ (0, N.jsxs)("section", {
				className: "n-empty",
				children: [/* @__PURE__ */ (0, N.jsx)("h2", { children: "Which grills are on your list?" }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Search above or add a selected configuration from a grill’s product page." })]
			})] })
		]
	});
}
//#endregion
//#region lib/project-share.ts
function nr(e) {
	let t = JSON.stringify({
		version: 1,
		name: e.name,
		notes: e.notes,
		items: e.items
	});
	if (t.length > 18e3) throw Error("This project is too large for a share link. Download the project brief instead.");
	return encodeURIComponent(t);
}
function rr(e, t) {
	if (e.length > 1e5) throw Error("This project link is too large.");
	let n = JSON.parse(decodeURIComponent(e));
	if (n?.version !== 1 || typeof n.name != "string" || typeof n.notes != "string" || !Array.isArray(n.items) || n.items.length > 443) throw Error("This project link is not valid.");
	let r = /* @__PURE__ */ new Set(), i = n.items.map((e) => {
		let n = e;
		if (!n || typeof n.sku != "string" || !t(n.sku) || r.has(n.sku) || typeof n.note != "string" || typeof n.quantity != "number" || !Number.isInteger(n.quantity) || n.quantity < 1 || n.quantity > 99 || typeof n.selected != "boolean") throw Error("This project contains an unsupported model or invalid quantity.");
		return r.add(n.sku), {
			sku: n.sku,
			quantity: n.quantity,
			note: n.note,
			selected: n.selected
		};
	});
	return {
		name: n.name,
		notes: n.notes,
		items: i
	};
}
//#endregion
//#region components/napoleon-account-projects.tsx
function ir() {
	let [e, t] = (0, A.useState)(""), [n, r] = (0, A.useState)(""), [i, a] = (0, A.useState)(!1), [o, s] = (0, A.useState)(), [c, l] = (0, A.useState)(!1);
	if ((0, A.useEffect)(() => {
		t(window.napoleonProjectsEndpoint || "");
	}, []), !e) return null;
	async function u(t, n) {
		let r = await fetch(e, {
			method: t,
			credentials: "same-origin",
			headers: { "Content-Type": "application/json" },
			...n ? { body: JSON.stringify(n) } : {}
		});
		if (r.status === 401) throw l(!0), Error("Sign in to save projects to your account.");
		let i = await r.json();
		if (!r.ok) throw r.status === 409 && s(void 0), Error(i.error || "Your account projects could not be reached.");
		return l(!1), i;
	}
	async function d() {
		a(!0);
		try {
			let e = await u("GET"), t = Mn();
			if (e.projects) {
				for (let n of e.projects.projectBooks) {
					let e = t.projectBooks.find((e) => e.id === n.id);
					e ? JSON.stringify(e) !== JSON.stringify(n) && t.projectBooks.push({
						...n,
						id: crypto.randomUUID(),
						name: n.name + " (account copy)"
					}) : t.projectBooks.push(n);
				}
				if (!Nn(t)) throw Error("This browser could not save your projects.");
			}
			s(e.revision), r(e.projects ? "Account projects loaded. Your browser projects have been kept." : "Your account is ready. Save your projects to access them on another device.");
		} catch (e) {
			r(e instanceof Error ? e.message : "Unable to load projects.");
		} finally {
			a(!1);
		}
	}
	async function p() {
		a(!0);
		try {
			if (o === void 0) throw Error("Load your account projects first so existing projects are preserved.");
			let { projectBooks: e, activeProjectId: t } = Mn();
			s((await u("POST", {
				projects: {
					projectBooks: e,
					activeProjectId: t
				},
				revision: o
			})).revision), r("Projects saved to your account.");
		} catch (e) {
			r(e instanceof Error ? e.message : "Unable to save projects.");
		} finally {
			a(!1);
		}
	}
	return /* @__PURE__ */ (0, N.jsxs)("section", {
		"aria-label": "Account projects",
		children: [/* @__PURE__ */ (0, N.jsxs)("div", {
			className: "n-project-toolbar",
			children: [
				/* @__PURE__ */ (0, N.jsx)(f, {
					variant: "outline",
					disabled: i,
					onClick: d,
					children: "Load account projects"
				}),
				/* @__PURE__ */ (0, N.jsx)(f, {
					disabled: i || o === void 0,
					onClick: p,
					children: "Save projects to account"
				}),
				c && /* @__PURE__ */ (0, N.jsx)("a", {
					href: "/account/login?return_url=%2Fpages%2Foutdoor-projects",
					children: "Sign in"
				})
			]
		}), /* @__PURE__ */ (0, N.jsx)("p", {
			role: "status",
			children: n
		})]
	});
}
//#endregion
//#region components/napoleon-saved-page.tsx
var ar = (e) => new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD"
}).format(e), or = (e) => e.replaceAll("_", " ").replace(/\b\w/g, (e) => e.toUpperCase()).replace(/\bbtus?\b/gi, "BTU"), sr = (e) => {
	let t = b.find((t) => t.variants.some((t) => t.saved_key === e));
	return t ? {
		p: t,
		v: t.variants.find((t) => t.saved_key === e)
	} : null;
}, cr = (e, t) => e.variants.find((e) => e.saved_key === t)?.product_url || "/#collection";
function lr({ kind: e }) {
	let { saved: t, toggle: n, addProjectToCart: r, activeProject: i, updateProject: a, createProject: o, selectProject: s, removeProject: c } = Fn(), [l, u] = (0, A.useState)(""), [d, p] = (0, A.useState)(""), [m, h] = (0, A.useState)(""), [g, _] = (0, A.useState)(""), [v, y] = (0, A.useState)("");
	(0, A.useEffect)(() => {
		if (e !== "compare") return;
		let t = new URLSearchParams(window.location.search).get("models");
		if (!t) return;
		let n = [...new Set(t.split(","))].filter((e) => sr(e)?.p.category === "Grills").slice(0, 4);
		if (n.length) {
			let e = Mn();
			e.compare = n, Nn(e);
		}
	}, [e]);
	let [x, S] = (0, A.useState)(null);
	(0, A.useEffect)(() => {
		if (!(e !== "projects" || !window.location.hash.startsWith("#project="))) try {
			S(rr(window.location.hash.slice(9), (e) => !!sr(e)));
		} catch (e) {
			y(e instanceof Error ? e.message : "Unable to read this project link.");
		}
	}, [e]);
	async function C() {
		try {
			let e = new URL(window.napoleonCommerce ? "/collections/projects" : "/projects", window.location.origin);
			e.hash = "project=" + nr(i);
			try {
				await navigator.clipboard.writeText(e.href), y("Project link copied, including your notes and exact models. Anyone with the link can view them.");
			} catch {
				y("Copy this project link: " + e.href);
			}
		} catch (e) {
			y(e instanceof Error ? e.message : "Unable to create the project link.");
		}
	}
	function ee() {
		if (!x) return;
		let e = Mn(), t = crypto.randomUUID();
		e.projectBooks.push({
			...x,
			id: t
		}), e.activeProjectId = t, Nn(e) && (S(null), history.replaceState(null, "", window.location.pathname), y("Shared project saved as a new project. Your existing projects are preserved."));
	}
	let T = t[e].flatMap((e) => {
		let t = sr(e);
		return t ? [{
			...t,
			v: {
				...t.v,
				specs: Yn(t.v.specs)
			}
		}] : [];
	}), E = [...new Set(T.flatMap((e) => e.v.specs.map((e) => e.attribute)))], D = (0, A.useMemo)(() => !l && !d && !g && !m ? [] : b.filter((e) => e.category === "Grills" && (!m || e.brand === m)).flatMap((e) => e.variants.filter((t) => (!l || `${e.brand} ${e.title} ${t.manufacturer_sku}`.toLowerCase().includes(l.toLowerCase())) && (!d || t.fuel === d) && (!g || t.installation === g)).map((t) => ({
		p: e,
		v: t
	}))).slice(0, 12), [
		l,
		d,
		g,
		m
	]);
	async function te() {
		let e = new URL(window.napoleonCommerce ? "/collections/all?view=compare-grills" : "/compare/grills", window.location.origin);
		e.searchParams.set("models", t.compare.join(","));
		try {
			await navigator.clipboard.writeText(e.href), y("Comparison link copied.");
		} catch {
			y("Copy this comparison link: " + e.href);
		}
	}
	function ne() {
		let e = i.items.map((e) => {
			let t = sr(e.sku);
			return {
				...e,
				manufacturer_sku: t?.v.manufacturer_sku,
				brand: t?.p.brand,
				title: t?.p.title,
				options: t?.v.options,
				price: t?.v.price,
				price_source: t?.v.price_caption,
				url: t ? new URL(cr(t.p, e.sku), window.location.origin).href : null
			};
		}); window.HearthOutpostDocuments.project({name:i.name, notes:i.notes, items:e});
	}
	let re = i.items.filter((e) => e.selected).reduce((e, t) => e + (sr(t.sku)?.v.price || 0) * t.quantity, 0), ie = /* @__PURE__ */ (0, N.jsxs)("section", {
		className: "n-compare-finder",
		children: [
			/* @__PURE__ */ (0, N.jsx)("h2", { children: "Find a grill to compare" }),
			/* @__PURE__ */ (0, N.jsx)("p", {
				className: "n-small",
				children: "Choose a brand, fuel, or installation, or search an exact model. Up to 12 matching configurations appear at a time."
			}),
			/* @__PURE__ */ (0, N.jsxs)("div", {
				className: "n-finder-fields",
				children: [
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Product or model", /* @__PURE__ */ (0, N.jsx)("input", {
						value: l,
						onChange: (e) => u(e.target.value),
						placeholder: "Search a series or exact model…"
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Brand", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: m,
						onChange: (e) => h(e.target.value),
						children: [
							/* @__PURE__ */ (0, N.jsx)("option", {
								value: "",
								children: "All brands"
							}),
							...[...new Set(b.filter(f => f.category === "Grills").map(f => f.brand).filter(Boolean))].sort().map(brand => (0, N.jsx)("option", {value: brand, children: brand}, brand))
						]
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Fuel", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: d,
						onChange: (e) => p(e.target.value),
						children: [/* @__PURE__ */ (0, N.jsx)("option", {
							value: "",
							children: "All fuels"
						}), [...new Set(b.filter((e) => e.category === "Grills").flatMap((e) => e.variants.map((e) => e.fuel)).filter((e) => !!e))].sort().map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
					})] }),
					/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Installation", /* @__PURE__ */ (0, N.jsxs)("select", {
						value: g,
						onChange: (e) => _(e.target.value),
						children: [/* @__PURE__ */ (0, N.jsx)("option", {
							value: "",
							children: "All installations"
						}), [...new Set(b.filter((e) => e.category === "Grills").flatMap((e) => e.variants.map((e) => e.installation)).filter((e) => !!e))].sort().map((e) => /* @__PURE__ */ (0, N.jsx)("option", { children: e }, e))]
					})] })
				]
			}),
			D.length > 0 && /* @__PURE__ */ (0, N.jsx)("div", {
				className: "n-finder-results",
				children: D.map(({ p: e, v: r }) => /* @__PURE__ */ (0, N.jsxs)("article", { children: [
					r.image && /* @__PURE__ */ (0, N.jsx)("img", {
						src: r.image,
						alt: ""
					}),
					/* @__PURE__ */ (0, N.jsxs)("div", { children: [
						/* @__PURE__ */ (0, N.jsx)(w, {
							href: cr(e, r.saved_key),
							target: "_blank",
							children: e.title
						}),
						/* @__PURE__ */ (0, N.jsx)("p", { children: Object.values(r.options).join(" · ") }),
						/* @__PURE__ */ (0, N.jsx)("small", { children: r.manufacturer_sku })
					] }),
					/* @__PURE__ */ (0, N.jsx)(f, {
						variant: "outline",
						onClick: () => {
							n("compare", r.saved_key) || y("Compare up to four configurations. Remove one to make room.");
						},
						children: t.compare.includes(r.saved_key) ? "Remove" : "Compare"
					})
				] }, r.saved_key))
			}),
			(l || d || g || m) && !D.length && /* @__PURE__ */ (0, N.jsx)("p", { children: "No matching configurations. Try another model or filter." })
		]
	});
	return /* @__PURE__ */ (0, N.jsxs)("main", {
		id: "content",
		className: "n-saved-page",
		children: [
			/* @__PURE__ */ (0, N.jsx)("p", {
				className: "n-kicker",
				children: "HEARTH OUTPOST · OUTDOOR PLANNING"
			}),
			/* @__PURE__ */ (0, N.jsx)("h1", { children: e === "projects" ? "Outdoor Projects" : "Compare your grills" }),
			/* @__PURE__ */ (0, N.jsx)("p", { children: e === "projects" ? "Plan your outdoor spaces with exact products, quantities, measurements and installer notes." : "Compare up to four exact configurations side by side." }),
			e === "projects" ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
				/* @__PURE__ */ (0, N.jsx)(ir, {}),
				x && /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "n-shared-project",
					children: [
						/* @__PURE__ */ (0, N.jsx)("p", {
							className: "n-kicker",
							children: "Shared project"
						}),
						/* @__PURE__ */ (0, N.jsx)("h2", { children: x.name }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: x.notes }),
						/* @__PURE__ */ (0, N.jsxs)("p", { children: [x.items.length, " exact product configurations"] }),
						/* @__PURE__ */ (0, N.jsx)(f, {
							onClick: ee,
							children: "Save a copy to my projects"
						}),
						/* @__PURE__ */ (0, N.jsx)(f, {
							variant: "ghost",
							onClick: () => {
								S(null), history.replaceState(null, "", window.location.pathname);
							},
							children: "Dismiss"
						})
					]
				}),
				/* @__PURE__ */ (0, N.jsxs)("section", {
					className: "n-project-toolbar",
					children: [
						/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Current project", /* @__PURE__ */ (0, N.jsx)("select", {
							value: i.id,
							onChange: (e) => s(e.target.value),
							children: t.projectBooks.map((e) => /* @__PURE__ */ (0, N.jsx)("option", {
								value: e.id,
								children: e.name || "My Outdoor Home Project"
							}, e.id))
						})] }),
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: o,
							children: [/* @__PURE__ */ (0, N.jsx)(Se, {}), "New project"]
						}),
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "ghost",
							onClick: c,
							children: [/* @__PURE__ */ (0, N.jsx)(Ie, {}), "Delete project"]
						})
					]
				}),
				/* @__PURE__ */ (0, N.jsxs)("section", {
					className: "n-project-fields",
					children: [/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Project name", /* @__PURE__ */ (0, N.jsx)("input", {
						value: i.name,
						onChange: (e) => a((t) => ({
							...t,
							name: e.target.value
						}))
					})] }), /* @__PURE__ */ (0, N.jsxs)("label", { children: ["Project notes", /* @__PURE__ */ (0, N.jsx)("textarea", {
						value: i.notes,
						onChange: (e) => a((t) => ({
							...t,
							notes: e.target.value
						})),
						placeholder: "Measurements, finishes, installer details, delivery plans…"
					})] })]
				}),
				/* @__PURE__ */ (0, N.jsx)("p", {
					className: "n-small",
					children: "Changes save automatically in this browser."
				}),
				T.length ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
					/* @__PURE__ */ (0, N.jsx)("div", {
						className: "n-project-grid",
						children: T.map(({ p: e, v: t }) => {
							let r = i.items.find((e) => e.sku === t.saved_key);
							return /* @__PURE__ */ (0, N.jsxs)("article", { children: [
								/* @__PURE__ */ (0, N.jsxs)(w, {
									href: cr(e, t.saved_key),
									target: "_blank",
									children: [t.image && /* @__PURE__ */ (0, N.jsx)("img", {
										src: t.image,
										alt: e.title
									}), /* @__PURE__ */ (0, N.jsx)("h2", { children: e.title })]
								}),
								/* @__PURE__ */ (0, N.jsx)("p", { children: Object.values(t.options).join(" · ") }),
								/* @__PURE__ */ (0, N.jsx)("p", {
									className: "n-sku",
									children: t.manufacturer_sku
								}),
								/* @__PURE__ */ (0, N.jsx)("strong", { children: t.price === null ? "Price on request" : ar(t.price) }),
								/* @__PURE__ */ (0, N.jsx)("p", {
									className: "n-small",
									children: t.price_caption
								}),
								/* @__PURE__ */ (0, N.jsxs)("label", {
									className: "n-project-check",
									children: [/* @__PURE__ */ (0, N.jsx)("input", {
										type: "checkbox",
										checked: r.selected,
										onChange: (e) => a((t) => ({
											...t,
											items: t.items.map((t) => t.sku === r.sku ? {
												...t,
												selected: e.target.checked
											} : t)
										}))
									}), "Include in planning total"]
								}),
								/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Quantity", /* @__PURE__ */ (0, N.jsx)("input", {
									type: "number",
									min: 1,
									max: 99,
									value: r.quantity,
									onChange: (e) => a((t) => ({
										...t,
										items: t.items.map((t) => t.sku === r.sku ? {
											...t,
											quantity: Number(e.target.value)
										} : t)
									}))
								})] }),
								/* @__PURE__ */ (0, N.jsxs)("label", { children: ["Item notes", /* @__PURE__ */ (0, N.jsx)("textarea", {
									value: r.note,
									placeholder: "Placement, finish, measurements…",
									onChange: (e) => a((t) => ({
										...t,
										items: t.items.map((t) => t.sku === r.sku ? {
											...t,
											note: e.target.value
										} : t)
									}))
								})] }),
								/* @__PURE__ */ (0, N.jsx)(f, {
									variant: "ghost",
									onClick: () => n("projects", t.saved_key),
									children: "Remove"
								})
							] }, t.saved_key);
						})
					}),
					/* @__PURE__ */ (0, N.jsxs)("p", {
						className: "n-project-total",
						children: ["Selected planning total: ", /* @__PURE__ */ (0, N.jsx)("strong", { children: ar(re) })]
					}),
					/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-small",
						children: "Uses the displayed price for each selected configuration and quantity. Excludes tax, shipping and installation."
					})
				] }) : /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "n-empty",
					children: [
						/* @__PURE__ */ (0, N.jsx)("h2", { children: "Start with something you love." }),
						/* @__PURE__ */ (0, N.jsx)("p", { children: "Save a product configuration to add it to this project." }),
						/* @__PURE__ */ (0, N.jsx)(w, {
							href: "/#collection",
							className: "n-primary",
							children: "Explore Napoleon →"
						})
					]
				}),
				/* @__PURE__ */ (0, N.jsxs)("div", {
					className: "n-project-toolbar",
					children: [
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: event => window.HearthOutpostDocuments.print(event),
							children: [/* @__PURE__ */ (0, N.jsx)(Oe, {}), "Print project"]
						}),
						/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: C,
							children: [/* @__PURE__ */ (0, N.jsx)(Me, {}), "Share project"]
						}),
						/* @__PURE__ */ (0, N.jsx)(f, {
							variant: "outline",
							onClick: ne,
							children: "Download project brief"
						}),
						/* @__PURE__ */ (0, N.jsx)(f, {
							disabled: !i.items.some((e) => e.selected),
							onClick: async () => {
								y(await r() ? "Selected project items and quantities added to your cart." : "The selected items could not be added. Please try again.");
							},
							children: "Add selected items to cart"
						}),
						/* @__PURE__ */ (0, N.jsx)(w, {
							className: "n-text-link",
							href: "/#collection",
							children: "Continue building your project →"
						})
					]
				})
			] }) : /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
				!T.length && ie,
				T.length ? /* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [
					/* @__PURE__ */ (0, N.jsxs)("div", {
						className: "n-project-toolbar",
						children: [/* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: te,
							children: [/* @__PURE__ */ (0, N.jsx)(Me, {}), "Share comparison"]
						}), /* @__PURE__ */ (0, N.jsxs)(f, {
							variant: "outline",
							onClick: event => window.HearthOutpostDocuments.print(event),
							children: [/* @__PURE__ */ (0, N.jsx)(Oe, {}), "Print comparison"]
						})]
					}),
					/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-small",
						children: "Primary cooking surface and total cooking area are shown separately. Main-burner heat and total appliance heat use different scopes; compare like measurements."
					}),
					/* @__PURE__ */ (0, N.jsx)("p", {
						className: "n-small n-comparison-hint",
						children: "Scroll sideways to see every grill. Specification labels stay visible."
					}),
					/* @__PURE__ */ (0, N.jsx)("div", {
						className: "n-comparison-scroll",
						tabIndex: 0,
						role: "region",
						"aria-label": "Grill comparison table, scroll horizontally for more configurations",
						children: /* @__PURE__ */ (0, N.jsxs)("table", {
							className: "n-comparison",
							children: [
								/* @__PURE__ */ (0, N.jsx)("caption", {
									className: "sr-only",
									children: "Comparison of your selected exact grill configurations"
								}),
								/* @__PURE__ */ (0, N.jsx)("thead", { children: /* @__PURE__ */ (0, N.jsxs)("tr", { children: [/* @__PURE__ */ (0, N.jsx)("th", {
									scope: "col",
									children: "Your configurations"
								}), T.map(({ p: e, v: r }) => /* @__PURE__ */ (0, N.jsxs)("th", {
									scope: "col",
									children: [
										e.brand === "Napoleon" ? /* @__PURE__ */ (0, N.jsx)("img", {
											className: "n-compare-logo",
											src: "https://cdn.shopify.com/s/files/1/0757/2245/7372/files/napoleon-ec5596025277.png?v=1788860781",
											alt: "Napoleon"
										}) : /* @__PURE__ */ (0, N.jsx)("p", {
											className: "n-kicker",
											children: "Fire Magic"
										}),
										/* @__PURE__ */ (0, N.jsxs)(w, {
											href: cr(e, r.saved_key),
											target: "_blank",
											children: [
												r.image && /* @__PURE__ */ (0, N.jsx)("img", {
													src: r.image,
													alt: e.title
												}),
												/* @__PURE__ */ (0, N.jsx)("h2", { children: e.title }),
												/* @__PURE__ */ (0, N.jsx)("p", { children: r.manufacturer_sku })
											]
										}),
										/* @__PURE__ */ (0, N.jsx)(f, {
											variant: "ghost",
											onClick: () => n("compare", r.saved_key),
											children: "Remove"
										}),
										/* @__PURE__ */ (0, N.jsx)(f, {
											variant: "outline",
											onClick: () => n("projects", r.saved_key),
											children: t.projects.includes(r.saved_key) ? "Saved to project" : "Add to project"
										})
									]
								}, r.saved_key))] }) }),
								/* @__PURE__ */ (0, N.jsx)("tbody", { children: [
									"Price",
									"Price source",
									"Fuel",
									"Installation",
									"Finish",
									...E,
									"Warranty"
								].map((e) => /* @__PURE__ */ (0, N.jsxs)("tr", { children: [/* @__PURE__ */ (0, N.jsx)("th", {
									scope: "row",
									children: or(e)
								}), T.map(({ v: t }) => {
									let n = t.specs.find((t) => t.attribute === e);
									return /* @__PURE__ */ (0, N.jsx)("td", { children: e === "Price" ? t.price === null ? "Price on request" : ar(t.price) : e === "Price source" ? t.price_caption : e === "Fuel" ? t.fuel || "—" : e === "Installation" ? t.installation || "—" : e === "Finish" ? t.finish || "—" : e === "Warranty" ? t.warranty_source_text || "—" : n ? `${n.value} ${n.unit}` : "—" }, t.saved_key);
								})] }, e)) })
							]
						})
					}),
					ie
				] }) : /* @__PURE__ */ (0, N.jsxs)("section", {
					className: "n-empty",
					children: [/* @__PURE__ */ (0, N.jsx)("h2", { children: "Which grills are on your list?" }), /* @__PURE__ */ (0, N.jsx)("p", { children: "Use the finder above or add the selected configuration from any grill page." })]
				}),
				/* @__PURE__ */ (0, N.jsx)(w, {
					className: "n-text-link",
					href: "/#collection",
					children: "Back to Napoleon grills →"
				})
			] }),
			/* @__PURE__ */ (0, N.jsx)("p", {
				role: "status",
				className: "n-notice",
				children: v
			})
		]
	});
}
//#endregion
//#region shopify/entry.tsx
function ur() {
	return A.useEffect(() => {
		if (location.hash) {
			let e = decodeURIComponent(location.hash.slice(1));
			document.getElementById(e)?.scrollIntoView();
		}
	}, []), null;
}
var dr = document.getElementById("napoleon-shopify-root");
if (dr && !dr.dataset.hopInitialCommitted) {
	let e = JSON.parse(document.getElementById("napoleon-shopify-settings").textContent);
	typeof e.projectsEndpoint == "string" && /^\/apps\/[a-z0-9-]+$/.test(e.projectsEndpoint) && (window.napoleonProjectsEndpoint = e.projectsEndpoint), window.napoleonAssetBase = new URL(".", new URL(e.scriptUrl, location.href)).href, window.napoleonCommerce = { async addItems(t) {
		let n = await fetch(e.idsUrl).then((e) => e.json());if(window.napoleonAssetBase)Object.assign(n,await fetch(new URL('trueflame-variant-ids.json',window.napoleonAssetBase)).then(r=>r.json()));let r = t.flatMap(({ sku: e, quantity: t }) => {
			if (!n[e]) throw Error("No store variant for " + e);
            if(Array.isArray(n[e]))return n[e].map(id=>({id,quantity:t}));
			return {
				id: n[e],
				quantity: t
			};
		});
		return (await fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ items: r })
		})).ok ? (document.dispatchEvent(new CustomEvent("cart:refresh")), !0) : !1;
	} }, document.addEventListener("click", (e) => {
		let t = e.target.closest("a");
		if (!t || !dr.contains(t)) return;
		let r = t.getAttribute("href");
		r && t.setAttribute("href", n(r));
	}, !0);
	async function t() {
		let t;
		if (e.kind === "product") {
			let n = await fetch(e.payloadUrl);
			if (!n.ok) throw Error("Product information could not load");
			let { product: r, merchandising: i, variantIds: a } = await n.json();
            if (hopPurchaseData && ['Napoleon','American Outdoor Grill','American Made Grills','TrueFlame','Primo Ceramic Grills','AMD'].includes(r.brand)) r.variants = r.variants.map(variant => {
              const stored = hopPurchaseData.variants[variant.manufacturer_sku];
              return stored ? {...variant,price:stored.price/100,msrp_usd:stored.compare_at_price ? stored.compare_at_price/100 : null,available:stored.available} : variant;
            });
            if(e.planningUrl){const response=await fetch(e.planningUrl);if(!response.ok)throw Error('Planning information could not load');const planning=await response.json();for(const family of planning.families)if(!b.some(existing=>existing.handle===family.handle))b.push(family);Object.assign(v,planning.ownershipProfiles);}
            if(r.brand_profile&&e.brandLogo)r.brand_profile.logo=e.brandLogo;
            if(e.assetMedia){
              const mediaUrl=url=>typeof url==='string'&&url.startsWith('asset:')?new URL(url.slice(6),new URL(e.payloadUrl,location.href)).href:url;
              r.variants=r.variants.map(v=>({...v,gallery:v.gallery.map(mediaUrl),gallery_metadata:Object.fromEntries(Object.entries(v.gallery_metadata||{}).map(([k,value])=>[mediaUrl(k),value]))}));
              for(const m of Object.values(i)){m.gallery=m.gallery.map(mediaUrl);m.lifestyle=mediaUrl(m.lifestyle);}
            }

            if(e.componentPdp && e.componentUrl){
                const response=await fetch(e.componentUrl);if(!response.ok)throw Error('Component information could not load');
                const profile=(await response.json())[r.handle];if(!profile)throw Error('Component profile missing');
                r.variants=r.variants.map(v=>({...v,...profile.variants?.[v.manufacturer_sku]}));
                for(const v of r.variants){
                    const m=i[v.manufacturer_sku]={...i[v.manufacturer_sku],...profile.merchandising?.[v.manufacturer_sku]};
                    if(m.lifestyle_asset){
                        m.lifestyle=new URL(m.lifestyle_asset,new URL(e.componentUrl,location.href)).href;
                        m.gallery=[...m.gallery,m.lifestyle];
                        v.gallery_metadata={...v.gallery_metadata,[m.lifestyle]:{alt:m.lifestyleAlt,caption:m.lifestyleCaption}};
                    }
                }
            }
			window.napoleonCommerce.variantId = (e) => a[e];
            if (hopPurchaseData && ['Napoleon','American Outdoor Grill','American Made Grills','TrueFlame','Primo Ceramic Grills','AMD'].includes(r.brand)) {
              window.napoleonCommerce.purchaseIds = {...a};
              try {
                const inclusionResponse = await fetch(hopPurchaseData.inclusions_url);
                if (inclusionResponse.ok) hopPurchaseData.inclusions = await inclusionResponse.json();
              } catch { /* Missing optional inclusions must not block purchasing. */ }
              try {
                const idsResponse = await fetch(e.idsUrl);
                if (idsResponse.ok) window.napoleonCommerce.purchaseIds = {...await idsResponse.json(),...a};
              } catch { /* Optional cart recognition must not prevent the PDP from loading. */ }
            }
			let o = new URLSearchParams(location.search);
			t = /* @__PURE__ */ (0, N.jsx)(Rn, {
				product: r,
				initialSku: o.get("sku") || Object.keys(a).find((e) => String(a[e]) === o.get("variant")) || e.sku,
				merchandising: i
			});
		} else t = e.kind === "brand" ? /* @__PURE__ */ (0, N.jsx)(Kn, {}) : e.kind === "compare" ? /* @__PURE__ */ (0, N.jsx)(tr, {}) : /* @__PURE__ */ (0, N.jsx)(lr, { kind: "projects" });
		(0, Xt.createRoot)(dr).render(/* @__PURE__ */ (0, N.jsxs)(N.Fragment, { children: [t, /* @__PURE__ */ (0, N.jsx)(ur, {})] })), document.getElementById("napoleon-liquid-fallback")?.setAttribute("hidden", "");
	}
	t().catch((e) => {
		dr.textContent = "Product details are temporarily unavailable. Please refresh the page.", console.error(e.message);
	});
}
//#endregion

function isPdpResource(url){try{const u=new URL(url,location.href);return u.origin===location.origin||['https://www.primogrill.com/warranty-parts.html','https://broilmaster.com/warranty/'].includes(u.href)||/\.pdf$/i.test(u.pathname);}catch{return false;}}

// Shared storefront entry point: other PDPs use the approved Napoleon player.
export function mountPdpVideo(container, video) {
  const root = Xt.createRoot(container);
  const scopedApi = ['/products/trueflame-32-inch-4-burner-gas-grill','/products/amg-estate-built-in-grills','/products/amg-estate-freestanding-grills'].includes(location.pathname);
  root.render(N.jsx(cn, { video: {...video,useYouTubeApi:scopedApi} }));
  return () => root.unmount();
}

// Reuse this renderer's existing React runtime for Liquid-based purchase adapters.
function purchaseIcons(){ return {shipping:(0,N.jsx)(Pe,{}),returns:(0,N.jsx)(Ae,{}),warranty:(0,N.jsx)(Ne,{}),gift:A.createElement('svg',{viewBox:'0 0 24 24','aria-hidden':true},A.createElement('path',{d:'M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8H7a3 3 0 1 1 3-3l2 3Zm0 0h5a3 3 0 1 0-3-3l-2 3Z'})),promo:A.createElement('svg',{viewBox:'0 0 24 24','aria-hidden':true},A.createElement('path',{d:'m21 3-8 0L2 14l8 8L21 11Z'}),A.createElement('circle',{cx:17,cy:7,r:1}))}; }
export function mountPurchaseComponents(hosts) {
 const roots=Object.fromEntries(Object.entries(hosts).map(([key,node])=>[key,Xt.createRoot(node)]));
 return {
  render(props) { roots.price.render(A.createElement(HopPurchase.PriceExtras,props.price)); roots.benefits.render(A.createElement(HopPurchase.Benefits,{...props.benefits,icons:purchaseIcons()})); roots.sticky.render(A.createElement(HopPurchase.Sticky,props.sticky)); },
  unmount(){Object.values(roots).forEach(root=>root.unmount());}
 };
}

// Native PDP adapter: reuses the existing sticky component without mounting other purchase UI.
export function mountPdpSticky(host) {
 const root=Xt.createRoot(host);
 return {render(props){root.render(A.createElement(HopPurchase.Sticky,props));},unmount(){root.unmount();}};
}
// Native PDP controls share the current comparison and project storage format.
export function addPdpComparison(sku) {
 const product=b.find(product=>hoIsComparable(product)&&product.variants.some(v=>v.manufacturer_sku===sku));
 const variant=product?.variants.find(v=>v.manufacturer_sku===sku);
 if(!variant)return {ok:false,message:'This configuration is not available in the comparison tool yet.'};
 const state=Mn(),next=Pn(hoVisibleGrillKeys(state.compare),variant.saved_key);
 if(!next)return {ok:false,message:'Your comparison already has four items. Remove one in the comparison tool to add this configuration.'};
 state.compare=next;
 return Nn(state)?{ok:true,message:'Added to your comparison.'}:{ok:false,message:'Your browser could not save this comparison.'};
}
export function savePdpProject(items) {
 if(!items.length||items.some(item=>typeof item.sku!=='string'||!Number.isInteger(item.quantity)||item.quantity<1||item.quantity>99))return {ok:false,message:'This configuration could not be saved.'};
 const state=Mn(),book=state.projectBooks.find(book=>book.id===state.activeProjectId);
 for(const item of items){const existing=book.items.find(row=>row.sku===item.sku);if(existing){existing.quantity=item.quantity;existing.selected=true;}else book.items.push({sku:item.sku,quantity:item.quantity,note:'',selected:true});}
 return Nn(state)?{ok:true,message:'Saved to your outdoor project in this browser. Open Projects to manage it or save it to your account.'}:{ok:false,message:'Your browser could not save this project.'};
}

// Shipping-only adapter for legacy PDPs; retains native buying controls.
export function mountPdpShipping(host, deliveryHost) {
 const root=Xt.createRoot(host), deliveryRoot=deliveryHost ? Xt.createRoot(deliveryHost) : null;
 return {render(data){root.render(A.createElement(HopPurchase.Shipping,{data,icons:purchaseIcons(),standalone:!deliveryRoot}));deliveryRoot?.render(A.createElement(HopPurchase.Delivery,{data}));},unmount(){root.unmount();deliveryRoot?.unmount();}};
}
